(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired3b3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired3b3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jPhJ8", function(module, exports) {
typeof navigator !== "undefined" && function(global11, factory11) {
    module.exports = factory11();
}(this, function() {
    "use strict";
    var svgNS = "http://www.w3.org/2000/svg";
    var locationHref = "";
    var _useWebWorker = false;
    var initialDefaultFrame = -999999;
    var setWebWorker = function setWebWorker11(flag11) {
        _useWebWorker = !!flag11;
    };
    var getWebWorker = function getWebWorker11() {
        return _useWebWorker;
    };
    var setLocationHref = function setLocationHref11(value31) {
        locationHref = value31;
    };
    var getLocationHref = function getLocationHref11() {
        return locationHref;
    };
    function createTag(type11) {
        // return {appendChild:function(){},setAttribute:function(){},style:{}}
        return document.createElement(type11);
    }
    function extendPrototype(sources11, destination11) {
        var i31;
        var len11 = sources11.length;
        var sourcePrototype11;
        for(i31 = 0; i31 < len11; i31 += 1){
            sourcePrototype11 = sources11[i31].prototype;
            for(var attr31 in sourcePrototype11)if (Object.prototype.hasOwnProperty.call(sourcePrototype11, attr31)) destination11.prototype[attr31] = sourcePrototype11[attr31];
        }
    }
    function getDescriptor(object11, prop11) {
        return Object.getOwnPropertyDescriptor(object11, prop11);
    }
    function createProxyFunction(prototype11) {
        function ProxyFunction11() {}
        ProxyFunction11.prototype = prototype11;
        return ProxyFunction11;
    }
    // import Howl from '../../3rd_party/howler';
    var audioControllerFactory = function() {
        function AudioController11(audioFactory11) {
            this.audios = [];
            this.audioFactory = audioFactory11;
            this._volume = 1;
            this._isMuted = false;
        }
        AudioController11.prototype = {
            addAudio: function addAudio11(audio11) {
                this.audios.push(audio11);
            },
            pause: function pause11() {
                var i31;
                var len11 = this.audios.length;
                for(i31 = 0; i31 < len11; i31 += 1)this.audios[i31].pause();
            },
            resume: function resume11() {
                var i31;
                var len11 = this.audios.length;
                for(i31 = 0; i31 < len11; i31 += 1)this.audios[i31].resume();
            },
            setRate: function setRate11(rateValue11) {
                var i31;
                var len11 = this.audios.length;
                for(i31 = 0; i31 < len11; i31 += 1)this.audios[i31].setRate(rateValue11);
            },
            createAudio: function createAudio11(assetPath11) {
                if (this.audioFactory) return this.audioFactory(assetPath11);
                if (window.Howl) return new window.Howl({
                    src: [
                        assetPath11
                    ]
                });
                return {
                    isPlaying: false,
                    play: function play11() {
                        this.isPlaying = true;
                    },
                    seek: function seek11() {
                        this.isPlaying = false;
                    },
                    playing: function playing11() {},
                    rate: function rate11() {},
                    setVolume: function setVolume11() {}
                };
            },
            setAudioFactory: function setAudioFactory11(audioFactory11) {
                this.audioFactory = audioFactory11;
            },
            setVolume: function setVolume11(value31) {
                this._volume = value31;
                this._updateVolume();
            },
            mute: function mute11() {
                this._isMuted = true;
                this._updateVolume();
            },
            unmute: function unmute11() {
                this._isMuted = false;
                this._updateVolume();
            },
            getVolume: function getVolume11() {
                return this._volume;
            },
            _updateVolume: function _updateVolume11() {
                var i31;
                var len11 = this.audios.length;
                for(i31 = 0; i31 < len11; i31 += 1)this.audios[i31].volume(this._volume * (this._isMuted ? 0 : 1));
            }
        };
        return function() {
            return new AudioController11();
        };
    }();
    var createTypedArray = function() {
        function createRegularArray11(type11, len11) {
            var i31 = 0;
            var arr31 = [];
            var value31;
            switch(type11){
                case "int16":
                case "uint8c":
                    value31 = 1;
                    break;
                default:
                    value31 = 1.1;
                    break;
            }
            for(i31 = 0; i31 < len11; i31 += 1)arr31.push(value31);
            return arr31;
        }
        function createTypedArrayFactory11(type11, len11) {
            if (type11 === "float32") return new Float32Array(len11);
            if (type11 === "int16") return new Int16Array(len11);
            if (type11 === "uint8c") return new Uint8ClampedArray(len11);
            return createRegularArray11(type11, len11);
        }
        if (typeof Uint8ClampedArray === "function" && typeof Float32Array === "function") return createTypedArrayFactory11;
        return createRegularArray11;
    }();
    function createSizedArray(len11) {
        return Array.apply(null, {
            length: len11
        });
    }
    function _typeof$6(obj11) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$6 = function _typeof11(obj11) {
            return typeof obj11;
        };
        else _typeof$6 = function _typeof11(obj11) {
            return obj11 && typeof Symbol === "function" && obj11.constructor === Symbol && obj11 !== Symbol.prototype ? "symbol" : typeof obj11;
        };
        return _typeof$6(obj11);
    }
    var subframeEnabled = true;
    var expressionsPlugin = null;
    var expressionsInterfaces = null;
    var idPrefix$1 = "";
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    var _shouldRoundValues = false;
    var bmPow = Math.pow;
    var bmSqrt = Math.sqrt;
    var bmFloor = Math.floor;
    var bmMax = Math.max;
    var bmMin = Math.min;
    var BMMath = {};
    (function() {
        var propertyNames11 = [
            "abs",
            "acos",
            "acosh",
            "asin",
            "asinh",
            "atan",
            "atanh",
            "atan2",
            "ceil",
            "cbrt",
            "expm1",
            "clz32",
            "cos",
            "cosh",
            "exp",
            "floor",
            "fround",
            "hypot",
            "imul",
            "log",
            "log1p",
            "log2",
            "log10",
            "max",
            "min",
            "pow",
            "random",
            "round",
            "sign",
            "sin",
            "sinh",
            "sqrt",
            "tan",
            "tanh",
            "trunc",
            "E",
            "LN10",
            "LN2",
            "LOG10E",
            "LOG2E",
            "PI",
            "SQRT1_2",
            "SQRT2"
        ];
        var i31;
        var len11 = propertyNames11.length;
        for(i31 = 0; i31 < len11; i31 += 1)BMMath[propertyNames11[i31]] = Math[propertyNames11[i31]];
    })();
    function ProjectInterface$1() {
        return {};
    }
    BMMath.random = Math.random;
    BMMath.abs = function(val31) {
        var tOfVal11 = _typeof$6(val31);
        if (tOfVal11 === "object" && val31.length) {
            var absArr11 = createSizedArray(val31.length);
            var i31;
            var len11 = val31.length;
            for(i31 = 0; i31 < len11; i31 += 1)absArr11[i31] = Math.abs(val31[i31]);
            return absArr11;
        }
        return Math.abs(val31);
    };
    var defaultCurveSegments = 150;
    var degToRads = Math.PI / 180;
    var roundCorner = 0.5519;
    function roundValues(flag11) {
        _shouldRoundValues = !!flag11;
    }
    function bmRnd(value31) {
        if (_shouldRoundValues) return Math.round(value31);
        return value31;
    }
    function styleDiv(element11) {
        element11.style.position = "absolute";
        element11.style.top = 0;
        element11.style.left = 0;
        element11.style.display = "block";
        element11.style.transformOrigin = "0 0";
        element11.style.webkitTransformOrigin = "0 0";
        element11.style.backfaceVisibility = "visible";
        element11.style.webkitBackfaceVisibility = "visible";
        element11.style.transformStyle = "preserve-3d";
        element11.style.webkitTransformStyle = "preserve-3d";
        element11.style.mozTransformStyle = "preserve-3d";
    }
    function BMEnterFrameEvent(type11, currentTime11, totalTime11, frameMultiplier11) {
        this.type = type11;
        this.currentTime = currentTime11;
        this.totalTime = totalTime11;
        this.direction = frameMultiplier11 < 0 ? -1 : 1;
    }
    function BMCompleteEvent(type11, frameMultiplier11) {
        this.type = type11;
        this.direction = frameMultiplier11 < 0 ? -1 : 1;
    }
    function BMCompleteLoopEvent(type11, totalLoops11, currentLoop11, frameMultiplier11) {
        this.type = type11;
        this.currentLoop = currentLoop11;
        this.totalLoops = totalLoops11;
        this.direction = frameMultiplier11 < 0 ? -1 : 1;
    }
    function BMSegmentStartEvent(type11, firstFrame11, totalFrames11) {
        this.type = type11;
        this.firstFrame = firstFrame11;
        this.totalFrames = totalFrames11;
    }
    function BMDestroyEvent(type11, target11) {
        this.type = type11;
        this.target = target11;
    }
    function BMRenderFrameErrorEvent(nativeError11, currentTime11) {
        this.type = "renderFrameError";
        this.nativeError = nativeError11;
        this.currentTime = currentTime11;
    }
    function BMConfigErrorEvent(nativeError11) {
        this.type = "configError";
        this.nativeError = nativeError11;
    }
    function BMAnimationConfigErrorEvent(type11, nativeError11) {
        this.type = type11;
        this.nativeError = nativeError11;
    }
    var createElementID = function() {
        var _count11 = 0;
        return function createID11() {
            _count11 += 1;
            return idPrefix$1 + "__lottie_element_" + _count11;
        };
    }();
    function HSVtoRGB(h31, s41, v51) {
        var r11;
        var g31;
        var b31;
        var i31;
        var f31;
        var p61;
        var q11;
        var t31;
        i31 = Math.floor(h31 * 6);
        f31 = h31 * 6 - i31;
        p61 = v51 * (1 - s41);
        q11 = v51 * (1 - f31 * s41);
        t31 = v51 * (1 - (1 - f31) * s41);
        switch(i31 % 6){
            case 0:
                r11 = v51;
                g31 = t31;
                b31 = p61;
                break;
            case 1:
                r11 = q11;
                g31 = v51;
                b31 = p61;
                break;
            case 2:
                r11 = p61;
                g31 = v51;
                b31 = t31;
                break;
            case 3:
                r11 = p61;
                g31 = q11;
                b31 = v51;
                break;
            case 4:
                r11 = t31;
                g31 = p61;
                b31 = v51;
                break;
            case 5:
                r11 = v51;
                g31 = p61;
                b31 = q11;
                break;
            default:
                break;
        }
        return [
            r11,
            g31,
            b31
        ];
    }
    function RGBtoHSV(r11, g31, b31) {
        var max11 = Math.max(r11, g31, b31);
        var min11 = Math.min(r11, g31, b31);
        var d31 = max11 - min11;
        var h31;
        var s41 = max11 === 0 ? 0 : d31 / max11;
        var v51 = max11 / 255;
        switch(max11){
            case min11:
                h31 = 0;
                break;
            case r11:
                h31 = g31 - b31 + d31 * (g31 < b31 ? 6 : 0);
                h31 /= 6 * d31;
                break;
            case g31:
                h31 = b31 - r11 + d31 * 2;
                h31 /= 6 * d31;
                break;
            case b31:
                h31 = r11 - g31 + d31 * 4;
                h31 /= 6 * d31;
                break;
            default:
                break;
        }
        return [
            h31,
            s41,
            v51
        ];
    }
    function addSaturationToRGB(color41, offset11) {
        var hsv11 = RGBtoHSV(color41[0] * 255, color41[1] * 255, color41[2] * 255);
        hsv11[1] += offset11;
        if (hsv11[1] > 1) hsv11[1] = 1;
        else if (hsv11[1] <= 0) hsv11[1] = 0;
        return HSVtoRGB(hsv11[0], hsv11[1], hsv11[2]);
    }
    function addBrightnessToRGB(color41, offset11) {
        var hsv11 = RGBtoHSV(color41[0] * 255, color41[1] * 255, color41[2] * 255);
        hsv11[2] += offset11;
        if (hsv11[2] > 1) hsv11[2] = 1;
        else if (hsv11[2] < 0) hsv11[2] = 0;
        return HSVtoRGB(hsv11[0], hsv11[1], hsv11[2]);
    }
    function addHueToRGB(color41, offset11) {
        var hsv11 = RGBtoHSV(color41[0] * 255, color41[1] * 255, color41[2] * 255);
        hsv11[0] += offset11 / 360;
        if (hsv11[0] > 1) hsv11[0] -= 1;
        else if (hsv11[0] < 0) hsv11[0] += 1;
        return HSVtoRGB(hsv11[0], hsv11[1], hsv11[2]);
    }
    var rgbToHex = function() {
        var colorMap11 = [];
        var i31;
        var hex11;
        for(i31 = 0; i31 < 256; i31 += 1){
            hex11 = i31.toString(16);
            colorMap11[i31] = hex11.length === 1 ? "0" + hex11 : hex11;
        }
        return function(r11, g31, b31) {
            if (r11 < 0) r11 = 0;
            if (g31 < 0) g31 = 0;
            if (b31 < 0) b31 = 0;
            return "#" + colorMap11[r11] + colorMap11[g31] + colorMap11[b31];
        };
    }();
    var setSubframeEnabled = function setSubframeEnabled11(flag11) {
        subframeEnabled = !!flag11;
    };
    var getSubframeEnabled = function getSubframeEnabled11() {
        return subframeEnabled;
    };
    var setExpressionsPlugin = function setExpressionsPlugin11(value31) {
        expressionsPlugin = value31;
    };
    var getExpressionsPlugin = function getExpressionsPlugin11() {
        return expressionsPlugin;
    };
    var setExpressionInterfaces = function setExpressionInterfaces11(value31) {
        expressionsInterfaces = value31;
    };
    var getExpressionInterfaces = function getExpressionInterfaces11() {
        return expressionsInterfaces;
    };
    var setDefaultCurveSegments = function setDefaultCurveSegments11(value31) {
        defaultCurveSegments = value31;
    };
    var getDefaultCurveSegments = function getDefaultCurveSegments11() {
        return defaultCurveSegments;
    };
    var setIdPrefix = function setIdPrefix11(value31) {
        idPrefix$1 = value31;
    };
    var getIdPrefix = function getIdPrefix11() {
        return idPrefix$1;
    };
    function createNS(type11) {
        // return {appendChild:function(){},setAttribute:function(){},style:{}}
        return document.createElementNS(svgNS, type11);
    }
    function _typeof$5(obj11) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$5 = function _typeof11(obj11) {
            return typeof obj11;
        };
        else _typeof$5 = function _typeof11(obj11) {
            return obj11 && typeof Symbol === "function" && obj11.constructor === Symbol && obj11 !== Symbol.prototype ? "symbol" : typeof obj11;
        };
        return _typeof$5(obj11);
    }
    var dataManager = function() {
        var _counterId11 = 1;
        var processes11 = [];
        var workerFn11;
        var workerInstance11;
        var workerProxy11 = {
            onmessage: function onmessage11() {},
            postMessage: function postMessage11(path11) {
                workerFn11({
                    data: path11
                });
            }
        };
        var _workerSelf11 = {
            postMessage: function postMessage11(data11) {
                workerProxy11.onmessage({
                    data: data11
                });
            }
        };
        function createWorker11(fn11) {
            if (window.Worker && window.Blob && getWebWorker()) {
                var blob11 = new Blob([
                    "var _workerSelf = self; self.onmessage = ",
                    fn11.toString()
                ], {
                    type: "text/javascript"
                }); // var blob = new Blob(['self.onmessage = ', fn.toString()], { type: 'text/javascript' });
                var url11 = URL.createObjectURL(blob11);
                return new Worker(url11);
            }
            workerFn11 = fn11;
            return workerProxy11;
        }
        function setupWorker11() {
            if (!workerInstance11) {
                workerInstance11 = createWorker11(function workerStart11(e31) {
                    function dataFunctionManager11() {
                        function completeLayers11(layers11, comps11) {
                            var layerData11;
                            var i31;
                            var len11 = layers11.length;
                            var j31;
                            var jLen11;
                            var k31;
                            var kLen11;
                            for(i31 = 0; i31 < len11; i31 += 1){
                                layerData11 = layers11[i31];
                                if ("ks" in layerData11 && !layerData11.completed) {
                                    layerData11.completed = true;
                                    if (layerData11.hasMask) {
                                        var maskProps11 = layerData11.masksProperties;
                                        jLen11 = maskProps11.length;
                                        for(j31 = 0; j31 < jLen11; j31 += 1)if (maskProps11[j31].pt.k.i) convertPathsToAbsoluteValues11(maskProps11[j31].pt.k);
                                        else {
                                            kLen11 = maskProps11[j31].pt.k.length;
                                            for(k31 = 0; k31 < kLen11; k31 += 1){
                                                if (maskProps11[j31].pt.k[k31].s) convertPathsToAbsoluteValues11(maskProps11[j31].pt.k[k31].s[0]);
                                                if (maskProps11[j31].pt.k[k31].e) convertPathsToAbsoluteValues11(maskProps11[j31].pt.k[k31].e[0]);
                                            }
                                        }
                                    }
                                    if (layerData11.ty === 0) {
                                        layerData11.layers = findCompLayers11(layerData11.refId, comps11);
                                        completeLayers11(layerData11.layers, comps11);
                                    } else if (layerData11.ty === 4) completeShapes11(layerData11.shapes);
                                    else if (layerData11.ty === 5) completeText11(layerData11);
                                }
                            }
                        }
                        function completeChars11(chars11, assets11) {
                            if (chars11) {
                                var i31 = 0;
                                var len11 = chars11.length;
                                for(i31 = 0; i31 < len11; i31 += 1)if (chars11[i31].t === 1) {
                                    // var compData = findComp(chars[i].data.refId, assets);
                                    chars11[i31].data.layers = findCompLayers11(chars11[i31].data.refId, assets11); // chars[i].data.ip = 0;
                                    // chars[i].data.op = 99999;
                                    // chars[i].data.st = 0;
                                    // chars[i].data.sr = 1;
                                    // chars[i].w = compData.w;
                                    // chars[i].data.ks = {
                                    //   a: { k: [0, 0, 0], a: 0 },
                                    //   p: { k: [0, -compData.h, 0], a: 0 },
                                    //   r: { k: 0, a: 0 },
                                    //   s: { k: [100, 100], a: 0 },
                                    //   o: { k: 100, a: 0 },
                                    // };
                                    completeLayers11(chars11[i31].data.layers, assets11);
                                }
                            }
                        }
                        function findComp11(id11, comps11) {
                            var i31 = 0;
                            var len11 = comps11.length;
                            while(i31 < len11){
                                if (comps11[i31].id === id11) return comps11[i31];
                                i31 += 1;
                            }
                            return null;
                        }
                        function findCompLayers11(id11, comps11) {
                            var comp11 = findComp11(id11, comps11);
                            if (comp11) {
                                if (!comp11.layers.__used) {
                                    comp11.layers.__used = true;
                                    return comp11.layers;
                                }
                                return JSON.parse(JSON.stringify(comp11.layers));
                            }
                            return null;
                        }
                        function completeShapes11(arr31) {
                            var i31;
                            var len11 = arr31.length;
                            var j31;
                            var jLen11;
                            for(i31 = len11 - 1; i31 >= 0; i31 -= 1){
                                if (arr31[i31].ty === "sh") {
                                    if (arr31[i31].ks.k.i) convertPathsToAbsoluteValues11(arr31[i31].ks.k);
                                    else {
                                        jLen11 = arr31[i31].ks.k.length;
                                        for(j31 = 0; j31 < jLen11; j31 += 1){
                                            if (arr31[i31].ks.k[j31].s) convertPathsToAbsoluteValues11(arr31[i31].ks.k[j31].s[0]);
                                            if (arr31[i31].ks.k[j31].e) convertPathsToAbsoluteValues11(arr31[i31].ks.k[j31].e[0]);
                                        }
                                    }
                                } else if (arr31[i31].ty === "gr") completeShapes11(arr31[i31].it);
                            }
                        }
                        function convertPathsToAbsoluteValues11(path11) {
                            var i31;
                            var len11 = path11.i.length;
                            for(i31 = 0; i31 < len11; i31 += 1){
                                path11.i[i31][0] += path11.v[i31][0];
                                path11.i[i31][1] += path11.v[i31][1];
                                path11.o[i31][0] += path11.v[i31][0];
                                path11.o[i31][1] += path11.v[i31][1];
                            }
                        }
                        function checkVersion11(minimum11, animVersionString11) {
                            var animVersion11 = animVersionString11 ? animVersionString11.split(".") : [
                                100,
                                100,
                                100
                            ];
                            if (minimum11[0] > animVersion11[0]) return true;
                            if (animVersion11[0] > minimum11[0]) return false;
                            if (minimum11[1] > animVersion11[1]) return true;
                            if (animVersion11[1] > minimum11[1]) return false;
                            if (minimum11[2] > animVersion11[2]) return true;
                            if (animVersion11[2] > minimum11[2]) return false;
                            return null;
                        }
                        var checkText11 = function() {
                            var minimumVersion11 = [
                                4,
                                4,
                                14
                            ];
                            function updateTextLayer11(textLayer11) {
                                var documentData11 = textLayer11.t.d;
                                textLayer11.t.d = {
                                    k: [
                                        {
                                            s: documentData11,
                                            t: 0
                                        }
                                    ]
                                };
                            }
                            function iterateLayers11(layers11) {
                                var i31;
                                var len11 = layers11.length;
                                for(i31 = 0; i31 < len11; i31 += 1)if (layers11[i31].ty === 5) updateTextLayer11(layers11[i31]);
                            }
                            return function(animationData11) {
                                if (checkVersion11(minimumVersion11, animationData11.v)) {
                                    iterateLayers11(animationData11.layers);
                                    if (animationData11.assets) {
                                        var i31;
                                        var len11 = animationData11.assets.length;
                                        for(i31 = 0; i31 < len11; i31 += 1)if (animationData11.assets[i31].layers) iterateLayers11(animationData11.assets[i31].layers);
                                    }
                                }
                            };
                        }();
                        var checkChars11 = function() {
                            var minimumVersion11 = [
                                4,
                                7,
                                99
                            ];
                            return function(animationData11) {
                                if (animationData11.chars && !checkVersion11(minimumVersion11, animationData11.v)) {
                                    var i31;
                                    var len11 = animationData11.chars.length;
                                    for(i31 = 0; i31 < len11; i31 += 1){
                                        var charData11 = animationData11.chars[i31];
                                        if (charData11.data && charData11.data.shapes) {
                                            completeShapes11(charData11.data.shapes);
                                            charData11.data.ip = 0;
                                            charData11.data.op = 99999;
                                            charData11.data.st = 0;
                                            charData11.data.sr = 1;
                                            charData11.data.ks = {
                                                p: {
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    a: 0
                                                },
                                                s: {
                                                    k: [
                                                        100,
                                                        100
                                                    ],
                                                    a: 0
                                                },
                                                a: {
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    a: 0
                                                },
                                                r: {
                                                    k: 0,
                                                    a: 0
                                                },
                                                o: {
                                                    k: 100,
                                                    a: 0
                                                }
                                            };
                                            if (!animationData11.chars[i31].t) {
                                                charData11.data.shapes.push({
                                                    ty: "no"
                                                });
                                                charData11.data.shapes[0].it.push({
                                                    p: {
                                                        k: [
                                                            0,
                                                            0
                                                        ],
                                                        a: 0
                                                    },
                                                    s: {
                                                        k: [
                                                            100,
                                                            100
                                                        ],
                                                        a: 0
                                                    },
                                                    a: {
                                                        k: [
                                                            0,
                                                            0
                                                        ],
                                                        a: 0
                                                    },
                                                    r: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    o: {
                                                        k: 100,
                                                        a: 0
                                                    },
                                                    sk: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    sa: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    ty: "tr"
                                                });
                                            }
                                        }
                                    }
                                }
                            };
                        }();
                        var checkPathProperties11 = function() {
                            var minimumVersion11 = [
                                5,
                                7,
                                15
                            ];
                            function updateTextLayer11(textLayer11) {
                                var pathData11 = textLayer11.t.p;
                                if (typeof pathData11.a === "number") pathData11.a = {
                                    a: 0,
                                    k: pathData11.a
                                };
                                if (typeof pathData11.p === "number") pathData11.p = {
                                    a: 0,
                                    k: pathData11.p
                                };
                                if (typeof pathData11.r === "number") pathData11.r = {
                                    a: 0,
                                    k: pathData11.r
                                };
                            }
                            function iterateLayers11(layers11) {
                                var i31;
                                var len11 = layers11.length;
                                for(i31 = 0; i31 < len11; i31 += 1)if (layers11[i31].ty === 5) updateTextLayer11(layers11[i31]);
                            }
                            return function(animationData11) {
                                if (checkVersion11(minimumVersion11, animationData11.v)) {
                                    iterateLayers11(animationData11.layers);
                                    if (animationData11.assets) {
                                        var i31;
                                        var len11 = animationData11.assets.length;
                                        for(i31 = 0; i31 < len11; i31 += 1)if (animationData11.assets[i31].layers) iterateLayers11(animationData11.assets[i31].layers);
                                    }
                                }
                            };
                        }();
                        var checkColors11 = function() {
                            var minimumVersion11 = [
                                4,
                                1,
                                9
                            ];
                            function iterateShapes11(shapes11) {
                                var i31;
                                var len11 = shapes11.length;
                                var j31;
                                var jLen11;
                                for(i31 = 0; i31 < len11; i31 += 1){
                                    if (shapes11[i31].ty === "gr") iterateShapes11(shapes11[i31].it);
                                    else if (shapes11[i31].ty === "fl" || shapes11[i31].ty === "st") {
                                        if (shapes11[i31].c.k && shapes11[i31].c.k[0].i) {
                                            jLen11 = shapes11[i31].c.k.length;
                                            for(j31 = 0; j31 < jLen11; j31 += 1){
                                                if (shapes11[i31].c.k[j31].s) {
                                                    shapes11[i31].c.k[j31].s[0] /= 255;
                                                    shapes11[i31].c.k[j31].s[1] /= 255;
                                                    shapes11[i31].c.k[j31].s[2] /= 255;
                                                    shapes11[i31].c.k[j31].s[3] /= 255;
                                                }
                                                if (shapes11[i31].c.k[j31].e) {
                                                    shapes11[i31].c.k[j31].e[0] /= 255;
                                                    shapes11[i31].c.k[j31].e[1] /= 255;
                                                    shapes11[i31].c.k[j31].e[2] /= 255;
                                                    shapes11[i31].c.k[j31].e[3] /= 255;
                                                }
                                            }
                                        } else {
                                            shapes11[i31].c.k[0] /= 255;
                                            shapes11[i31].c.k[1] /= 255;
                                            shapes11[i31].c.k[2] /= 255;
                                            shapes11[i31].c.k[3] /= 255;
                                        }
                                    }
                                }
                            }
                            function iterateLayers11(layers11) {
                                var i31;
                                var len11 = layers11.length;
                                for(i31 = 0; i31 < len11; i31 += 1)if (layers11[i31].ty === 4) iterateShapes11(layers11[i31].shapes);
                            }
                            return function(animationData11) {
                                if (checkVersion11(minimumVersion11, animationData11.v)) {
                                    iterateLayers11(animationData11.layers);
                                    if (animationData11.assets) {
                                        var i31;
                                        var len11 = animationData11.assets.length;
                                        for(i31 = 0; i31 < len11; i31 += 1)if (animationData11.assets[i31].layers) iterateLayers11(animationData11.assets[i31].layers);
                                    }
                                }
                            };
                        }();
                        var checkShapes11 = function() {
                            var minimumVersion11 = [
                                4,
                                4,
                                18
                            ];
                            function completeClosingShapes11(arr31) {
                                var i31;
                                var len11 = arr31.length;
                                var j31;
                                var jLen11;
                                for(i31 = len11 - 1; i31 >= 0; i31 -= 1){
                                    if (arr31[i31].ty === "sh") {
                                        if (arr31[i31].ks.k.i) arr31[i31].ks.k.c = arr31[i31].closed;
                                        else {
                                            jLen11 = arr31[i31].ks.k.length;
                                            for(j31 = 0; j31 < jLen11; j31 += 1){
                                                if (arr31[i31].ks.k[j31].s) arr31[i31].ks.k[j31].s[0].c = arr31[i31].closed;
                                                if (arr31[i31].ks.k[j31].e) arr31[i31].ks.k[j31].e[0].c = arr31[i31].closed;
                                            }
                                        }
                                    } else if (arr31[i31].ty === "gr") completeClosingShapes11(arr31[i31].it);
                                }
                            }
                            function iterateLayers11(layers11) {
                                var layerData11;
                                var i31;
                                var len11 = layers11.length;
                                var j31;
                                var jLen11;
                                var k31;
                                var kLen11;
                                for(i31 = 0; i31 < len11; i31 += 1){
                                    layerData11 = layers11[i31];
                                    if (layerData11.hasMask) {
                                        var maskProps11 = layerData11.masksProperties;
                                        jLen11 = maskProps11.length;
                                        for(j31 = 0; j31 < jLen11; j31 += 1)if (maskProps11[j31].pt.k.i) maskProps11[j31].pt.k.c = maskProps11[j31].cl;
                                        else {
                                            kLen11 = maskProps11[j31].pt.k.length;
                                            for(k31 = 0; k31 < kLen11; k31 += 1){
                                                if (maskProps11[j31].pt.k[k31].s) maskProps11[j31].pt.k[k31].s[0].c = maskProps11[j31].cl;
                                                if (maskProps11[j31].pt.k[k31].e) maskProps11[j31].pt.k[k31].e[0].c = maskProps11[j31].cl;
                                            }
                                        }
                                    }
                                    if (layerData11.ty === 4) completeClosingShapes11(layerData11.shapes);
                                }
                            }
                            return function(animationData11) {
                                if (checkVersion11(minimumVersion11, animationData11.v)) {
                                    iterateLayers11(animationData11.layers);
                                    if (animationData11.assets) {
                                        var i31;
                                        var len11 = animationData11.assets.length;
                                        for(i31 = 0; i31 < len11; i31 += 1)if (animationData11.assets[i31].layers) iterateLayers11(animationData11.assets[i31].layers);
                                    }
                                }
                            };
                        }();
                        function completeData11(animationData11) {
                            if (animationData11.__complete) return;
                            checkColors11(animationData11);
                            checkText11(animationData11);
                            checkChars11(animationData11);
                            checkPathProperties11(animationData11);
                            checkShapes11(animationData11);
                            completeLayers11(animationData11.layers, animationData11.assets);
                            completeChars11(animationData11.chars, animationData11.assets);
                            animationData11.__complete = true;
                        }
                        function completeText11(data11) {
                            data11.t.a.length === 0 && data11.t.p;
                        }
                        var moduleOb11 = {};
                        moduleOb11.completeData = completeData11;
                        moduleOb11.checkColors = checkColors11;
                        moduleOb11.checkChars = checkChars11;
                        moduleOb11.checkPathProperties = checkPathProperties11;
                        moduleOb11.checkShapes = checkShapes11;
                        moduleOb11.completeLayers = completeLayers11;
                        return moduleOb11;
                    }
                    if (!_workerSelf11.dataManager) _workerSelf11.dataManager = dataFunctionManager11();
                    if (!_workerSelf11.assetLoader) _workerSelf11.assetLoader = function() {
                        function formatResponse11(xhr11) {
                            // using typeof doubles the time of execution of this method,
                            // so if available, it's better to use the header to validate the type
                            var contentTypeHeader11 = xhr11.getResponseHeader("content-type");
                            if (contentTypeHeader11 && xhr11.responseType === "json" && contentTypeHeader11.indexOf("json") !== -1) return xhr11.response;
                            if (xhr11.response && _typeof$5(xhr11.response) === "object") return xhr11.response;
                            if (xhr11.response && typeof xhr11.response === "string") return JSON.parse(xhr11.response);
                            if (xhr11.responseText) return JSON.parse(xhr11.responseText);
                            return null;
                        }
                        function loadAsset11(path11, fullPath11, callback11, errorCallback11) {
                            var response11;
                            var xhr11 = new XMLHttpRequest(); // set responseType after calling open or IE will break.
                            try {
                                // This crashes on Android WebView prior to KitKat
                                xhr11.responseType = "json";
                            } catch (err11) {} // eslint-disable-line no-empty
                            xhr11.onreadystatechange = function() {
                                if (xhr11.readyState === 4) {
                                    if (xhr11.status === 200) {
                                        response11 = formatResponse11(xhr11);
                                        callback11(response11);
                                    } else try {
                                        response11 = formatResponse11(xhr11);
                                        callback11(response11);
                                    } catch (err11) {
                                        if (errorCallback11) errorCallback11(err11);
                                    }
                                }
                            };
                            try {
                                // Hack to workaround banner validation
                                xhr11.open([
                                    "G",
                                    "E",
                                    "T"
                                ].join(""), path11, true);
                            } catch (error11) {
                                // Hack to workaround banner validation
                                xhr11.open([
                                    "G",
                                    "E",
                                    "T"
                                ].join(""), fullPath11 + "/" + path11, true);
                            }
                            xhr11.send();
                        }
                        return {
                            load: loadAsset11
                        };
                    }();
                    if (e31.data.type === "loadAnimation") _workerSelf11.assetLoader.load(e31.data.path, e31.data.fullPath, function(data11) {
                        _workerSelf11.dataManager.completeData(data11);
                        _workerSelf11.postMessage({
                            id: e31.data.id,
                            payload: data11,
                            status: "success"
                        });
                    }, function() {
                        _workerSelf11.postMessage({
                            id: e31.data.id,
                            status: "error"
                        });
                    });
                    else if (e31.data.type === "complete") {
                        var animation11 = e31.data.animation;
                        _workerSelf11.dataManager.completeData(animation11);
                        _workerSelf11.postMessage({
                            id: e31.data.id,
                            payload: animation11,
                            status: "success"
                        });
                    } else if (e31.data.type === "loadData") _workerSelf11.assetLoader.load(e31.data.path, e31.data.fullPath, function(data11) {
                        _workerSelf11.postMessage({
                            id: e31.data.id,
                            payload: data11,
                            status: "success"
                        });
                    }, function() {
                        _workerSelf11.postMessage({
                            id: e31.data.id,
                            status: "error"
                        });
                    });
                });
                workerInstance11.onmessage = function(event11) {
                    var data11 = event11.data;
                    var id11 = data11.id;
                    var process11 = processes11[id11];
                    processes11[id11] = null;
                    if (data11.status === "success") process11.onComplete(data11.payload);
                    else if (process11.onError) process11.onError();
                };
            }
        }
        function createProcess11(onComplete11, onError11) {
            _counterId11 += 1;
            var id11 = "processId_" + _counterId11;
            processes11[id11] = {
                onComplete: onComplete11,
                onError: onError11
            };
            return id11;
        }
        function loadAnimation11(path11, onComplete11, onError11) {
            setupWorker11();
            var processId11 = createProcess11(onComplete11, onError11);
            workerInstance11.postMessage({
                type: "loadAnimation",
                path: path11,
                fullPath: window.location.origin + window.location.pathname,
                id: processId11
            });
        }
        function loadData11(path11, onComplete11, onError11) {
            setupWorker11();
            var processId11 = createProcess11(onComplete11, onError11);
            workerInstance11.postMessage({
                type: "loadData",
                path: path11,
                fullPath: window.location.origin + window.location.pathname,
                id: processId11
            });
        }
        function completeAnimation11(anim11, onComplete11, onError11) {
            setupWorker11();
            var processId11 = createProcess11(onComplete11, onError11);
            workerInstance11.postMessage({
                type: "complete",
                animation: anim11,
                id: processId11
            });
        }
        return {
            loadAnimation: loadAnimation11,
            loadData: loadData11,
            completeAnimation: completeAnimation11
        };
    }();
    var ImagePreloader = function() {
        var proxyImage11 = function() {
            var canvas11 = createTag("canvas");
            canvas11.width = 1;
            canvas11.height = 1;
            var ctx11 = canvas11.getContext("2d");
            ctx11.fillStyle = "rgba(0,0,0,0)";
            ctx11.fillRect(0, 0, 1, 1);
            return canvas11;
        }();
        function imageLoaded11() {
            this.loadedAssets += 1;
            if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
                if (this.imagesLoadedCb) this.imagesLoadedCb(null);
            }
        }
        function footageLoaded11() {
            this.loadedFootagesCount += 1;
            if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
                if (this.imagesLoadedCb) this.imagesLoadedCb(null);
            }
        }
        function getAssetsPath11(assetData11, assetsPath11, originalPath11) {
            var path11 = "";
            if (assetData11.e) path11 = assetData11.p;
            else if (assetsPath11) {
                var imagePath11 = assetData11.p;
                if (imagePath11.indexOf("images/") !== -1) imagePath11 = imagePath11.split("/")[1];
                path11 = assetsPath11 + imagePath11;
            } else {
                path11 = originalPath11;
                path11 += assetData11.u ? assetData11.u : "";
                path11 += assetData11.p;
            }
            return path11;
        }
        function testImageLoaded11(img11) {
            var _count11 = 0;
            var intervalId11 = setInterval((function() {
                var box11 = img11.getBBox();
                if (box11.width || _count11 > 500) {
                    this._imageLoaded();
                    clearInterval(intervalId11);
                }
                _count11 += 1;
            }).bind(this), 50);
        }
        function createImageData11(assetData11) {
            var path11 = getAssetsPath11(assetData11, this.assetsPath, this.path);
            var img11 = createNS("image");
            if (isSafari) this.testImageLoaded(img11);
            else img11.addEventListener("load", this._imageLoaded, false);
            img11.addEventListener("error", (function() {
                ob11.img = proxyImage11;
                this._imageLoaded();
            }).bind(this), false);
            img11.setAttributeNS("http://www.w3.org/1999/xlink", "href", path11);
            if (this._elementHelper.append) this._elementHelper.append(img11);
            else this._elementHelper.appendChild(img11);
            var ob11 = {
                img: img11,
                assetData: assetData11
            };
            return ob11;
        }
        function createImgData11(assetData11) {
            var path11 = getAssetsPath11(assetData11, this.assetsPath, this.path);
            var img11 = createTag("img");
            img11.crossOrigin = "anonymous";
            img11.addEventListener("load", this._imageLoaded, false);
            img11.addEventListener("error", (function() {
                ob11.img = proxyImage11;
                this._imageLoaded();
            }).bind(this), false);
            img11.src = path11;
            var ob11 = {
                img: img11,
                assetData: assetData11
            };
            return ob11;
        }
        function createFootageData11(data11) {
            var ob11 = {
                assetData: data11
            };
            var path11 = getAssetsPath11(data11, this.assetsPath, this.path);
            dataManager.loadData(path11, (function(footageData11) {
                ob11.img = footageData11;
                this._footageLoaded();
            }).bind(this), (function() {
                ob11.img = {};
                this._footageLoaded();
            }).bind(this));
            return ob11;
        }
        function loadAssets11(assets11, cb11) {
            this.imagesLoadedCb = cb11;
            var i31;
            var len11 = assets11.length;
            for(i31 = 0; i31 < len11; i31 += 1)if (!assets11[i31].layers) {
                if (!assets11[i31].t || assets11[i31].t === "seq") {
                    this.totalImages += 1;
                    this.images.push(this._createImageData(assets11[i31]));
                } else if (assets11[i31].t === 3) {
                    this.totalFootages += 1;
                    this.images.push(this.createFootageData(assets11[i31]));
                }
            }
        }
        function setPath11(path11) {
            this.path = path11 || "";
        }
        function setAssetsPath11(path11) {
            this.assetsPath = path11 || "";
        }
        function getAsset11(assetData11) {
            var i31 = 0;
            var len11 = this.images.length;
            while(i31 < len11){
                if (this.images[i31].assetData === assetData11) return this.images[i31].img;
                i31 += 1;
            }
            return null;
        }
        function destroy11() {
            this.imagesLoadedCb = null;
            this.images.length = 0;
        }
        function loadedImages11() {
            return this.totalImages === this.loadedAssets;
        }
        function loadedFootages11() {
            return this.totalFootages === this.loadedFootagesCount;
        }
        function setCacheType11(type11, elementHelper11) {
            if (type11 === "svg") {
                this._elementHelper = elementHelper11;
                this._createImageData = this.createImageData.bind(this);
            } else this._createImageData = this.createImgData.bind(this);
        }
        function ImagePreloaderFactory11() {
            this._imageLoaded = imageLoaded11.bind(this);
            this._footageLoaded = footageLoaded11.bind(this);
            this.testImageLoaded = testImageLoaded11.bind(this);
            this.createFootageData = createFootageData11.bind(this);
            this.assetsPath = "";
            this.path = "";
            this.totalImages = 0;
            this.totalFootages = 0;
            this.loadedAssets = 0;
            this.loadedFootagesCount = 0;
            this.imagesLoadedCb = null;
            this.images = [];
        }
        ImagePreloaderFactory11.prototype = {
            loadAssets: loadAssets11,
            setAssetsPath: setAssetsPath11,
            setPath: setPath11,
            loadedImages: loadedImages11,
            loadedFootages: loadedFootages11,
            destroy: destroy11,
            getAsset: getAsset11,
            createImgData: createImgData11,
            createImageData: createImageData11,
            imageLoaded: imageLoaded11,
            footageLoaded: footageLoaded11,
            setCacheType: setCacheType11
        };
        return ImagePreloaderFactory11;
    }();
    function BaseEvent() {}
    BaseEvent.prototype = {
        triggerEvent: function triggerEvent11(eventName11, args11) {
            if (this._cbs[eventName11]) {
                var callbacks11 = this._cbs[eventName11];
                for(var i31 = 0; i31 < callbacks11.length; i31 += 1)callbacks11[i31](args11);
            }
        },
        addEventListener: function addEventListener11(eventName11, callback11) {
            if (!this._cbs[eventName11]) this._cbs[eventName11] = [];
            this._cbs[eventName11].push(callback11);
            return (function() {
                this.removeEventListener(eventName11, callback11);
            }).bind(this);
        },
        removeEventListener: function removeEventListener11(eventName11, callback11) {
            if (!callback11) this._cbs[eventName11] = null;
            else if (this._cbs[eventName11]) {
                var i31 = 0;
                var len11 = this._cbs[eventName11].length;
                while(i31 < len11){
                    if (this._cbs[eventName11][i31] === callback11) {
                        this._cbs[eventName11].splice(i31, 1);
                        i31 -= 1;
                        len11 -= 1;
                    }
                    i31 += 1;
                }
                if (!this._cbs[eventName11].length) this._cbs[eventName11] = null;
            }
        }
    };
    var markerParser = function() {
        function parsePayloadLines11(payload11) {
            var lines11 = payload11.split("\r\n");
            var keys11 = {};
            var line11;
            var keysCount11 = 0;
            for(var i31 = 0; i31 < lines11.length; i31 += 1){
                line11 = lines11[i31].split(":");
                if (line11.length === 2) {
                    keys11[line11[0]] = line11[1].trim();
                    keysCount11 += 1;
                }
            }
            if (keysCount11 === 0) throw new Error();
            return keys11;
        }
        return function(_markers11) {
            var markers11 = [];
            for(var i31 = 0; i31 < _markers11.length; i31 += 1){
                var _marker11 = _markers11[i31];
                var markerData11 = {
                    time: _marker11.tm,
                    duration: _marker11.dr
                };
                try {
                    markerData11.payload = JSON.parse(_markers11[i31].cm);
                } catch (_11) {
                    try {
                        markerData11.payload = parsePayloadLines11(_markers11[i31].cm);
                    } catch (__11) {
                        markerData11.payload = {
                            name: _markers11[i31].cm
                        };
                    }
                }
                markers11.push(markerData11);
            }
            return markers11;
        };
    }();
    var ProjectInterface = function() {
        function registerComposition11(comp11) {
            this.compositions.push(comp11);
        }
        return function() {
            function _thisProjectFunction11(name11) {
                var i31 = 0;
                var len11 = this.compositions.length;
                while(i31 < len11){
                    if (this.compositions[i31].data && this.compositions[i31].data.nm === name11) {
                        if (this.compositions[i31].prepareFrame && this.compositions[i31].data.xt) this.compositions[i31].prepareFrame(this.currentFrame);
                        return this.compositions[i31].compInterface;
                    }
                    i31 += 1;
                }
                return null;
            }
            _thisProjectFunction11.compositions = [];
            _thisProjectFunction11.currentFrame = 0;
            _thisProjectFunction11.registerComposition = registerComposition11;
            return _thisProjectFunction11;
        };
    }();
    var renderers = {};
    var registerRenderer = function registerRenderer11(key11, value31) {
        renderers[key11] = value31;
    };
    function getRenderer(key11) {
        return renderers[key11];
    }
    function getRegisteredRenderer() {
        // Returns canvas by default for compatibility
        if (renderers.canvas) return "canvas";
         // Returns any renderer that is registered
        for(var key11 in renderers){
            if (renderers[key11]) return key11;
        }
        return "";
    }
    function _typeof$4(obj11) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$4 = function _typeof11(obj11) {
            return typeof obj11;
        };
        else _typeof$4 = function _typeof11(obj11) {
            return obj11 && typeof Symbol === "function" && obj11.constructor === Symbol && obj11 !== Symbol.prototype ? "symbol" : typeof obj11;
        };
        return _typeof$4(obj11);
    }
    var AnimationItem = function AnimationItem11() {
        this._cbs = [];
        this.name = "";
        this.path = "";
        this.isLoaded = false;
        this.currentFrame = 0;
        this.currentRawFrame = 0;
        this.firstFrame = 0;
        this.totalFrames = 0;
        this.frameRate = 0;
        this.frameMult = 0;
        this.playSpeed = 1;
        this.playDirection = 1;
        this.playCount = 0;
        this.animationData = {};
        this.assets = [];
        this.isPaused = true;
        this.autoplay = false;
        this.loop = true;
        this.renderer = null;
        this.animationID = createElementID();
        this.assetsPath = "";
        this.timeCompleted = 0;
        this.segmentPos = 0;
        this.isSubframeEnabled = getSubframeEnabled();
        this.segments = [];
        this._idle = true;
        this._completedLoop = false;
        this.projectInterface = ProjectInterface();
        this.imagePreloader = new ImagePreloader();
        this.audioController = audioControllerFactory();
        this.markers = [];
        this.configAnimation = this.configAnimation.bind(this);
        this.onSetupError = this.onSetupError.bind(this);
        this.onSegmentComplete = this.onSegmentComplete.bind(this);
        this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame", 0, 0, 0);
        this.expressionsPlugin = getExpressionsPlugin();
    };
    extendPrototype([
        BaseEvent
    ], AnimationItem);
    AnimationItem.prototype.setParams = function(params11) {
        if (params11.wrapper || params11.container) this.wrapper = params11.wrapper || params11.container;
        var animType11 = "svg";
        if (params11.animType) animType11 = params11.animType;
        else if (params11.renderer) animType11 = params11.renderer;
        var RendererClass11 = getRenderer(animType11);
        this.renderer = new RendererClass11(this, params11.rendererSettings);
        this.imagePreloader.setCacheType(animType11, this.renderer.globalData.defs);
        this.renderer.setProjectInterface(this.projectInterface);
        this.animType = animType11;
        if (params11.loop === "" || params11.loop === null || params11.loop === undefined || params11.loop === true) this.loop = true;
        else if (params11.loop === false) this.loop = false;
        else this.loop = parseInt(params11.loop, 10);
        this.autoplay = "autoplay" in params11 ? params11.autoplay : true;
        this.name = params11.name ? params11.name : "";
        this.autoloadSegments = Object.prototype.hasOwnProperty.call(params11, "autoloadSegments") ? params11.autoloadSegments : true;
        this.assetsPath = params11.assetsPath;
        this.initialSegment = params11.initialSegment;
        if (params11.audioFactory) this.audioController.setAudioFactory(params11.audioFactory);
        if (params11.animationData) this.setupAnimation(params11.animationData);
        else if (params11.path) {
            if (params11.path.lastIndexOf("\\") !== -1) this.path = params11.path.substr(0, params11.path.lastIndexOf("\\") + 1);
            else this.path = params11.path.substr(0, params11.path.lastIndexOf("/") + 1);
            this.fileName = params11.path.substr(params11.path.lastIndexOf("/") + 1);
            this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json"));
            dataManager.loadAnimation(params11.path, this.configAnimation, this.onSetupError);
        }
    };
    AnimationItem.prototype.onSetupError = function() {
        this.trigger("data_failed");
    };
    AnimationItem.prototype.setupAnimation = function(data11) {
        dataManager.completeAnimation(data11, this.configAnimation);
    };
    AnimationItem.prototype.setData = function(wrapper11, animationData11) {
        if (animationData11) {
            if (_typeof$4(animationData11) !== "object") animationData11 = JSON.parse(animationData11);
        }
        var params11 = {
            wrapper: wrapper11,
            animationData: animationData11
        };
        var wrapperAttributes11 = wrapper11.attributes;
        params11.path = wrapperAttributes11.getNamedItem("data-animation-path") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes11.getNamedItem("data-animation-path").value : wrapperAttributes11.getNamedItem("data-bm-path") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes11.getNamedItem("data-bm-path").value : wrapperAttributes11.getNamedItem("bm-path") ? wrapperAttributes11.getNamedItem("bm-path").value : "";
        params11.animType = wrapperAttributes11.getNamedItem("data-anim-type") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes11.getNamedItem("data-anim-type").value : wrapperAttributes11.getNamedItem("data-bm-type") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes11.getNamedItem("data-bm-type").value : wrapperAttributes11.getNamedItem("bm-type") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes11.getNamedItem("bm-type").value : wrapperAttributes11.getNamedItem("data-bm-renderer") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes11.getNamedItem("data-bm-renderer").value : wrapperAttributes11.getNamedItem("bm-renderer") ? wrapperAttributes11.getNamedItem("bm-renderer").value : getRegisteredRenderer() || "canvas";
        var loop11 = wrapperAttributes11.getNamedItem("data-anim-loop") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes11.getNamedItem("data-anim-loop").value : wrapperAttributes11.getNamedItem("data-bm-loop") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes11.getNamedItem("data-bm-loop").value : wrapperAttributes11.getNamedItem("bm-loop") ? wrapperAttributes11.getNamedItem("bm-loop").value : "";
        if (loop11 === "false") params11.loop = false;
        else if (loop11 === "true") params11.loop = true;
        else if (loop11 !== "") params11.loop = parseInt(loop11, 10);
        var autoplay11 = wrapperAttributes11.getNamedItem("data-anim-autoplay") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes11.getNamedItem("data-anim-autoplay").value : wrapperAttributes11.getNamedItem("data-bm-autoplay") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes11.getNamedItem("data-bm-autoplay").value : wrapperAttributes11.getNamedItem("bm-autoplay") ? wrapperAttributes11.getNamedItem("bm-autoplay").value : true;
        params11.autoplay = autoplay11 !== "false";
        params11.name = wrapperAttributes11.getNamedItem("data-name") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes11.getNamedItem("data-name").value : wrapperAttributes11.getNamedItem("data-bm-name") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes11.getNamedItem("data-bm-name").value : wrapperAttributes11.getNamedItem("bm-name") ? wrapperAttributes11.getNamedItem("bm-name").value : "";
        var prerender11 = wrapperAttributes11.getNamedItem("data-anim-prerender") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes11.getNamedItem("data-anim-prerender").value : wrapperAttributes11.getNamedItem("data-bm-prerender") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes11.getNamedItem("data-bm-prerender").value : wrapperAttributes11.getNamedItem("bm-prerender") ? wrapperAttributes11.getNamedItem("bm-prerender").value : "";
        if (prerender11 === "false") params11.prerender = false;
        if (!params11.path) this.trigger("destroy");
        else this.setParams(params11);
    };
    AnimationItem.prototype.includeLayers = function(data11) {
        if (data11.op > this.animationData.op) {
            this.animationData.op = data11.op;
            this.totalFrames = Math.floor(data11.op - this.animationData.ip);
        }
        var layers11 = this.animationData.layers;
        var i31;
        var len11 = layers11.length;
        var newLayers11 = data11.layers;
        var j31;
        var jLen11 = newLayers11.length;
        for(j31 = 0; j31 < jLen11; j31 += 1){
            i31 = 0;
            while(i31 < len11){
                if (layers11[i31].id === newLayers11[j31].id) {
                    layers11[i31] = newLayers11[j31];
                    break;
                }
                i31 += 1;
            }
        }
        if (data11.chars || data11.fonts) {
            this.renderer.globalData.fontManager.addChars(data11.chars);
            this.renderer.globalData.fontManager.addFonts(data11.fonts, this.renderer.globalData.defs);
        }
        if (data11.assets) {
            len11 = data11.assets.length;
            for(i31 = 0; i31 < len11; i31 += 1)this.animationData.assets.push(data11.assets[i31]);
        }
        this.animationData.__complete = false;
        dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
    };
    AnimationItem.prototype.onSegmentComplete = function(data11) {
        this.animationData = data11;
        var expressionsPlugin11 = getExpressionsPlugin();
        if (expressionsPlugin11) expressionsPlugin11.initExpressions(this);
        this.loadNextSegment();
    };
    AnimationItem.prototype.loadNextSegment = function() {
        var segments11 = this.animationData.segments;
        if (!segments11 || segments11.length === 0 || !this.autoloadSegments) {
            this.trigger("data_ready");
            this.timeCompleted = this.totalFrames;
            return;
        }
        var segment11 = segments11.shift();
        this.timeCompleted = segment11.time * this.frameRate;
        var segmentPath11 = this.path + this.fileName + "_" + this.segmentPos + ".json";
        this.segmentPos += 1;
        dataManager.loadData(segmentPath11, this.includeLayers.bind(this), (function() {
            this.trigger("data_failed");
        }).bind(this));
    };
    AnimationItem.prototype.loadSegments = function() {
        var segments11 = this.animationData.segments;
        if (!segments11) this.timeCompleted = this.totalFrames;
        this.loadNextSegment();
    };
    AnimationItem.prototype.imagesLoaded = function() {
        this.trigger("loaded_images");
        this.checkLoaded();
    };
    AnimationItem.prototype.preloadImages = function() {
        this.imagePreloader.setAssetsPath(this.assetsPath);
        this.imagePreloader.setPath(this.path);
        this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
    };
    AnimationItem.prototype.configAnimation = function(animData11) {
        if (!this.renderer) return;
        try {
            this.animationData = animData11;
            if (this.initialSegment) {
                this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]);
                this.firstFrame = Math.round(this.initialSegment[0]);
            } else {
                this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
                this.firstFrame = Math.round(this.animationData.ip);
            }
            this.renderer.configAnimation(animData11);
            if (!animData11.assets) animData11.assets = [];
            this.assets = this.animationData.assets;
            this.frameRate = this.animationData.fr;
            this.frameMult = this.animationData.fr / 1000;
            this.renderer.searchExtraCompositions(animData11.assets);
            this.markers = markerParser(animData11.markers || []);
            this.trigger("config_ready");
            this.preloadImages();
            this.loadSegments();
            this.updaFrameModifier();
            this.waitForFontsLoaded();
            if (this.isPaused) this.audioController.pause();
        } catch (error11) {
            this.triggerConfigError(error11);
        }
    };
    AnimationItem.prototype.waitForFontsLoaded = function() {
        if (!this.renderer) return;
        if (this.renderer.globalData.fontManager.isLoaded) this.checkLoaded();
        else setTimeout(this.waitForFontsLoaded.bind(this), 20);
    };
    AnimationItem.prototype.checkLoaded = function() {
        if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== "canvas") && this.imagePreloader.loadedFootages()) {
            this.isLoaded = true;
            var expressionsPlugin11 = getExpressionsPlugin();
            if (expressionsPlugin11) expressionsPlugin11.initExpressions(this);
            this.renderer.initItems();
            setTimeout((function() {
                this.trigger("DOMLoaded");
            }).bind(this), 0);
            this.gotoFrame();
            if (this.autoplay) this.play();
        }
    };
    AnimationItem.prototype.resize = function(width11, height11) {
        // Adding this validation for backwards compatibility in case an event object was being passed down
        var _width11 = typeof width11 === "number" ? width11 : undefined;
        var _height11 = typeof height11 === "number" ? height11 : undefined;
        this.renderer.updateContainerSize(_width11, _height11);
    };
    AnimationItem.prototype.setSubframe = function(flag11) {
        this.isSubframeEnabled = !!flag11;
    };
    AnimationItem.prototype.gotoFrame = function() {
        this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame; // eslint-disable-line no-bitwise
        if (this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted) this.currentFrame = this.timeCompleted;
        this.trigger("enterFrame");
        this.renderFrame();
        this.trigger("drawnFrame");
    };
    AnimationItem.prototype.renderFrame = function() {
        if (this.isLoaded === false || !this.renderer) return;
        try {
            if (this.expressionsPlugin) this.expressionsPlugin.resetFrame();
            this.renderer.renderFrame(this.currentFrame + this.firstFrame);
        } catch (error11) {
            this.triggerRenderFrameError(error11);
        }
    };
    AnimationItem.prototype.play = function(name11) {
        if (name11 && this.name !== name11) return;
        if (this.isPaused === true) {
            this.isPaused = false;
            this.trigger("_play");
            this.audioController.resume();
            if (this._idle) {
                this._idle = false;
                this.trigger("_active");
            }
        }
    };
    AnimationItem.prototype.pause = function(name11) {
        if (name11 && this.name !== name11) return;
        if (this.isPaused === false) {
            this.isPaused = true;
            this.trigger("_pause");
            this._idle = true;
            this.trigger("_idle");
            this.audioController.pause();
        }
    };
    AnimationItem.prototype.togglePause = function(name11) {
        if (name11 && this.name !== name11) return;
        if (this.isPaused === true) this.play();
        else this.pause();
    };
    AnimationItem.prototype.stop = function(name11) {
        if (name11 && this.name !== name11) return;
        this.pause();
        this.playCount = 0;
        this._completedLoop = false;
        this.setCurrentRawFrameValue(0);
    };
    AnimationItem.prototype.getMarkerData = function(markerName11) {
        var marker11;
        for(var i31 = 0; i31 < this.markers.length; i31 += 1){
            marker11 = this.markers[i31];
            if (marker11.payload && marker11.payload.name === markerName11) return marker11;
        }
        return null;
    };
    AnimationItem.prototype.goToAndStop = function(value31, isFrame11, name11) {
        if (name11 && this.name !== name11) return;
        var numValue11 = Number(value31);
        if (isNaN(numValue11)) {
            var marker11 = this.getMarkerData(value31);
            if (marker11) this.goToAndStop(marker11.time, true);
        } else if (isFrame11) this.setCurrentRawFrameValue(value31);
        else this.setCurrentRawFrameValue(value31 * this.frameModifier);
        this.pause();
    };
    AnimationItem.prototype.goToAndPlay = function(value31, isFrame11, name11) {
        if (name11 && this.name !== name11) return;
        var numValue11 = Number(value31);
        if (isNaN(numValue11)) {
            var marker11 = this.getMarkerData(value31);
            if (marker11) {
                if (!marker11.duration) this.goToAndStop(marker11.time, true);
                else this.playSegments([
                    marker11.time,
                    marker11.time + marker11.duration
                ], true);
            }
        } else this.goToAndStop(numValue11, isFrame11, name11);
        this.play();
    };
    AnimationItem.prototype.advanceTime = function(value31) {
        if (this.isPaused === true || this.isLoaded === false) return;
        var nextValue11 = this.currentRawFrame + value31 * this.frameModifier;
        var _isComplete11 = false; // Checking if nextValue > totalFrames - 1 for addressing non looping and looping animations.
        // If animation won't loop, it should stop at totalFrames - 1. If it will loop it should complete the last frame and then loop.
        if (nextValue11 >= this.totalFrames - 1 && this.frameModifier > 0) {
            if (!this.loop || this.playCount === this.loop) {
                if (!this.checkSegments(nextValue11 > this.totalFrames ? nextValue11 % this.totalFrames : 0)) {
                    _isComplete11 = true;
                    nextValue11 = this.totalFrames - 1;
                }
            } else if (nextValue11 >= this.totalFrames) {
                this.playCount += 1;
                if (!this.checkSegments(nextValue11 % this.totalFrames)) {
                    this.setCurrentRawFrameValue(nextValue11 % this.totalFrames);
                    this._completedLoop = true;
                    this.trigger("loopComplete");
                }
            } else this.setCurrentRawFrameValue(nextValue11);
        } else if (nextValue11 < 0) {
            if (!this.checkSegments(nextValue11 % this.totalFrames)) {
                if (this.loop && !(this.playCount-- <= 0 && this.loop !== true)) {
                    // eslint-disable-line no-plusplus
                    this.setCurrentRawFrameValue(this.totalFrames + nextValue11 % this.totalFrames);
                    if (!this._completedLoop) this._completedLoop = true;
                    else this.trigger("loopComplete");
                } else {
                    _isComplete11 = true;
                    nextValue11 = 0;
                }
            }
        } else this.setCurrentRawFrameValue(nextValue11);
        if (_isComplete11) {
            this.setCurrentRawFrameValue(nextValue11);
            this.pause();
            this.trigger("complete");
        }
    };
    AnimationItem.prototype.adjustSegment = function(arr31, offset11) {
        this.playCount = 0;
        if (arr31[1] < arr31[0]) {
            if (this.frameModifier > 0) {
                if (this.playSpeed < 0) this.setSpeed(-this.playSpeed);
                else this.setDirection(-1);
            }
            this.totalFrames = arr31[0] - arr31[1];
            this.timeCompleted = this.totalFrames;
            this.firstFrame = arr31[1];
            this.setCurrentRawFrameValue(this.totalFrames - 0.001 - offset11);
        } else if (arr31[1] > arr31[0]) {
            if (this.frameModifier < 0) {
                if (this.playSpeed < 0) this.setSpeed(-this.playSpeed);
                else this.setDirection(1);
            }
            this.totalFrames = arr31[1] - arr31[0];
            this.timeCompleted = this.totalFrames;
            this.firstFrame = arr31[0];
            this.setCurrentRawFrameValue(0.001 + offset11);
        }
        this.trigger("segmentStart");
    };
    AnimationItem.prototype.setSegment = function(init11, end31) {
        var pendingFrame11 = -1;
        if (this.isPaused) {
            if (this.currentRawFrame + this.firstFrame < init11) pendingFrame11 = init11;
            else if (this.currentRawFrame + this.firstFrame > end31) pendingFrame11 = end31 - init11;
        }
        this.firstFrame = init11;
        this.totalFrames = end31 - init11;
        this.timeCompleted = this.totalFrames;
        if (pendingFrame11 !== -1) this.goToAndStop(pendingFrame11, true);
    };
    AnimationItem.prototype.playSegments = function(arr31, forceFlag11) {
        if (forceFlag11) this.segments.length = 0;
        if (_typeof$4(arr31[0]) === "object") {
            var i31;
            var len11 = arr31.length;
            for(i31 = 0; i31 < len11; i31 += 1)this.segments.push(arr31[i31]);
        } else this.segments.push(arr31);
        if (this.segments.length && forceFlag11) this.adjustSegment(this.segments.shift(), 0);
        if (this.isPaused) this.play();
    };
    AnimationItem.prototype.resetSegments = function(forceFlag11) {
        this.segments.length = 0;
        this.segments.push([
            this.animationData.ip,
            this.animationData.op
        ]);
        if (forceFlag11) this.checkSegments(0);
    };
    AnimationItem.prototype.checkSegments = function(offset11) {
        if (this.segments.length) {
            this.adjustSegment(this.segments.shift(), offset11);
            return true;
        }
        return false;
    };
    AnimationItem.prototype.destroy = function(name11) {
        if (name11 && this.name !== name11 || !this.renderer) return;
        this.renderer.destroy();
        this.imagePreloader.destroy();
        this.trigger("destroy");
        this._cbs = null;
        this.onEnterFrame = null;
        this.onLoopComplete = null;
        this.onComplete = null;
        this.onSegmentStart = null;
        this.onDestroy = null;
        this.renderer = null;
        this.expressionsPlugin = null;
        this.imagePreloader = null;
        this.projectInterface = null;
    };
    AnimationItem.prototype.setCurrentRawFrameValue = function(value31) {
        this.currentRawFrame = value31;
        this.gotoFrame();
    };
    AnimationItem.prototype.setSpeed = function(val31) {
        this.playSpeed = val31;
        this.updaFrameModifier();
    };
    AnimationItem.prototype.setDirection = function(val31) {
        this.playDirection = val31 < 0 ? -1 : 1;
        this.updaFrameModifier();
    };
    AnimationItem.prototype.setLoop = function(isLooping11) {
        this.loop = isLooping11;
    };
    AnimationItem.prototype.setVolume = function(val31, name11) {
        if (name11 && this.name !== name11) return;
        this.audioController.setVolume(val31);
    };
    AnimationItem.prototype.getVolume = function() {
        return this.audioController.getVolume();
    };
    AnimationItem.prototype.mute = function(name11) {
        if (name11 && this.name !== name11) return;
        this.audioController.mute();
    };
    AnimationItem.prototype.unmute = function(name11) {
        if (name11 && this.name !== name11) return;
        this.audioController.unmute();
    };
    AnimationItem.prototype.updaFrameModifier = function() {
        this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
        this.audioController.setRate(this.playSpeed * this.playDirection);
    };
    AnimationItem.prototype.getPath = function() {
        return this.path;
    };
    AnimationItem.prototype.getAssetsPath = function(assetData11) {
        var path11 = "";
        if (assetData11.e) path11 = assetData11.p;
        else if (this.assetsPath) {
            var imagePath11 = assetData11.p;
            if (imagePath11.indexOf("images/") !== -1) imagePath11 = imagePath11.split("/")[1];
            path11 = this.assetsPath + imagePath11;
        } else {
            path11 = this.path;
            path11 += assetData11.u ? assetData11.u : "";
            path11 += assetData11.p;
        }
        return path11;
    };
    AnimationItem.prototype.getAssetData = function(id11) {
        var i31 = 0;
        var len11 = this.assets.length;
        while(i31 < len11){
            if (id11 === this.assets[i31].id) return this.assets[i31];
            i31 += 1;
        }
        return null;
    };
    AnimationItem.prototype.hide = function() {
        this.renderer.hide();
    };
    AnimationItem.prototype.show = function() {
        this.renderer.show();
    };
    AnimationItem.prototype.getDuration = function(isFrame11) {
        return isFrame11 ? this.totalFrames : this.totalFrames / this.frameRate;
    };
    AnimationItem.prototype.updateDocumentData = function(path11, documentData11, index11) {
        try {
            var element11 = this.renderer.getElementByPath(path11);
            element11.updateDocumentData(documentData11, index11);
        } catch (error11) {}
    };
    AnimationItem.prototype.trigger = function(name11) {
        if (this._cbs && this._cbs[name11]) switch(name11){
            case "enterFrame":
                this.triggerEvent(name11, new BMEnterFrameEvent(name11, this.currentFrame, this.totalFrames, this.frameModifier));
                break;
            case "drawnFrame":
                this.drawnFrameEvent.currentTime = this.currentFrame;
                this.drawnFrameEvent.totalTime = this.totalFrames;
                this.drawnFrameEvent.direction = this.frameModifier;
                this.triggerEvent(name11, this.drawnFrameEvent);
                break;
            case "loopComplete":
                this.triggerEvent(name11, new BMCompleteLoopEvent(name11, this.loop, this.playCount, this.frameMult));
                break;
            case "complete":
                this.triggerEvent(name11, new BMCompleteEvent(name11, this.frameMult));
                break;
            case "segmentStart":
                this.triggerEvent(name11, new BMSegmentStartEvent(name11, this.firstFrame, this.totalFrames));
                break;
            case "destroy":
                this.triggerEvent(name11, new BMDestroyEvent(name11, this));
                break;
            default:
                this.triggerEvent(name11);
        }
        if (name11 === "enterFrame" && this.onEnterFrame) this.onEnterFrame.call(this, new BMEnterFrameEvent(name11, this.currentFrame, this.totalFrames, this.frameMult));
        if (name11 === "loopComplete" && this.onLoopComplete) this.onLoopComplete.call(this, new BMCompleteLoopEvent(name11, this.loop, this.playCount, this.frameMult));
        if (name11 === "complete" && this.onComplete) this.onComplete.call(this, new BMCompleteEvent(name11, this.frameMult));
        if (name11 === "segmentStart" && this.onSegmentStart) this.onSegmentStart.call(this, new BMSegmentStartEvent(name11, this.firstFrame, this.totalFrames));
        if (name11 === "destroy" && this.onDestroy) this.onDestroy.call(this, new BMDestroyEvent(name11, this));
    };
    AnimationItem.prototype.triggerRenderFrameError = function(nativeError11) {
        var error11 = new BMRenderFrameErrorEvent(nativeError11, this.currentFrame);
        this.triggerEvent("error", error11);
        if (this.onError) this.onError.call(this, error11);
    };
    AnimationItem.prototype.triggerConfigError = function(nativeError11) {
        var error11 = new BMConfigErrorEvent(nativeError11, this.currentFrame);
        this.triggerEvent("error", error11);
        if (this.onError) this.onError.call(this, error11);
    };
    var animationManager = function() {
        var moduleOb11 = {};
        var registeredAnimations11 = [];
        var initTime11 = 0;
        var len11 = 0;
        var playingAnimationsNum11 = 0;
        var _stopped11 = true;
        var _isFrozen11 = false;
        function removeElement11(ev11) {
            var i31 = 0;
            var animItem11 = ev11.target;
            while(i31 < len11){
                if (registeredAnimations11[i31].animation === animItem11) {
                    registeredAnimations11.splice(i31, 1);
                    i31 -= 1;
                    len11 -= 1;
                    if (!animItem11.isPaused) subtractPlayingCount11();
                }
                i31 += 1;
            }
        }
        function registerAnimation11(element11, animationData11) {
            if (!element11) return null;
            var i31 = 0;
            while(i31 < len11){
                if (registeredAnimations11[i31].elem === element11 && registeredAnimations11[i31].elem !== null) return registeredAnimations11[i31].animation;
                i31 += 1;
            }
            var animItem11 = new AnimationItem();
            setupAnimation11(animItem11, element11);
            animItem11.setData(element11, animationData11);
            return animItem11;
        }
        function getRegisteredAnimations11() {
            var i31;
            var lenAnims11 = registeredAnimations11.length;
            var animations11 = [];
            for(i31 = 0; i31 < lenAnims11; i31 += 1)animations11.push(registeredAnimations11[i31].animation);
            return animations11;
        }
        function addPlayingCount11() {
            playingAnimationsNum11 += 1;
            activate11();
        }
        function subtractPlayingCount11() {
            playingAnimationsNum11 -= 1;
        }
        function setupAnimation11(animItem11, element11) {
            animItem11.addEventListener("destroy", removeElement11);
            animItem11.addEventListener("_active", addPlayingCount11);
            animItem11.addEventListener("_idle", subtractPlayingCount11);
            registeredAnimations11.push({
                elem: element11,
                animation: animItem11
            });
            len11 += 1;
        }
        function loadAnimation11(params11) {
            var animItem11 = new AnimationItem();
            setupAnimation11(animItem11, null);
            animItem11.setParams(params11);
            return animItem11;
        }
        function setSpeed11(val31, animation11) {
            var i31;
            for(i31 = 0; i31 < len11; i31 += 1)registeredAnimations11[i31].animation.setSpeed(val31, animation11);
        }
        function setDirection11(val31, animation11) {
            var i31;
            for(i31 = 0; i31 < len11; i31 += 1)registeredAnimations11[i31].animation.setDirection(val31, animation11);
        }
        function play11(animation11) {
            var i31;
            for(i31 = 0; i31 < len11; i31 += 1)registeredAnimations11[i31].animation.play(animation11);
        }
        function resume11(nowTime11) {
            var elapsedTime11 = nowTime11 - initTime11;
            var i31;
            for(i31 = 0; i31 < len11; i31 += 1)registeredAnimations11[i31].animation.advanceTime(elapsedTime11);
            initTime11 = nowTime11;
            if (playingAnimationsNum11 && !_isFrozen11) window.requestAnimationFrame(resume11);
            else _stopped11 = true;
        }
        function first11(nowTime11) {
            initTime11 = nowTime11;
            window.requestAnimationFrame(resume11);
        }
        function pause11(animation11) {
            var i31;
            for(i31 = 0; i31 < len11; i31 += 1)registeredAnimations11[i31].animation.pause(animation11);
        }
        function goToAndStop11(value31, isFrame11, animation11) {
            var i31;
            for(i31 = 0; i31 < len11; i31 += 1)registeredAnimations11[i31].animation.goToAndStop(value31, isFrame11, animation11);
        }
        function stop11(animation11) {
            var i31;
            for(i31 = 0; i31 < len11; i31 += 1)registeredAnimations11[i31].animation.stop(animation11);
        }
        function togglePause11(animation11) {
            var i31;
            for(i31 = 0; i31 < len11; i31 += 1)registeredAnimations11[i31].animation.togglePause(animation11);
        }
        function destroy11(animation11) {
            var i31;
            for(i31 = len11 - 1; i31 >= 0; i31 -= 1)registeredAnimations11[i31].animation.destroy(animation11);
        }
        function searchAnimations11(animationData11, standalone11, renderer11) {
            var animElements11 = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin")));
            var i31;
            var lenAnims11 = animElements11.length;
            for(i31 = 0; i31 < lenAnims11; i31 += 1){
                if (renderer11) animElements11[i31].setAttribute("data-bm-type", renderer11);
                registerAnimation11(animElements11[i31], animationData11);
            }
            if (standalone11 && lenAnims11 === 0) {
                if (!renderer11) renderer11 = "svg";
                var body11 = document.getElementsByTagName("body")[0];
                body11.innerText = "";
                var div11 = createTag("div");
                div11.style.width = "100%";
                div11.style.height = "100%";
                div11.setAttribute("data-bm-type", renderer11);
                body11.appendChild(div11);
                registerAnimation11(div11, animationData11);
            }
        }
        function resize11() {
            var i31;
            for(i31 = 0; i31 < len11; i31 += 1)registeredAnimations11[i31].animation.resize();
        }
        function activate11() {
            if (!_isFrozen11 && playingAnimationsNum11) {
                if (_stopped11) {
                    window.requestAnimationFrame(first11);
                    _stopped11 = false;
                }
            }
        }
        function freeze11() {
            _isFrozen11 = true;
        }
        function unfreeze11() {
            _isFrozen11 = false;
            activate11();
        }
        function setVolume11(val31, animation11) {
            var i31;
            for(i31 = 0; i31 < len11; i31 += 1)registeredAnimations11[i31].animation.setVolume(val31, animation11);
        }
        function mute11(animation11) {
            var i31;
            for(i31 = 0; i31 < len11; i31 += 1)registeredAnimations11[i31].animation.mute(animation11);
        }
        function unmute11(animation11) {
            var i31;
            for(i31 = 0; i31 < len11; i31 += 1)registeredAnimations11[i31].animation.unmute(animation11);
        }
        moduleOb11.registerAnimation = registerAnimation11;
        moduleOb11.loadAnimation = loadAnimation11;
        moduleOb11.setSpeed = setSpeed11;
        moduleOb11.setDirection = setDirection11;
        moduleOb11.play = play11;
        moduleOb11.pause = pause11;
        moduleOb11.stop = stop11;
        moduleOb11.togglePause = togglePause11;
        moduleOb11.searchAnimations = searchAnimations11;
        moduleOb11.resize = resize11; // moduleOb.start = start;
        moduleOb11.goToAndStop = goToAndStop11;
        moduleOb11.destroy = destroy11;
        moduleOb11.freeze = freeze11;
        moduleOb11.unfreeze = unfreeze11;
        moduleOb11.setVolume = setVolume11;
        moduleOb11.mute = mute11;
        moduleOb11.unmute = unmute11;
        moduleOb11.getRegisteredAnimations = getRegisteredAnimations11;
        return moduleOb11;
    }();
    /* eslint-disable */ var BezierFactory = function() {
        /**
       * BezierEasing - use bezier curve for transition easing function
       * by Gaëtan Renaudeau 2014 - 2015 – MIT License
       *
       * Credits: is based on Firefox's nsSMILKeySpline.cpp
       * Usage:
       * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
       * spline.get(x) => returns the easing value | x must be in [0, 1] range
       *
       */ var ob11 = {};
        ob11.getBezierEasing = getBezierEasing11;
        var beziers11 = {};
        function getBezierEasing11(a31, b31, c41, d31, nm11) {
            var str11 = nm11 || ("bez_" + a31 + "_" + b31 + "_" + c41 + "_" + d31).replace(/\./g, "p");
            if (beziers11[str11]) return beziers11[str11];
            var bezEasing11 = new BezierEasing11([
                a31,
                b31,
                c41,
                d31
            ]);
            beziers11[str11] = bezEasing11;
            return bezEasing11;
        } // These values are established by empiricism with tests (tradeoff: performance VS precision)
        var NEWTON_ITERATIONS11 = 4;
        var NEWTON_MIN_SLOPE11 = 0.001;
        var SUBDIVISION_PRECISION11 = 0.0000001;
        var SUBDIVISION_MAX_ITERATIONS11 = 10;
        var kSplineTableSize11 = 11;
        var kSampleStepSize11 = 1.0 / (kSplineTableSize11 - 1.0);
        var float32ArraySupported11 = typeof Float32Array === "function";
        function A11(aA111, aA211) {
            return 1.0 - 3.0 * aA211 + 3.0 * aA111;
        }
        function B11(aA111, aA211) {
            return 3.0 * aA211 - 6.0 * aA111;
        }
        function C11(aA111) {
            return 3.0 * aA111;
        } // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
        function calcBezier11(aT11, aA111, aA211) {
            return ((A11(aA111, aA211) * aT11 + B11(aA111, aA211)) * aT11 + C11(aA111)) * aT11;
        } // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
        function getSlope11(aT11, aA111, aA211) {
            return 3.0 * A11(aA111, aA211) * aT11 * aT11 + 2.0 * B11(aA111, aA211) * aT11 + C11(aA111);
        }
        function binarySubdivide11(aX11, aA31, aB11, mX111, mX211) {
            var currentX11, currentT11, i31 = 0;
            do {
                currentT11 = aA31 + (aB11 - aA31) / 2.0;
                currentX11 = calcBezier11(currentT11, mX111, mX211) - aX11;
                if (currentX11 > 0.0) aB11 = currentT11;
                else aA31 = currentT11;
            }while (Math.abs(currentX11) > SUBDIVISION_PRECISION11 && ++i31 < SUBDIVISION_MAX_ITERATIONS11);
            return currentT11;
        }
        function newtonRaphsonIterate11(aX11, aGuessT11, mX111, mX211) {
            for(var i31 = 0; i31 < NEWTON_ITERATIONS11; ++i31){
                var currentSlope11 = getSlope11(aGuessT11, mX111, mX211);
                if (currentSlope11 === 0.0) return aGuessT11;
                var currentX11 = calcBezier11(aGuessT11, mX111, mX211) - aX11;
                aGuessT11 -= currentX11 / currentSlope11;
            }
            return aGuessT11;
        }
        /**
       * points is an array of [ mX1, mY1, mX2, mY2 ]
       */ function BezierEasing11(points11) {
            this._p = points11;
            this._mSampleValues = float32ArraySupported11 ? new Float32Array(kSplineTableSize11) : new Array(kSplineTableSize11);
            this._precomputed = false;
            this.get = this.get.bind(this);
        }
        BezierEasing11.prototype = {
            get: function get11(x41) {
                var mX111 = this._p[0], mY111 = this._p[1], mX211 = this._p[2], mY211 = this._p[3];
                if (!this._precomputed) this._precompute();
                if (mX111 === mY111 && mX211 === mY211) return x41; // linear
                // Because JavaScript number are imprecise, we should guarantee the extremes are right.
                if (x41 === 0) return 0;
                if (x41 === 1) return 1;
                return calcBezier11(this._getTForX(x41), mY111, mY211);
            },
            // Private part
            _precompute: function _precompute11() {
                var mX111 = this._p[0], mY111 = this._p[1], mX211 = this._p[2], mY211 = this._p[3];
                this._precomputed = true;
                if (mX111 !== mY111 || mX211 !== mY211) this._calcSampleValues();
            },
            _calcSampleValues: function _calcSampleValues11() {
                var mX111 = this._p[0], mX211 = this._p[2];
                for(var i31 = 0; i31 < kSplineTableSize11; ++i31)this._mSampleValues[i31] = calcBezier11(i31 * kSampleStepSize11, mX111, mX211);
            },
            /**
           * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
           */ _getTForX: function _getTForX11(aX11) {
                var mX111 = this._p[0], mX211 = this._p[2], mSampleValues11 = this._mSampleValues;
                var intervalStart11 = 0.0;
                var currentSample11 = 1;
                var lastSample11 = kSplineTableSize11 - 1;
                for(; currentSample11 !== lastSample11 && mSampleValues11[currentSample11] <= aX11; ++currentSample11)intervalStart11 += kSampleStepSize11;
                --currentSample11; // Interpolate to provide an initial guess for t
                var dist41 = (aX11 - mSampleValues11[currentSample11]) / (mSampleValues11[currentSample11 + 1] - mSampleValues11[currentSample11]);
                var guessForT11 = intervalStart11 + dist41 * kSampleStepSize11;
                var initialSlope11 = getSlope11(guessForT11, mX111, mX211);
                if (initialSlope11 >= NEWTON_MIN_SLOPE11) return newtonRaphsonIterate11(aX11, guessForT11, mX111, mX211);
                if (initialSlope11 === 0.0) return guessForT11;
                return binarySubdivide11(aX11, intervalStart11, intervalStart11 + kSampleStepSize11, mX111, mX211);
            }
        };
        return ob11;
    }();
    var pooling = function() {
        function _double11(arr31) {
            return arr31.concat(createSizedArray(arr31.length));
        }
        return {
            "double": _double11
        };
    }();
    var poolFactory = function() {
        return function(initialLength11, _create11, _release11) {
            var _length11 = 0;
            var _maxLength11 = initialLength11;
            var pool11 = createSizedArray(_maxLength11);
            var ob11 = {
                newElement: newElement11,
                release: release11
            };
            function newElement11() {
                var element11;
                if (_length11) {
                    _length11 -= 1;
                    element11 = pool11[_length11];
                } else element11 = _create11();
                return element11;
            }
            function release11(element11) {
                if (_length11 === _maxLength11) {
                    pool11 = pooling["double"](pool11);
                    _maxLength11 *= 2;
                }
                if (_release11) _release11(element11);
                pool11[_length11] = element11;
                _length11 += 1;
            }
            return ob11;
        };
    }();
    var bezierLengthPool = function() {
        function create11() {
            return {
                addedLength: 0,
                percents: createTypedArray("float32", getDefaultCurveSegments()),
                lengths: createTypedArray("float32", getDefaultCurveSegments())
            };
        }
        return poolFactory(8, create11);
    }();
    var segmentsLengthPool = function() {
        function create11() {
            return {
                lengths: [],
                totalLength: 0
            };
        }
        function release11(element11) {
            var i31;
            var len11 = element11.lengths.length;
            for(i31 = 0; i31 < len11; i31 += 1)bezierLengthPool.release(element11.lengths[i31]);
            element11.lengths.length = 0;
        }
        return poolFactory(8, create11, release11);
    }();
    function bezFunction() {
        var math11 = Math;
        function pointOnLine2D11(x111, y111, x211, y211, x311, y311) {
            var det111 = x111 * y211 + y111 * x311 + x211 * y311 - x311 * y211 - y311 * x111 - x211 * y111;
            return det111 > -0.001 && det111 < 0.001;
        }
        function pointOnLine3D11(x111, y111, z111, x211, y211, z211, x311, y311, z311) {
            if (z111 === 0 && z211 === 0 && z311 === 0) return pointOnLine2D11(x111, y111, x211, y211, x311, y311);
            var dist111 = math11.sqrt(math11.pow(x211 - x111, 2) + math11.pow(y211 - y111, 2) + math11.pow(z211 - z111, 2));
            var dist211 = math11.sqrt(math11.pow(x311 - x111, 2) + math11.pow(y311 - y111, 2) + math11.pow(z311 - z111, 2));
            var dist311 = math11.sqrt(math11.pow(x311 - x211, 2) + math11.pow(y311 - y211, 2) + math11.pow(z311 - z211, 2));
            var diffDist11;
            if (dist111 > dist211) {
                if (dist111 > dist311) diffDist11 = dist111 - dist211 - dist311;
                else diffDist11 = dist311 - dist211 - dist111;
            } else if (dist311 > dist211) diffDist11 = dist311 - dist211 - dist111;
            else diffDist11 = dist211 - dist111 - dist311;
            return diffDist11 > -0.0001 && diffDist11 < 0.0001;
        }
        var getBezierLength11 = function() {
            return function(pt111, pt211, pt311, pt411) {
                var curveSegments11 = getDefaultCurveSegments();
                var k31;
                var i31;
                var len11;
                var ptCoord11;
                var perc11;
                var addedLength11 = 0;
                var ptDistance11;
                var point11 = [];
                var lastPoint11 = [];
                var lengthData11 = bezierLengthPool.newElement();
                len11 = pt311.length;
                for(k31 = 0; k31 < curveSegments11; k31 += 1){
                    perc11 = k31 / (curveSegments11 - 1);
                    ptDistance11 = 0;
                    for(i31 = 0; i31 < len11; i31 += 1){
                        ptCoord11 = bmPow(1 - perc11, 3) * pt111[i31] + 3 * bmPow(1 - perc11, 2) * perc11 * pt311[i31] + 3 * (1 - perc11) * bmPow(perc11, 2) * pt411[i31] + bmPow(perc11, 3) * pt211[i31];
                        point11[i31] = ptCoord11;
                        if (lastPoint11[i31] !== null) ptDistance11 += bmPow(point11[i31] - lastPoint11[i31], 2);
                        lastPoint11[i31] = point11[i31];
                    }
                    if (ptDistance11) {
                        ptDistance11 = bmSqrt(ptDistance11);
                        addedLength11 += ptDistance11;
                    }
                    lengthData11.percents[k31] = perc11;
                    lengthData11.lengths[k31] = addedLength11;
                }
                lengthData11.addedLength = addedLength11;
                return lengthData11;
            };
        }();
        function getSegmentsLength11(shapeData11) {
            var segmentsLength11 = segmentsLengthPool.newElement();
            var closed11 = shapeData11.c;
            var pathV11 = shapeData11.v;
            var pathO11 = shapeData11.o;
            var pathI11 = shapeData11.i;
            var i31;
            var len11 = shapeData11._length;
            var lengths11 = segmentsLength11.lengths;
            var totalLength11 = 0;
            for(i31 = 0; i31 < len11 - 1; i31 += 1){
                lengths11[i31] = getBezierLength11(pathV11[i31], pathV11[i31 + 1], pathO11[i31], pathI11[i31 + 1]);
                totalLength11 += lengths11[i31].addedLength;
            }
            if (closed11 && len11) {
                lengths11[i31] = getBezierLength11(pathV11[i31], pathV11[0], pathO11[i31], pathI11[0]);
                totalLength11 += lengths11[i31].addedLength;
            }
            segmentsLength11.totalLength = totalLength11;
            return segmentsLength11;
        }
        function BezierData11(length11) {
            this.segmentLength = 0;
            this.points = new Array(length11);
        }
        function PointData11(partial11, point11) {
            this.partialLength = partial11;
            this.point = point11;
        }
        var buildBezierData11 = function() {
            var storedData11 = {};
            return function(pt111, pt211, pt311, pt411) {
                var bezierName11 = (pt111[0] + "_" + pt111[1] + "_" + pt211[0] + "_" + pt211[1] + "_" + pt311[0] + "_" + pt311[1] + "_" + pt411[0] + "_" + pt411[1]).replace(/\./g, "p");
                if (!storedData11[bezierName11]) {
                    var curveSegments11 = getDefaultCurveSegments();
                    var k31;
                    var i31;
                    var len11;
                    var ptCoord11;
                    var perc11;
                    var addedLength11 = 0;
                    var ptDistance11;
                    var point11;
                    var lastPoint11 = null;
                    if (pt111.length === 2 && (pt111[0] !== pt211[0] || pt111[1] !== pt211[1]) && pointOnLine2D11(pt111[0], pt111[1], pt211[0], pt211[1], pt111[0] + pt311[0], pt111[1] + pt311[1]) && pointOnLine2D11(pt111[0], pt111[1], pt211[0], pt211[1], pt211[0] + pt411[0], pt211[1] + pt411[1])) curveSegments11 = 2;
                    var bezierData11 = new BezierData11(curveSegments11);
                    len11 = pt311.length;
                    for(k31 = 0; k31 < curveSegments11; k31 += 1){
                        point11 = createSizedArray(len11);
                        perc11 = k31 / (curveSegments11 - 1);
                        ptDistance11 = 0;
                        for(i31 = 0; i31 < len11; i31 += 1){
                            ptCoord11 = bmPow(1 - perc11, 3) * pt111[i31] + 3 * bmPow(1 - perc11, 2) * perc11 * (pt111[i31] + pt311[i31]) + 3 * (1 - perc11) * bmPow(perc11, 2) * (pt211[i31] + pt411[i31]) + bmPow(perc11, 3) * pt211[i31];
                            point11[i31] = ptCoord11;
                            if (lastPoint11 !== null) ptDistance11 += bmPow(point11[i31] - lastPoint11[i31], 2);
                        }
                        ptDistance11 = bmSqrt(ptDistance11);
                        addedLength11 += ptDistance11;
                        bezierData11.points[k31] = new PointData11(ptDistance11, point11);
                        lastPoint11 = point11;
                    }
                    bezierData11.segmentLength = addedLength11;
                    storedData11[bezierName11] = bezierData11;
                }
                return storedData11[bezierName11];
            };
        }();
        function getDistancePerc11(perc11, bezierData11) {
            var percents11 = bezierData11.percents;
            var lengths11 = bezierData11.lengths;
            var len11 = percents11.length;
            var initPos11 = bmFloor((len11 - 1) * perc11);
            var lengthPos11 = perc11 * bezierData11.addedLength;
            var lPerc11 = 0;
            if (initPos11 === len11 - 1 || initPos11 === 0 || lengthPos11 === lengths11[initPos11]) return percents11[initPos11];
            var dir11 = lengths11[initPos11] > lengthPos11 ? -1 : 1;
            var flag11 = true;
            while(flag11){
                if (lengths11[initPos11] <= lengthPos11 && lengths11[initPos11 + 1] > lengthPos11) {
                    lPerc11 = (lengthPos11 - lengths11[initPos11]) / (lengths11[initPos11 + 1] - lengths11[initPos11]);
                    flag11 = false;
                } else initPos11 += dir11;
                if (initPos11 < 0 || initPos11 >= len11 - 1) {
                    // FIX for TypedArrays that don't store floating point values with enough accuracy
                    if (initPos11 === len11 - 1) return percents11[initPos11];
                    flag11 = false;
                }
            }
            return percents11[initPos11] + (percents11[initPos11 + 1] - percents11[initPos11]) * lPerc11;
        }
        function getPointInSegment11(pt111, pt211, pt311, pt411, percent11, bezierData11) {
            var t111 = getDistancePerc11(percent11, bezierData11);
            var u111 = 1 - t111;
            var ptX11 = math11.round((u111 * u111 * u111 * pt111[0] + (t111 * u111 * u111 + u111 * t111 * u111 + u111 * u111 * t111) * pt311[0] + (t111 * t111 * u111 + u111 * t111 * t111 + t111 * u111 * t111) * pt411[0] + t111 * t111 * t111 * pt211[0]) * 1000) / 1000;
            var ptY11 = math11.round((u111 * u111 * u111 * pt111[1] + (t111 * u111 * u111 + u111 * t111 * u111 + u111 * u111 * t111) * pt311[1] + (t111 * t111 * u111 + u111 * t111 * t111 + t111 * u111 * t111) * pt411[1] + t111 * t111 * t111 * pt211[1]) * 1000) / 1000;
            return [
                ptX11,
                ptY11
            ];
        }
        var bezierSegmentPoints11 = createTypedArray("float32", 8);
        function getNewSegment11(pt111, pt211, pt311, pt411, startPerc11, endPerc11, bezierData11) {
            if (startPerc11 < 0) startPerc11 = 0;
            else if (startPerc11 > 1) startPerc11 = 1;
            var t011 = getDistancePerc11(startPerc11, bezierData11);
            endPerc11 = endPerc11 > 1 ? 1 : endPerc11;
            var t111 = getDistancePerc11(endPerc11, bezierData11);
            var i31;
            var len11 = pt111.length;
            var u011 = 1 - t011;
            var u111 = 1 - t111;
            var u0u0u011 = u011 * u011 * u011;
            var t0u0u0_311 = t011 * u011 * u011 * 3; // eslint-disable-line camelcase
            var t0t0u0_311 = t011 * t011 * u011 * 3; // eslint-disable-line camelcase
            var t0t0t011 = t011 * t011 * t011; //
            var u0u0u111 = u011 * u011 * u111;
            var t0u0u1_311 = t011 * u011 * u111 + u011 * t011 * u111 + u011 * u011 * t111; // eslint-disable-line camelcase
            var t0t0u1_311 = t011 * t011 * u111 + u011 * t011 * t111 + t011 * u011 * t111; // eslint-disable-line camelcase
            var t0t0t111 = t011 * t011 * t111; //
            var u0u1u111 = u011 * u111 * u111;
            var t0u1u1_311 = t011 * u111 * u111 + u011 * t111 * u111 + u011 * u111 * t111; // eslint-disable-line camelcase
            var t0t1u1_311 = t011 * t111 * u111 + u011 * t111 * t111 + t011 * u111 * t111; // eslint-disable-line camelcase
            var t0t1t111 = t011 * t111 * t111; //
            var u1u1u111 = u111 * u111 * u111;
            var t1u1u1_311 = t111 * u111 * u111 + u111 * t111 * u111 + u111 * u111 * t111; // eslint-disable-line camelcase
            var t1t1u1_311 = t111 * t111 * u111 + u111 * t111 * t111 + t111 * u111 * t111; // eslint-disable-line camelcase
            var t1t1t111 = t111 * t111 * t111;
            for(i31 = 0; i31 < len11; i31 += 1){
                bezierSegmentPoints11[i31 * 4] = math11.round((u0u0u011 * pt111[i31] + t0u0u0_311 * pt311[i31] + t0t0u0_311 * pt411[i31] + t0t0t011 * pt211[i31]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints11[i31 * 4 + 1] = math11.round((u0u0u111 * pt111[i31] + t0u0u1_311 * pt311[i31] + t0t0u1_311 * pt411[i31] + t0t0t111 * pt211[i31]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints11[i31 * 4 + 2] = math11.round((u0u1u111 * pt111[i31] + t0u1u1_311 * pt311[i31] + t0t1u1_311 * pt411[i31] + t0t1t111 * pt211[i31]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints11[i31 * 4 + 3] = math11.round((u1u1u111 * pt111[i31] + t1u1u1_311 * pt311[i31] + t1t1u1_311 * pt411[i31] + t1t1t111 * pt211[i31]) * 1000) / 1000; // eslint-disable-line camelcase
            }
            return bezierSegmentPoints11;
        }
        return {
            getSegmentsLength: getSegmentsLength11,
            getNewSegment: getNewSegment11,
            getPointInSegment: getPointInSegment11,
            buildBezierData: buildBezierData11,
            pointOnLine2D: pointOnLine2D11,
            pointOnLine3D: pointOnLine3D11
        };
    }
    var bez = bezFunction();
    var initFrame = initialDefaultFrame;
    var mathAbs = Math.abs;
    function interpolateValue(frameNum11, caching11) {
        var offsetTime11 = this.offsetTime;
        var newValue11;
        if (this.propType === "multidimensional") newValue11 = createTypedArray("float32", this.pv.length);
        var iterationIndex11 = caching11.lastIndex;
        var i31 = iterationIndex11;
        var len11 = this.keyframes.length - 1;
        var flag11 = true;
        var keyData11;
        var nextKeyData11;
        var keyframeMetadata11;
        while(flag11){
            keyData11 = this.keyframes[i31];
            nextKeyData11 = this.keyframes[i31 + 1];
            if (i31 === len11 - 1 && frameNum11 >= nextKeyData11.t - offsetTime11) {
                if (keyData11.h) keyData11 = nextKeyData11;
                iterationIndex11 = 0;
                break;
            }
            if (nextKeyData11.t - offsetTime11 > frameNum11) {
                iterationIndex11 = i31;
                break;
            }
            if (i31 < len11 - 1) i31 += 1;
            else {
                iterationIndex11 = 0;
                flag11 = false;
            }
        }
        keyframeMetadata11 = this.keyframesMetadata[i31] || {};
        var k31;
        var kLen11;
        var perc11;
        var jLen11;
        var j31;
        var fnc11;
        var nextKeyTime11 = nextKeyData11.t - offsetTime11;
        var keyTime11 = keyData11.t - offsetTime11;
        var endValue11;
        if (keyData11.to) {
            if (!keyframeMetadata11.bezierData) keyframeMetadata11.bezierData = bez.buildBezierData(keyData11.s, nextKeyData11.s || keyData11.e, keyData11.to, keyData11.ti);
            var bezierData11 = keyframeMetadata11.bezierData;
            if (frameNum11 >= nextKeyTime11 || frameNum11 < keyTime11) {
                var ind11 = frameNum11 >= nextKeyTime11 ? bezierData11.points.length - 1 : 0;
                kLen11 = bezierData11.points[ind11].point.length;
                for(k31 = 0; k31 < kLen11; k31 += 1)newValue11[k31] = bezierData11.points[ind11].point[k31];
                 // caching._lastKeyframeIndex = -1;
            } else {
                if (keyframeMetadata11.__fnct) fnc11 = keyframeMetadata11.__fnct;
                else {
                    fnc11 = BezierFactory.getBezierEasing(keyData11.o.x, keyData11.o.y, keyData11.i.x, keyData11.i.y, keyData11.n).get;
                    keyframeMetadata11.__fnct = fnc11;
                }
                perc11 = fnc11((frameNum11 - keyTime11) / (nextKeyTime11 - keyTime11));
                var distanceInLine11 = bezierData11.segmentLength * perc11;
                var segmentPerc11;
                var addedLength11 = caching11.lastFrame < frameNum11 && caching11._lastKeyframeIndex === i31 ? caching11._lastAddedLength : 0;
                j31 = caching11.lastFrame < frameNum11 && caching11._lastKeyframeIndex === i31 ? caching11._lastPoint : 0;
                flag11 = true;
                jLen11 = bezierData11.points.length;
                while(flag11){
                    addedLength11 += bezierData11.points[j31].partialLength;
                    if (distanceInLine11 === 0 || perc11 === 0 || j31 === bezierData11.points.length - 1) {
                        kLen11 = bezierData11.points[j31].point.length;
                        for(k31 = 0; k31 < kLen11; k31 += 1)newValue11[k31] = bezierData11.points[j31].point[k31];
                        break;
                    } else if (distanceInLine11 >= addedLength11 && distanceInLine11 < addedLength11 + bezierData11.points[j31 + 1].partialLength) {
                        segmentPerc11 = (distanceInLine11 - addedLength11) / bezierData11.points[j31 + 1].partialLength;
                        kLen11 = bezierData11.points[j31].point.length;
                        for(k31 = 0; k31 < kLen11; k31 += 1)newValue11[k31] = bezierData11.points[j31].point[k31] + (bezierData11.points[j31 + 1].point[k31] - bezierData11.points[j31].point[k31]) * segmentPerc11;
                        break;
                    }
                    if (j31 < jLen11 - 1) j31 += 1;
                    else flag11 = false;
                }
                caching11._lastPoint = j31;
                caching11._lastAddedLength = addedLength11 - bezierData11.points[j31].partialLength;
                caching11._lastKeyframeIndex = i31;
            }
        } else {
            var outX11;
            var outY11;
            var inX11;
            var inY11;
            var keyValue11;
            len11 = keyData11.s.length;
            endValue11 = nextKeyData11.s || keyData11.e;
            if (this.sh && keyData11.h !== 1) {
                if (frameNum11 >= nextKeyTime11) {
                    newValue11[0] = endValue11[0];
                    newValue11[1] = endValue11[1];
                    newValue11[2] = endValue11[2];
                } else if (frameNum11 <= keyTime11) {
                    newValue11[0] = keyData11.s[0];
                    newValue11[1] = keyData11.s[1];
                    newValue11[2] = keyData11.s[2];
                } else {
                    var quatStart11 = createQuaternion(keyData11.s);
                    var quatEnd11 = createQuaternion(endValue11);
                    var time11 = (frameNum11 - keyTime11) / (nextKeyTime11 - keyTime11);
                    quaternionToEuler(newValue11, slerp(quatStart11, quatEnd11, time11));
                }
            } else for(i31 = 0; i31 < len11; i31 += 1){
                if (keyData11.h !== 1) {
                    if (frameNum11 >= nextKeyTime11) perc11 = 1;
                    else if (frameNum11 < keyTime11) perc11 = 0;
                    else {
                        if (keyData11.o.x.constructor === Array) {
                            if (!keyframeMetadata11.__fnct) keyframeMetadata11.__fnct = [];
                            if (!keyframeMetadata11.__fnct[i31]) {
                                outX11 = keyData11.o.x[i31] === undefined ? keyData11.o.x[0] : keyData11.o.x[i31];
                                outY11 = keyData11.o.y[i31] === undefined ? keyData11.o.y[0] : keyData11.o.y[i31];
                                inX11 = keyData11.i.x[i31] === undefined ? keyData11.i.x[0] : keyData11.i.x[i31];
                                inY11 = keyData11.i.y[i31] === undefined ? keyData11.i.y[0] : keyData11.i.y[i31];
                                fnc11 = BezierFactory.getBezierEasing(outX11, outY11, inX11, inY11).get;
                                keyframeMetadata11.__fnct[i31] = fnc11;
                            } else fnc11 = keyframeMetadata11.__fnct[i31];
                        } else if (!keyframeMetadata11.__fnct) {
                            outX11 = keyData11.o.x;
                            outY11 = keyData11.o.y;
                            inX11 = keyData11.i.x;
                            inY11 = keyData11.i.y;
                            fnc11 = BezierFactory.getBezierEasing(outX11, outY11, inX11, inY11).get;
                            keyData11.keyframeMetadata = fnc11;
                        } else fnc11 = keyframeMetadata11.__fnct;
                        perc11 = fnc11((frameNum11 - keyTime11) / (nextKeyTime11 - keyTime11));
                    }
                }
                endValue11 = nextKeyData11.s || keyData11.e;
                keyValue11 = keyData11.h === 1 ? keyData11.s[i31] : keyData11.s[i31] + (endValue11[i31] - keyData11.s[i31]) * perc11;
                if (this.propType === "multidimensional") newValue11[i31] = keyValue11;
                else newValue11 = keyValue11;
            }
        }
        caching11.lastIndex = iterationIndex11;
        return newValue11;
    } // based on @Toji's https://github.com/toji/gl-matrix/
    function slerp(a31, b31, t31) {
        var out11 = [];
        var ax11 = a31[0];
        var ay11 = a31[1];
        var az11 = a31[2];
        var aw11 = a31[3];
        var bx11 = b31[0];
        var by11 = b31[1];
        var bz11 = b31[2];
        var bw11 = b31[3];
        var omega11;
        var cosom11;
        var sinom11;
        var scale011;
        var scale111;
        cosom11 = ax11 * bx11 + ay11 * by11 + az11 * bz11 + aw11 * bw11;
        if (cosom11 < 0.0) {
            cosom11 = -cosom11;
            bx11 = -bx11;
            by11 = -by11;
            bz11 = -bz11;
            bw11 = -bw11;
        }
        if (1.0 - cosom11 > 0.000001) {
            omega11 = Math.acos(cosom11);
            sinom11 = Math.sin(omega11);
            scale011 = Math.sin((1.0 - t31) * omega11) / sinom11;
            scale111 = Math.sin(t31 * omega11) / sinom11;
        } else {
            scale011 = 1.0 - t31;
            scale111 = t31;
        }
        out11[0] = scale011 * ax11 + scale111 * bx11;
        out11[1] = scale011 * ay11 + scale111 * by11;
        out11[2] = scale011 * az11 + scale111 * bz11;
        out11[3] = scale011 * aw11 + scale111 * bw11;
        return out11;
    }
    function quaternionToEuler(out11, quat11) {
        var qx11 = quat11[0];
        var qy11 = quat11[1];
        var qz11 = quat11[2];
        var qw11 = quat11[3];
        var heading11 = Math.atan2(2 * qy11 * qw11 - 2 * qx11 * qz11, 1 - 2 * qy11 * qy11 - 2 * qz11 * qz11);
        var attitude11 = Math.asin(2 * qx11 * qy11 + 2 * qz11 * qw11);
        var bank11 = Math.atan2(2 * qx11 * qw11 - 2 * qy11 * qz11, 1 - 2 * qx11 * qx11 - 2 * qz11 * qz11);
        out11[0] = heading11 / degToRads;
        out11[1] = attitude11 / degToRads;
        out11[2] = bank11 / degToRads;
    }
    function createQuaternion(values11) {
        var heading11 = values11[0] * degToRads;
        var attitude11 = values11[1] * degToRads;
        var bank11 = values11[2] * degToRads;
        var c111 = Math.cos(heading11 / 2);
        var c211 = Math.cos(attitude11 / 2);
        var c311 = Math.cos(bank11 / 2);
        var s111 = Math.sin(heading11 / 2);
        var s211 = Math.sin(attitude11 / 2);
        var s311 = Math.sin(bank11 / 2);
        var w11 = c111 * c211 * c311 - s111 * s211 * s311;
        var x41 = s111 * s211 * c311 + c111 * c211 * s311;
        var y41 = s111 * c211 * c311 + c111 * s211 * s311;
        var z41 = c111 * s211 * c311 - s111 * c211 * s311;
        return [
            x41,
            y41,
            z41,
            w11
        ];
    }
    function getValueAtCurrentTime() {
        var frameNum11 = this.comp.renderedFrame - this.offsetTime;
        var initTime11 = this.keyframes[0].t - this.offsetTime;
        var endTime11 = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
        if (!(frameNum11 === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= endTime11 && frameNum11 >= endTime11 || this._caching.lastFrame < initTime11 && frameNum11 < initTime11))) {
            if (this._caching.lastFrame >= frameNum11) {
                this._caching._lastKeyframeIndex = -1;
                this._caching.lastIndex = 0;
            }
            var renderResult11 = this.interpolateValue(frameNum11, this._caching);
            this.pv = renderResult11;
        }
        this._caching.lastFrame = frameNum11;
        return this.pv;
    }
    function setVValue(val31) {
        var multipliedValue11;
        if (this.propType === "unidimensional") {
            multipliedValue11 = val31 * this.mult;
            if (mathAbs(this.v - multipliedValue11) > 0.00001) {
                this.v = multipliedValue11;
                this._mdf = true;
            }
        } else {
            var i31 = 0;
            var len11 = this.v.length;
            while(i31 < len11){
                multipliedValue11 = val31[i31] * this.mult;
                if (mathAbs(this.v[i31] - multipliedValue11) > 0.00001) {
                    this.v[i31] = multipliedValue11;
                    this._mdf = true;
                }
                i31 += 1;
            }
        }
    }
    function processEffectsSequence() {
        if (this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) return;
        if (this.lock) {
            this.setVValue(this.pv);
            return;
        }
        this.lock = true;
        this._mdf = this._isFirstFrame;
        var i31;
        var len11 = this.effectsSequence.length;
        var finalValue11 = this.kf ? this.pv : this.data.k;
        for(i31 = 0; i31 < len11; i31 += 1)finalValue11 = this.effectsSequence[i31](finalValue11);
        this.setVValue(finalValue11);
        this._isFirstFrame = false;
        this.lock = false;
        this.frameId = this.elem.globalData.frameId;
    }
    function addEffect(effectFunction11) {
        this.effectsSequence.push(effectFunction11);
        this.container.addDynamicProperty(this);
    }
    function ValueProperty(elem31, data11, mult11, container11) {
        this.propType = "unidimensional";
        this.mult = mult11 || 1;
        this.data = data11;
        this.v = mult11 ? data11.k * mult11 : data11.k;
        this.pv = data11.k;
        this._mdf = false;
        this.elem = elem31;
        this.container = container11;
        this.comp = elem31.comp;
        this.k = false;
        this.kf = false;
        this.vel = 0;
        this.effectsSequence = [];
        this._isFirstFrame = true;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.addEffect = addEffect;
    }
    function MultiDimensionalProperty(elem31, data11, mult11, container11) {
        this.propType = "multidimensional";
        this.mult = mult11 || 1;
        this.data = data11;
        this._mdf = false;
        this.elem = elem31;
        this.container = container11;
        this.comp = elem31.comp;
        this.k = false;
        this.kf = false;
        this.frameId = -1;
        var i31;
        var len11 = data11.k.length;
        this.v = createTypedArray("float32", len11);
        this.pv = createTypedArray("float32", len11);
        this.vel = createTypedArray("float32", len11);
        for(i31 = 0; i31 < len11; i31 += 1){
            this.v[i31] = data11.k[i31] * this.mult;
            this.pv[i31] = data11.k[i31];
        }
        this._isFirstFrame = true;
        this.effectsSequence = [];
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.addEffect = addEffect;
    }
    function KeyframedValueProperty(elem31, data11, mult11, container11) {
        this.propType = "unidimensional";
        this.keyframes = data11.k;
        this.keyframesMetadata = [];
        this.offsetTime = elem31.data.st;
        this.frameId = -1;
        this._caching = {
            lastFrame: initFrame,
            lastIndex: 0,
            value: 0,
            _lastKeyframeIndex: -1
        };
        this.k = true;
        this.kf = true;
        this.data = data11;
        this.mult = mult11 || 1;
        this.elem = elem31;
        this.container = container11;
        this.comp = elem31.comp;
        this.v = initFrame;
        this.pv = initFrame;
        this._isFirstFrame = true;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.interpolateValue = interpolateValue;
        this.effectsSequence = [
            getValueAtCurrentTime.bind(this)
        ];
        this.addEffect = addEffect;
    }
    function KeyframedMultidimensionalProperty(elem31, data11, mult11, container11) {
        this.propType = "multidimensional";
        var i31;
        var len11 = data11.k.length;
        var s41;
        var e31;
        var to11;
        var ti11;
        for(i31 = 0; i31 < len11 - 1; i31 += 1)if (data11.k[i31].to && data11.k[i31].s && data11.k[i31 + 1] && data11.k[i31 + 1].s) {
            s41 = data11.k[i31].s;
            e31 = data11.k[i31 + 1].s;
            to11 = data11.k[i31].to;
            ti11 = data11.k[i31].ti;
            if (s41.length === 2 && !(s41[0] === e31[0] && s41[1] === e31[1]) && bez.pointOnLine2D(s41[0], s41[1], e31[0], e31[1], s41[0] + to11[0], s41[1] + to11[1]) && bez.pointOnLine2D(s41[0], s41[1], e31[0], e31[1], e31[0] + ti11[0], e31[1] + ti11[1]) || s41.length === 3 && !(s41[0] === e31[0] && s41[1] === e31[1] && s41[2] === e31[2]) && bez.pointOnLine3D(s41[0], s41[1], s41[2], e31[0], e31[1], e31[2], s41[0] + to11[0], s41[1] + to11[1], s41[2] + to11[2]) && bez.pointOnLine3D(s41[0], s41[1], s41[2], e31[0], e31[1], e31[2], e31[0] + ti11[0], e31[1] + ti11[1], e31[2] + ti11[2])) {
                data11.k[i31].to = null;
                data11.k[i31].ti = null;
            }
            if (s41[0] === e31[0] && s41[1] === e31[1] && to11[0] === 0 && to11[1] === 0 && ti11[0] === 0 && ti11[1] === 0) {
                if (s41.length === 2 || s41[2] === e31[2] && to11[2] === 0 && ti11[2] === 0) {
                    data11.k[i31].to = null;
                    data11.k[i31].ti = null;
                }
            }
        }
        this.effectsSequence = [
            getValueAtCurrentTime.bind(this)
        ];
        this.data = data11;
        this.keyframes = data11.k;
        this.keyframesMetadata = [];
        this.offsetTime = elem31.data.st;
        this.k = true;
        this.kf = true;
        this._isFirstFrame = true;
        this.mult = mult11 || 1;
        this.elem = elem31;
        this.container = container11;
        this.comp = elem31.comp;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.interpolateValue = interpolateValue;
        this.frameId = -1;
        var arrLen11 = data11.k[0].s.length;
        this.v = createTypedArray("float32", arrLen11);
        this.pv = createTypedArray("float32", arrLen11);
        for(i31 = 0; i31 < arrLen11; i31 += 1){
            this.v[i31] = initFrame;
            this.pv[i31] = initFrame;
        }
        this._caching = {
            lastFrame: initFrame,
            lastIndex: 0,
            value: createTypedArray("float32", arrLen11)
        };
        this.addEffect = addEffect;
    }
    var PropertyFactory = function() {
        function getProp11(elem31, data11, type11, mult11, container11) {
            if (data11.sid) data11 = elem31.globalData.slotManager.getProp(data11);
            var p61;
            if (!data11.k.length) p61 = new ValueProperty(elem31, data11, mult11, container11);
            else if (typeof data11.k[0] === "number") p61 = new MultiDimensionalProperty(elem31, data11, mult11, container11);
            else switch(type11){
                case 0:
                    p61 = new KeyframedValueProperty(elem31, data11, mult11, container11);
                    break;
                case 1:
                    p61 = new KeyframedMultidimensionalProperty(elem31, data11, mult11, container11);
                    break;
                default:
                    break;
            }
            if (p61.effectsSequence.length) container11.addDynamicProperty(p61);
            return p61;
        }
        var ob11 = {
            getProp: getProp11
        };
        return ob11;
    }();
    function DynamicPropertyContainer() {}
    DynamicPropertyContainer.prototype = {
        addDynamicProperty: function addDynamicProperty11(prop11) {
            if (this.dynamicProperties.indexOf(prop11) === -1) {
                this.dynamicProperties.push(prop11);
                this.container.addDynamicProperty(this);
                this._isAnimated = true;
            }
        },
        iterateDynamicProperties: function iterateDynamicProperties11() {
            this._mdf = false;
            var i31;
            var len11 = this.dynamicProperties.length;
            for(i31 = 0; i31 < len11; i31 += 1){
                this.dynamicProperties[i31].getValue();
                if (this.dynamicProperties[i31]._mdf) this._mdf = true;
            }
        },
        initDynamicPropertyContainer: function initDynamicPropertyContainer11(container11) {
            this.container = container11;
            this.dynamicProperties = [];
            this._mdf = false;
            this._isAnimated = false;
        }
    };
    var pointPool = function() {
        function create11() {
            return createTypedArray("float32", 2);
        }
        return poolFactory(8, create11);
    }();
    function ShapePath() {
        this.c = false;
        this._length = 0;
        this._maxLength = 8;
        this.v = createSizedArray(this._maxLength);
        this.o = createSizedArray(this._maxLength);
        this.i = createSizedArray(this._maxLength);
    }
    ShapePath.prototype.setPathData = function(closed11, len11) {
        this.c = closed11;
        this.setLength(len11);
        var i31 = 0;
        while(i31 < len11){
            this.v[i31] = pointPool.newElement();
            this.o[i31] = pointPool.newElement();
            this.i[i31] = pointPool.newElement();
            i31 += 1;
        }
    };
    ShapePath.prototype.setLength = function(len11) {
        while(this._maxLength < len11)this.doubleArrayLength();
        this._length = len11;
    };
    ShapePath.prototype.doubleArrayLength = function() {
        this.v = this.v.concat(createSizedArray(this._maxLength));
        this.i = this.i.concat(createSizedArray(this._maxLength));
        this.o = this.o.concat(createSizedArray(this._maxLength));
        this._maxLength *= 2;
    };
    ShapePath.prototype.setXYAt = function(x41, y41, type11, pos11, replace11) {
        var arr31;
        this._length = Math.max(this._length, pos11 + 1);
        if (this._length >= this._maxLength) this.doubleArrayLength();
        switch(type11){
            case "v":
                arr31 = this.v;
                break;
            case "i":
                arr31 = this.i;
                break;
            case "o":
                arr31 = this.o;
                break;
            default:
                arr31 = [];
                break;
        }
        if (!arr31[pos11] || arr31[pos11] && !replace11) arr31[pos11] = pointPool.newElement();
        arr31[pos11][0] = x41;
        arr31[pos11][1] = y41;
    };
    ShapePath.prototype.setTripleAt = function(vX11, vY11, oX11, oY11, iX11, iY11, pos11, replace11) {
        this.setXYAt(vX11, vY11, "v", pos11, replace11);
        this.setXYAt(oX11, oY11, "o", pos11, replace11);
        this.setXYAt(iX11, iY11, "i", pos11, replace11);
    };
    ShapePath.prototype.reverse = function() {
        var newPath11 = new ShapePath();
        newPath11.setPathData(this.c, this._length);
        var vertices11 = this.v;
        var outPoints11 = this.o;
        var inPoints11 = this.i;
        var init11 = 0;
        if (this.c) {
            newPath11.setTripleAt(vertices11[0][0], vertices11[0][1], inPoints11[0][0], inPoints11[0][1], outPoints11[0][0], outPoints11[0][1], 0, false);
            init11 = 1;
        }
        var cnt11 = this._length - 1;
        var len11 = this._length;
        var i31;
        for(i31 = init11; i31 < len11; i31 += 1){
            newPath11.setTripleAt(vertices11[cnt11][0], vertices11[cnt11][1], inPoints11[cnt11][0], inPoints11[cnt11][1], outPoints11[cnt11][0], outPoints11[cnt11][1], i31, false);
            cnt11 -= 1;
        }
        return newPath11;
    };
    ShapePath.prototype.length = function() {
        return this._length;
    };
    var shapePool = function() {
        function create11() {
            return new ShapePath();
        }
        function release11(shapePath11) {
            var len11 = shapePath11._length;
            var i31;
            for(i31 = 0; i31 < len11; i31 += 1){
                pointPool.release(shapePath11.v[i31]);
                pointPool.release(shapePath11.i[i31]);
                pointPool.release(shapePath11.o[i31]);
                shapePath11.v[i31] = null;
                shapePath11.i[i31] = null;
                shapePath11.o[i31] = null;
            }
            shapePath11._length = 0;
            shapePath11.c = false;
        }
        function clone11(shape31) {
            var cloned11 = factory11.newElement();
            var i31;
            var len11 = shape31._length === undefined ? shape31.v.length : shape31._length;
            cloned11.setLength(len11);
            cloned11.c = shape31.c;
            for(i31 = 0; i31 < len11; i31 += 1)cloned11.setTripleAt(shape31.v[i31][0], shape31.v[i31][1], shape31.o[i31][0], shape31.o[i31][1], shape31.i[i31][0], shape31.i[i31][1], i31);
            return cloned11;
        }
        var factory11 = poolFactory(4, create11, release11);
        factory11.clone = clone11;
        return factory11;
    }();
    function ShapeCollection() {
        this._length = 0;
        this._maxLength = 4;
        this.shapes = createSizedArray(this._maxLength);
    }
    ShapeCollection.prototype.addShape = function(shapeData11) {
        if (this._length === this._maxLength) {
            this.shapes = this.shapes.concat(createSizedArray(this._maxLength));
            this._maxLength *= 2;
        }
        this.shapes[this._length] = shapeData11;
        this._length += 1;
    };
    ShapeCollection.prototype.releaseShapes = function() {
        var i31;
        for(i31 = 0; i31 < this._length; i31 += 1)shapePool.release(this.shapes[i31]);
        this._length = 0;
    };
    var shapeCollectionPool = function() {
        var ob11 = {
            newShapeCollection: newShapeCollection11,
            release: release11
        };
        var _length11 = 0;
        var _maxLength11 = 4;
        var pool11 = createSizedArray(_maxLength11);
        function newShapeCollection11() {
            var shapeCollection11;
            if (_length11) {
                _length11 -= 1;
                shapeCollection11 = pool11[_length11];
            } else shapeCollection11 = new ShapeCollection();
            return shapeCollection11;
        }
        function release11(shapeCollection11) {
            var i31;
            var len11 = shapeCollection11._length;
            for(i31 = 0; i31 < len11; i31 += 1)shapePool.release(shapeCollection11.shapes[i31]);
            shapeCollection11._length = 0;
            if (_length11 === _maxLength11) {
                pool11 = pooling["double"](pool11);
                _maxLength11 *= 2;
            }
            pool11[_length11] = shapeCollection11;
            _length11 += 1;
        }
        return ob11;
    }();
    var ShapePropertyFactory = function() {
        var initFrame11 = -999999;
        function interpolateShape11(frameNum11, previousValue11, caching11) {
            var iterationIndex11 = caching11.lastIndex;
            var keyPropS11;
            var keyPropE11;
            var isHold11;
            var j31;
            var k31;
            var jLen11;
            var kLen11;
            var perc11;
            var vertexValue11;
            var kf11 = this.keyframes;
            if (frameNum11 < kf11[0].t - this.offsetTime) {
                keyPropS11 = kf11[0].s[0];
                isHold11 = true;
                iterationIndex11 = 0;
            } else if (frameNum11 >= kf11[kf11.length - 1].t - this.offsetTime) {
                keyPropS11 = kf11[kf11.length - 1].s ? kf11[kf11.length - 1].s[0] : kf11[kf11.length - 2].e[0];
                /* if(kf[kf.length - 1].s){
                  keyPropS = kf[kf.length - 1].s[0];
              }else{
                  keyPropS = kf[kf.length - 2].e[0];
              } */ isHold11 = true;
            } else {
                var i31 = iterationIndex11;
                var len11 = kf11.length - 1;
                var flag11 = true;
                var keyData11;
                var nextKeyData11;
                var keyframeMetadata11;
                while(flag11){
                    keyData11 = kf11[i31];
                    nextKeyData11 = kf11[i31 + 1];
                    if (nextKeyData11.t - this.offsetTime > frameNum11) break;
                    if (i31 < len11 - 1) i31 += 1;
                    else flag11 = false;
                }
                keyframeMetadata11 = this.keyframesMetadata[i31] || {};
                isHold11 = keyData11.h === 1;
                iterationIndex11 = i31;
                if (!isHold11) {
                    if (frameNum11 >= nextKeyData11.t - this.offsetTime) perc11 = 1;
                    else if (frameNum11 < keyData11.t - this.offsetTime) perc11 = 0;
                    else {
                        var fnc11;
                        if (keyframeMetadata11.__fnct) fnc11 = keyframeMetadata11.__fnct;
                        else {
                            fnc11 = BezierFactory.getBezierEasing(keyData11.o.x, keyData11.o.y, keyData11.i.x, keyData11.i.y).get;
                            keyframeMetadata11.__fnct = fnc11;
                        }
                        perc11 = fnc11((frameNum11 - (keyData11.t - this.offsetTime)) / (nextKeyData11.t - this.offsetTime - (keyData11.t - this.offsetTime)));
                    }
                    keyPropE11 = nextKeyData11.s ? nextKeyData11.s[0] : keyData11.e[0];
                }
                keyPropS11 = keyData11.s[0];
            }
            jLen11 = previousValue11._length;
            kLen11 = keyPropS11.i[0].length;
            caching11.lastIndex = iterationIndex11;
            for(j31 = 0; j31 < jLen11; j31 += 1)for(k31 = 0; k31 < kLen11; k31 += 1){
                vertexValue11 = isHold11 ? keyPropS11.i[j31][k31] : keyPropS11.i[j31][k31] + (keyPropE11.i[j31][k31] - keyPropS11.i[j31][k31]) * perc11;
                previousValue11.i[j31][k31] = vertexValue11;
                vertexValue11 = isHold11 ? keyPropS11.o[j31][k31] : keyPropS11.o[j31][k31] + (keyPropE11.o[j31][k31] - keyPropS11.o[j31][k31]) * perc11;
                previousValue11.o[j31][k31] = vertexValue11;
                vertexValue11 = isHold11 ? keyPropS11.v[j31][k31] : keyPropS11.v[j31][k31] + (keyPropE11.v[j31][k31] - keyPropS11.v[j31][k31]) * perc11;
                previousValue11.v[j31][k31] = vertexValue11;
            }
        }
        function interpolateShapeCurrentTime11() {
            var frameNum11 = this.comp.renderedFrame - this.offsetTime;
            var initTime11 = this.keyframes[0].t - this.offsetTime;
            var endTime11 = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
            var lastFrame11 = this._caching.lastFrame;
            if (!(lastFrame11 !== initFrame11 && (lastFrame11 < initTime11 && frameNum11 < initTime11 || lastFrame11 > endTime11 && frameNum11 > endTime11))) {
                /// /
                this._caching.lastIndex = lastFrame11 < frameNum11 ? this._caching.lastIndex : 0;
                this.interpolateShape(frameNum11, this.pv, this._caching); /// /
            }
            this._caching.lastFrame = frameNum11;
            return this.pv;
        }
        function resetShape11() {
            this.paths = this.localShapeCollection;
        }
        function shapesEqual11(shape111, shape211) {
            if (shape111._length !== shape211._length || shape111.c !== shape211.c) return false;
            var i31;
            var len11 = shape111._length;
            for(i31 = 0; i31 < len11; i31 += 1){
                if (shape111.v[i31][0] !== shape211.v[i31][0] || shape111.v[i31][1] !== shape211.v[i31][1] || shape111.o[i31][0] !== shape211.o[i31][0] || shape111.o[i31][1] !== shape211.o[i31][1] || shape111.i[i31][0] !== shape211.i[i31][0] || shape111.i[i31][1] !== shape211.i[i31][1]) return false;
            }
            return true;
        }
        function setVValue11(newPath11) {
            if (!shapesEqual11(this.v, newPath11)) {
                this.v = shapePool.clone(newPath11);
                this.localShapeCollection.releaseShapes();
                this.localShapeCollection.addShape(this.v);
                this._mdf = true;
                this.paths = this.localShapeCollection;
            }
        }
        function processEffectsSequence11() {
            if (this.elem.globalData.frameId === this.frameId) return;
            if (!this.effectsSequence.length) {
                this._mdf = false;
                return;
            }
            if (this.lock) {
                this.setVValue(this.pv);
                return;
            }
            this.lock = true;
            this._mdf = false;
            var finalValue11;
            if (this.kf) finalValue11 = this.pv;
            else if (this.data.ks) finalValue11 = this.data.ks.k;
            else finalValue11 = this.data.pt.k;
            var i31;
            var len11 = this.effectsSequence.length;
            for(i31 = 0; i31 < len11; i31 += 1)finalValue11 = this.effectsSequence[i31](finalValue11);
            this.setVValue(finalValue11);
            this.lock = false;
            this.frameId = this.elem.globalData.frameId;
        }
        function ShapeProperty11(elem31, data11, type11) {
            this.propType = "shape";
            this.comp = elem31.comp;
            this.container = elem31;
            this.elem = elem31;
            this.data = data11;
            this.k = false;
            this.kf = false;
            this._mdf = false;
            var pathData11 = type11 === 3 ? data11.pt.k : data11.ks.k;
            this.v = shapePool.clone(pathData11);
            this.pv = shapePool.clone(this.v);
            this.localShapeCollection = shapeCollectionPool.newShapeCollection();
            this.paths = this.localShapeCollection;
            this.paths.addShape(this.v);
            this.reset = resetShape11;
            this.effectsSequence = [];
        }
        function addEffect11(effectFunction11) {
            this.effectsSequence.push(effectFunction11);
            this.container.addDynamicProperty(this);
        }
        ShapeProperty11.prototype.interpolateShape = interpolateShape11;
        ShapeProperty11.prototype.getValue = processEffectsSequence11;
        ShapeProperty11.prototype.setVValue = setVValue11;
        ShapeProperty11.prototype.addEffect = addEffect11;
        function KeyframedShapeProperty11(elem31, data11, type11) {
            this.propType = "shape";
            this.comp = elem31.comp;
            this.elem = elem31;
            this.container = elem31;
            this.offsetTime = elem31.data.st;
            this.keyframes = type11 === 3 ? data11.pt.k : data11.ks.k;
            this.keyframesMetadata = [];
            this.k = true;
            this.kf = true;
            var len11 = this.keyframes[0].s[0].i.length;
            this.v = shapePool.newElement();
            this.v.setPathData(this.keyframes[0].s[0].c, len11);
            this.pv = shapePool.clone(this.v);
            this.localShapeCollection = shapeCollectionPool.newShapeCollection();
            this.paths = this.localShapeCollection;
            this.paths.addShape(this.v);
            this.lastFrame = initFrame11;
            this.reset = resetShape11;
            this._caching = {
                lastFrame: initFrame11,
                lastIndex: 0
            };
            this.effectsSequence = [
                interpolateShapeCurrentTime11.bind(this)
            ];
        }
        KeyframedShapeProperty11.prototype.getValue = processEffectsSequence11;
        KeyframedShapeProperty11.prototype.interpolateShape = interpolateShape11;
        KeyframedShapeProperty11.prototype.setVValue = setVValue11;
        KeyframedShapeProperty11.prototype.addEffect = addEffect11;
        var EllShapeProperty11 = function() {
            var cPoint11 = roundCorner;
            function EllShapePropertyFactory11(elem31, data11) {
                this.v = shapePool.newElement();
                this.v.setPathData(true, 4);
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.paths = this.localShapeCollection;
                this.localShapeCollection.addShape(this.v);
                this.d = data11.d;
                this.elem = elem31;
                this.comp = elem31.comp;
                this.frameId = -1;
                this.initDynamicPropertyContainer(elem31);
                this.p = PropertyFactory.getProp(elem31, data11.p, 1, 0, this);
                this.s = PropertyFactory.getProp(elem31, data11.s, 1, 0, this);
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertEllToPath();
                }
            }
            EllShapePropertyFactory11.prototype = {
                reset: resetShape11,
                getValue: function getValue11() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertEllToPath();
                },
                convertEllToPath: function convertEllToPath11() {
                    var p011 = this.p.v[0];
                    var p141 = this.p.v[1];
                    var s011 = this.s.v[0] / 2;
                    var s111 = this.s.v[1] / 2;
                    var _cw11 = this.d !== 3;
                    var _v11 = this.v;
                    _v11.v[0][0] = p011;
                    _v11.v[0][1] = p141 - s111;
                    _v11.v[1][0] = _cw11 ? p011 + s011 : p011 - s011;
                    _v11.v[1][1] = p141;
                    _v11.v[2][0] = p011;
                    _v11.v[2][1] = p141 + s111;
                    _v11.v[3][0] = _cw11 ? p011 - s011 : p011 + s011;
                    _v11.v[3][1] = p141;
                    _v11.i[0][0] = _cw11 ? p011 - s011 * cPoint11 : p011 + s011 * cPoint11;
                    _v11.i[0][1] = p141 - s111;
                    _v11.i[1][0] = _cw11 ? p011 + s011 : p011 - s011;
                    _v11.i[1][1] = p141 - s111 * cPoint11;
                    _v11.i[2][0] = _cw11 ? p011 + s011 * cPoint11 : p011 - s011 * cPoint11;
                    _v11.i[2][1] = p141 + s111;
                    _v11.i[3][0] = _cw11 ? p011 - s011 : p011 + s011;
                    _v11.i[3][1] = p141 + s111 * cPoint11;
                    _v11.o[0][0] = _cw11 ? p011 + s011 * cPoint11 : p011 - s011 * cPoint11;
                    _v11.o[0][1] = p141 - s111;
                    _v11.o[1][0] = _cw11 ? p011 + s011 : p011 - s011;
                    _v11.o[1][1] = p141 + s111 * cPoint11;
                    _v11.o[2][0] = _cw11 ? p011 - s011 * cPoint11 : p011 + s011 * cPoint11;
                    _v11.o[2][1] = p141 + s111;
                    _v11.o[3][0] = _cw11 ? p011 - s011 : p011 + s011;
                    _v11.o[3][1] = p141 - s111 * cPoint11;
                }
            };
            extendPrototype([
                DynamicPropertyContainer
            ], EllShapePropertyFactory11);
            return EllShapePropertyFactory11;
        }();
        var StarShapeProperty11 = function() {
            function StarShapePropertyFactory11(elem31, data11) {
                this.v = shapePool.newElement();
                this.v.setPathData(true, 0);
                this.elem = elem31;
                this.comp = elem31.comp;
                this.data = data11;
                this.frameId = -1;
                this.d = data11.d;
                this.initDynamicPropertyContainer(elem31);
                if (data11.sy === 1) {
                    this.ir = PropertyFactory.getProp(elem31, data11.ir, 0, 0, this);
                    this.is = PropertyFactory.getProp(elem31, data11.is, 0, 0.01, this);
                    this.convertToPath = this.convertStarToPath;
                } else this.convertToPath = this.convertPolygonToPath;
                this.pt = PropertyFactory.getProp(elem31, data11.pt, 0, 0, this);
                this.p = PropertyFactory.getProp(elem31, data11.p, 1, 0, this);
                this.r = PropertyFactory.getProp(elem31, data11.r, 0, degToRads, this);
                this.or = PropertyFactory.getProp(elem31, data11.or, 0, 0, this);
                this.os = PropertyFactory.getProp(elem31, data11.os, 0, 0.01, this);
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.localShapeCollection.addShape(this.v);
                this.paths = this.localShapeCollection;
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertToPath();
                }
            }
            StarShapePropertyFactory11.prototype = {
                reset: resetShape11,
                getValue: function getValue11() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertToPath();
                },
                convertStarToPath: function convertStarToPath11() {
                    var numPts11 = Math.floor(this.pt.v) * 2;
                    var angle11 = Math.PI * 2 / numPts11;
                    /* this.v.v.length = numPts;
                  this.v.i.length = numPts;
                  this.v.o.length = numPts; */ var longFlag11 = true;
                    var longRad11 = this.or.v;
                    var shortRad11 = this.ir.v;
                    var longRound11 = this.os.v;
                    var shortRound11 = this.is.v;
                    var longPerimSegment11 = 2 * Math.PI * longRad11 / (numPts11 * 2);
                    var shortPerimSegment11 = 2 * Math.PI * shortRad11 / (numPts11 * 2);
                    var i31;
                    var rad11;
                    var roundness11;
                    var perimSegment11;
                    var currentAng11 = -Math.PI / 2;
                    currentAng11 += this.r.v;
                    var dir11 = this.data.d === 3 ? -1 : 1;
                    this.v._length = 0;
                    for(i31 = 0; i31 < numPts11; i31 += 1){
                        rad11 = longFlag11 ? longRad11 : shortRad11;
                        roundness11 = longFlag11 ? longRound11 : shortRound11;
                        perimSegment11 = longFlag11 ? longPerimSegment11 : shortPerimSegment11;
                        var x41 = rad11 * Math.cos(currentAng11);
                        var y41 = rad11 * Math.sin(currentAng11);
                        var ox11 = x41 === 0 && y41 === 0 ? 0 : y41 / Math.sqrt(x41 * x41 + y41 * y41);
                        var oy11 = x41 === 0 && y41 === 0 ? 0 : -x41 / Math.sqrt(x41 * x41 + y41 * y41);
                        x41 += +this.p.v[0];
                        y41 += +this.p.v[1];
                        this.v.setTripleAt(x41, y41, x41 - ox11 * perimSegment11 * roundness11 * dir11, y41 - oy11 * perimSegment11 * roundness11 * dir11, x41 + ox11 * perimSegment11 * roundness11 * dir11, y41 + oy11 * perimSegment11 * roundness11 * dir11, i31, true);
                        /* this.v.v[i] = [x,y];
                      this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
                      this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
                      this.v._length = numPts; */ longFlag11 = !longFlag11;
                        currentAng11 += angle11 * dir11;
                    }
                },
                convertPolygonToPath: function convertPolygonToPath11() {
                    var numPts11 = Math.floor(this.pt.v);
                    var angle11 = Math.PI * 2 / numPts11;
                    var rad11 = this.or.v;
                    var roundness11 = this.os.v;
                    var perimSegment11 = 2 * Math.PI * rad11 / (numPts11 * 4);
                    var i31;
                    var currentAng11 = -Math.PI * 0.5;
                    var dir11 = this.data.d === 3 ? -1 : 1;
                    currentAng11 += this.r.v;
                    this.v._length = 0;
                    for(i31 = 0; i31 < numPts11; i31 += 1){
                        var x41 = rad11 * Math.cos(currentAng11);
                        var y41 = rad11 * Math.sin(currentAng11);
                        var ox11 = x41 === 0 && y41 === 0 ? 0 : y41 / Math.sqrt(x41 * x41 + y41 * y41);
                        var oy11 = x41 === 0 && y41 === 0 ? 0 : -x41 / Math.sqrt(x41 * x41 + y41 * y41);
                        x41 += +this.p.v[0];
                        y41 += +this.p.v[1];
                        this.v.setTripleAt(x41, y41, x41 - ox11 * perimSegment11 * roundness11 * dir11, y41 - oy11 * perimSegment11 * roundness11 * dir11, x41 + ox11 * perimSegment11 * roundness11 * dir11, y41 + oy11 * perimSegment11 * roundness11 * dir11, i31, true);
                        currentAng11 += angle11 * dir11;
                    }
                    this.paths.length = 0;
                    this.paths[0] = this.v;
                }
            };
            extendPrototype([
                DynamicPropertyContainer
            ], StarShapePropertyFactory11);
            return StarShapePropertyFactory11;
        }();
        var RectShapeProperty11 = function() {
            function RectShapePropertyFactory11(elem31, data11) {
                this.v = shapePool.newElement();
                this.v.c = true;
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.localShapeCollection.addShape(this.v);
                this.paths = this.localShapeCollection;
                this.elem = elem31;
                this.comp = elem31.comp;
                this.frameId = -1;
                this.d = data11.d;
                this.initDynamicPropertyContainer(elem31);
                this.p = PropertyFactory.getProp(elem31, data11.p, 1, 0, this);
                this.s = PropertyFactory.getProp(elem31, data11.s, 1, 0, this);
                this.r = PropertyFactory.getProp(elem31, data11.r, 0, 0, this);
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertRectToPath();
                }
            }
            RectShapePropertyFactory11.prototype = {
                convertRectToPath: function convertRectToPath11() {
                    var p011 = this.p.v[0];
                    var p141 = this.p.v[1];
                    var v011 = this.s.v[0] / 2;
                    var v111 = this.s.v[1] / 2;
                    var round11 = bmMin(v011, v111, this.r.v);
                    var cPoint11 = round11 * (1 - roundCorner);
                    this.v._length = 0;
                    if (this.d === 2 || this.d === 1) {
                        this.v.setTripleAt(p011 + v011, p141 - v111 + round11, p011 + v011, p141 - v111 + round11, p011 + v011, p141 - v111 + cPoint11, 0, true);
                        this.v.setTripleAt(p011 + v011, p141 + v111 - round11, p011 + v011, p141 + v111 - cPoint11, p011 + v011, p141 + v111 - round11, 1, true);
                        if (round11 !== 0) {
                            this.v.setTripleAt(p011 + v011 - round11, p141 + v111, p011 + v011 - round11, p141 + v111, p011 + v011 - cPoint11, p141 + v111, 2, true);
                            this.v.setTripleAt(p011 - v011 + round11, p141 + v111, p011 - v011 + cPoint11, p141 + v111, p011 - v011 + round11, p141 + v111, 3, true);
                            this.v.setTripleAt(p011 - v011, p141 + v111 - round11, p011 - v011, p141 + v111 - round11, p011 - v011, p141 + v111 - cPoint11, 4, true);
                            this.v.setTripleAt(p011 - v011, p141 - v111 + round11, p011 - v011, p141 - v111 + cPoint11, p011 - v011, p141 - v111 + round11, 5, true);
                            this.v.setTripleAt(p011 - v011 + round11, p141 - v111, p011 - v011 + round11, p141 - v111, p011 - v011 + cPoint11, p141 - v111, 6, true);
                            this.v.setTripleAt(p011 + v011 - round11, p141 - v111, p011 + v011 - cPoint11, p141 - v111, p011 + v011 - round11, p141 - v111, 7, true);
                        } else {
                            this.v.setTripleAt(p011 - v011, p141 + v111, p011 - v011 + cPoint11, p141 + v111, p011 - v011, p141 + v111, 2);
                            this.v.setTripleAt(p011 - v011, p141 - v111, p011 - v011, p141 - v111 + cPoint11, p011 - v011, p141 - v111, 3);
                        }
                    } else {
                        this.v.setTripleAt(p011 + v011, p141 - v111 + round11, p011 + v011, p141 - v111 + cPoint11, p011 + v011, p141 - v111 + round11, 0, true);
                        if (round11 !== 0) {
                            this.v.setTripleAt(p011 + v011 - round11, p141 - v111, p011 + v011 - round11, p141 - v111, p011 + v011 - cPoint11, p141 - v111, 1, true);
                            this.v.setTripleAt(p011 - v011 + round11, p141 - v111, p011 - v011 + cPoint11, p141 - v111, p011 - v011 + round11, p141 - v111, 2, true);
                            this.v.setTripleAt(p011 - v011, p141 - v111 + round11, p011 - v011, p141 - v111 + round11, p011 - v011, p141 - v111 + cPoint11, 3, true);
                            this.v.setTripleAt(p011 - v011, p141 + v111 - round11, p011 - v011, p141 + v111 - cPoint11, p011 - v011, p141 + v111 - round11, 4, true);
                            this.v.setTripleAt(p011 - v011 + round11, p141 + v111, p011 - v011 + round11, p141 + v111, p011 - v011 + cPoint11, p141 + v111, 5, true);
                            this.v.setTripleAt(p011 + v011 - round11, p141 + v111, p011 + v011 - cPoint11, p141 + v111, p011 + v011 - round11, p141 + v111, 6, true);
                            this.v.setTripleAt(p011 + v011, p141 + v111 - round11, p011 + v011, p141 + v111 - round11, p011 + v011, p141 + v111 - cPoint11, 7, true);
                        } else {
                            this.v.setTripleAt(p011 - v011, p141 - v111, p011 - v011 + cPoint11, p141 - v111, p011 - v011, p141 - v111, 1, true);
                            this.v.setTripleAt(p011 - v011, p141 + v111, p011 - v011, p141 + v111 - cPoint11, p011 - v011, p141 + v111, 2, true);
                            this.v.setTripleAt(p011 + v011, p141 + v111, p011 + v011 - cPoint11, p141 + v111, p011 + v011, p141 + v111, 3, true);
                        }
                    }
                },
                getValue: function getValue11() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertRectToPath();
                },
                reset: resetShape11
            };
            extendPrototype([
                DynamicPropertyContainer
            ], RectShapePropertyFactory11);
            return RectShapePropertyFactory11;
        }();
        function getShapeProp11(elem31, data11, type11) {
            var prop11;
            if (type11 === 3 || type11 === 4) {
                var dataProp11 = type11 === 3 ? data11.pt : data11.ks;
                var keys11 = dataProp11.k;
                if (keys11.length) prop11 = new KeyframedShapeProperty11(elem31, data11, type11);
                else prop11 = new ShapeProperty11(elem31, data11, type11);
            } else if (type11 === 5) prop11 = new RectShapeProperty11(elem31, data11);
            else if (type11 === 6) prop11 = new EllShapeProperty11(elem31, data11);
            else if (type11 === 7) prop11 = new StarShapeProperty11(elem31, data11);
            if (prop11.k) elem31.addDynamicProperty(prop11);
            return prop11;
        }
        function getConstructorFunction11() {
            return ShapeProperty11;
        }
        function getKeyframedConstructorFunction11() {
            return KeyframedShapeProperty11;
        }
        var ob11 = {};
        ob11.getShapeProp = getShapeProp11;
        ob11.getConstructorFunction = getConstructorFunction11;
        ob11.getKeyframedConstructorFunction = getKeyframedConstructorFunction11;
        return ob11;
    }();
    /*!
   Transformation Matrix v2.0
   (c) Epistemex 2014-2015
   www.epistemex.com
   By Ken Fyrstenberg
   Contributions by leeoniya.
   License: MIT, header required.
   */ /**
   * 2D transformation matrix object initialized with identity matrix.
   *
   * The matrix can synchronize a canvas context by supplying the context
   * as an argument, or later apply current absolute transform to an
   * existing context.
   *
   * All values are handled as floating point values.
   *
   * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
   * @prop {number} a - scale x
   * @prop {number} b - shear y
   * @prop {number} c - shear x
   * @prop {number} d - scale y
   * @prop {number} e - translate x
   * @prop {number} f - translate y
   * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
   * @constructor
   */ var Matrix = function() {
        var _cos11 = Math.cos;
        var _sin11 = Math.sin;
        var _tan11 = Math.tan;
        var _rnd11 = Math.round;
        function reset11() {
            this.props[0] = 1;
            this.props[1] = 0;
            this.props[2] = 0;
            this.props[3] = 0;
            this.props[4] = 0;
            this.props[5] = 1;
            this.props[6] = 0;
            this.props[7] = 0;
            this.props[8] = 0;
            this.props[9] = 0;
            this.props[10] = 1;
            this.props[11] = 0;
            this.props[12] = 0;
            this.props[13] = 0;
            this.props[14] = 0;
            this.props[15] = 1;
            return this;
        }
        function rotate11(angle11) {
            if (angle11 === 0) return this;
            var mCos11 = _cos11(angle11);
            var mSin11 = _sin11(angle11);
            return this._t(mCos11, -mSin11, 0, 0, mSin11, mCos11, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function rotateX11(angle11) {
            if (angle11 === 0) return this;
            var mCos11 = _cos11(angle11);
            var mSin11 = _sin11(angle11);
            return this._t(1, 0, 0, 0, 0, mCos11, -mSin11, 0, 0, mSin11, mCos11, 0, 0, 0, 0, 1);
        }
        function rotateY11(angle11) {
            if (angle11 === 0) return this;
            var mCos11 = _cos11(angle11);
            var mSin11 = _sin11(angle11);
            return this._t(mCos11, 0, mSin11, 0, 0, 1, 0, 0, -mSin11, 0, mCos11, 0, 0, 0, 0, 1);
        }
        function rotateZ11(angle11) {
            if (angle11 === 0) return this;
            var mCos11 = _cos11(angle11);
            var mSin11 = _sin11(angle11);
            return this._t(mCos11, -mSin11, 0, 0, mSin11, mCos11, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function shear11(sx11, sy11) {
            return this._t(1, sy11, sx11, 1, 0, 0);
        }
        function skew11(ax11, ay11) {
            return this.shear(_tan11(ax11), _tan11(ay11));
        }
        function skewFromAxis11(ax11, angle11) {
            var mCos11 = _cos11(angle11);
            var mSin11 = _sin11(angle11);
            return this._t(mCos11, mSin11, 0, 0, -mSin11, mCos11, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, _tan11(ax11), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(mCos11, -mSin11, 0, 0, mSin11, mCos11, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); // return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
        }
        function scale21(sx11, sy11, sz11) {
            if (!sz11 && sz11 !== 0) sz11 = 1;
            if (sx11 === 1 && sy11 === 1 && sz11 === 1) return this;
            return this._t(sx11, 0, 0, 0, 0, sy11, 0, 0, 0, 0, sz11, 0, 0, 0, 0, 1);
        }
        function setTransform11(a31, b31, c41, d31, e31, f31, g31, h31, i31, j31, k31, l31, m31, n31, o31, p61) {
            this.props[0] = a31;
            this.props[1] = b31;
            this.props[2] = c41;
            this.props[3] = d31;
            this.props[4] = e31;
            this.props[5] = f31;
            this.props[6] = g31;
            this.props[7] = h31;
            this.props[8] = i31;
            this.props[9] = j31;
            this.props[10] = k31;
            this.props[11] = l31;
            this.props[12] = m31;
            this.props[13] = n31;
            this.props[14] = o31;
            this.props[15] = p61;
            return this;
        }
        function translate11(tx11, ty11, tz11) {
            tz11 = tz11 || 0;
            if (tx11 !== 0 || ty11 !== 0 || tz11 !== 0) return this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, tx11, ty11, tz11, 1);
            return this;
        }
        function transform11(a211, b211, c211, d211, e211, f211, g211, h211, i211, j211, k211, l211, m211, n211, o211, p221) {
            var _p11 = this.props;
            if (a211 === 1 && b211 === 0 && c211 === 0 && d211 === 0 && e211 === 0 && f211 === 1 && g211 === 0 && h211 === 0 && i211 === 0 && j211 === 0 && k211 === 1 && l211 === 0) {
                // NOTE: commenting this condition because TurboFan deoptimizes code when present
                // if(m2 !== 0 || n2 !== 0 || o2 !== 0){
                _p11[12] = _p11[12] * a211 + _p11[15] * m211;
                _p11[13] = _p11[13] * f211 + _p11[15] * n211;
                _p11[14] = _p11[14] * k211 + _p11[15] * o211;
                _p11[15] *= p221; // }
                this._identityCalculated = false;
                return this;
            }
            var a111 = _p11[0];
            var b111 = _p11[1];
            var c111 = _p11[2];
            var d111 = _p11[3];
            var e111 = _p11[4];
            var f111 = _p11[5];
            var g111 = _p11[6];
            var h111 = _p11[7];
            var i111 = _p11[8];
            var j111 = _p11[9];
            var k111 = _p11[10];
            var l111 = _p11[11];
            var m111 = _p11[12];
            var n111 = _p11[13];
            var o111 = _p11[14];
            var p141 = _p11[15];
            /* matrix order (canvas compatible):
           * ace
           * bdf
           * 001
           */ _p11[0] = a111 * a211 + b111 * e211 + c111 * i211 + d111 * m211;
            _p11[1] = a111 * b211 + b111 * f211 + c111 * j211 + d111 * n211;
            _p11[2] = a111 * c211 + b111 * g211 + c111 * k211 + d111 * o211;
            _p11[3] = a111 * d211 + b111 * h211 + c111 * l211 + d111 * p221;
            _p11[4] = e111 * a211 + f111 * e211 + g111 * i211 + h111 * m211;
            _p11[5] = e111 * b211 + f111 * f211 + g111 * j211 + h111 * n211;
            _p11[6] = e111 * c211 + f111 * g211 + g111 * k211 + h111 * o211;
            _p11[7] = e111 * d211 + f111 * h211 + g111 * l211 + h111 * p221;
            _p11[8] = i111 * a211 + j111 * e211 + k111 * i211 + l111 * m211;
            _p11[9] = i111 * b211 + j111 * f211 + k111 * j211 + l111 * n211;
            _p11[10] = i111 * c211 + j111 * g211 + k111 * k211 + l111 * o211;
            _p11[11] = i111 * d211 + j111 * h211 + k111 * l211 + l111 * p221;
            _p11[12] = m111 * a211 + n111 * e211 + o111 * i211 + p141 * m211;
            _p11[13] = m111 * b211 + n111 * f211 + o111 * j211 + p141 * n211;
            _p11[14] = m111 * c211 + n111 * g211 + o111 * k211 + p141 * o211;
            _p11[15] = m111 * d211 + n111 * h211 + o111 * l211 + p141 * p221;
            this._identityCalculated = false;
            return this;
        }
        function multiply11(matrix11) {
            var matrixProps11 = matrix11.props;
            return this.transform(matrixProps11[0], matrixProps11[1], matrixProps11[2], matrixProps11[3], matrixProps11[4], matrixProps11[5], matrixProps11[6], matrixProps11[7], matrixProps11[8], matrixProps11[9], matrixProps11[10], matrixProps11[11], matrixProps11[12], matrixProps11[13], matrixProps11[14], matrixProps11[15]);
        }
        function isIdentity11() {
            if (!this._identityCalculated) {
                this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
                this._identityCalculated = true;
            }
            return this._identity;
        }
        function equals11(matr11) {
            var i31 = 0;
            while(i31 < 16){
                if (matr11.props[i31] !== this.props[i31]) return false;
                i31 += 1;
            }
            return true;
        }
        function clone11(matr11) {
            var i31;
            for(i31 = 0; i31 < 16; i31 += 1)matr11.props[i31] = this.props[i31];
            return matr11;
        }
        function cloneFromProps11(props11) {
            var i31;
            for(i31 = 0; i31 < 16; i31 += 1)this.props[i31] = props11[i31];
        }
        function applyToPoint11(x41, y41, z41) {
            return {
                x: x41 * this.props[0] + y41 * this.props[4] + z41 * this.props[8] + this.props[12],
                y: x41 * this.props[1] + y41 * this.props[5] + z41 * this.props[9] + this.props[13],
                z: x41 * this.props[2] + y41 * this.props[6] + z41 * this.props[10] + this.props[14]
            };
        /* return {
           x: x * me.a + y * me.c + me.e,
           y: x * me.b + y * me.d + me.f
           }; */ }
        function applyToX11(x41, y41, z41) {
            return x41 * this.props[0] + y41 * this.props[4] + z41 * this.props[8] + this.props[12];
        }
        function applyToY11(x41, y41, z41) {
            return x41 * this.props[1] + y41 * this.props[5] + z41 * this.props[9] + this.props[13];
        }
        function applyToZ11(x41, y41, z41) {
            return x41 * this.props[2] + y41 * this.props[6] + z41 * this.props[10] + this.props[14];
        }
        function getInverseMatrix11() {
            var determinant11 = this.props[0] * this.props[5] - this.props[1] * this.props[4];
            var a31 = this.props[5] / determinant11;
            var b31 = -this.props[1] / determinant11;
            var c41 = -this.props[4] / determinant11;
            var d31 = this.props[0] / determinant11;
            var e31 = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / determinant11;
            var f31 = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / determinant11;
            var inverseMatrix11 = new Matrix();
            inverseMatrix11.props[0] = a31;
            inverseMatrix11.props[1] = b31;
            inverseMatrix11.props[4] = c41;
            inverseMatrix11.props[5] = d31;
            inverseMatrix11.props[12] = e31;
            inverseMatrix11.props[13] = f31;
            return inverseMatrix11;
        }
        function inversePoint11(pt51) {
            var inverseMatrix11 = this.getInverseMatrix();
            return inverseMatrix11.applyToPointArray(pt51[0], pt51[1], pt51[2] || 0);
        }
        function inversePoints11(pts11) {
            var i31;
            var len11 = pts11.length;
            var retPts11 = [];
            for(i31 = 0; i31 < len11; i31 += 1)retPts11[i31] = inversePoint11(pts11[i31]);
            return retPts11;
        }
        function applyToTriplePoints11(pt111, pt211, pt311) {
            var arr31 = createTypedArray("float32", 6);
            if (this.isIdentity()) {
                arr31[0] = pt111[0];
                arr31[1] = pt111[1];
                arr31[2] = pt211[0];
                arr31[3] = pt211[1];
                arr31[4] = pt311[0];
                arr31[5] = pt311[1];
            } else {
                var p011 = this.props[0];
                var p141 = this.props[1];
                var p411 = this.props[4];
                var p511 = this.props[5];
                var p1211 = this.props[12];
                var p1311 = this.props[13];
                arr31[0] = pt111[0] * p011 + pt111[1] * p411 + p1211;
                arr31[1] = pt111[0] * p141 + pt111[1] * p511 + p1311;
                arr31[2] = pt211[0] * p011 + pt211[1] * p411 + p1211;
                arr31[3] = pt211[0] * p141 + pt211[1] * p511 + p1311;
                arr31[4] = pt311[0] * p011 + pt311[1] * p411 + p1211;
                arr31[5] = pt311[0] * p141 + pt311[1] * p511 + p1311;
            }
            return arr31;
        }
        function applyToPointArray11(x41, y41, z41) {
            var arr31;
            if (this.isIdentity()) arr31 = [
                x41,
                y41,
                z41
            ];
            else arr31 = [
                x41 * this.props[0] + y41 * this.props[4] + z41 * this.props[8] + this.props[12],
                x41 * this.props[1] + y41 * this.props[5] + z41 * this.props[9] + this.props[13],
                x41 * this.props[2] + y41 * this.props[6] + z41 * this.props[10] + this.props[14]
            ];
            return arr31;
        }
        function applyToPointStringified11(x41, y41) {
            if (this.isIdentity()) return x41 + "," + y41;
            var _p11 = this.props;
            return Math.round((x41 * _p11[0] + y41 * _p11[4] + _p11[12]) * 100) / 100 + "," + Math.round((x41 * _p11[1] + y41 * _p11[5] + _p11[13]) * 100) / 100;
        }
        function toCSS11() {
            // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
            /* if(this.isIdentity()) {
              return '';
          } */ var i31 = 0;
            var props11 = this.props;
            var cssValue11 = "matrix3d(";
            var v51 = 10000;
            while(i31 < 16){
                cssValue11 += _rnd11(props11[i31] * v51) / v51;
                cssValue11 += i31 === 15 ? ")" : ",";
                i31 += 1;
            }
            return cssValue11;
        }
        function roundMatrixProperty11(val31) {
            var v51 = 10000;
            if (val31 < 0.000001 && val31 > 0 || val31 > -0.000001 && val31 < 0) return _rnd11(val31 * v51) / v51;
            return val31;
        }
        function to2dCSS11() {
            // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
            /* if(this.isIdentity()) {
              return '';
          } */ var props11 = this.props;
            var _a11 = roundMatrixProperty11(props11[0]);
            var _b11 = roundMatrixProperty11(props11[1]);
            var _c11 = roundMatrixProperty11(props11[4]);
            var _d11 = roundMatrixProperty11(props11[5]);
            var _e11 = roundMatrixProperty11(props11[12]);
            var _f11 = roundMatrixProperty11(props11[13]);
            return "matrix(" + _a11 + "," + _b11 + "," + _c11 + "," + _d11 + "," + _e11 + "," + _f11 + ")";
        }
        return function() {
            this.reset = reset11;
            this.rotate = rotate11;
            this.rotateX = rotateX11;
            this.rotateY = rotateY11;
            this.rotateZ = rotateZ11;
            this.skew = skew11;
            this.skewFromAxis = skewFromAxis11;
            this.shear = shear11;
            this.scale = scale21;
            this.setTransform = setTransform11;
            this.translate = translate11;
            this.transform = transform11;
            this.multiply = multiply11;
            this.applyToPoint = applyToPoint11;
            this.applyToX = applyToX11;
            this.applyToY = applyToY11;
            this.applyToZ = applyToZ11;
            this.applyToPointArray = applyToPointArray11;
            this.applyToTriplePoints = applyToTriplePoints11;
            this.applyToPointStringified = applyToPointStringified11;
            this.toCSS = toCSS11;
            this.to2dCSS = to2dCSS11;
            this.clone = clone11;
            this.cloneFromProps = cloneFromProps11;
            this.equals = equals11;
            this.inversePoints = inversePoints11;
            this.inversePoint = inversePoint11;
            this.getInverseMatrix = getInverseMatrix11;
            this._t = this.transform;
            this.isIdentity = isIdentity11;
            this._identity = true;
            this._identityCalculated = false;
            this.props = createTypedArray("float32", 16);
            this.reset();
        };
    }();
    function _typeof$3(obj11) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$3 = function _typeof11(obj11) {
            return typeof obj11;
        };
        else _typeof$3 = function _typeof11(obj11) {
            return obj11 && typeof Symbol === "function" && obj11.constructor === Symbol && obj11 !== Symbol.prototype ? "symbol" : typeof obj11;
        };
        return _typeof$3(obj11);
    }
    var lottie = {};
    var standalone = "__[STANDALONE]__";
    var animationData = "__[ANIMATIONDATA]__";
    var renderer = "";
    function setLocation(href11) {
        setLocationHref(href11);
    }
    function searchAnimations() {
        if (standalone === true) animationManager.searchAnimations(animationData, standalone, renderer);
        else animationManager.searchAnimations();
    }
    function setSubframeRendering(flag11) {
        setSubframeEnabled(flag11);
    }
    function setPrefix(prefix11) {
        setIdPrefix(prefix11);
    }
    function loadAnimation(params11) {
        if (standalone === true) params11.animationData = JSON.parse(animationData);
        return animationManager.loadAnimation(params11);
    }
    function setQuality(value31) {
        if (typeof value31 === "string") switch(value31){
            case "high":
                setDefaultCurveSegments(200);
                break;
            default:
            case "medium":
                setDefaultCurveSegments(50);
                break;
            case "low":
                setDefaultCurveSegments(10);
                break;
        }
        else if (!isNaN(value31) && value31 > 1) setDefaultCurveSegments(value31);
        if (getDefaultCurveSegments() >= 50) roundValues(false);
        else roundValues(true);
    }
    function inBrowser() {
        return typeof navigator !== "undefined";
    }
    function installPlugin(type11, plugin11) {
        if (type11 === "expressions") setExpressionsPlugin(plugin11);
    }
    function getFactory(name11) {
        switch(name11){
            case "propertyFactory":
                return PropertyFactory;
            case "shapePropertyFactory":
                return ShapePropertyFactory;
            case "matrix":
                return Matrix;
            default:
                return null;
        }
    }
    lottie.play = animationManager.play;
    lottie.pause = animationManager.pause;
    lottie.setLocationHref = setLocation;
    lottie.togglePause = animationManager.togglePause;
    lottie.setSpeed = animationManager.setSpeed;
    lottie.setDirection = animationManager.setDirection;
    lottie.stop = animationManager.stop;
    lottie.searchAnimations = searchAnimations;
    lottie.registerAnimation = animationManager.registerAnimation;
    lottie.loadAnimation = loadAnimation;
    lottie.setSubframeRendering = setSubframeRendering;
    lottie.resize = animationManager.resize; // lottie.start = start;
    lottie.goToAndStop = animationManager.goToAndStop;
    lottie.destroy = animationManager.destroy;
    lottie.setQuality = setQuality;
    lottie.inBrowser = inBrowser;
    lottie.installPlugin = installPlugin;
    lottie.freeze = animationManager.freeze;
    lottie.unfreeze = animationManager.unfreeze;
    lottie.setVolume = animationManager.setVolume;
    lottie.mute = animationManager.mute;
    lottie.unmute = animationManager.unmute;
    lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations;
    lottie.useWebWorker = setWebWorker;
    lottie.setIDPrefix = setPrefix;
    lottie.__getFactory = getFactory;
    lottie.version = "5.12.2";
    function checkReady() {
        if (document.readyState === "complete") {
            clearInterval(readyStateCheckInterval);
            searchAnimations();
        }
    }
    function getQueryVariable(variable11) {
        var vars11 = queryString.split("&");
        for(var i31 = 0; i31 < vars11.length; i31 += 1){
            var pair11 = vars11[i31].split("=");
            if (decodeURIComponent(pair11[0]) == variable11) // eslint-disable-line eqeqeq
            return decodeURIComponent(pair11[1]);
        }
        return null;
    }
    var queryString = "";
    if (standalone) {
        var scripts = document.getElementsByTagName("script");
        var index = scripts.length - 1;
        var myScript = scripts[index] || {
            src: ""
        };
        queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, "") : ""; // eslint-disable-line no-useless-escape
        renderer = getQueryVariable("renderer");
    }
    var readyStateCheckInterval = setInterval(checkReady, 100); // this adds bodymovin to the window object for backwards compatibility
    try {
        if (!(_typeof$3(exports) === "object" && true) && !(typeof define === "function" && define.amd // eslint-disable-line no-undef
        )) window.bodymovin = lottie;
    } catch (err) {}
    var ShapeModifiers = function() {
        var ob11 = {};
        var modifiers11 = {};
        ob11.registerModifier = registerModifier11;
        ob11.getModifier = getModifier11;
        function registerModifier11(nm11, factory11) {
            if (!modifiers11[nm11]) modifiers11[nm11] = factory11;
        }
        function getModifier11(nm11, elem31, data11) {
            return new modifiers11[nm11](elem31, data11);
        }
        return ob11;
    }();
    function ShapeModifier() {}
    ShapeModifier.prototype.initModifierProperties = function() {};
    ShapeModifier.prototype.addShapeToModifier = function() {};
    ShapeModifier.prototype.addShape = function(data11) {
        if (!this.closed) {
            // Adding shape to dynamic properties. It covers the case where a shape has no effects applied, to reset it's _mdf state on every tick.
            data11.sh.container.addDynamicProperty(data11.sh);
            var shapeData11 = {
                shape: data11.sh,
                data: data11,
                localShapeCollection: shapeCollectionPool.newShapeCollection()
            };
            this.shapes.push(shapeData11);
            this.addShapeToModifier(shapeData11);
            if (this._isAnimated) data11.setAsAnimated();
        }
    };
    ShapeModifier.prototype.init = function(elem31, data11) {
        this.shapes = [];
        this.elem = elem31;
        this.initDynamicPropertyContainer(elem31);
        this.initModifierProperties(elem31, data11);
        this.frameId = initialDefaultFrame;
        this.closed = false;
        this.k = false;
        if (this.dynamicProperties.length) this.k = true;
        else this.getValue(true);
    };
    ShapeModifier.prototype.processKeys = function() {
        if (this.elem.globalData.frameId === this.frameId) return;
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
    };
    extendPrototype([
        DynamicPropertyContainer
    ], ShapeModifier);
    function TrimModifier() {}
    extendPrototype([
        ShapeModifier
    ], TrimModifier);
    TrimModifier.prototype.initModifierProperties = function(elem31, data11) {
        this.s = PropertyFactory.getProp(elem31, data11.s, 0, 0.01, this);
        this.e = PropertyFactory.getProp(elem31, data11.e, 0, 0.01, this);
        this.o = PropertyFactory.getProp(elem31, data11.o, 0, 0, this);
        this.sValue = 0;
        this.eValue = 0;
        this.getValue = this.processKeys;
        this.m = data11.m;
        this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
    };
    TrimModifier.prototype.addShapeToModifier = function(shapeData11) {
        shapeData11.pathsData = [];
    };
    TrimModifier.prototype.calculateShapeEdges = function(s41, e31, shapeLength11, addedLength11, totalModifierLength11) {
        var segments11 = [];
        if (e31 <= 1) segments11.push({
            s: s41,
            e: e31
        });
        else if (s41 >= 1) segments11.push({
            s: s41 - 1,
            e: e31 - 1
        });
        else {
            segments11.push({
                s: s41,
                e: 1
            });
            segments11.push({
                s: 0,
                e: e31 - 1
            });
        }
        var shapeSegments11 = [];
        var i31;
        var len11 = segments11.length;
        var segmentOb11;
        for(i31 = 0; i31 < len11; i31 += 1){
            segmentOb11 = segments11[i31];
            if (!(segmentOb11.e * totalModifierLength11 < addedLength11 || segmentOb11.s * totalModifierLength11 > addedLength11 + shapeLength11)) {
                var shapeS11;
                var shapeE11;
                if (segmentOb11.s * totalModifierLength11 <= addedLength11) shapeS11 = 0;
                else shapeS11 = (segmentOb11.s * totalModifierLength11 - addedLength11) / shapeLength11;
                if (segmentOb11.e * totalModifierLength11 >= addedLength11 + shapeLength11) shapeE11 = 1;
                else shapeE11 = (segmentOb11.e * totalModifierLength11 - addedLength11) / shapeLength11;
                shapeSegments11.push([
                    shapeS11,
                    shapeE11
                ]);
            }
        }
        if (!shapeSegments11.length) shapeSegments11.push([
            0,
            0
        ]);
        return shapeSegments11;
    };
    TrimModifier.prototype.releasePathsData = function(pathsData11) {
        var i31;
        var len11 = pathsData11.length;
        for(i31 = 0; i31 < len11; i31 += 1)segmentsLengthPool.release(pathsData11[i31]);
        pathsData11.length = 0;
        return pathsData11;
    };
    TrimModifier.prototype.processShapes = function(_isFirstFrame11) {
        var s41;
        var e31;
        if (this._mdf || _isFirstFrame11) {
            var o31 = this.o.v % 360 / 360;
            if (o31 < 0) o31 += 1;
            if (this.s.v > 1) s41 = 1 + o31;
            else if (this.s.v < 0) s41 = 0 + o31;
            else s41 = this.s.v + o31;
            if (this.e.v > 1) e31 = 1 + o31;
            else if (this.e.v < 0) e31 = 0 + o31;
            else e31 = this.e.v + o31;
            if (s41 > e31) {
                var _s11 = s41;
                s41 = e31;
                e31 = _s11;
            }
            s41 = Math.round(s41 * 10000) * 0.0001;
            e31 = Math.round(e31 * 10000) * 0.0001;
            this.sValue = s41;
            this.eValue = e31;
        } else {
            s41 = this.sValue;
            e31 = this.eValue;
        }
        var shapePaths11;
        var i31;
        var len11 = this.shapes.length;
        var j31;
        var jLen11;
        var pathsData11;
        var pathData11;
        var totalShapeLength11;
        var totalModifierLength11 = 0;
        if (e31 === s41) for(i31 = 0; i31 < len11; i31 += 1){
            this.shapes[i31].localShapeCollection.releaseShapes();
            this.shapes[i31].shape._mdf = true;
            this.shapes[i31].shape.paths = this.shapes[i31].localShapeCollection;
            if (this._mdf) this.shapes[i31].pathsData.length = 0;
        }
        else if (!(e31 === 1 && s41 === 0 || e31 === 0 && s41 === 1)) {
            var segments11 = [];
            var shapeData11;
            var localShapeCollection11;
            for(i31 = 0; i31 < len11; i31 += 1){
                shapeData11 = this.shapes[i31]; // if shape hasn't changed and trim properties haven't changed, cached previous path can be used
                if (!shapeData11.shape._mdf && !this._mdf && !_isFirstFrame11 && this.m !== 2) shapeData11.shape.paths = shapeData11.localShapeCollection;
                else {
                    shapePaths11 = shapeData11.shape.paths;
                    jLen11 = shapePaths11._length;
                    totalShapeLength11 = 0;
                    if (!shapeData11.shape._mdf && shapeData11.pathsData.length) totalShapeLength11 = shapeData11.totalShapeLength;
                    else {
                        pathsData11 = this.releasePathsData(shapeData11.pathsData);
                        for(j31 = 0; j31 < jLen11; j31 += 1){
                            pathData11 = bez.getSegmentsLength(shapePaths11.shapes[j31]);
                            pathsData11.push(pathData11);
                            totalShapeLength11 += pathData11.totalLength;
                        }
                        shapeData11.totalShapeLength = totalShapeLength11;
                        shapeData11.pathsData = pathsData11;
                    }
                    totalModifierLength11 += totalShapeLength11;
                    shapeData11.shape._mdf = true;
                }
            }
            var shapeS11 = s41;
            var shapeE11 = e31;
            var addedLength11 = 0;
            var edges11;
            for(i31 = len11 - 1; i31 >= 0; i31 -= 1){
                shapeData11 = this.shapes[i31];
                if (shapeData11.shape._mdf) {
                    localShapeCollection11 = shapeData11.localShapeCollection;
                    localShapeCollection11.releaseShapes(); // if m === 2 means paths are trimmed individually so edges need to be found for this specific shape relative to whoel group
                    if (this.m === 2 && len11 > 1) {
                        edges11 = this.calculateShapeEdges(s41, e31, shapeData11.totalShapeLength, addedLength11, totalModifierLength11);
                        addedLength11 += shapeData11.totalShapeLength;
                    } else edges11 = [
                        [
                            shapeS11,
                            shapeE11
                        ]
                    ];
                    jLen11 = edges11.length;
                    for(j31 = 0; j31 < jLen11; j31 += 1){
                        shapeS11 = edges11[j31][0];
                        shapeE11 = edges11[j31][1];
                        segments11.length = 0;
                        if (shapeE11 <= 1) segments11.push({
                            s: shapeData11.totalShapeLength * shapeS11,
                            e: shapeData11.totalShapeLength * shapeE11
                        });
                        else if (shapeS11 >= 1) segments11.push({
                            s: shapeData11.totalShapeLength * (shapeS11 - 1),
                            e: shapeData11.totalShapeLength * (shapeE11 - 1)
                        });
                        else {
                            segments11.push({
                                s: shapeData11.totalShapeLength * shapeS11,
                                e: shapeData11.totalShapeLength
                            });
                            segments11.push({
                                s: 0,
                                e: shapeData11.totalShapeLength * (shapeE11 - 1)
                            });
                        }
                        var newShapesData11 = this.addShapes(shapeData11, segments11[0]);
                        if (segments11[0].s !== segments11[0].e) {
                            if (segments11.length > 1) {
                                var lastShapeInCollection11 = shapeData11.shape.paths.shapes[shapeData11.shape.paths._length - 1];
                                if (lastShapeInCollection11.c) {
                                    var lastShape11 = newShapesData11.pop();
                                    this.addPaths(newShapesData11, localShapeCollection11);
                                    newShapesData11 = this.addShapes(shapeData11, segments11[1], lastShape11);
                                } else {
                                    this.addPaths(newShapesData11, localShapeCollection11);
                                    newShapesData11 = this.addShapes(shapeData11, segments11[1]);
                                }
                            }
                            this.addPaths(newShapesData11, localShapeCollection11);
                        }
                    }
                    shapeData11.shape.paths = localShapeCollection11;
                }
            }
        } else if (this._mdf) for(i31 = 0; i31 < len11; i31 += 1){
            // Releasign Trim Cached paths data when no trim applied in case shapes are modified inbetween.
            // Don't remove this even if it's losing cached info.
            this.shapes[i31].pathsData.length = 0;
            this.shapes[i31].shape._mdf = true;
        }
    };
    TrimModifier.prototype.addPaths = function(newPaths11, localShapeCollection11) {
        var i31;
        var len11 = newPaths11.length;
        for(i31 = 0; i31 < len11; i31 += 1)localShapeCollection11.addShape(newPaths11[i31]);
    };
    TrimModifier.prototype.addSegment = function(pt111, pt211, pt311, pt411, shapePath11, pos11, newShape11) {
        shapePath11.setXYAt(pt211[0], pt211[1], "o", pos11);
        shapePath11.setXYAt(pt311[0], pt311[1], "i", pos11 + 1);
        if (newShape11) shapePath11.setXYAt(pt111[0], pt111[1], "v", pos11);
        shapePath11.setXYAt(pt411[0], pt411[1], "v", pos11 + 1);
    };
    TrimModifier.prototype.addSegmentFromArray = function(points11, shapePath11, pos11, newShape11) {
        shapePath11.setXYAt(points11[1], points11[5], "o", pos11);
        shapePath11.setXYAt(points11[2], points11[6], "i", pos11 + 1);
        if (newShape11) shapePath11.setXYAt(points11[0], points11[4], "v", pos11);
        shapePath11.setXYAt(points11[3], points11[7], "v", pos11 + 1);
    };
    TrimModifier.prototype.addShapes = function(shapeData11, shapeSegment11, shapePath11) {
        var pathsData11 = shapeData11.pathsData;
        var shapePaths11 = shapeData11.shape.paths.shapes;
        var i31;
        var len11 = shapeData11.shape.paths._length;
        var j31;
        var jLen11;
        var addedLength11 = 0;
        var currentLengthData11;
        var segmentCount11;
        var lengths11;
        var segment11;
        var shapes11 = [];
        var initPos11;
        var newShape11 = true;
        if (!shapePath11) {
            shapePath11 = shapePool.newElement();
            segmentCount11 = 0;
            initPos11 = 0;
        } else {
            segmentCount11 = shapePath11._length;
            initPos11 = shapePath11._length;
        }
        shapes11.push(shapePath11);
        for(i31 = 0; i31 < len11; i31 += 1){
            lengths11 = pathsData11[i31].lengths;
            shapePath11.c = shapePaths11[i31].c;
            jLen11 = shapePaths11[i31].c ? lengths11.length : lengths11.length + 1;
            for(j31 = 1; j31 < jLen11; j31 += 1){
                currentLengthData11 = lengths11[j31 - 1];
                if (addedLength11 + currentLengthData11.addedLength < shapeSegment11.s) {
                    addedLength11 += currentLengthData11.addedLength;
                    shapePath11.c = false;
                } else if (addedLength11 > shapeSegment11.e) {
                    shapePath11.c = false;
                    break;
                } else {
                    if (shapeSegment11.s <= addedLength11 && shapeSegment11.e >= addedLength11 + currentLengthData11.addedLength) {
                        this.addSegment(shapePaths11[i31].v[j31 - 1], shapePaths11[i31].o[j31 - 1], shapePaths11[i31].i[j31], shapePaths11[i31].v[j31], shapePath11, segmentCount11, newShape11);
                        newShape11 = false;
                    } else {
                        segment11 = bez.getNewSegment(shapePaths11[i31].v[j31 - 1], shapePaths11[i31].v[j31], shapePaths11[i31].o[j31 - 1], shapePaths11[i31].i[j31], (shapeSegment11.s - addedLength11) / currentLengthData11.addedLength, (shapeSegment11.e - addedLength11) / currentLengthData11.addedLength, lengths11[j31 - 1]);
                        this.addSegmentFromArray(segment11, shapePath11, segmentCount11, newShape11); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
                        newShape11 = false;
                        shapePath11.c = false;
                    }
                    addedLength11 += currentLengthData11.addedLength;
                    segmentCount11 += 1;
                }
            }
            if (shapePaths11[i31].c && lengths11.length) {
                currentLengthData11 = lengths11[j31 - 1];
                if (addedLength11 <= shapeSegment11.e) {
                    var segmentLength11 = lengths11[j31 - 1].addedLength;
                    if (shapeSegment11.s <= addedLength11 && shapeSegment11.e >= addedLength11 + segmentLength11) {
                        this.addSegment(shapePaths11[i31].v[j31 - 1], shapePaths11[i31].o[j31 - 1], shapePaths11[i31].i[0], shapePaths11[i31].v[0], shapePath11, segmentCount11, newShape11);
                        newShape11 = false;
                    } else {
                        segment11 = bez.getNewSegment(shapePaths11[i31].v[j31 - 1], shapePaths11[i31].v[0], shapePaths11[i31].o[j31 - 1], shapePaths11[i31].i[0], (shapeSegment11.s - addedLength11) / segmentLength11, (shapeSegment11.e - addedLength11) / segmentLength11, lengths11[j31 - 1]);
                        this.addSegmentFromArray(segment11, shapePath11, segmentCount11, newShape11); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
                        newShape11 = false;
                        shapePath11.c = false;
                    }
                } else shapePath11.c = false;
                addedLength11 += currentLengthData11.addedLength;
                segmentCount11 += 1;
            }
            if (shapePath11._length) {
                shapePath11.setXYAt(shapePath11.v[initPos11][0], shapePath11.v[initPos11][1], "i", initPos11);
                shapePath11.setXYAt(shapePath11.v[shapePath11._length - 1][0], shapePath11.v[shapePath11._length - 1][1], "o", shapePath11._length - 1);
            }
            if (addedLength11 > shapeSegment11.e) break;
            if (i31 < len11 - 1) {
                shapePath11 = shapePool.newElement();
                newShape11 = true;
                shapes11.push(shapePath11);
                segmentCount11 = 0;
            }
        }
        return shapes11;
    };
    function PuckerAndBloatModifier() {}
    extendPrototype([
        ShapeModifier
    ], PuckerAndBloatModifier);
    PuckerAndBloatModifier.prototype.initModifierProperties = function(elem31, data11) {
        this.getValue = this.processKeys;
        this.amount = PropertyFactory.getProp(elem31, data11.a, 0, null, this);
        this._isAnimated = !!this.amount.effectsSequence.length;
    };
    PuckerAndBloatModifier.prototype.processPath = function(path11, amount11) {
        var percent11 = amount11 / 100;
        var centerPoint11 = [
            0,
            0
        ];
        var pathLength11 = path11._length;
        var i31 = 0;
        for(i31 = 0; i31 < pathLength11; i31 += 1){
            centerPoint11[0] += path11.v[i31][0];
            centerPoint11[1] += path11.v[i31][1];
        }
        centerPoint11[0] /= pathLength11;
        centerPoint11[1] /= pathLength11;
        var clonedPath11 = shapePool.newElement();
        clonedPath11.c = path11.c;
        var vX11;
        var vY11;
        var oX11;
        var oY11;
        var iX11;
        var iY11;
        for(i31 = 0; i31 < pathLength11; i31 += 1){
            vX11 = path11.v[i31][0] + (centerPoint11[0] - path11.v[i31][0]) * percent11;
            vY11 = path11.v[i31][1] + (centerPoint11[1] - path11.v[i31][1]) * percent11;
            oX11 = path11.o[i31][0] + (centerPoint11[0] - path11.o[i31][0]) * -percent11;
            oY11 = path11.o[i31][1] + (centerPoint11[1] - path11.o[i31][1]) * -percent11;
            iX11 = path11.i[i31][0] + (centerPoint11[0] - path11.i[i31][0]) * -percent11;
            iY11 = path11.i[i31][1] + (centerPoint11[1] - path11.i[i31][1]) * -percent11;
            clonedPath11.setTripleAt(vX11, vY11, oX11, oY11, iX11, iY11, i31);
        }
        return clonedPath11;
    };
    PuckerAndBloatModifier.prototype.processShapes = function(_isFirstFrame11) {
        var shapePaths11;
        var i31;
        var len11 = this.shapes.length;
        var j31;
        var jLen11;
        var amount11 = this.amount.v;
        if (amount11 !== 0) {
            var shapeData11;
            var localShapeCollection11;
            for(i31 = 0; i31 < len11; i31 += 1){
                shapeData11 = this.shapes[i31];
                localShapeCollection11 = shapeData11.localShapeCollection;
                if (!(!shapeData11.shape._mdf && !this._mdf && !_isFirstFrame11)) {
                    localShapeCollection11.releaseShapes();
                    shapeData11.shape._mdf = true;
                    shapePaths11 = shapeData11.shape.paths.shapes;
                    jLen11 = shapeData11.shape.paths._length;
                    for(j31 = 0; j31 < jLen11; j31 += 1)localShapeCollection11.addShape(this.processPath(shapePaths11[j31], amount11));
                }
                shapeData11.shape.paths = shapeData11.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    var TransformPropertyFactory = function() {
        var defaultVector11 = [
            0,
            0
        ];
        function applyToMatrix11(mat11) {
            var _mdf11 = this._mdf;
            this.iterateDynamicProperties();
            this._mdf = this._mdf || _mdf11;
            if (this.a) mat11.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
            if (this.s) mat11.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
            if (this.sk) mat11.skewFromAxis(-this.sk.v, this.sa.v);
            if (this.r) mat11.rotate(-this.r.v);
            else mat11.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
            if (this.data.p.s) {
                if (this.data.p.z) mat11.translate(this.px.v, this.py.v, -this.pz.v);
                else mat11.translate(this.px.v, this.py.v, 0);
            } else mat11.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
        }
        function processKeys11(forceRender11) {
            if (this.elem.globalData.frameId === this.frameId) return;
            if (this._isDirty) {
                this.precalculateMatrix();
                this._isDirty = false;
            }
            this.iterateDynamicProperties();
            if (this._mdf || forceRender11) {
                var frameRate11;
                this.v.cloneFromProps(this.pre.props);
                if (this.appliedTransformations < 1) this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
                if (this.appliedTransformations < 2) this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
                if (this.sk && this.appliedTransformations < 3) this.v.skewFromAxis(-this.sk.v, this.sa.v);
                if (this.r && this.appliedTransformations < 4) this.v.rotate(-this.r.v);
                else if (!this.r && this.appliedTransformations < 4) this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
                if (this.autoOriented) {
                    var v111;
                    var v211;
                    frameRate11 = this.elem.globalData.frameRate;
                    if (this.p && this.p.keyframes && this.p.getValueAtTime) {
                        if (this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t) {
                            v111 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / frameRate11, 0);
                            v211 = this.p.getValueAtTime(this.p.keyframes[0].t / frameRate11, 0);
                        } else if (this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
                            v111 = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / frameRate11, 0);
                            v211 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / frameRate11, 0);
                        } else {
                            v111 = this.p.pv;
                            v211 = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / frameRate11, this.p.offsetTime);
                        }
                    } else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                        v111 = [];
                        v211 = [];
                        var px11 = this.px;
                        var py11 = this.py;
                        if (px11._caching.lastFrame + px11.offsetTime <= px11.keyframes[0].t) {
                            v111[0] = px11.getValueAtTime((px11.keyframes[0].t + 0.01) / frameRate11, 0);
                            v111[1] = py11.getValueAtTime((py11.keyframes[0].t + 0.01) / frameRate11, 0);
                            v211[0] = px11.getValueAtTime(px11.keyframes[0].t / frameRate11, 0);
                            v211[1] = py11.getValueAtTime(py11.keyframes[0].t / frameRate11, 0);
                        } else if (px11._caching.lastFrame + px11.offsetTime >= px11.keyframes[px11.keyframes.length - 1].t) {
                            v111[0] = px11.getValueAtTime(px11.keyframes[px11.keyframes.length - 1].t / frameRate11, 0);
                            v111[1] = py11.getValueAtTime(py11.keyframes[py11.keyframes.length - 1].t / frameRate11, 0);
                            v211[0] = px11.getValueAtTime((px11.keyframes[px11.keyframes.length - 1].t - 0.01) / frameRate11, 0);
                            v211[1] = py11.getValueAtTime((py11.keyframes[py11.keyframes.length - 1].t - 0.01) / frameRate11, 0);
                        } else {
                            v111 = [
                                px11.pv,
                                py11.pv
                            ];
                            v211[0] = px11.getValueAtTime((px11._caching.lastFrame + px11.offsetTime - 0.01) / frameRate11, px11.offsetTime);
                            v211[1] = py11.getValueAtTime((py11._caching.lastFrame + py11.offsetTime - 0.01) / frameRate11, py11.offsetTime);
                        }
                    } else {
                        v211 = defaultVector11;
                        v111 = v211;
                    }
                    this.v.rotate(-Math.atan2(v111[1] - v211[1], v111[0] - v211[0]));
                }
                if (this.data.p && this.data.p.s) {
                    if (this.data.p.z) this.v.translate(this.px.v, this.py.v, -this.pz.v);
                    else this.v.translate(this.px.v, this.py.v, 0);
                } else this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
            }
            this.frameId = this.elem.globalData.frameId;
        }
        function precalculateMatrix11() {
            this.appliedTransformations = 0;
            this.pre.reset();
            if (!this.a.effectsSequence.length) {
                this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
                this.appliedTransformations = 1;
            } else return;
            if (!this.s.effectsSequence.length) {
                this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
                this.appliedTransformations = 2;
            } else return;
            if (this.sk) {
                if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length) {
                    this.pre.skewFromAxis(-this.sk.v, this.sa.v);
                    this.appliedTransformations = 3;
                } else return;
            }
            if (this.r) {
                if (!this.r.effectsSequence.length) {
                    this.pre.rotate(-this.r.v);
                    this.appliedTransformations = 4;
                }
            } else if (!this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length) {
                this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
                this.appliedTransformations = 4;
            }
        }
        function autoOrient11() {
        // var prevP = this.getValueAtTime();
        }
        function addDynamicProperty11(prop11) {
            this._addDynamicProperty(prop11);
            this.elem.addDynamicProperty(prop11);
            this._isDirty = true;
        }
        function TransformProperty11(elem31, data11, container11) {
            this.elem = elem31;
            this.frameId = -1;
            this.propType = "transform";
            this.data = data11;
            this.v = new Matrix(); // Precalculated matrix with non animated properties
            this.pre = new Matrix();
            this.appliedTransformations = 0;
            this.initDynamicPropertyContainer(container11 || elem31);
            if (data11.p && data11.p.s) {
                this.px = PropertyFactory.getProp(elem31, data11.p.x, 0, 0, this);
                this.py = PropertyFactory.getProp(elem31, data11.p.y, 0, 0, this);
                if (data11.p.z) this.pz = PropertyFactory.getProp(elem31, data11.p.z, 0, 0, this);
            } else this.p = PropertyFactory.getProp(elem31, data11.p || {
                k: [
                    0,
                    0,
                    0
                ]
            }, 1, 0, this);
            if (data11.rx) {
                this.rx = PropertyFactory.getProp(elem31, data11.rx, 0, degToRads, this);
                this.ry = PropertyFactory.getProp(elem31, data11.ry, 0, degToRads, this);
                this.rz = PropertyFactory.getProp(elem31, data11.rz, 0, degToRads, this);
                if (data11.or.k[0].ti) {
                    var i31;
                    var len11 = data11.or.k.length;
                    for(i31 = 0; i31 < len11; i31 += 1){
                        data11.or.k[i31].to = null;
                        data11.or.k[i31].ti = null;
                    }
                }
                this.or = PropertyFactory.getProp(elem31, data11.or, 1, degToRads, this); // sh Indicates it needs to be capped between -180 and 180
                this.or.sh = true;
            } else this.r = PropertyFactory.getProp(elem31, data11.r || {
                k: 0
            }, 0, degToRads, this);
            if (data11.sk) {
                this.sk = PropertyFactory.getProp(elem31, data11.sk, 0, degToRads, this);
                this.sa = PropertyFactory.getProp(elem31, data11.sa, 0, degToRads, this);
            }
            this.a = PropertyFactory.getProp(elem31, data11.a || {
                k: [
                    0,
                    0,
                    0
                ]
            }, 1, 0, this);
            this.s = PropertyFactory.getProp(elem31, data11.s || {
                k: [
                    100,
                    100,
                    100
                ]
            }, 1, 0.01, this); // Opacity is not part of the transform properties, that's why it won't use this.dynamicProperties. That way transforms won't get updated if opacity changes.
            if (data11.o) this.o = PropertyFactory.getProp(elem31, data11.o, 0, 0.01, elem31);
            else this.o = {
                _mdf: false,
                v: 1
            };
            this._isDirty = true;
            if (!this.dynamicProperties.length) this.getValue(true);
        }
        TransformProperty11.prototype = {
            applyToMatrix: applyToMatrix11,
            getValue: processKeys11,
            precalculateMatrix: precalculateMatrix11,
            autoOrient: autoOrient11
        };
        extendPrototype([
            DynamicPropertyContainer
        ], TransformProperty11);
        TransformProperty11.prototype.addDynamicProperty = addDynamicProperty11;
        TransformProperty11.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;
        function getTransformProperty11(elem31, data11, container11) {
            return new TransformProperty11(elem31, data11, container11);
        }
        return {
            getTransformProperty: getTransformProperty11
        };
    }();
    function RepeaterModifier() {}
    extendPrototype([
        ShapeModifier
    ], RepeaterModifier);
    RepeaterModifier.prototype.initModifierProperties = function(elem31, data11) {
        this.getValue = this.processKeys;
        this.c = PropertyFactory.getProp(elem31, data11.c, 0, null, this);
        this.o = PropertyFactory.getProp(elem31, data11.o, 0, null, this);
        this.tr = TransformPropertyFactory.getTransformProperty(elem31, data11.tr, this);
        this.so = PropertyFactory.getProp(elem31, data11.tr.so, 0, 0.01, this);
        this.eo = PropertyFactory.getProp(elem31, data11.tr.eo, 0, 0.01, this);
        this.data = data11;
        if (!this.dynamicProperties.length) this.getValue(true);
        this._isAnimated = !!this.dynamicProperties.length;
        this.pMatrix = new Matrix();
        this.rMatrix = new Matrix();
        this.sMatrix = new Matrix();
        this.tMatrix = new Matrix();
        this.matrix = new Matrix();
    };
    RepeaterModifier.prototype.applyTransforms = function(pMatrix11, rMatrix11, sMatrix11, transform11, perc11, inv11) {
        var dir11 = inv11 ? -1 : 1;
        var scaleX11 = transform11.s.v[0] + (1 - transform11.s.v[0]) * (1 - perc11);
        var scaleY11 = transform11.s.v[1] + (1 - transform11.s.v[1]) * (1 - perc11);
        pMatrix11.translate(transform11.p.v[0] * dir11 * perc11, transform11.p.v[1] * dir11 * perc11, transform11.p.v[2]);
        rMatrix11.translate(-transform11.a.v[0], -transform11.a.v[1], transform11.a.v[2]);
        rMatrix11.rotate(-transform11.r.v * dir11 * perc11);
        rMatrix11.translate(transform11.a.v[0], transform11.a.v[1], transform11.a.v[2]);
        sMatrix11.translate(-transform11.a.v[0], -transform11.a.v[1], transform11.a.v[2]);
        sMatrix11.scale(inv11 ? 1 / scaleX11 : scaleX11, inv11 ? 1 / scaleY11 : scaleY11);
        sMatrix11.translate(transform11.a.v[0], transform11.a.v[1], transform11.a.v[2]);
    };
    RepeaterModifier.prototype.init = function(elem31, arr31, pos11, elemsData11) {
        this.elem = elem31;
        this.arr = arr31;
        this.pos = pos11;
        this.elemsData = elemsData11;
        this._currentCopies = 0;
        this._elements = [];
        this._groups = [];
        this.frameId = -1;
        this.initDynamicPropertyContainer(elem31);
        this.initModifierProperties(elem31, arr31[pos11]);
        while(pos11 > 0){
            pos11 -= 1; // this._elements.unshift(arr.splice(pos,1)[0]);
            this._elements.unshift(arr31[pos11]);
        }
        if (this.dynamicProperties.length) this.k = true;
        else this.getValue(true);
    };
    RepeaterModifier.prototype.resetElements = function(elements11) {
        var i31;
        var len11 = elements11.length;
        for(i31 = 0; i31 < len11; i31 += 1){
            elements11[i31]._processed = false;
            if (elements11[i31].ty === "gr") this.resetElements(elements11[i31].it);
        }
    };
    RepeaterModifier.prototype.cloneElements = function(elements11) {
        var newElements11 = JSON.parse(JSON.stringify(elements11));
        this.resetElements(newElements11);
        return newElements11;
    };
    RepeaterModifier.prototype.changeGroupRender = function(elements11, renderFlag11) {
        var i31;
        var len11 = elements11.length;
        for(i31 = 0; i31 < len11; i31 += 1){
            elements11[i31]._render = renderFlag11;
            if (elements11[i31].ty === "gr") this.changeGroupRender(elements11[i31].it, renderFlag11);
        }
    };
    RepeaterModifier.prototype.processShapes = function(_isFirstFrame11) {
        var items11;
        var itemsTransform11;
        var i31;
        var dir11;
        var cont11;
        var hasReloaded11 = false;
        if (this._mdf || _isFirstFrame11) {
            var copies11 = Math.ceil(this.c.v);
            if (this._groups.length < copies11) {
                while(this._groups.length < copies11){
                    var group11 = {
                        it: this.cloneElements(this._elements),
                        ty: "gr"
                    };
                    group11.it.push({
                        a: {
                            a: 0,
                            ix: 1,
                            k: [
                                0,
                                0
                            ]
                        },
                        nm: "Transform",
                        o: {
                            a: 0,
                            ix: 7,
                            k: 100
                        },
                        p: {
                            a: 0,
                            ix: 2,
                            k: [
                                0,
                                0
                            ]
                        },
                        r: {
                            a: 1,
                            ix: 6,
                            k: [
                                {
                                    s: 0,
                                    e: 0,
                                    t: 0
                                },
                                {
                                    s: 0,
                                    e: 0,
                                    t: 1
                                }
                            ]
                        },
                        s: {
                            a: 0,
                            ix: 3,
                            k: [
                                100,
                                100
                            ]
                        },
                        sa: {
                            a: 0,
                            ix: 5,
                            k: 0
                        },
                        sk: {
                            a: 0,
                            ix: 4,
                            k: 0
                        },
                        ty: "tr"
                    });
                    this.arr.splice(0, 0, group11);
                    this._groups.splice(0, 0, group11);
                    this._currentCopies += 1;
                }
                this.elem.reloadShapes();
                hasReloaded11 = true;
            }
            cont11 = 0;
            var renderFlag11;
            for(i31 = 0; i31 <= this._groups.length - 1; i31 += 1){
                renderFlag11 = cont11 < copies11;
                this._groups[i31]._render = renderFlag11;
                this.changeGroupRender(this._groups[i31].it, renderFlag11);
                if (!renderFlag11) {
                    var elems11 = this.elemsData[i31].it;
                    var transformData11 = elems11[elems11.length - 1];
                    if (transformData11.transform.op.v !== 0) {
                        transformData11.transform.op._mdf = true;
                        transformData11.transform.op.v = 0;
                    } else transformData11.transform.op._mdf = false;
                }
                cont11 += 1;
            }
            this._currentCopies = copies11; /// /
            var offset11 = this.o.v;
            var offsetModulo11 = offset11 % 1;
            var roundOffset11 = offset11 > 0 ? Math.floor(offset11) : Math.ceil(offset11);
            var pProps11 = this.pMatrix.props;
            var rProps11 = this.rMatrix.props;
            var sProps11 = this.sMatrix.props;
            this.pMatrix.reset();
            this.rMatrix.reset();
            this.sMatrix.reset();
            this.tMatrix.reset();
            this.matrix.reset();
            var iteration11 = 0;
            if (offset11 > 0) {
                while(iteration11 < roundOffset11){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                    iteration11 += 1;
                }
                if (offsetModulo11) {
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo11, false);
                    iteration11 += offsetModulo11;
                }
            } else if (offset11 < 0) {
                while(iteration11 > roundOffset11){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
                    iteration11 -= 1;
                }
                if (offsetModulo11) {
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -offsetModulo11, true);
                    iteration11 -= offsetModulo11;
                }
            }
            i31 = this.data.m === 1 ? 0 : this._currentCopies - 1;
            dir11 = this.data.m === 1 ? 1 : -1;
            cont11 = this._currentCopies;
            var j31;
            var jLen11;
            while(cont11){
                items11 = this.elemsData[i31].it;
                itemsTransform11 = items11[items11.length - 1].transform.mProps.v.props;
                jLen11 = itemsTransform11.length;
                items11[items11.length - 1].transform.mProps._mdf = true;
                items11[items11.length - 1].transform.op._mdf = true;
                items11[items11.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i31 / (this._currentCopies - 1));
                if (iteration11 !== 0) {
                    if (i31 !== 0 && dir11 === 1 || i31 !== this._currentCopies - 1 && dir11 === -1) this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                    this.matrix.transform(rProps11[0], rProps11[1], rProps11[2], rProps11[3], rProps11[4], rProps11[5], rProps11[6], rProps11[7], rProps11[8], rProps11[9], rProps11[10], rProps11[11], rProps11[12], rProps11[13], rProps11[14], rProps11[15]);
                    this.matrix.transform(sProps11[0], sProps11[1], sProps11[2], sProps11[3], sProps11[4], sProps11[5], sProps11[6], sProps11[7], sProps11[8], sProps11[9], sProps11[10], sProps11[11], sProps11[12], sProps11[13], sProps11[14], sProps11[15]);
                    this.matrix.transform(pProps11[0], pProps11[1], pProps11[2], pProps11[3], pProps11[4], pProps11[5], pProps11[6], pProps11[7], pProps11[8], pProps11[9], pProps11[10], pProps11[11], pProps11[12], pProps11[13], pProps11[14], pProps11[15]);
                    for(j31 = 0; j31 < jLen11; j31 += 1)itemsTransform11[j31] = this.matrix.props[j31];
                    this.matrix.reset();
                } else {
                    this.matrix.reset();
                    for(j31 = 0; j31 < jLen11; j31 += 1)itemsTransform11[j31] = this.matrix.props[j31];
                }
                iteration11 += 1;
                cont11 -= 1;
                i31 += dir11;
            }
        } else {
            cont11 = this._currentCopies;
            i31 = 0;
            dir11 = 1;
            while(cont11){
                items11 = this.elemsData[i31].it;
                itemsTransform11 = items11[items11.length - 1].transform.mProps.v.props;
                items11[items11.length - 1].transform.mProps._mdf = false;
                items11[items11.length - 1].transform.op._mdf = false;
                cont11 -= 1;
                i31 += dir11;
            }
        }
        return hasReloaded11;
    };
    RepeaterModifier.prototype.addShape = function() {};
    function RoundCornersModifier() {}
    extendPrototype([
        ShapeModifier
    ], RoundCornersModifier);
    RoundCornersModifier.prototype.initModifierProperties = function(elem31, data11) {
        this.getValue = this.processKeys;
        this.rd = PropertyFactory.getProp(elem31, data11.r, 0, null, this);
        this._isAnimated = !!this.rd.effectsSequence.length;
    };
    RoundCornersModifier.prototype.processPath = function(path11, round11) {
        var clonedPath11 = shapePool.newElement();
        clonedPath11.c = path11.c;
        var i31;
        var len11 = path11._length;
        var currentV11;
        var currentI11;
        var currentO11;
        var closerV11;
        var distance11;
        var newPosPerc11;
        var index11 = 0;
        var vX11;
        var vY11;
        var oX11;
        var oY11;
        var iX11;
        var iY11;
        for(i31 = 0; i31 < len11; i31 += 1){
            currentV11 = path11.v[i31];
            currentO11 = path11.o[i31];
            currentI11 = path11.i[i31];
            if (currentV11[0] === currentO11[0] && currentV11[1] === currentO11[1] && currentV11[0] === currentI11[0] && currentV11[1] === currentI11[1]) {
                if ((i31 === 0 || i31 === len11 - 1) && !path11.c) {
                    clonedPath11.setTripleAt(currentV11[0], currentV11[1], currentO11[0], currentO11[1], currentI11[0], currentI11[1], index11);
                    /* clonedPath.v[index] = currentV;
                  clonedPath.o[index] = currentO;
                  clonedPath.i[index] = currentI; */ index11 += 1;
                } else {
                    if (i31 === 0) closerV11 = path11.v[len11 - 1];
                    else closerV11 = path11.v[i31 - 1];
                    distance11 = Math.sqrt(Math.pow(currentV11[0] - closerV11[0], 2) + Math.pow(currentV11[1] - closerV11[1], 2));
                    newPosPerc11 = distance11 ? Math.min(distance11 / 2, round11) / distance11 : 0;
                    iX11 = currentV11[0] + (closerV11[0] - currentV11[0]) * newPosPerc11;
                    vX11 = iX11;
                    iY11 = currentV11[1] - (currentV11[1] - closerV11[1]) * newPosPerc11;
                    vY11 = iY11;
                    oX11 = vX11 - (vX11 - currentV11[0]) * roundCorner;
                    oY11 = vY11 - (vY11 - currentV11[1]) * roundCorner;
                    clonedPath11.setTripleAt(vX11, vY11, oX11, oY11, iX11, iY11, index11);
                    index11 += 1;
                    if (i31 === len11 - 1) closerV11 = path11.v[0];
                    else closerV11 = path11.v[i31 + 1];
                    distance11 = Math.sqrt(Math.pow(currentV11[0] - closerV11[0], 2) + Math.pow(currentV11[1] - closerV11[1], 2));
                    newPosPerc11 = distance11 ? Math.min(distance11 / 2, round11) / distance11 : 0;
                    oX11 = currentV11[0] + (closerV11[0] - currentV11[0]) * newPosPerc11;
                    vX11 = oX11;
                    oY11 = currentV11[1] + (closerV11[1] - currentV11[1]) * newPosPerc11;
                    vY11 = oY11;
                    iX11 = vX11 - (vX11 - currentV11[0]) * roundCorner;
                    iY11 = vY11 - (vY11 - currentV11[1]) * roundCorner;
                    clonedPath11.setTripleAt(vX11, vY11, oX11, oY11, iX11, iY11, index11);
                    index11 += 1;
                }
            } else {
                clonedPath11.setTripleAt(path11.v[i31][0], path11.v[i31][1], path11.o[i31][0], path11.o[i31][1], path11.i[i31][0], path11.i[i31][1], index11);
                index11 += 1;
            }
        }
        return clonedPath11;
    };
    RoundCornersModifier.prototype.processShapes = function(_isFirstFrame11) {
        var shapePaths11;
        var i31;
        var len11 = this.shapes.length;
        var j31;
        var jLen11;
        var rd11 = this.rd.v;
        if (rd11 !== 0) {
            var shapeData11;
            var localShapeCollection11;
            for(i31 = 0; i31 < len11; i31 += 1){
                shapeData11 = this.shapes[i31];
                localShapeCollection11 = shapeData11.localShapeCollection;
                if (!(!shapeData11.shape._mdf && !this._mdf && !_isFirstFrame11)) {
                    localShapeCollection11.releaseShapes();
                    shapeData11.shape._mdf = true;
                    shapePaths11 = shapeData11.shape.paths.shapes;
                    jLen11 = shapeData11.shape.paths._length;
                    for(j31 = 0; j31 < jLen11; j31 += 1)localShapeCollection11.addShape(this.processPath(shapePaths11[j31], rd11));
                }
                shapeData11.shape.paths = shapeData11.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function floatEqual(a31, b31) {
        return Math.abs(a31 - b31) * 100000 <= Math.min(Math.abs(a31), Math.abs(b31));
    }
    function floatZero(f31) {
        return Math.abs(f31) <= 0.00001;
    }
    function lerp(p011, p141, amount11) {
        return p011 * (1 - amount11) + p141 * amount11;
    }
    function lerpPoint(p011, p141, amount11) {
        return [
            lerp(p011[0], p141[0], amount11),
            lerp(p011[1], p141[1], amount11)
        ];
    }
    function quadRoots(a31, b31, c41) {
        // no root
        if (a31 === 0) return [];
        var s41 = b31 * b31 - 4 * a31 * c41; // Complex roots
        if (s41 < 0) return [];
        var singleRoot11 = -b31 / (2 * a31); // 1 root
        if (s41 === 0) return [
            singleRoot11
        ];
        var delta11 = Math.sqrt(s41) / (2 * a31); // 2 roots
        return [
            singleRoot11 - delta11,
            singleRoot11 + delta11
        ];
    }
    function polynomialCoefficients(p011, p141, p221, p311) {
        return [
            -p011 + 3 * p141 - 3 * p221 + p311,
            3 * p011 - 6 * p141 + 3 * p221,
            -3 * p011 + 3 * p141,
            p011
        ];
    }
    function singlePoint(p61) {
        return new PolynomialBezier(p61, p61, p61, p61, false);
    }
    function PolynomialBezier(p011, p141, p221, p311, linearize11) {
        if (linearize11 && pointEqual(p011, p141)) p141 = lerpPoint(p011, p311, 1 / 3);
        if (linearize11 && pointEqual(p221, p311)) p221 = lerpPoint(p011, p311, 2 / 3);
        var coeffx11 = polynomialCoefficients(p011[0], p141[0], p221[0], p311[0]);
        var coeffy11 = polynomialCoefficients(p011[1], p141[1], p221[1], p311[1]);
        this.a = [
            coeffx11[0],
            coeffy11[0]
        ];
        this.b = [
            coeffx11[1],
            coeffy11[1]
        ];
        this.c = [
            coeffx11[2],
            coeffy11[2]
        ];
        this.d = [
            coeffx11[3],
            coeffy11[3]
        ];
        this.points = [
            p011,
            p141,
            p221,
            p311
        ];
    }
    PolynomialBezier.prototype.point = function(t31) {
        return [
            ((this.a[0] * t31 + this.b[0]) * t31 + this.c[0]) * t31 + this.d[0],
            ((this.a[1] * t31 + this.b[1]) * t31 + this.c[1]) * t31 + this.d[1]
        ];
    };
    PolynomialBezier.prototype.derivative = function(t31) {
        return [
            (3 * t31 * this.a[0] + 2 * this.b[0]) * t31 + this.c[0],
            (3 * t31 * this.a[1] + 2 * this.b[1]) * t31 + this.c[1]
        ];
    };
    PolynomialBezier.prototype.tangentAngle = function(t31) {
        var p61 = this.derivative(t31);
        return Math.atan2(p61[1], p61[0]);
    };
    PolynomialBezier.prototype.normalAngle = function(t31) {
        var p61 = this.derivative(t31);
        return Math.atan2(p61[0], p61[1]);
    };
    PolynomialBezier.prototype.inflectionPoints = function() {
        var denom11 = this.a[1] * this.b[0] - this.a[0] * this.b[1];
        if (floatZero(denom11)) return [];
        var tcusp11 = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / denom11;
        var square11 = tcusp11 * tcusp11 - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / denom11;
        if (square11 < 0) return [];
        var root11 = Math.sqrt(square11);
        if (floatZero(root11)) {
            if (root11 > 0 && root11 < 1) return [
                tcusp11
            ];
            return [];
        }
        return [
            tcusp11 - root11,
            tcusp11 + root11
        ].filter(function(r11) {
            return r11 > 0 && r11 < 1;
        });
    };
    PolynomialBezier.prototype.split = function(t31) {
        if (t31 <= 0) return [
            singlePoint(this.points[0]),
            this
        ];
        if (t31 >= 1) return [
            this,
            singlePoint(this.points[this.points.length - 1])
        ];
        var p1011 = lerpPoint(this.points[0], this.points[1], t31);
        var p1111 = lerpPoint(this.points[1], this.points[2], t31);
        var p1211 = lerpPoint(this.points[2], this.points[3], t31);
        var p2011 = lerpPoint(p1011, p1111, t31);
        var p2111 = lerpPoint(p1111, p1211, t31);
        var p311 = lerpPoint(p2011, p2111, t31);
        return [
            new PolynomialBezier(this.points[0], p1011, p2011, p311, true),
            new PolynomialBezier(p311, p2111, p1211, this.points[3], true)
        ];
    };
    function extrema(bez11, comp11) {
        var min11 = bez11.points[0][comp11];
        var max11 = bez11.points[bez11.points.length - 1][comp11];
        if (min11 > max11) {
            var e31 = max11;
            max11 = min11;
            min11 = e31;
        } // Derivative roots to find min/max
        var f31 = quadRoots(3 * bez11.a[comp11], 2 * bez11.b[comp11], bez11.c[comp11]);
        for(var i31 = 0; i31 < f31.length; i31 += 1)if (f31[i31] > 0 && f31[i31] < 1) {
            var val31 = bez11.point(f31[i31])[comp11];
            if (val31 < min11) min11 = val31;
            else if (val31 > max11) max11 = val31;
        }
        return {
            min: min11,
            max: max11
        };
    }
    PolynomialBezier.prototype.bounds = function() {
        return {
            x: extrema(this, 0),
            y: extrema(this, 1)
        };
    };
    PolynomialBezier.prototype.boundingBox = function() {
        var bounds11 = this.bounds();
        return {
            left: bounds11.x.min,
            right: bounds11.x.max,
            top: bounds11.y.min,
            bottom: bounds11.y.max,
            width: bounds11.x.max - bounds11.x.min,
            height: bounds11.y.max - bounds11.y.min,
            cx: (bounds11.x.max + bounds11.x.min) / 2,
            cy: (bounds11.y.max + bounds11.y.min) / 2
        };
    };
    function intersectData(bez11, t111, t211) {
        var box11 = bez11.boundingBox();
        return {
            cx: box11.cx,
            cy: box11.cy,
            width: box11.width,
            height: box11.height,
            bez: bez11,
            t: (t111 + t211) / 2,
            t1: t111,
            t2: t211
        };
    }
    function splitData(data11) {
        var split11 = data11.bez.split(0.5);
        return [
            intersectData(split11[0], data11.t1, data11.t),
            intersectData(split11[1], data11.t, data11.t2)
        ];
    }
    function boxIntersect(b111, b211) {
        return Math.abs(b111.cx - b211.cx) * 2 < b111.width + b211.width && Math.abs(b111.cy - b211.cy) * 2 < b111.height + b211.height;
    }
    function intersectsImpl(d111, d211, depth11, tolerance11, intersections11, maxRecursion11) {
        if (!boxIntersect(d111, d211)) return;
        if (depth11 >= maxRecursion11 || d111.width <= tolerance11 && d111.height <= tolerance11 && d211.width <= tolerance11 && d211.height <= tolerance11) {
            intersections11.push([
                d111.t,
                d211.t
            ]);
            return;
        }
        var d1s11 = splitData(d111);
        var d2s11 = splitData(d211);
        intersectsImpl(d1s11[0], d2s11[0], depth11 + 1, tolerance11, intersections11, maxRecursion11);
        intersectsImpl(d1s11[0], d2s11[1], depth11 + 1, tolerance11, intersections11, maxRecursion11);
        intersectsImpl(d1s11[1], d2s11[0], depth11 + 1, tolerance11, intersections11, maxRecursion11);
        intersectsImpl(d1s11[1], d2s11[1], depth11 + 1, tolerance11, intersections11, maxRecursion11);
    }
    PolynomialBezier.prototype.intersections = function(other11, tolerance11, maxRecursion11) {
        if (tolerance11 === undefined) tolerance11 = 2;
        if (maxRecursion11 === undefined) maxRecursion11 = 7;
        var intersections11 = [];
        intersectsImpl(intersectData(this, 0, 1), intersectData(other11, 0, 1), 0, tolerance11, intersections11, maxRecursion11);
        return intersections11;
    };
    PolynomialBezier.shapeSegment = function(shapePath11, index11) {
        var nextIndex11 = (index11 + 1) % shapePath11.length();
        return new PolynomialBezier(shapePath11.v[index11], shapePath11.o[index11], shapePath11.i[nextIndex11], shapePath11.v[nextIndex11], true);
    };
    PolynomialBezier.shapeSegmentInverted = function(shapePath11, index11) {
        var nextIndex11 = (index11 + 1) % shapePath11.length();
        return new PolynomialBezier(shapePath11.v[nextIndex11], shapePath11.i[nextIndex11], shapePath11.o[index11], shapePath11.v[index11], true);
    };
    function crossProduct(a31, b31) {
        return [
            a31[1] * b31[2] - a31[2] * b31[1],
            a31[2] * b31[0] - a31[0] * b31[2],
            a31[0] * b31[1] - a31[1] * b31[0]
        ];
    }
    function lineIntersection(start111, end111, start211, end211) {
        var v111 = [
            start111[0],
            start111[1],
            1
        ];
        var v211 = [
            end111[0],
            end111[1],
            1
        ];
        var v311 = [
            start211[0],
            start211[1],
            1
        ];
        var v411 = [
            end211[0],
            end211[1],
            1
        ];
        var r11 = crossProduct(crossProduct(v111, v211), crossProduct(v311, v411));
        if (floatZero(r11[2])) return null;
        return [
            r11[0] / r11[2],
            r11[1] / r11[2]
        ];
    }
    function polarOffset(p61, angle11, length11) {
        return [
            p61[0] + Math.cos(angle11) * length11,
            p61[1] - Math.sin(angle11) * length11
        ];
    }
    function pointDistance(p141, p221) {
        return Math.hypot(p141[0] - p221[0], p141[1] - p221[1]);
    }
    function pointEqual(p141, p221) {
        return floatEqual(p141[0], p221[0]) && floatEqual(p141[1], p221[1]);
    }
    function ZigZagModifier() {}
    extendPrototype([
        ShapeModifier
    ], ZigZagModifier);
    ZigZagModifier.prototype.initModifierProperties = function(elem31, data11) {
        this.getValue = this.processKeys;
        this.amplitude = PropertyFactory.getProp(elem31, data11.s, 0, null, this);
        this.frequency = PropertyFactory.getProp(elem31, data11.r, 0, null, this);
        this.pointsType = PropertyFactory.getProp(elem31, data11.pt, 0, null, this);
        this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
    };
    function setPoint(outputBezier11, point11, angle11, direction11, amplitude11, outAmplitude11, inAmplitude11) {
        var angO11 = angle11 - Math.PI / 2;
        var angI11 = angle11 + Math.PI / 2;
        var px11 = point11[0] + Math.cos(angle11) * direction11 * amplitude11;
        var py11 = point11[1] - Math.sin(angle11) * direction11 * amplitude11;
        outputBezier11.setTripleAt(px11, py11, px11 + Math.cos(angO11) * outAmplitude11, py11 - Math.sin(angO11) * outAmplitude11, px11 + Math.cos(angI11) * inAmplitude11, py11 - Math.sin(angI11) * inAmplitude11, outputBezier11.length());
    }
    function getPerpendicularVector(pt111, pt211) {
        var vector11 = [
            pt211[0] - pt111[0],
            pt211[1] - pt111[1]
        ];
        var rot11 = -Math.PI * 0.5;
        var rotatedVector11 = [
            Math.cos(rot11) * vector11[0] - Math.sin(rot11) * vector11[1],
            Math.sin(rot11) * vector11[0] + Math.cos(rot11) * vector11[1]
        ];
        return rotatedVector11;
    }
    function getProjectingAngle(path11, cur11) {
        var prevIndex11 = cur11 === 0 ? path11.length() - 1 : cur11 - 1;
        var nextIndex11 = (cur11 + 1) % path11.length();
        var prevPoint11 = path11.v[prevIndex11];
        var nextPoint11 = path11.v[nextIndex11];
        var pVector11 = getPerpendicularVector(prevPoint11, nextPoint11);
        return Math.atan2(0, 1) - Math.atan2(pVector11[1], pVector11[0]);
    }
    function zigZagCorner(outputBezier11, path11, cur11, amplitude11, frequency11, pointType11, direction11) {
        var angle11 = getProjectingAngle(path11, cur11);
        var point11 = path11.v[cur11 % path11._length];
        var prevPoint11 = path11.v[cur11 === 0 ? path11._length - 1 : cur11 - 1];
        var nextPoint11 = path11.v[(cur11 + 1) % path11._length];
        var prevDist11 = pointType11 === 2 ? Math.sqrt(Math.pow(point11[0] - prevPoint11[0], 2) + Math.pow(point11[1] - prevPoint11[1], 2)) : 0;
        var nextDist11 = pointType11 === 2 ? Math.sqrt(Math.pow(point11[0] - nextPoint11[0], 2) + Math.pow(point11[1] - nextPoint11[1], 2)) : 0;
        setPoint(outputBezier11, path11.v[cur11 % path11._length], angle11, direction11, amplitude11, nextDist11 / ((frequency11 + 1) * 2), prevDist11 / ((frequency11 + 1) * 2), pointType11);
    }
    function zigZagSegment(outputBezier11, segment11, amplitude11, frequency11, pointType11, direction11) {
        for(var i31 = 0; i31 < frequency11; i31 += 1){
            var t31 = (i31 + 1) / (frequency11 + 1);
            var dist41 = pointType11 === 2 ? Math.sqrt(Math.pow(segment11.points[3][0] - segment11.points[0][0], 2) + Math.pow(segment11.points[3][1] - segment11.points[0][1], 2)) : 0;
            var angle11 = segment11.normalAngle(t31);
            var point11 = segment11.point(t31);
            setPoint(outputBezier11, point11, angle11, direction11, amplitude11, dist41 / ((frequency11 + 1) * 2), dist41 / ((frequency11 + 1) * 2), pointType11);
            direction11 = -direction11;
        }
        return direction11;
    }
    ZigZagModifier.prototype.processPath = function(path11, amplitude11, frequency11, pointType11) {
        var count11 = path11._length;
        var clonedPath11 = shapePool.newElement();
        clonedPath11.c = path11.c;
        if (!path11.c) count11 -= 1;
        if (count11 === 0) return clonedPath11;
        var direction11 = -1;
        var segment11 = PolynomialBezier.shapeSegment(path11, 0);
        zigZagCorner(clonedPath11, path11, 0, amplitude11, frequency11, pointType11, direction11);
        for(var i31 = 0; i31 < count11; i31 += 1){
            direction11 = zigZagSegment(clonedPath11, segment11, amplitude11, frequency11, pointType11, -direction11);
            if (i31 === count11 - 1 && !path11.c) segment11 = null;
            else segment11 = PolynomialBezier.shapeSegment(path11, (i31 + 1) % count11);
            zigZagCorner(clonedPath11, path11, i31 + 1, amplitude11, frequency11, pointType11, direction11);
        }
        return clonedPath11;
    };
    ZigZagModifier.prototype.processShapes = function(_isFirstFrame11) {
        var shapePaths11;
        var i31;
        var len11 = this.shapes.length;
        var j31;
        var jLen11;
        var amplitude11 = this.amplitude.v;
        var frequency11 = Math.max(0, Math.round(this.frequency.v));
        var pointType11 = this.pointsType.v;
        if (amplitude11 !== 0) {
            var shapeData11;
            var localShapeCollection11;
            for(i31 = 0; i31 < len11; i31 += 1){
                shapeData11 = this.shapes[i31];
                localShapeCollection11 = shapeData11.localShapeCollection;
                if (!(!shapeData11.shape._mdf && !this._mdf && !_isFirstFrame11)) {
                    localShapeCollection11.releaseShapes();
                    shapeData11.shape._mdf = true;
                    shapePaths11 = shapeData11.shape.paths.shapes;
                    jLen11 = shapeData11.shape.paths._length;
                    for(j31 = 0; j31 < jLen11; j31 += 1)localShapeCollection11.addShape(this.processPath(shapePaths11[j31], amplitude11, frequency11, pointType11));
                }
                shapeData11.shape.paths = shapeData11.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function linearOffset(p141, p221, amount11) {
        var angle11 = Math.atan2(p221[0] - p141[0], p221[1] - p141[1]);
        return [
            polarOffset(p141, angle11, amount11),
            polarOffset(p221, angle11, amount11)
        ];
    }
    function offsetSegment(segment11, amount11) {
        var p011;
        var p1a11;
        var p1b11;
        var p2b11;
        var p2a11;
        var p311;
        var e31;
        e31 = linearOffset(segment11.points[0], segment11.points[1], amount11);
        p011 = e31[0];
        p1a11 = e31[1];
        e31 = linearOffset(segment11.points[1], segment11.points[2], amount11);
        p1b11 = e31[0];
        p2b11 = e31[1];
        e31 = linearOffset(segment11.points[2], segment11.points[3], amount11);
        p2a11 = e31[0];
        p311 = e31[1];
        var p141 = lineIntersection(p011, p1a11, p1b11, p2b11);
        if (p141 === null) p141 = p1a11;
        var p221 = lineIntersection(p2a11, p311, p1b11, p2b11);
        if (p221 === null) p221 = p2a11;
        return new PolynomialBezier(p011, p141, p221, p311);
    }
    function joinLines(outputBezier11, seg111, seg211, lineJoin11, miterLimit11) {
        var p011 = seg111.points[3];
        var p141 = seg211.points[0]; // Bevel
        if (lineJoin11 === 3) return p011; // Connected, they don't need a joint
        if (pointEqual(p011, p141)) return p011; // Round
        if (lineJoin11 === 2) {
            var angleOut11 = -seg111.tangentAngle(1);
            var angleIn11 = -seg211.tangentAngle(0) + Math.PI;
            var center11 = lineIntersection(p011, polarOffset(p011, angleOut11 + Math.PI / 2, 100), p141, polarOffset(p141, angleOut11 + Math.PI / 2, 100));
            var radius11 = center11 ? pointDistance(center11, p011) : pointDistance(p011, p141) / 2;
            var tan11 = polarOffset(p011, angleOut11, 2 * radius11 * roundCorner);
            outputBezier11.setXYAt(tan11[0], tan11[1], "o", outputBezier11.length() - 1);
            tan11 = polarOffset(p141, angleIn11, 2 * radius11 * roundCorner);
            outputBezier11.setTripleAt(p141[0], p141[1], p141[0], p141[1], tan11[0], tan11[1], outputBezier11.length());
            return p141;
        } // Miter
        var t011 = pointEqual(p011, seg111.points[2]) ? seg111.points[0] : seg111.points[2];
        var t111 = pointEqual(p141, seg211.points[1]) ? seg211.points[3] : seg211.points[1];
        var intersection11 = lineIntersection(t011, p011, p141, t111);
        if (intersection11 && pointDistance(intersection11, p011) < miterLimit11) {
            outputBezier11.setTripleAt(intersection11[0], intersection11[1], intersection11[0], intersection11[1], intersection11[0], intersection11[1], outputBezier11.length());
            return intersection11;
        }
        return p011;
    }
    function getIntersection(a31, b31) {
        var intersect11 = a31.intersections(b31);
        if (intersect11.length && floatEqual(intersect11[0][0], 1)) intersect11.shift();
        if (intersect11.length) return intersect11[0];
        return null;
    }
    function pruneSegmentIntersection(a31, b31) {
        var outa11 = a31.slice();
        var outb11 = b31.slice();
        var intersect11 = getIntersection(a31[a31.length - 1], b31[0]);
        if (intersect11) {
            outa11[a31.length - 1] = a31[a31.length - 1].split(intersect11[0])[0];
            outb11[0] = b31[0].split(intersect11[1])[1];
        }
        if (a31.length > 1 && b31.length > 1) {
            intersect11 = getIntersection(a31[0], b31[b31.length - 1]);
            if (intersect11) return [
                [
                    a31[0].split(intersect11[0])[0]
                ],
                [
                    b31[b31.length - 1].split(intersect11[1])[1]
                ]
            ];
        }
        return [
            outa11,
            outb11
        ];
    }
    function pruneIntersections(segments11) {
        var e31;
        for(var i31 = 1; i31 < segments11.length; i31 += 1){
            e31 = pruneSegmentIntersection(segments11[i31 - 1], segments11[i31]);
            segments11[i31 - 1] = e31[0];
            segments11[i31] = e31[1];
        }
        if (segments11.length > 1) {
            e31 = pruneSegmentIntersection(segments11[segments11.length - 1], segments11[0]);
            segments11[segments11.length - 1] = e31[0];
            segments11[0] = e31[1];
        }
        return segments11;
    }
    function offsetSegmentSplit(segment11, amount11) {
        /*
      We split each bezier segment into smaller pieces based
      on inflection points, this ensures the control point
      polygon is convex.
        (A cubic bezier can have none, one, or two inflection points)
    */ var flex11 = segment11.inflectionPoints();
        var left11;
        var right11;
        var split11;
        var mid11;
        if (flex11.length === 0) return [
            offsetSegment(segment11, amount11)
        ];
        if (flex11.length === 1 || floatEqual(flex11[1], 1)) {
            split11 = segment11.split(flex11[0]);
            left11 = split11[0];
            right11 = split11[1];
            return [
                offsetSegment(left11, amount11),
                offsetSegment(right11, amount11)
            ];
        }
        split11 = segment11.split(flex11[0]);
        left11 = split11[0];
        var t31 = (flex11[1] - flex11[0]) / (1 - flex11[0]);
        split11 = split11[1].split(t31);
        mid11 = split11[0];
        right11 = split11[1];
        return [
            offsetSegment(left11, amount11),
            offsetSegment(mid11, amount11),
            offsetSegment(right11, amount11)
        ];
    }
    function OffsetPathModifier() {}
    extendPrototype([
        ShapeModifier
    ], OffsetPathModifier);
    OffsetPathModifier.prototype.initModifierProperties = function(elem31, data11) {
        this.getValue = this.processKeys;
        this.amount = PropertyFactory.getProp(elem31, data11.a, 0, null, this);
        this.miterLimit = PropertyFactory.getProp(elem31, data11.ml, 0, null, this);
        this.lineJoin = data11.lj;
        this._isAnimated = this.amount.effectsSequence.length !== 0;
    };
    OffsetPathModifier.prototype.processPath = function(inputBezier11, amount11, lineJoin11, miterLimit11) {
        var outputBezier11 = shapePool.newElement();
        outputBezier11.c = inputBezier11.c;
        var count11 = inputBezier11.length();
        if (!inputBezier11.c) count11 -= 1;
        var i31;
        var j31;
        var segment11;
        var multiSegments11 = [];
        for(i31 = 0; i31 < count11; i31 += 1){
            segment11 = PolynomialBezier.shapeSegment(inputBezier11, i31);
            multiSegments11.push(offsetSegmentSplit(segment11, amount11));
        }
        if (!inputBezier11.c) for(i31 = count11 - 1; i31 >= 0; i31 -= 1){
            segment11 = PolynomialBezier.shapeSegmentInverted(inputBezier11, i31);
            multiSegments11.push(offsetSegmentSplit(segment11, amount11));
        }
        multiSegments11 = pruneIntersections(multiSegments11); // Add bezier segments to the output and apply line joints
        var lastPoint11 = null;
        var lastSeg11 = null;
        for(i31 = 0; i31 < multiSegments11.length; i31 += 1){
            var multiSegment11 = multiSegments11[i31];
            if (lastSeg11) lastPoint11 = joinLines(outputBezier11, lastSeg11, multiSegment11[0], lineJoin11, miterLimit11);
            lastSeg11 = multiSegment11[multiSegment11.length - 1];
            for(j31 = 0; j31 < multiSegment11.length; j31 += 1){
                segment11 = multiSegment11[j31];
                if (lastPoint11 && pointEqual(segment11.points[0], lastPoint11)) outputBezier11.setXYAt(segment11.points[1][0], segment11.points[1][1], "o", outputBezier11.length() - 1);
                else outputBezier11.setTripleAt(segment11.points[0][0], segment11.points[0][1], segment11.points[1][0], segment11.points[1][1], segment11.points[0][0], segment11.points[0][1], outputBezier11.length());
                outputBezier11.setTripleAt(segment11.points[3][0], segment11.points[3][1], segment11.points[3][0], segment11.points[3][1], segment11.points[2][0], segment11.points[2][1], outputBezier11.length());
                lastPoint11 = segment11.points[3];
            }
        }
        if (multiSegments11.length) joinLines(outputBezier11, lastSeg11, multiSegments11[0][0], lineJoin11, miterLimit11);
        return outputBezier11;
    };
    OffsetPathModifier.prototype.processShapes = function(_isFirstFrame11) {
        var shapePaths11;
        var i31;
        var len11 = this.shapes.length;
        var j31;
        var jLen11;
        var amount11 = this.amount.v;
        var miterLimit11 = this.miterLimit.v;
        var lineJoin11 = this.lineJoin;
        if (amount11 !== 0) {
            var shapeData11;
            var localShapeCollection11;
            for(i31 = 0; i31 < len11; i31 += 1){
                shapeData11 = this.shapes[i31];
                localShapeCollection11 = shapeData11.localShapeCollection;
                if (!(!shapeData11.shape._mdf && !this._mdf && !_isFirstFrame11)) {
                    localShapeCollection11.releaseShapes();
                    shapeData11.shape._mdf = true;
                    shapePaths11 = shapeData11.shape.paths.shapes;
                    jLen11 = shapeData11.shape.paths._length;
                    for(j31 = 0; j31 < jLen11; j31 += 1)localShapeCollection11.addShape(this.processPath(shapePaths11[j31], amount11, lineJoin11, miterLimit11));
                }
                shapeData11.shape.paths = shapeData11.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function getFontProperties(fontData11) {
        var styles11 = fontData11.fStyle ? fontData11.fStyle.split(" ") : [];
        var fWeight11 = "normal";
        var fStyle11 = "normal";
        var len11 = styles11.length;
        var styleName11;
        for(var i31 = 0; i31 < len11; i31 += 1){
            styleName11 = styles11[i31].toLowerCase();
            switch(styleName11){
                case "italic":
                    fStyle11 = "italic";
                    break;
                case "bold":
                    fWeight11 = "700";
                    break;
                case "black":
                    fWeight11 = "900";
                    break;
                case "medium":
                    fWeight11 = "500";
                    break;
                case "regular":
                case "normal":
                    fWeight11 = "400";
                    break;
                case "light":
                case "thin":
                    fWeight11 = "200";
                    break;
                default:
                    break;
            }
        }
        return {
            style: fStyle11,
            weight: fontData11.fWeight || fWeight11
        };
    }
    var FontManager = function() {
        var maxWaitingTime11 = 5000;
        var emptyChar11 = {
            w: 0,
            size: 0,
            shapes: [],
            data: {
                shapes: []
            }
        };
        var combinedCharacters11 = []; // Hindi characters
        combinedCharacters11 = combinedCharacters11.concat([
            2304,
            2305,
            2306,
            2307,
            2362,
            2363,
            2364,
            2364,
            2366,
            2367,
            2368,
            2369,
            2370,
            2371,
            2372,
            2373,
            2374,
            2375,
            2376,
            2377,
            2378,
            2379,
            2380,
            2381,
            2382,
            2383,
            2387,
            2388,
            2389,
            2390,
            2391,
            2402,
            2403
        ]);
        var BLACK_FLAG_CODE_POINT11 = 127988;
        var CANCEL_TAG_CODE_POINT11 = 917631;
        var A_TAG_CODE_POINT11 = 917601;
        var Z_TAG_CODE_POINT11 = 917626;
        var VARIATION_SELECTOR_16_CODE_POINT11 = 65039;
        var ZERO_WIDTH_JOINER_CODE_POINT11 = 8205;
        var REGIONAL_CHARACTER_A_CODE_POINT11 = 127462;
        var REGIONAL_CHARACTER_Z_CODE_POINT11 = 127487;
        var surrogateModifiers11 = [
            "d83cdffb",
            "d83cdffc",
            "d83cdffd",
            "d83cdffe",
            "d83cdfff"
        ];
        function trimFontOptions11(font11) {
            var familyArray11 = font11.split(",");
            var i31;
            var len11 = familyArray11.length;
            var enabledFamilies11 = [];
            for(i31 = 0; i31 < len11; i31 += 1)if (familyArray11[i31] !== "sans-serif" && familyArray11[i31] !== "monospace") enabledFamilies11.push(familyArray11[i31]);
            return enabledFamilies11.join(",");
        }
        function setUpNode11(font11, family11) {
            var parentNode11 = createTag("span"); // Node is invisible to screen readers.
            parentNode11.setAttribute("aria-hidden", true);
            parentNode11.style.fontFamily = family11;
            var node11 = createTag("span"); // Characters that vary significantly among different fonts
            node11.innerText = "giItT1WQy@!-/#"; // Visible - so we can measure it - but not on the screen
            parentNode11.style.position = "absolute";
            parentNode11.style.left = "-10000px";
            parentNode11.style.top = "-10000px"; // Large font size makes even subtle changes obvious
            parentNode11.style.fontSize = "300px"; // Reset any font properties
            parentNode11.style.fontVariant = "normal";
            parentNode11.style.fontStyle = "normal";
            parentNode11.style.fontWeight = "normal";
            parentNode11.style.letterSpacing = "0";
            parentNode11.appendChild(node11);
            document.body.appendChild(parentNode11); // Remember width with no applied web font
            var width11 = node11.offsetWidth;
            node11.style.fontFamily = trimFontOptions11(font11) + ", " + family11;
            return {
                node: node11,
                w: width11,
                parent: parentNode11
            };
        }
        function checkLoadedFonts11() {
            var i31;
            var len11 = this.fonts.length;
            var node11;
            var w11;
            var loadedCount11 = len11;
            for(i31 = 0; i31 < len11; i31 += 1){
                if (this.fonts[i31].loaded) loadedCount11 -= 1;
                else if (this.fonts[i31].fOrigin === "n" || this.fonts[i31].origin === 0) this.fonts[i31].loaded = true;
                else {
                    node11 = this.fonts[i31].monoCase.node;
                    w11 = this.fonts[i31].monoCase.w;
                    if (node11.offsetWidth !== w11) {
                        loadedCount11 -= 1;
                        this.fonts[i31].loaded = true;
                    } else {
                        node11 = this.fonts[i31].sansCase.node;
                        w11 = this.fonts[i31].sansCase.w;
                        if (node11.offsetWidth !== w11) {
                            loadedCount11 -= 1;
                            this.fonts[i31].loaded = true;
                        }
                    }
                    if (this.fonts[i31].loaded) {
                        this.fonts[i31].sansCase.parent.parentNode.removeChild(this.fonts[i31].sansCase.parent);
                        this.fonts[i31].monoCase.parent.parentNode.removeChild(this.fonts[i31].monoCase.parent);
                    }
                }
            }
            if (loadedCount11 !== 0 && Date.now() - this.initTime < maxWaitingTime11) setTimeout(this.checkLoadedFontsBinded, 20);
            else setTimeout(this.setIsLoadedBinded, 10);
        }
        function createHelper11(fontData11, def11) {
            var engine11 = document.body && def11 ? "svg" : "canvas";
            var helper11;
            var fontProps11 = getFontProperties(fontData11);
            if (engine11 === "svg") {
                var tHelper11 = createNS("text");
                tHelper11.style.fontSize = "100px"; // tHelper.style.fontFamily = fontData.fFamily;
                tHelper11.setAttribute("font-family", fontData11.fFamily);
                tHelper11.setAttribute("font-style", fontProps11.style);
                tHelper11.setAttribute("font-weight", fontProps11.weight);
                tHelper11.textContent = "1";
                if (fontData11.fClass) {
                    tHelper11.style.fontFamily = "inherit";
                    tHelper11.setAttribute("class", fontData11.fClass);
                } else tHelper11.style.fontFamily = fontData11.fFamily;
                def11.appendChild(tHelper11);
                helper11 = tHelper11;
            } else {
                var tCanvasHelper11 = new OffscreenCanvas(500, 500).getContext("2d");
                tCanvasHelper11.font = fontProps11.style + " " + fontProps11.weight + " 100px " + fontData11.fFamily;
                helper11 = tCanvasHelper11;
            }
            function measure11(text11) {
                if (engine11 === "svg") {
                    helper11.textContent = text11;
                    return helper11.getComputedTextLength();
                }
                return helper11.measureText(text11).width;
            }
            return {
                measureText: measure11
            };
        }
        function addFonts11(fontData11, defs11) {
            if (!fontData11) {
                this.isLoaded = true;
                return;
            }
            if (this.chars) {
                this.isLoaded = true;
                this.fonts = fontData11.list;
                return;
            }
            if (!document.body) {
                this.isLoaded = true;
                fontData11.list.forEach(function(data11) {
                    data11.helper = createHelper11(data11);
                    data11.cache = {};
                });
                this.fonts = fontData11.list;
                return;
            }
            var fontArr11 = fontData11.list;
            var i31;
            var len11 = fontArr11.length;
            var _pendingFonts11 = len11;
            for(i31 = 0; i31 < len11; i31 += 1){
                var shouldLoadFont11 = true;
                var loadedSelector11;
                var j31;
                fontArr11[i31].loaded = false;
                fontArr11[i31].monoCase = setUpNode11(fontArr11[i31].fFamily, "monospace");
                fontArr11[i31].sansCase = setUpNode11(fontArr11[i31].fFamily, "sans-serif");
                if (!fontArr11[i31].fPath) {
                    fontArr11[i31].loaded = true;
                    _pendingFonts11 -= 1;
                } else if (fontArr11[i31].fOrigin === "p" || fontArr11[i31].origin === 3) {
                    loadedSelector11 = document.querySelectorAll('style[f-forigin="p"][f-family="' + fontArr11[i31].fFamily + '"], style[f-origin="3"][f-family="' + fontArr11[i31].fFamily + '"]');
                    if (loadedSelector11.length > 0) shouldLoadFont11 = false;
                    if (shouldLoadFont11) {
                        var s41 = createTag("style");
                        s41.setAttribute("f-forigin", fontArr11[i31].fOrigin);
                        s41.setAttribute("f-origin", fontArr11[i31].origin);
                        s41.setAttribute("f-family", fontArr11[i31].fFamily);
                        s41.type = "text/css";
                        s41.innerText = "@font-face {font-family: " + fontArr11[i31].fFamily + "; font-style: normal; src: url('" + fontArr11[i31].fPath + "');}";
                        defs11.appendChild(s41);
                    }
                } else if (fontArr11[i31].fOrigin === "g" || fontArr11[i31].origin === 1) {
                    loadedSelector11 = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]');
                    for(j31 = 0; j31 < loadedSelector11.length; j31 += 1)if (loadedSelector11[j31].href.indexOf(fontArr11[i31].fPath) !== -1) // Font is already loaded
                    shouldLoadFont11 = false;
                    if (shouldLoadFont11) {
                        var l31 = createTag("link");
                        l31.setAttribute("f-forigin", fontArr11[i31].fOrigin);
                        l31.setAttribute("f-origin", fontArr11[i31].origin);
                        l31.type = "text/css";
                        l31.rel = "stylesheet";
                        l31.href = fontArr11[i31].fPath;
                        document.body.appendChild(l31);
                    }
                } else if (fontArr11[i31].fOrigin === "t" || fontArr11[i31].origin === 2) {
                    loadedSelector11 = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]');
                    for(j31 = 0; j31 < loadedSelector11.length; j31 += 1)if (fontArr11[i31].fPath === loadedSelector11[j31].src) // Font is already loaded
                    shouldLoadFont11 = false;
                    if (shouldLoadFont11) {
                        var sc11 = createTag("link");
                        sc11.setAttribute("f-forigin", fontArr11[i31].fOrigin);
                        sc11.setAttribute("f-origin", fontArr11[i31].origin);
                        sc11.setAttribute("rel", "stylesheet");
                        sc11.setAttribute("href", fontArr11[i31].fPath);
                        defs11.appendChild(sc11);
                    }
                }
                fontArr11[i31].helper = createHelper11(fontArr11[i31], defs11);
                fontArr11[i31].cache = {};
                this.fonts.push(fontArr11[i31]);
            }
            if (_pendingFonts11 === 0) this.isLoaded = true;
            else // On some cases even if the font is loaded, it won't load correctly when measuring text on canvas.
            // Adding this timeout seems to fix it
            setTimeout(this.checkLoadedFonts.bind(this), 100);
        }
        function addChars11(chars11) {
            if (!chars11) return;
            if (!this.chars) this.chars = [];
            var i31;
            var len11 = chars11.length;
            var j31;
            var jLen11 = this.chars.length;
            var found11;
            for(i31 = 0; i31 < len11; i31 += 1){
                j31 = 0;
                found11 = false;
                while(j31 < jLen11){
                    if (this.chars[j31].style === chars11[i31].style && this.chars[j31].fFamily === chars11[i31].fFamily && this.chars[j31].ch === chars11[i31].ch) found11 = true;
                    j31 += 1;
                }
                if (!found11) {
                    this.chars.push(chars11[i31]);
                    jLen11 += 1;
                }
            }
        }
        function getCharData11(_char11, style11, font11) {
            var i31 = 0;
            var len11 = this.chars.length;
            while(i31 < len11){
                if (this.chars[i31].ch === _char11 && this.chars[i31].style === style11 && this.chars[i31].fFamily === font11) return this.chars[i31];
                i31 += 1;
            }
            if ((typeof _char11 === "string" && _char11.charCodeAt(0) !== 13 || !_char11) && console && console.warn // eslint-disable-line no-console
             && !this._warned) {
                this._warned = true;
                console.warn("Missing character from exported characters list: ", _char11, style11, font11); // eslint-disable-line no-console
            }
            return emptyChar11;
        }
        function measureText11(_char211, fontName11, size11) {
            var fontData11 = this.getFontByName(fontName11); // Using the char instead of char.charCodeAt(0)
            // to avoid collisions between equal chars
            var index11 = _char211;
            if (!fontData11.cache[index11]) {
                var tHelper11 = fontData11.helper;
                if (_char211 === " ") {
                    var doubleSize11 = tHelper11.measureText("|" + _char211 + "|");
                    var singleSize11 = tHelper11.measureText("||");
                    fontData11.cache[index11] = (doubleSize11 - singleSize11) / 100;
                } else fontData11.cache[index11] = tHelper11.measureText(_char211) / 100;
            }
            return fontData11.cache[index11] * size11;
        }
        function getFontByName11(name11) {
            var i31 = 0;
            var len11 = this.fonts.length;
            while(i31 < len11){
                if (this.fonts[i31].fName === name11) return this.fonts[i31];
                i31 += 1;
            }
            return this.fonts[0];
        }
        function getCodePoint11(string11) {
            var codePoint11 = 0;
            var first11 = string11.charCodeAt(0);
            if (first11 >= 0xD800 && first11 <= 0xDBFF) {
                var second11 = string11.charCodeAt(1);
                if (second11 >= 0xDC00 && second11 <= 0xDFFF) codePoint11 = (first11 - 0xD800) * 0x400 + second11 - 0xDC00 + 0x10000;
            }
            return codePoint11;
        } // Skin tone modifiers
        function isModifier11(firstCharCode11, secondCharCode11) {
            var sum11 = firstCharCode11.toString(16) + secondCharCode11.toString(16);
            return surrogateModifiers11.indexOf(sum11) !== -1;
        }
        function isZeroWidthJoiner11(charCode11) {
            return charCode11 === ZERO_WIDTH_JOINER_CODE_POINT11;
        } // This codepoint may change the appearance of the preceding character.
        // If that is a symbol, dingbat or emoji, U+FE0F forces it to be rendered
        // as a colorful image as compared to a monochrome text variant.
        function isVariationSelector11(charCode11) {
            return charCode11 === VARIATION_SELECTOR_16_CODE_POINT11;
        } // The regional indicator symbols are a set of 26 alphabetic Unicode
        /// characters (A–Z) intended to be used to encode ISO 3166-1 alpha-2
        // two-letter country codes in a way that allows optional special treatment.
        function isRegionalCode11(string11) {
            var codePoint11 = getCodePoint11(string11);
            if (codePoint11 >= REGIONAL_CHARACTER_A_CODE_POINT11 && codePoint11 <= REGIONAL_CHARACTER_Z_CODE_POINT11) return true;
            return false;
        } // Some Emoji implementations represent combinations of
        // two “regional indicator” letters as a single flag symbol.
        function isFlagEmoji11(string11) {
            return isRegionalCode11(string11.substr(0, 2)) && isRegionalCode11(string11.substr(2, 2));
        }
        function isCombinedCharacter11(_char311) {
            return combinedCharacters11.indexOf(_char311) !== -1;
        } // Regional flags start with a BLACK_FLAG_CODE_POINT
        // folowed by 5 chars in the TAG range
        // and end with a CANCEL_TAG_CODE_POINT
        function isRegionalFlag11(text11, index11) {
            var codePoint11 = getCodePoint11(text11.substr(index11, 2));
            if (codePoint11 !== BLACK_FLAG_CODE_POINT11) return false;
            var count11 = 0;
            index11 += 2;
            while(count11 < 5){
                codePoint11 = getCodePoint11(text11.substr(index11, 2));
                if (codePoint11 < A_TAG_CODE_POINT11 || codePoint11 > Z_TAG_CODE_POINT11) return false;
                count11 += 1;
                index11 += 2;
            }
            return getCodePoint11(text11.substr(index11, 2)) === CANCEL_TAG_CODE_POINT11;
        }
        function setIsLoaded11() {
            this.isLoaded = true;
        }
        var Font11 = function Font11() {
            this.fonts = [];
            this.chars = null;
            this.typekitLoaded = 0;
            this.isLoaded = false;
            this._warned = false;
            this.initTime = Date.now();
            this.setIsLoadedBinded = this.setIsLoaded.bind(this);
            this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
        };
        Font11.isModifier = isModifier11;
        Font11.isZeroWidthJoiner = isZeroWidthJoiner11;
        Font11.isFlagEmoji = isFlagEmoji11;
        Font11.isRegionalCode = isRegionalCode11;
        Font11.isCombinedCharacter = isCombinedCharacter11;
        Font11.isRegionalFlag = isRegionalFlag11;
        Font11.isVariationSelector = isVariationSelector11;
        Font11.BLACK_FLAG_CODE_POINT = BLACK_FLAG_CODE_POINT11;
        var fontPrototype11 = {
            addChars: addChars11,
            addFonts: addFonts11,
            getCharData: getCharData11,
            getFontByName: getFontByName11,
            measureText: measureText11,
            checkLoadedFonts: checkLoadedFonts11,
            setIsLoaded: setIsLoaded11
        };
        Font11.prototype = fontPrototype11;
        return Font11;
    }();
    function SlotManager(animationData11) {
        this.animationData = animationData11;
    }
    SlotManager.prototype.getProp = function(data11) {
        if (this.animationData.slots && this.animationData.slots[data11.sid]) return Object.assign(data11, this.animationData.slots[data11.sid].p);
        return data11;
    };
    function slotFactory(animationData11) {
        return new SlotManager(animationData11);
    }
    function RenderableElement() {}
    RenderableElement.prototype = {
        initRenderable: function initRenderable11() {
            // layer's visibility related to inpoint and outpoint. Rename isVisible to isInRange
            this.isInRange = false; // layer's display state
            this.hidden = false; // If layer's transparency equals 0, it can be hidden
            this.isTransparent = false; // list of animated components
            this.renderableComponents = [];
        },
        addRenderableComponent: function addRenderableComponent11(component11) {
            if (this.renderableComponents.indexOf(component11) === -1) this.renderableComponents.push(component11);
        },
        removeRenderableComponent: function removeRenderableComponent11(component11) {
            if (this.renderableComponents.indexOf(component11) !== -1) this.renderableComponents.splice(this.renderableComponents.indexOf(component11), 1);
        },
        prepareRenderableFrame: function prepareRenderableFrame11(num11) {
            this.checkLayerLimits(num11);
        },
        checkTransparency: function checkTransparency11() {
            if (this.finalTransform.mProp.o.v <= 0) {
                if (!this.isTransparent && this.globalData.renderConfig.hideOnTransparent) {
                    this.isTransparent = true;
                    this.hide();
                }
            } else if (this.isTransparent) {
                this.isTransparent = false;
                this.show();
            }
        },
        /**
       * @function
       * Initializes frame related properties.
       *
       * @param {number} num
       * current frame number in Layer's time
       *
       */ checkLayerLimits: function checkLayerLimits11(num11) {
            if (this.data.ip - this.data.st <= num11 && this.data.op - this.data.st > num11) {
                if (this.isInRange !== true) {
                    this.globalData._mdf = true;
                    this._mdf = true;
                    this.isInRange = true;
                    this.show();
                }
            } else if (this.isInRange !== false) {
                this.globalData._mdf = true;
                this.isInRange = false;
                this.hide();
            }
        },
        renderRenderable: function renderRenderable11() {
            var i31;
            var len11 = this.renderableComponents.length;
            for(i31 = 0; i31 < len11; i31 += 1)this.renderableComponents[i31].renderFrame(this._isFirstFrame);
        /* this.maskManager.renderFrame(this.finalTransform.mat);
          this.renderableEffectsManager.renderFrame(this._isFirstFrame); */ },
        sourceRectAtTime: function sourceRectAtTime11() {
            return {
                top: 0,
                left: 0,
                width: 100,
                height: 100
            };
        },
        getLayerSize: function getLayerSize11() {
            if (this.data.ty === 5) return {
                w: this.data.textData.width,
                h: this.data.textData.height
            };
            return {
                w: this.data.width,
                h: this.data.height
            };
        }
    };
    var getBlendMode = function() {
        var blendModeEnums11 = {
            0: "source-over",
            1: "multiply",
            2: "screen",
            3: "overlay",
            4: "darken",
            5: "lighten",
            6: "color-dodge",
            7: "color-burn",
            8: "hard-light",
            9: "soft-light",
            10: "difference",
            11: "exclusion",
            12: "hue",
            13: "saturation",
            14: "color",
            15: "luminosity"
        };
        return function(mode11) {
            return blendModeEnums11[mode11] || "";
        };
    }();
    function SliderEffect(data11, elem31, container11) {
        this.p = PropertyFactory.getProp(elem31, data11.v, 0, 0, container11);
    }
    function AngleEffect(data11, elem31, container11) {
        this.p = PropertyFactory.getProp(elem31, data11.v, 0, 0, container11);
    }
    function ColorEffect(data11, elem31, container11) {
        this.p = PropertyFactory.getProp(elem31, data11.v, 1, 0, container11);
    }
    function PointEffect(data11, elem31, container11) {
        this.p = PropertyFactory.getProp(elem31, data11.v, 1, 0, container11);
    }
    function LayerIndexEffect(data11, elem31, container11) {
        this.p = PropertyFactory.getProp(elem31, data11.v, 0, 0, container11);
    }
    function MaskIndexEffect(data11, elem31, container11) {
        this.p = PropertyFactory.getProp(elem31, data11.v, 0, 0, container11);
    }
    function CheckboxEffect(data11, elem31, container11) {
        this.p = PropertyFactory.getProp(elem31, data11.v, 0, 0, container11);
    }
    function NoValueEffect() {
        this.p = {};
    }
    function EffectsManager(data11, element11) {
        var effects11 = data11.ef || [];
        this.effectElements = [];
        var i31;
        var len11 = effects11.length;
        var effectItem11;
        for(i31 = 0; i31 < len11; i31 += 1){
            effectItem11 = new GroupEffect(effects11[i31], element11);
            this.effectElements.push(effectItem11);
        }
    }
    function GroupEffect(data11, element11) {
        this.init(data11, element11);
    }
    extendPrototype([
        DynamicPropertyContainer
    ], GroupEffect);
    GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties;
    GroupEffect.prototype.init = function(data11, element11) {
        this.data = data11;
        this.effectElements = [];
        this.initDynamicPropertyContainer(element11);
        var i31;
        var len11 = this.data.ef.length;
        var eff11;
        var effects11 = this.data.ef;
        for(i31 = 0; i31 < len11; i31 += 1){
            eff11 = null;
            switch(effects11[i31].ty){
                case 0:
                    eff11 = new SliderEffect(effects11[i31], element11, this);
                    break;
                case 1:
                    eff11 = new AngleEffect(effects11[i31], element11, this);
                    break;
                case 2:
                    eff11 = new ColorEffect(effects11[i31], element11, this);
                    break;
                case 3:
                    eff11 = new PointEffect(effects11[i31], element11, this);
                    break;
                case 4:
                case 7:
                    eff11 = new CheckboxEffect(effects11[i31], element11, this);
                    break;
                case 10:
                    eff11 = new LayerIndexEffect(effects11[i31], element11, this);
                    break;
                case 11:
                    eff11 = new MaskIndexEffect(effects11[i31], element11, this);
                    break;
                case 5:
                    eff11 = new EffectsManager(effects11[i31], element11, this);
                    break;
                // case 6:
                default:
                    eff11 = new NoValueEffect(effects11[i31], element11, this);
                    break;
            }
            if (eff11) this.effectElements.push(eff11);
        }
    };
    function BaseElement() {}
    BaseElement.prototype = {
        checkMasks: function checkMasks11() {
            if (!this.data.hasMask) return false;
            var i31 = 0;
            var len11 = this.data.masksProperties.length;
            while(i31 < len11){
                if (this.data.masksProperties[i31].mode !== "n" && this.data.masksProperties[i31].cl !== false) return true;
                i31 += 1;
            }
            return false;
        },
        initExpressions: function initExpressions11() {
            var expressionsInterfaces11 = getExpressionInterfaces();
            if (!expressionsInterfaces11) return;
            var LayerExpressionInterface11 = expressionsInterfaces11("layer");
            var EffectsExpressionInterface11 = expressionsInterfaces11("effects");
            var ShapeExpressionInterface11 = expressionsInterfaces11("shape");
            var TextExpressionInterface11 = expressionsInterfaces11("text");
            var CompExpressionInterface11 = expressionsInterfaces11("comp");
            this.layerInterface = LayerExpressionInterface11(this);
            if (this.data.hasMask && this.maskManager) this.layerInterface.registerMaskInterface(this.maskManager);
            var effectsInterface11 = EffectsExpressionInterface11.createEffectsInterface(this, this.layerInterface);
            this.layerInterface.registerEffectsInterface(effectsInterface11);
            if (this.data.ty === 0 || this.data.xt) this.compInterface = CompExpressionInterface11(this);
            else if (this.data.ty === 4) {
                this.layerInterface.shapeInterface = ShapeExpressionInterface11(this.shapesData, this.itemsData, this.layerInterface);
                this.layerInterface.content = this.layerInterface.shapeInterface;
            } else if (this.data.ty === 5) {
                this.layerInterface.textInterface = TextExpressionInterface11(this);
                this.layerInterface.text = this.layerInterface.textInterface;
            }
        },
        setBlendMode: function setBlendMode11() {
            var blendModeValue11 = getBlendMode(this.data.bm);
            var elem31 = this.baseElement || this.layerElement;
            elem31.style["mix-blend-mode"] = blendModeValue11;
        },
        initBaseData: function initBaseData11(data11, globalData11, comp11) {
            this.globalData = globalData11;
            this.comp = comp11;
            this.data = data11;
            this.layerId = createElementID(); // Stretch factor for old animations missing this property.
            if (!this.data.sr) this.data.sr = 1;
             // effects manager
            this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
        },
        getType: function getType11() {
            return this.type;
        },
        sourceRectAtTime: function sourceRectAtTime11() {}
    };
    /**
   * @file
   * Handles element's layer frame update.
   * Checks layer in point and out point
   *
   */ function FrameElement() {}
    FrameElement.prototype = {
        /**
       * @function
       * Initializes frame related properties.
       *
       */ initFrame: function initFrame11() {
            // set to true when inpoint is rendered
            this._isFirstFrame = false; // list of animated properties
            this.dynamicProperties = []; // If layer has been modified in current tick this will be true
            this._mdf = false;
        },
        /**
       * @function
       * Calculates all dynamic values
       *
       * @param {number} num
       * current frame number in Layer's time
       * @param {boolean} isVisible
       * if layers is currently in range
       *
       */ prepareProperties: function prepareProperties11(num11, isVisible11) {
            var i31;
            var len11 = this.dynamicProperties.length;
            for(i31 = 0; i31 < len11; i31 += 1)if (isVisible11 || this._isParent && this.dynamicProperties[i31].propType === "transform") {
                this.dynamicProperties[i31].getValue();
                if (this.dynamicProperties[i31]._mdf) {
                    this.globalData._mdf = true;
                    this._mdf = true;
                }
            }
        },
        addDynamicProperty: function addDynamicProperty11(prop11) {
            if (this.dynamicProperties.indexOf(prop11) === -1) this.dynamicProperties.push(prop11);
        }
    };
    function FootageElement(data11, globalData11, comp11) {
        this.initFrame();
        this.initRenderable();
        this.assetData = globalData11.getAssetData(data11.refId);
        this.footageData = globalData11.imageLoader.getAsset(this.assetData);
        this.initBaseData(data11, globalData11, comp11);
    }
    FootageElement.prototype.prepareFrame = function() {};
    extendPrototype([
        RenderableElement,
        BaseElement,
        FrameElement
    ], FootageElement);
    FootageElement.prototype.getBaseElement = function() {
        return null;
    };
    FootageElement.prototype.renderFrame = function() {};
    FootageElement.prototype.destroy = function() {};
    FootageElement.prototype.initExpressions = function() {
        var expressionsInterfaces11 = getExpressionInterfaces();
        if (!expressionsInterfaces11) return;
        var FootageInterface11 = expressionsInterfaces11("footage");
        this.layerInterface = FootageInterface11(this);
    };
    FootageElement.prototype.getFootageData = function() {
        return this.footageData;
    };
    function AudioElement(data11, globalData11, comp11) {
        this.initFrame();
        this.initRenderable();
        this.assetData = globalData11.getAssetData(data11.refId);
        this.initBaseData(data11, globalData11, comp11);
        this._isPlaying = false;
        this._canPlay = false;
        var assetPath11 = this.globalData.getAssetsPath(this.assetData);
        this.audio = this.globalData.audioController.createAudio(assetPath11);
        this._currentTime = 0;
        this.globalData.audioController.addAudio(this);
        this._volumeMultiplier = 1;
        this._volume = 1;
        this._previousVolume = null;
        this.tm = data11.tm ? PropertyFactory.getProp(this, data11.tm, 0, globalData11.frameRate, this) : {
            _placeholder: true
        };
        this.lv = PropertyFactory.getProp(this, data11.au && data11.au.lv ? data11.au.lv : {
            k: [
                100
            ]
        }, 1, 0.01, this);
    }
    AudioElement.prototype.prepareFrame = function(num11) {
        this.prepareRenderableFrame(num11, true);
        this.prepareProperties(num11, true);
        if (!this.tm._placeholder) {
            var timeRemapped11 = this.tm.v;
            this._currentTime = timeRemapped11;
        } else this._currentTime = num11 / this.data.sr;
        this._volume = this.lv.v[0];
        var totalVolume11 = this._volume * this._volumeMultiplier;
        if (this._previousVolume !== totalVolume11) {
            this._previousVolume = totalVolume11;
            this.audio.volume(totalVolume11);
        }
    };
    extendPrototype([
        RenderableElement,
        BaseElement,
        FrameElement
    ], AudioElement);
    AudioElement.prototype.renderFrame = function() {
        if (this.isInRange && this._canPlay) {
            if (!this._isPlaying) {
                this.audio.play();
                this.audio.seek(this._currentTime / this.globalData.frameRate);
                this._isPlaying = true;
            } else if (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) this.audio.seek(this._currentTime / this.globalData.frameRate);
        }
    };
    AudioElement.prototype.show = function() {};
    AudioElement.prototype.hide = function() {
        this.audio.pause();
        this._isPlaying = false;
    };
    AudioElement.prototype.pause = function() {
        this.audio.pause();
        this._isPlaying = false;
        this._canPlay = false;
    };
    AudioElement.prototype.resume = function() {
        this._canPlay = true;
    };
    AudioElement.prototype.setRate = function(rateValue11) {
        this.audio.rate(rateValue11);
    };
    AudioElement.prototype.volume = function(volumeValue11) {
        this._volumeMultiplier = volumeValue11;
        this._previousVolume = volumeValue11 * this._volume;
        this.audio.volume(this._previousVolume);
    };
    AudioElement.prototype.getBaseElement = function() {
        return null;
    };
    AudioElement.prototype.destroy = function() {};
    AudioElement.prototype.sourceRectAtTime = function() {};
    AudioElement.prototype.initExpressions = function() {};
    function BaseRenderer() {}
    BaseRenderer.prototype.checkLayers = function(num11) {
        var i31;
        var len11 = this.layers.length;
        var data11;
        this.completeLayers = true;
        for(i31 = len11 - 1; i31 >= 0; i31 -= 1){
            if (!this.elements[i31]) {
                data11 = this.layers[i31];
                if (data11.ip - data11.st <= num11 - this.layers[i31].st && data11.op - data11.st > num11 - this.layers[i31].st) this.buildItem(i31);
            }
            this.completeLayers = this.elements[i31] ? this.completeLayers : false;
        }
        this.checkPendingElements();
    };
    BaseRenderer.prototype.createItem = function(layer11) {
        switch(layer11.ty){
            case 2:
                return this.createImage(layer11);
            case 0:
                return this.createComp(layer11);
            case 1:
                return this.createSolid(layer11);
            case 3:
                return this.createNull(layer11);
            case 4:
                return this.createShape(layer11);
            case 5:
                return this.createText(layer11);
            case 6:
                return this.createAudio(layer11);
            case 13:
                return this.createCamera(layer11);
            case 15:
                return this.createFootage(layer11);
            default:
                return this.createNull(layer11);
        }
    };
    BaseRenderer.prototype.createCamera = function() {
        throw new Error("You're using a 3d camera. Try the html renderer.");
    };
    BaseRenderer.prototype.createAudio = function(data11) {
        return new AudioElement(data11, this.globalData, this);
    };
    BaseRenderer.prototype.createFootage = function(data11) {
        return new FootageElement(data11, this.globalData, this);
    };
    BaseRenderer.prototype.buildAllItems = function() {
        var i31;
        var len11 = this.layers.length;
        for(i31 = 0; i31 < len11; i31 += 1)this.buildItem(i31);
        this.checkPendingElements();
    };
    BaseRenderer.prototype.includeLayers = function(newLayers11) {
        this.completeLayers = false;
        var i31;
        var len11 = newLayers11.length;
        var j31;
        var jLen11 = this.layers.length;
        for(i31 = 0; i31 < len11; i31 += 1){
            j31 = 0;
            while(j31 < jLen11){
                if (this.layers[j31].id === newLayers11[i31].id) {
                    this.layers[j31] = newLayers11[i31];
                    break;
                }
                j31 += 1;
            }
        }
    };
    BaseRenderer.prototype.setProjectInterface = function(pInterface11) {
        this.globalData.projectInterface = pInterface11;
    };
    BaseRenderer.prototype.initItems = function() {
        if (!this.globalData.progressiveLoad) this.buildAllItems();
    };
    BaseRenderer.prototype.buildElementParenting = function(element11, parentName11, hierarchy11) {
        var elements11 = this.elements;
        var layers11 = this.layers;
        var i31 = 0;
        var len11 = layers11.length;
        while(i31 < len11){
            if (layers11[i31].ind == parentName11) {
                // eslint-disable-line eqeqeq
                if (!elements11[i31] || elements11[i31] === true) {
                    this.buildItem(i31);
                    this.addPendingElement(element11);
                } else {
                    hierarchy11.push(elements11[i31]);
                    elements11[i31].setAsParent();
                    if (layers11[i31].parent !== undefined) this.buildElementParenting(element11, layers11[i31].parent, hierarchy11);
                    else element11.setHierarchy(hierarchy11);
                }
            }
            i31 += 1;
        }
    };
    BaseRenderer.prototype.addPendingElement = function(element11) {
        this.pendingElements.push(element11);
    };
    BaseRenderer.prototype.searchExtraCompositions = function(assets11) {
        var i31;
        var len11 = assets11.length;
        for(i31 = 0; i31 < len11; i31 += 1)if (assets11[i31].xt) {
            var comp11 = this.createComp(assets11[i31]);
            comp11.initExpressions();
            this.globalData.projectInterface.registerComposition(comp11);
        }
    };
    BaseRenderer.prototype.getElementById = function(ind11) {
        var i31;
        var len11 = this.elements.length;
        for(i31 = 0; i31 < len11; i31 += 1){
            if (this.elements[i31].data.ind === ind11) return this.elements[i31];
        }
        return null;
    };
    BaseRenderer.prototype.getElementByPath = function(path11) {
        var pathValue11 = path11.shift();
        var element11;
        if (typeof pathValue11 === "number") element11 = this.elements[pathValue11];
        else {
            var i31;
            var len11 = this.elements.length;
            for(i31 = 0; i31 < len11; i31 += 1)if (this.elements[i31].data.nm === pathValue11) {
                element11 = this.elements[i31];
                break;
            }
        }
        if (path11.length === 0) return element11;
        return element11.getElementByPath(path11);
    };
    BaseRenderer.prototype.setupGlobalData = function(animData11, fontsContainer11) {
        this.globalData.fontManager = new FontManager();
        this.globalData.slotManager = slotFactory(animData11);
        this.globalData.fontManager.addChars(animData11.chars);
        this.globalData.fontManager.addFonts(animData11.fonts, fontsContainer11);
        this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
        this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
        this.globalData.imageLoader = this.animationItem.imagePreloader;
        this.globalData.audioController = this.animationItem.audioController;
        this.globalData.frameId = 0;
        this.globalData.frameRate = animData11.fr;
        this.globalData.nm = animData11.nm;
        this.globalData.compSize = {
            w: animData11.w,
            h: animData11.h
        };
    };
    var effectTypes = {
        TRANSFORM_EFFECT: "transformEFfect"
    };
    function TransformElement() {}
    TransformElement.prototype = {
        initTransform: function initTransform11() {
            var mat11 = new Matrix();
            this.finalTransform = {
                mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
                    o: 0
                },
                _matMdf: false,
                _localMatMdf: false,
                _opMdf: false,
                mat: mat11,
                localMat: mat11,
                localOpacity: 1
            };
            if (this.data.ao) this.finalTransform.mProp.autoOriented = true;
             // TODO: check TYPE 11: Guided elements
            this.data.ty;
        },
        renderTransform: function renderTransform11() {
            this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame;
            this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame;
            if (this.hierarchy) {
                var mat11;
                var finalMat11 = this.finalTransform.mat;
                var i31 = 0;
                var len11 = this.hierarchy.length; // Checking if any of the transformation matrices in the hierarchy chain has changed.
                if (!this.finalTransform._matMdf) while(i31 < len11){
                    if (this.hierarchy[i31].finalTransform.mProp._mdf) {
                        this.finalTransform._matMdf = true;
                        break;
                    }
                    i31 += 1;
                }
                if (this.finalTransform._matMdf) {
                    mat11 = this.finalTransform.mProp.v.props;
                    finalMat11.cloneFromProps(mat11);
                    for(i31 = 0; i31 < len11; i31 += 1)finalMat11.multiply(this.hierarchy[i31].finalTransform.mProp.v);
                }
            }
            if (this.finalTransform._matMdf) this.finalTransform._localMatMdf = this.finalTransform._matMdf;
            if (this.finalTransform._opMdf) this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
        },
        renderLocalTransform: function renderLocalTransform11() {
            if (this.localTransforms) {
                var i31 = 0;
                var len11 = this.localTransforms.length;
                this.finalTransform._localMatMdf = this.finalTransform._matMdf;
                if (!this.finalTransform._localMatMdf || !this.finalTransform._opMdf) while(i31 < len11){
                    if (this.localTransforms[i31]._mdf) this.finalTransform._localMatMdf = true;
                    if (this.localTransforms[i31]._opMdf && !this.finalTransform._opMdf) {
                        this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
                        this.finalTransform._opMdf = true;
                    }
                    i31 += 1;
                }
                if (this.finalTransform._localMatMdf) {
                    var localMat11 = this.finalTransform.localMat;
                    this.localTransforms[0].matrix.clone(localMat11);
                    for(i31 = 1; i31 < len11; i31 += 1){
                        var lmat11 = this.localTransforms[i31].matrix;
                        localMat11.multiply(lmat11);
                    }
                    localMat11.multiply(this.finalTransform.mat);
                }
                if (this.finalTransform._opMdf) {
                    var localOp11 = this.finalTransform.localOpacity;
                    for(i31 = 0; i31 < len11; i31 += 1)localOp11 *= this.localTransforms[i31].opacity * 0.01;
                    this.finalTransform.localOpacity = localOp11;
                }
            }
        },
        searchEffectTransforms: function searchEffectTransforms11() {
            if (this.renderableEffectsManager) {
                var transformEffects11 = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
                if (transformEffects11.length) {
                    this.localTransforms = [];
                    this.finalTransform.localMat = new Matrix();
                    var i31 = 0;
                    var len11 = transformEffects11.length;
                    for(i31 = 0; i31 < len11; i31 += 1)this.localTransforms.push(transformEffects11[i31]);
                }
            }
        },
        globalToLocal: function globalToLocal11(pt51) {
            var transforms11 = [];
            transforms11.push(this.finalTransform);
            var flag11 = true;
            var comp11 = this.comp;
            while(flag11)if (comp11.finalTransform) {
                if (comp11.data.hasMask) transforms11.splice(0, 0, comp11.finalTransform);
                comp11 = comp11.comp;
            } else flag11 = false;
            var i31;
            var len11 = transforms11.length;
            var ptNew11;
            for(i31 = 0; i31 < len11; i31 += 1){
                ptNew11 = transforms11[i31].mat.applyToPointArray(0, 0, 0); // ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
                pt51 = [
                    pt51[0] - ptNew11[0],
                    pt51[1] - ptNew11[1],
                    0
                ];
            }
            return pt51;
        },
        mHelper: new Matrix()
    };
    function MaskElement(data11, element11, globalData11) {
        this.data = data11;
        this.element = element11;
        this.globalData = globalData11;
        this.storedData = [];
        this.masksProperties = this.data.masksProperties || [];
        this.maskElement = null;
        var defs11 = this.globalData.defs;
        var i31;
        var len11 = this.masksProperties ? this.masksProperties.length : 0;
        this.viewData = createSizedArray(len11);
        this.solidPath = "";
        var path11;
        var properties11 = this.masksProperties;
        var count11 = 0;
        var currentMasks11 = [];
        var j31;
        var jLen11;
        var layerId11 = createElementID();
        var rect11;
        var expansor11;
        var feMorph11;
        var x41;
        var maskType11 = "clipPath";
        var maskRef11 = "clip-path";
        for(i31 = 0; i31 < len11; i31 += 1){
            if (properties11[i31].mode !== "a" && properties11[i31].mode !== "n" || properties11[i31].inv || properties11[i31].o.k !== 100 || properties11[i31].o.x) {
                maskType11 = "mask";
                maskRef11 = "mask";
            }
            if ((properties11[i31].mode === "s" || properties11[i31].mode === "i") && count11 === 0) {
                rect11 = createNS("rect");
                rect11.setAttribute("fill", "#ffffff");
                rect11.setAttribute("width", this.element.comp.data.w || 0);
                rect11.setAttribute("height", this.element.comp.data.h || 0);
                currentMasks11.push(rect11);
            } else rect11 = null;
            path11 = createNS("path");
            if (properties11[i31].mode === "n") {
                // TODO move this to a factory or to a constructor
                this.viewData[i31] = {
                    op: PropertyFactory.getProp(this.element, properties11[i31].o, 0, 0.01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, properties11[i31], 3),
                    elem: path11,
                    lastPath: ""
                };
                defs11.appendChild(path11);
            } else {
                count11 += 1;
                path11.setAttribute("fill", properties11[i31].mode === "s" ? "#000000" : "#ffffff");
                path11.setAttribute("clip-rule", "nonzero");
                var filterID11;
                if (properties11[i31].x.k !== 0) {
                    maskType11 = "mask";
                    maskRef11 = "mask";
                    x41 = PropertyFactory.getProp(this.element, properties11[i31].x, 0, null, this.element);
                    filterID11 = createElementID();
                    expansor11 = createNS("filter");
                    expansor11.setAttribute("id", filterID11);
                    feMorph11 = createNS("feMorphology");
                    feMorph11.setAttribute("operator", "erode");
                    feMorph11.setAttribute("in", "SourceGraphic");
                    feMorph11.setAttribute("radius", "0");
                    expansor11.appendChild(feMorph11);
                    defs11.appendChild(expansor11);
                    path11.setAttribute("stroke", properties11[i31].mode === "s" ? "#000000" : "#ffffff");
                } else {
                    feMorph11 = null;
                    x41 = null;
                } // TODO move this to a factory or to a constructor
                this.storedData[i31] = {
                    elem: path11,
                    x: x41,
                    expan: feMorph11,
                    lastPath: "",
                    lastOperator: "",
                    filterId: filterID11,
                    lastRadius: 0
                };
                if (properties11[i31].mode === "i") {
                    jLen11 = currentMasks11.length;
                    var g31 = createNS("g");
                    for(j31 = 0; j31 < jLen11; j31 += 1)g31.appendChild(currentMasks11[j31]);
                    var mask11 = createNS("mask");
                    mask11.setAttribute("mask-type", "alpha");
                    mask11.setAttribute("id", layerId11 + "_" + count11);
                    mask11.appendChild(path11);
                    defs11.appendChild(mask11);
                    g31.setAttribute("mask", "url(" + getLocationHref() + "#" + layerId11 + "_" + count11 + ")");
                    currentMasks11.length = 0;
                    currentMasks11.push(g31);
                } else currentMasks11.push(path11);
                if (properties11[i31].inv && !this.solidPath) this.solidPath = this.createLayerSolidPath();
                 // TODO move this to a factory or to a constructor
                this.viewData[i31] = {
                    elem: path11,
                    lastPath: "",
                    op: PropertyFactory.getProp(this.element, properties11[i31].o, 0, 0.01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, properties11[i31], 3),
                    invRect: rect11
                };
                if (!this.viewData[i31].prop.k) this.drawPath(properties11[i31], this.viewData[i31].prop.v, this.viewData[i31]);
            }
        }
        this.maskElement = createNS(maskType11);
        len11 = currentMasks11.length;
        for(i31 = 0; i31 < len11; i31 += 1)this.maskElement.appendChild(currentMasks11[i31]);
        if (count11 > 0) {
            this.maskElement.setAttribute("id", layerId11);
            this.element.maskedElement.setAttribute(maskRef11, "url(" + getLocationHref() + "#" + layerId11 + ")");
            defs11.appendChild(this.maskElement);
        }
        if (this.viewData.length) this.element.addRenderableComponent(this);
    }
    MaskElement.prototype.getMaskProperty = function(pos11) {
        return this.viewData[pos11].prop;
    };
    MaskElement.prototype.renderFrame = function(isFirstFrame11) {
        var finalMat11 = this.element.finalTransform.mat;
        var i31;
        var len11 = this.masksProperties.length;
        for(i31 = 0; i31 < len11; i31 += 1){
            if (this.viewData[i31].prop._mdf || isFirstFrame11) this.drawPath(this.masksProperties[i31], this.viewData[i31].prop.v, this.viewData[i31]);
            if (this.viewData[i31].op._mdf || isFirstFrame11) this.viewData[i31].elem.setAttribute("fill-opacity", this.viewData[i31].op.v);
            if (this.masksProperties[i31].mode !== "n") {
                if (this.viewData[i31].invRect && (this.element.finalTransform.mProp._mdf || isFirstFrame11)) this.viewData[i31].invRect.setAttribute("transform", finalMat11.getInverseMatrix().to2dCSS());
                if (this.storedData[i31].x && (this.storedData[i31].x._mdf || isFirstFrame11)) {
                    var feMorph11 = this.storedData[i31].expan;
                    if (this.storedData[i31].x.v < 0) {
                        if (this.storedData[i31].lastOperator !== "erode") {
                            this.storedData[i31].lastOperator = "erode";
                            this.storedData[i31].elem.setAttribute("filter", "url(" + getLocationHref() + "#" + this.storedData[i31].filterId + ")");
                        }
                        feMorph11.setAttribute("radius", -this.storedData[i31].x.v);
                    } else {
                        if (this.storedData[i31].lastOperator !== "dilate") {
                            this.storedData[i31].lastOperator = "dilate";
                            this.storedData[i31].elem.setAttribute("filter", null);
                        }
                        this.storedData[i31].elem.setAttribute("stroke-width", this.storedData[i31].x.v * 2);
                    }
                }
            }
        }
    };
    MaskElement.prototype.getMaskelement = function() {
        return this.maskElement;
    };
    MaskElement.prototype.createLayerSolidPath = function() {
        var path11 = "M0,0 ";
        path11 += " h" + this.globalData.compSize.w;
        path11 += " v" + this.globalData.compSize.h;
        path11 += " h-" + this.globalData.compSize.w;
        path11 += " v-" + this.globalData.compSize.h + " ";
        return path11;
    };
    MaskElement.prototype.drawPath = function(pathData11, pathNodes11, viewData11) {
        var pathString11 = " M" + pathNodes11.v[0][0] + "," + pathNodes11.v[0][1];
        var i31;
        var len11;
        len11 = pathNodes11._length;
        for(i31 = 1; i31 < len11; i31 += 1)// pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
        pathString11 += " C" + pathNodes11.o[i31 - 1][0] + "," + pathNodes11.o[i31 - 1][1] + " " + pathNodes11.i[i31][0] + "," + pathNodes11.i[i31][1] + " " + pathNodes11.v[i31][0] + "," + pathNodes11.v[i31][1];
         // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
        if (pathNodes11.c && len11 > 1) pathString11 += " C" + pathNodes11.o[i31 - 1][0] + "," + pathNodes11.o[i31 - 1][1] + " " + pathNodes11.i[0][0] + "," + pathNodes11.i[0][1] + " " + pathNodes11.v[0][0] + "," + pathNodes11.v[0][1];
         // pathNodes.__renderedString = pathString;
        if (viewData11.lastPath !== pathString11) {
            var pathShapeValue11 = "";
            if (viewData11.elem) {
                if (pathNodes11.c) pathShapeValue11 = pathData11.inv ? this.solidPath + pathString11 : pathString11;
                viewData11.elem.setAttribute("d", pathShapeValue11);
            }
            viewData11.lastPath = pathString11;
        }
    };
    MaskElement.prototype.destroy = function() {
        this.element = null;
        this.globalData = null;
        this.maskElement = null;
        this.data = null;
        this.masksProperties = null;
    };
    var filtersFactory = function() {
        var ob11 = {};
        ob11.createFilter = createFilter11;
        ob11.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter11;
        function createFilter11(filId11, skipCoordinates11) {
            var fil11 = createNS("filter");
            fil11.setAttribute("id", filId11);
            if (skipCoordinates11 !== true) {
                fil11.setAttribute("filterUnits", "objectBoundingBox");
                fil11.setAttribute("x", "0%");
                fil11.setAttribute("y", "0%");
                fil11.setAttribute("width", "100%");
                fil11.setAttribute("height", "100%");
            }
            return fil11;
        }
        function createAlphaToLuminanceFilter11() {
            var feColorMatrix11 = createNS("feColorMatrix");
            feColorMatrix11.setAttribute("type", "matrix");
            feColorMatrix11.setAttribute("color-interpolation-filters", "sRGB");
            feColorMatrix11.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1");
            return feColorMatrix11;
        }
        return ob11;
    }();
    var featureSupport = function() {
        var ob11 = {
            maskType: true,
            svgLumaHidden: true,
            offscreenCanvas: typeof OffscreenCanvas !== "undefined"
        };
        if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) ob11.maskType = false;
        if (/firefox/i.test(navigator.userAgent)) ob11.svgLumaHidden = false;
        return ob11;
    }();
    var registeredEffects$1 = {};
    var idPrefix = "filter_result_";
    function SVGEffects(elem31) {
        var i31;
        var source11 = "SourceGraphic";
        var len11 = elem31.data.ef ? elem31.data.ef.length : 0;
        var filId11 = createElementID();
        var fil11 = filtersFactory.createFilter(filId11, true);
        var count11 = 0;
        this.filters = [];
        var filterManager11;
        for(i31 = 0; i31 < len11; i31 += 1){
            filterManager11 = null;
            var type11 = elem31.data.ef[i31].ty;
            if (registeredEffects$1[type11]) {
                var Effect11 = registeredEffects$1[type11].effect;
                filterManager11 = new Effect11(fil11, elem31.effectsManager.effectElements[i31], elem31, idPrefix + count11, source11);
                source11 = idPrefix + count11;
                if (registeredEffects$1[type11].countsAsEffect) count11 += 1;
            }
            if (filterManager11) this.filters.push(filterManager11);
        }
        if (count11) {
            elem31.globalData.defs.appendChild(fil11);
            elem31.layerElement.setAttribute("filter", "url(" + getLocationHref() + "#" + filId11 + ")");
        }
        if (this.filters.length) elem31.addRenderableComponent(this);
    }
    SVGEffects.prototype.renderFrame = function(_isFirstFrame11) {
        var i31;
        var len11 = this.filters.length;
        for(i31 = 0; i31 < len11; i31 += 1)this.filters[i31].renderFrame(_isFirstFrame11);
    };
    SVGEffects.prototype.getEffects = function(type11) {
        var i31;
        var len11 = this.filters.length;
        var effects11 = [];
        for(i31 = 0; i31 < len11; i31 += 1)if (this.filters[i31].type === type11) effects11.push(this.filters[i31]);
        return effects11;
    };
    function registerEffect$1(id11, effect11, countsAsEffect11) {
        registeredEffects$1[id11] = {
            effect: effect11,
            countsAsEffect: countsAsEffect11
        };
    }
    function SVGBaseElement() {}
    SVGBaseElement.prototype = {
        initRendererElement: function initRendererElement11() {
            this.layerElement = createNS("g");
        },
        createContainerElements: function createContainerElements11() {
            this.matteElement = createNS("g");
            this.transformedElement = this.layerElement;
            this.maskedElement = this.layerElement;
            this._sizeChanged = false;
            var layerElementParent11 = null; // If this layer acts as a mask for the following layer
            if (this.data.td) {
                this.matteMasks = {};
                var gg11 = createNS("g");
                gg11.setAttribute("id", this.layerId);
                gg11.appendChild(this.layerElement);
                layerElementParent11 = gg11;
                this.globalData.defs.appendChild(gg11);
            } else if (this.data.tt) {
                this.matteElement.appendChild(this.layerElement);
                layerElementParent11 = this.matteElement;
                this.baseElement = this.matteElement;
            } else this.baseElement = this.layerElement;
            if (this.data.ln) this.layerElement.setAttribute("id", this.data.ln);
            if (this.data.cl) this.layerElement.setAttribute("class", this.data.cl);
             // Clipping compositions to hide content that exceeds boundaries. If collapsed transformations is on, component should not be clipped
            if (this.data.ty === 0 && !this.data.hd) {
                var cp11 = createNS("clipPath");
                var pt51 = createNS("path");
                pt51.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
                var clipId11 = createElementID();
                cp11.setAttribute("id", clipId11);
                cp11.appendChild(pt51);
                this.globalData.defs.appendChild(cp11);
                if (this.checkMasks()) {
                    var cpGroup11 = createNS("g");
                    cpGroup11.setAttribute("clip-path", "url(" + getLocationHref() + "#" + clipId11 + ")");
                    cpGroup11.appendChild(this.layerElement);
                    this.transformedElement = cpGroup11;
                    if (layerElementParent11) layerElementParent11.appendChild(this.transformedElement);
                    else this.baseElement = this.transformedElement;
                } else this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + clipId11 + ")");
            }
            if (this.data.bm !== 0) this.setBlendMode();
        },
        renderElement: function renderElement11() {
            if (this.finalTransform._localMatMdf) this.transformedElement.setAttribute("transform", this.finalTransform.localMat.to2dCSS());
            if (this.finalTransform._opMdf) this.transformedElement.setAttribute("opacity", this.finalTransform.localOpacity);
        },
        destroyBaseElement: function destroyBaseElement11() {
            this.layerElement = null;
            this.matteElement = null;
            this.maskManager.destroy();
        },
        getBaseElement: function getBaseElement11() {
            if (this.data.hd) return null;
            return this.baseElement;
        },
        createRenderableComponents: function createRenderableComponents11() {
            this.maskManager = new MaskElement(this.data, this, this.globalData);
            this.renderableEffectsManager = new SVGEffects(this);
            this.searchEffectTransforms();
        },
        getMatte: function getMatte11(matteType11) {
            // This should not be a common case. But for backward compatibility, we'll create the matte object.
            // It solves animations that have two consecutive layers marked as matte masks.
            // Which is an undefined behavior in AE.
            if (!this.matteMasks) this.matteMasks = {};
            if (!this.matteMasks[matteType11]) {
                var id11 = this.layerId + "_" + matteType11;
                var filId11;
                var fil11;
                var useElement11;
                var gg11;
                if (matteType11 === 1 || matteType11 === 3) {
                    var masker11 = createNS("mask");
                    masker11.setAttribute("id", id11);
                    masker11.setAttribute("mask-type", matteType11 === 3 ? "luminance" : "alpha");
                    useElement11 = createNS("use");
                    useElement11.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId);
                    masker11.appendChild(useElement11);
                    this.globalData.defs.appendChild(masker11);
                    if (!featureSupport.maskType && matteType11 === 1) {
                        masker11.setAttribute("mask-type", "luminance");
                        filId11 = createElementID();
                        fil11 = filtersFactory.createFilter(filId11);
                        this.globalData.defs.appendChild(fil11);
                        fil11.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                        gg11 = createNS("g");
                        gg11.appendChild(useElement11);
                        masker11.appendChild(gg11);
                        gg11.setAttribute("filter", "url(" + getLocationHref() + "#" + filId11 + ")");
                    }
                } else if (matteType11 === 2) {
                    var maskGroup11 = createNS("mask");
                    maskGroup11.setAttribute("id", id11);
                    maskGroup11.setAttribute("mask-type", "alpha");
                    var maskGrouper11 = createNS("g");
                    maskGroup11.appendChild(maskGrouper11);
                    filId11 = createElementID();
                    fil11 = filtersFactory.createFilter(filId11); /// /
                    var feCTr11 = createNS("feComponentTransfer");
                    feCTr11.setAttribute("in", "SourceGraphic");
                    fil11.appendChild(feCTr11);
                    var feFunc11 = createNS("feFuncA");
                    feFunc11.setAttribute("type", "table");
                    feFunc11.setAttribute("tableValues", "1.0 0.0");
                    feCTr11.appendChild(feFunc11); /// /
                    this.globalData.defs.appendChild(fil11);
                    var alphaRect11 = createNS("rect");
                    alphaRect11.setAttribute("width", this.comp.data.w);
                    alphaRect11.setAttribute("height", this.comp.data.h);
                    alphaRect11.setAttribute("x", "0");
                    alphaRect11.setAttribute("y", "0");
                    alphaRect11.setAttribute("fill", "#ffffff");
                    alphaRect11.setAttribute("opacity", "0");
                    maskGrouper11.setAttribute("filter", "url(" + getLocationHref() + "#" + filId11 + ")");
                    maskGrouper11.appendChild(alphaRect11);
                    useElement11 = createNS("use");
                    useElement11.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId);
                    maskGrouper11.appendChild(useElement11);
                    if (!featureSupport.maskType) {
                        maskGroup11.setAttribute("mask-type", "luminance");
                        fil11.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                        gg11 = createNS("g");
                        maskGrouper11.appendChild(alphaRect11);
                        gg11.appendChild(this.layerElement);
                        maskGrouper11.appendChild(gg11);
                    }
                    this.globalData.defs.appendChild(maskGroup11);
                }
                this.matteMasks[matteType11] = id11;
            }
            return this.matteMasks[matteType11];
        },
        setMatte: function setMatte11(id11) {
            if (!this.matteElement) return;
            this.matteElement.setAttribute("mask", "url(" + getLocationHref() + "#" + id11 + ")");
        }
    };
    /**
   * @file
   * Handles AE's layer parenting property.
   *
   */ function HierarchyElement() {}
    HierarchyElement.prototype = {
        /**
       * @function
       * Initializes hierarchy properties
       *
       */ initHierarchy: function initHierarchy11() {
            // element's parent list
            this.hierarchy = []; // if element is parent of another layer _isParent will be true
            this._isParent = false;
            this.checkParenting();
        },
        /**
       * @function
       * Sets layer's hierarchy.
       * @param {array} hierarch
       * layer's parent list
       *
       */ setHierarchy: function setHierarchy11(hierarchy11) {
            this.hierarchy = hierarchy11;
        },
        /**
       * @function
       * Sets layer as parent.
       *
       */ setAsParent: function setAsParent11() {
            this._isParent = true;
        },
        /**
       * @function
       * Searches layer's parenting chain
       *
       */ checkParenting: function checkParenting11() {
            if (this.data.parent !== undefined) this.comp.buildElementParenting(this, this.data.parent, []);
        }
    };
    function RenderableDOMElement() {}
    (function() {
        var _prototype11 = {
            initElement: function initElement11(data11, globalData11, comp11) {
                this.initFrame();
                this.initBaseData(data11, globalData11, comp11);
                this.initTransform(data11, globalData11, comp11);
                this.initHierarchy();
                this.initRenderable();
                this.initRendererElement();
                this.createContainerElements();
                this.createRenderableComponents();
                this.createContent();
                this.hide();
            },
            hide: function hide11() {
                // console.log('HIDE', this);
                if (!this.hidden && (!this.isInRange || this.isTransparent)) {
                    var elem31 = this.baseElement || this.layerElement;
                    elem31.style.display = "none";
                    this.hidden = true;
                }
            },
            show: function show11() {
                // console.log('SHOW', this);
                if (this.isInRange && !this.isTransparent) {
                    if (!this.data.hd) {
                        var elem31 = this.baseElement || this.layerElement;
                        elem31.style.display = "block";
                    }
                    this.hidden = false;
                    this._isFirstFrame = true;
                }
            },
            renderFrame: function renderFrame11() {
                // If it is exported as hidden (data.hd === true) no need to render
                // If it is not visible no need to render
                if (this.data.hd || this.hidden) return;
                this.renderTransform();
                this.renderRenderable();
                this.renderLocalTransform();
                this.renderElement();
                this.renderInnerContent();
                if (this._isFirstFrame) this._isFirstFrame = false;
            },
            renderInnerContent: function renderInnerContent11() {},
            prepareFrame: function prepareFrame11(num11) {
                this._mdf = false;
                this.prepareRenderableFrame(num11);
                this.prepareProperties(num11, this.isInRange);
                this.checkTransparency();
            },
            destroy: function destroy11() {
                this.innerElem = null;
                this.destroyBaseElement();
            }
        };
        extendPrototype([
            RenderableElement,
            createProxyFunction(_prototype11)
        ], RenderableDOMElement);
    })();
    function IImageElement(data11, globalData11, comp11) {
        this.assetData = globalData11.getAssetData(data11.refId);
        if (this.assetData && this.assetData.sid) this.assetData = globalData11.slotManager.getProp(this.assetData);
        this.initElement(data11, globalData11, comp11);
        this.sourceRect = {
            top: 0,
            left: 0,
            width: this.assetData.w,
            height: this.assetData.h
        };
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], IImageElement);
    IImageElement.prototype.createContent = function() {
        var assetPath11 = this.globalData.getAssetsPath(this.assetData);
        this.innerElem = createNS("image");
        this.innerElem.setAttribute("width", this.assetData.w + "px");
        this.innerElem.setAttribute("height", this.assetData.h + "px");
        this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio);
        this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", assetPath11);
        this.layerElement.appendChild(this.innerElem);
    };
    IImageElement.prototype.sourceRectAtTime = function() {
        return this.sourceRect;
    };
    function ProcessedElement(element11, position11) {
        this.elem = element11;
        this.pos = position11;
    }
    function IShapeElement() {}
    IShapeElement.prototype = {
        addShapeToModifiers: function addShapeToModifiers11(data11) {
            var i31;
            var len11 = this.shapeModifiers.length;
            for(i31 = 0; i31 < len11; i31 += 1)this.shapeModifiers[i31].addShape(data11);
        },
        isShapeInAnimatedModifiers: function isShapeInAnimatedModifiers11(data11) {
            var i31 = 0;
            var len11 = this.shapeModifiers.length;
            while(i31 < len11){
                if (this.shapeModifiers[i31].isAnimatedWithShape(data11)) return true;
            }
            return false;
        },
        renderModifiers: function renderModifiers11() {
            if (!this.shapeModifiers.length) return;
            var i31;
            var len11 = this.shapes.length;
            for(i31 = 0; i31 < len11; i31 += 1)this.shapes[i31].sh.reset();
            len11 = this.shapeModifiers.length;
            var shouldBreakProcess11;
            for(i31 = len11 - 1; i31 >= 0; i31 -= 1){
                shouldBreakProcess11 = this.shapeModifiers[i31].processShapes(this._isFirstFrame); // workaround to fix cases where a repeater resets the shape so the following processes get called twice
                // TODO: find a better solution for this
                if (shouldBreakProcess11) break;
            }
        },
        searchProcessedElement: function searchProcessedElement11(elem31) {
            var elements11 = this.processedElements;
            var i31 = 0;
            var len11 = elements11.length;
            while(i31 < len11){
                if (elements11[i31].elem === elem31) return elements11[i31].pos;
                i31 += 1;
            }
            return 0;
        },
        addProcessedElement: function addProcessedElement11(elem31, pos11) {
            var elements11 = this.processedElements;
            var i31 = elements11.length;
            while(i31){
                i31 -= 1;
                if (elements11[i31].elem === elem31) {
                    elements11[i31].pos = pos11;
                    return;
                }
            }
            elements11.push(new ProcessedElement(elem31, pos11));
        },
        prepareFrame: function prepareFrame11(num11) {
            this.prepareRenderableFrame(num11);
            this.prepareProperties(num11, this.isInRange);
        }
    };
    var lineCapEnum = {
        1: "butt",
        2: "round",
        3: "square"
    };
    var lineJoinEnum = {
        1: "miter",
        2: "round",
        3: "bevel"
    };
    function SVGShapeData(transformers11, level11, shape31) {
        this.caches = [];
        this.styles = [];
        this.transformers = transformers11;
        this.lStr = "";
        this.sh = shape31;
        this.lvl = level11; // TODO find if there are some cases where _isAnimated can be false.
        // For now, since shapes add up with other shapes. They have to be calculated every time.
        // One way of finding out is checking if all styles associated to this shape depend only of this shape
        this._isAnimated = !!shape31.k; // TODO: commenting this for now since all shapes are animated
        var i31 = 0;
        var len11 = transformers11.length;
        while(i31 < len11){
            if (transformers11[i31].mProps.dynamicProperties.length) {
                this._isAnimated = true;
                break;
            }
            i31 += 1;
        }
    }
    SVGShapeData.prototype.setAsAnimated = function() {
        this._isAnimated = true;
    };
    function SVGStyleData(data11, level11) {
        this.data = data11;
        this.type = data11.ty;
        this.d = "";
        this.lvl = level11;
        this._mdf = false;
        this.closed = data11.hd === true;
        this.pElem = createNS("path");
        this.msElem = null;
    }
    SVGStyleData.prototype.reset = function() {
        this.d = "";
        this._mdf = false;
    };
    function DashProperty(elem31, data11, renderer11, container11) {
        this.elem = elem31;
        this.frameId = -1;
        this.dataProps = createSizedArray(data11.length);
        this.renderer = renderer11;
        this.k = false;
        this.dashStr = "";
        this.dashArray = createTypedArray("float32", data11.length ? data11.length - 1 : 0);
        this.dashoffset = createTypedArray("float32", 1);
        this.initDynamicPropertyContainer(container11);
        var i31;
        var len11 = data11.length || 0;
        var prop11;
        for(i31 = 0; i31 < len11; i31 += 1){
            prop11 = PropertyFactory.getProp(elem31, data11[i31].v, 0, 0, this);
            this.k = prop11.k || this.k;
            this.dataProps[i31] = {
                n: data11[i31].n,
                p: prop11
            };
        }
        if (!this.k) this.getValue(true);
        this._isAnimated = this.k;
    }
    DashProperty.prototype.getValue = function(forceRender11) {
        if (this.elem.globalData.frameId === this.frameId && !forceRender11) return;
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
        this._mdf = this._mdf || forceRender11;
        if (this._mdf) {
            var i31 = 0;
            var len11 = this.dataProps.length;
            if (this.renderer === "svg") this.dashStr = "";
            for(i31 = 0; i31 < len11; i31 += 1)if (this.dataProps[i31].n !== "o") {
                if (this.renderer === "svg") this.dashStr += " " + this.dataProps[i31].p.v;
                else this.dashArray[i31] = this.dataProps[i31].p.v;
            } else this.dashoffset[0] = this.dataProps[i31].p.v;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], DashProperty);
    function SVGStrokeStyleData(elem31, data11, styleOb11) {
        this.initDynamicPropertyContainer(elem31);
        this.getValue = this.iterateDynamicProperties;
        this.o = PropertyFactory.getProp(elem31, data11.o, 0, 0.01, this);
        this.w = PropertyFactory.getProp(elem31, data11.w, 0, null, this);
        this.d = new DashProperty(elem31, data11.d || {}, "svg", this);
        this.c = PropertyFactory.getProp(elem31, data11.c, 1, 255, this);
        this.style = styleOb11;
        this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGStrokeStyleData);
    function SVGFillStyleData(elem31, data11, styleOb11) {
        this.initDynamicPropertyContainer(elem31);
        this.getValue = this.iterateDynamicProperties;
        this.o = PropertyFactory.getProp(elem31, data11.o, 0, 0.01, this);
        this.c = PropertyFactory.getProp(elem31, data11.c, 1, 255, this);
        this.style = styleOb11;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGFillStyleData);
    function SVGNoStyleData(elem31, data11, styleOb11) {
        this.initDynamicPropertyContainer(elem31);
        this.getValue = this.iterateDynamicProperties;
        this.style = styleOb11;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGNoStyleData);
    function GradientProperty(elem31, data11, container11) {
        this.data = data11;
        this.c = createTypedArray("uint8c", data11.p * 4);
        var cLength11 = data11.k.k[0].s ? data11.k.k[0].s.length - data11.p * 4 : data11.k.k.length - data11.p * 4;
        this.o = createTypedArray("float32", cLength11);
        this._cmdf = false;
        this._omdf = false;
        this._collapsable = this.checkCollapsable();
        this._hasOpacity = cLength11;
        this.initDynamicPropertyContainer(container11);
        this.prop = PropertyFactory.getProp(elem31, data11.k, 1, null, this);
        this.k = this.prop.k;
        this.getValue(true);
    }
    GradientProperty.prototype.comparePoints = function(values11, points11) {
        var i31 = 0;
        var len11 = this.o.length / 2;
        var diff11;
        while(i31 < len11){
            diff11 = Math.abs(values11[i31 * 4] - values11[points11 * 4 + i31 * 2]);
            if (diff11 > 0.01) return false;
            i31 += 1;
        }
        return true;
    };
    GradientProperty.prototype.checkCollapsable = function() {
        if (this.o.length / 2 !== this.c.length / 4) return false;
        if (this.data.k.k[0].s) {
            var i31 = 0;
            var len11 = this.data.k.k.length;
            while(i31 < len11){
                if (!this.comparePoints(this.data.k.k[i31].s, this.data.p)) return false;
                i31 += 1;
            }
        } else if (!this.comparePoints(this.data.k.k, this.data.p)) return false;
        return true;
    };
    GradientProperty.prototype.getValue = function(forceRender11) {
        this.prop.getValue();
        this._mdf = false;
        this._cmdf = false;
        this._omdf = false;
        if (this.prop._mdf || forceRender11) {
            var i31;
            var len11 = this.data.p * 4;
            var mult11;
            var val31;
            for(i31 = 0; i31 < len11; i31 += 1){
                mult11 = i31 % 4 === 0 ? 100 : 255;
                val31 = Math.round(this.prop.v[i31] * mult11);
                if (this.c[i31] !== val31) {
                    this.c[i31] = val31;
                    this._cmdf = !forceRender11;
                }
            }
            if (this.o.length) {
                len11 = this.prop.v.length;
                for(i31 = this.data.p * 4; i31 < len11; i31 += 1){
                    mult11 = i31 % 2 === 0 ? 100 : 1;
                    val31 = i31 % 2 === 0 ? Math.round(this.prop.v[i31] * 100) : this.prop.v[i31];
                    if (this.o[i31 - this.data.p * 4] !== val31) {
                        this.o[i31 - this.data.p * 4] = val31;
                        this._omdf = !forceRender11;
                    }
                }
            }
            this._mdf = !forceRender11;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], GradientProperty);
    function SVGGradientFillStyleData(elem31, data11, styleOb11) {
        this.initDynamicPropertyContainer(elem31);
        this.getValue = this.iterateDynamicProperties;
        this.initGradientData(elem31, data11, styleOb11);
    }
    SVGGradientFillStyleData.prototype.initGradientData = function(elem31, data11, styleOb11) {
        this.o = PropertyFactory.getProp(elem31, data11.o, 0, 0.01, this);
        this.s = PropertyFactory.getProp(elem31, data11.s, 1, null, this);
        this.e = PropertyFactory.getProp(elem31, data11.e, 1, null, this);
        this.h = PropertyFactory.getProp(elem31, data11.h || {
            k: 0
        }, 0, 0.01, this);
        this.a = PropertyFactory.getProp(elem31, data11.a || {
            k: 0
        }, 0, degToRads, this);
        this.g = new GradientProperty(elem31, data11.g, this);
        this.style = styleOb11;
        this.stops = [];
        this.setGradientData(styleOb11.pElem, data11);
        this.setGradientOpacity(data11, styleOb11);
        this._isAnimated = !!this._isAnimated;
    };
    SVGGradientFillStyleData.prototype.setGradientData = function(pathElement11, data11) {
        var gradientId11 = createElementID();
        var gfill11 = createNS(data11.t === 1 ? "linearGradient" : "radialGradient");
        gfill11.setAttribute("id", gradientId11);
        gfill11.setAttribute("spreadMethod", "pad");
        gfill11.setAttribute("gradientUnits", "userSpaceOnUse");
        var stops11 = [];
        var stop11;
        var j31;
        var jLen11;
        jLen11 = data11.g.p * 4;
        for(j31 = 0; j31 < jLen11; j31 += 4){
            stop11 = createNS("stop");
            gfill11.appendChild(stop11);
            stops11.push(stop11);
        }
        pathElement11.setAttribute(data11.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + gradientId11 + ")");
        this.gf = gfill11;
        this.cst = stops11;
    };
    SVGGradientFillStyleData.prototype.setGradientOpacity = function(data11, styleOb11) {
        if (this.g._hasOpacity && !this.g._collapsable) {
            var stop11;
            var j31;
            var jLen11;
            var mask11 = createNS("mask");
            var maskElement11 = createNS("path");
            mask11.appendChild(maskElement11);
            var opacityId11 = createElementID();
            var maskId11 = createElementID();
            mask11.setAttribute("id", maskId11);
            var opFill11 = createNS(data11.t === 1 ? "linearGradient" : "radialGradient");
            opFill11.setAttribute("id", opacityId11);
            opFill11.setAttribute("spreadMethod", "pad");
            opFill11.setAttribute("gradientUnits", "userSpaceOnUse");
            jLen11 = data11.g.k.k[0].s ? data11.g.k.k[0].s.length : data11.g.k.k.length;
            var stops11 = this.stops;
            for(j31 = data11.g.p * 4; j31 < jLen11; j31 += 2){
                stop11 = createNS("stop");
                stop11.setAttribute("stop-color", "rgb(255,255,255)");
                opFill11.appendChild(stop11);
                stops11.push(stop11);
            }
            maskElement11.setAttribute(data11.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + opacityId11 + ")");
            if (data11.ty === "gs") {
                maskElement11.setAttribute("stroke-linecap", lineCapEnum[data11.lc || 2]);
                maskElement11.setAttribute("stroke-linejoin", lineJoinEnum[data11.lj || 2]);
                if (data11.lj === 1) maskElement11.setAttribute("stroke-miterlimit", data11.ml);
            }
            this.of = opFill11;
            this.ms = mask11;
            this.ost = stops11;
            this.maskId = maskId11;
            styleOb11.msElem = maskElement11;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], SVGGradientFillStyleData);
    function SVGGradientStrokeStyleData(elem31, data11, styleOb11) {
        this.initDynamicPropertyContainer(elem31);
        this.getValue = this.iterateDynamicProperties;
        this.w = PropertyFactory.getProp(elem31, data11.w, 0, null, this);
        this.d = new DashProperty(elem31, data11.d || {}, "svg", this);
        this.initGradientData(elem31, data11, styleOb11);
        this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([
        SVGGradientFillStyleData,
        DynamicPropertyContainer
    ], SVGGradientStrokeStyleData);
    function ShapeGroupData() {
        this.it = [];
        this.prevViewData = [];
        this.gr = createNS("g");
    }
    function SVGTransformData(mProps11, op11, container11) {
        this.transform = {
            mProps: mProps11,
            op: op11,
            container: container11
        };
        this.elements = [];
        this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
    }
    var buildShapeString = function buildShapeString11(pathNodes11, length11, closed11, mat11) {
        if (length11 === 0) return "";
        var _o11 = pathNodes11.o;
        var _i11 = pathNodes11.i;
        var _v11 = pathNodes11.v;
        var i31;
        var shapeString11 = " M" + mat11.applyToPointStringified(_v11[0][0], _v11[0][1]);
        for(i31 = 1; i31 < length11; i31 += 1)shapeString11 += " C" + mat11.applyToPointStringified(_o11[i31 - 1][0], _o11[i31 - 1][1]) + " " + mat11.applyToPointStringified(_i11[i31][0], _i11[i31][1]) + " " + mat11.applyToPointStringified(_v11[i31][0], _v11[i31][1]);
        if (closed11 && length11) {
            shapeString11 += " C" + mat11.applyToPointStringified(_o11[i31 - 1][0], _o11[i31 - 1][1]) + " " + mat11.applyToPointStringified(_i11[0][0], _i11[0][1]) + " " + mat11.applyToPointStringified(_v11[0][0], _v11[0][1]);
            shapeString11 += "z";
        }
        return shapeString11;
    };
    var SVGElementsRenderer = function() {
        var _identityMatrix11 = new Matrix();
        var _matrixHelper11 = new Matrix();
        var ob11 = {
            createRenderFunction: createRenderFunction11
        };
        function createRenderFunction11(data11) {
            switch(data11.ty){
                case "fl":
                    return renderFill11;
                case "gf":
                    return renderGradient11;
                case "gs":
                    return renderGradientStroke11;
                case "st":
                    return renderStroke11;
                case "sh":
                case "el":
                case "rc":
                case "sr":
                    return renderPath11;
                case "tr":
                    return renderContentTransform11;
                case "no":
                    return renderNoop11;
                default:
                    return null;
            }
        }
        function renderContentTransform11(styleData11, itemData11, isFirstFrame11) {
            if (isFirstFrame11 || itemData11.transform.op._mdf) itemData11.transform.container.setAttribute("opacity", itemData11.transform.op.v);
            if (isFirstFrame11 || itemData11.transform.mProps._mdf) itemData11.transform.container.setAttribute("transform", itemData11.transform.mProps.v.to2dCSS());
        }
        function renderNoop11() {}
        function renderPath11(styleData11, itemData11, isFirstFrame11) {
            var j31;
            var jLen11;
            var pathStringTransformed11;
            var redraw11;
            var pathNodes11;
            var l31;
            var lLen11 = itemData11.styles.length;
            var lvl11 = itemData11.lvl;
            var paths11;
            var mat11;
            var iterations11;
            var k31;
            for(l31 = 0; l31 < lLen11; l31 += 1){
                redraw11 = itemData11.sh._mdf || isFirstFrame11;
                if (itemData11.styles[l31].lvl < lvl11) {
                    mat11 = _matrixHelper11.reset();
                    iterations11 = lvl11 - itemData11.styles[l31].lvl;
                    k31 = itemData11.transformers.length - 1;
                    while(!redraw11 && iterations11 > 0){
                        redraw11 = itemData11.transformers[k31].mProps._mdf || redraw11;
                        iterations11 -= 1;
                        k31 -= 1;
                    }
                    if (redraw11) {
                        iterations11 = lvl11 - itemData11.styles[l31].lvl;
                        k31 = itemData11.transformers.length - 1;
                        while(iterations11 > 0){
                            mat11.multiply(itemData11.transformers[k31].mProps.v);
                            iterations11 -= 1;
                            k31 -= 1;
                        }
                    }
                } else mat11 = _identityMatrix11;
                paths11 = itemData11.sh.paths;
                jLen11 = paths11._length;
                if (redraw11) {
                    pathStringTransformed11 = "";
                    for(j31 = 0; j31 < jLen11; j31 += 1){
                        pathNodes11 = paths11.shapes[j31];
                        if (pathNodes11 && pathNodes11._length) pathStringTransformed11 += buildShapeString(pathNodes11, pathNodes11._length, pathNodes11.c, mat11);
                    }
                    itemData11.caches[l31] = pathStringTransformed11;
                } else pathStringTransformed11 = itemData11.caches[l31];
                itemData11.styles[l31].d += styleData11.hd === true ? "" : pathStringTransformed11;
                itemData11.styles[l31]._mdf = redraw11 || itemData11.styles[l31]._mdf;
            }
        }
        function renderFill11(styleData11, itemData11, isFirstFrame11) {
            var styleElem11 = itemData11.style;
            if (itemData11.c._mdf || isFirstFrame11) styleElem11.pElem.setAttribute("fill", "rgb(" + bmFloor(itemData11.c.v[0]) + "," + bmFloor(itemData11.c.v[1]) + "," + bmFloor(itemData11.c.v[2]) + ")");
            if (itemData11.o._mdf || isFirstFrame11) styleElem11.pElem.setAttribute("fill-opacity", itemData11.o.v);
        }
        function renderGradientStroke11(styleData11, itemData11, isFirstFrame11) {
            renderGradient11(styleData11, itemData11, isFirstFrame11);
            renderStroke11(styleData11, itemData11, isFirstFrame11);
        }
        function renderGradient11(styleData11, itemData11, isFirstFrame11) {
            var gfill11 = itemData11.gf;
            var hasOpacity11 = itemData11.g._hasOpacity;
            var pt111 = itemData11.s.v;
            var pt211 = itemData11.e.v;
            if (itemData11.o._mdf || isFirstFrame11) {
                var attr31 = styleData11.ty === "gf" ? "fill-opacity" : "stroke-opacity";
                itemData11.style.pElem.setAttribute(attr31, itemData11.o.v);
            }
            if (itemData11.s._mdf || isFirstFrame11) {
                var attr111 = styleData11.t === 1 ? "x1" : "cx";
                var attr211 = attr111 === "x1" ? "y1" : "cy";
                gfill11.setAttribute(attr111, pt111[0]);
                gfill11.setAttribute(attr211, pt111[1]);
                if (hasOpacity11 && !itemData11.g._collapsable) {
                    itemData11.of.setAttribute(attr111, pt111[0]);
                    itemData11.of.setAttribute(attr211, pt111[1]);
                }
            }
            var stops11;
            var i31;
            var len11;
            var stop11;
            if (itemData11.g._cmdf || isFirstFrame11) {
                stops11 = itemData11.cst;
                var cValues11 = itemData11.g.c;
                len11 = stops11.length;
                for(i31 = 0; i31 < len11; i31 += 1){
                    stop11 = stops11[i31];
                    stop11.setAttribute("offset", cValues11[i31 * 4] + "%");
                    stop11.setAttribute("stop-color", "rgb(" + cValues11[i31 * 4 + 1] + "," + cValues11[i31 * 4 + 2] + "," + cValues11[i31 * 4 + 3] + ")");
                }
            }
            if (hasOpacity11 && (itemData11.g._omdf || isFirstFrame11)) {
                var oValues11 = itemData11.g.o;
                if (itemData11.g._collapsable) stops11 = itemData11.cst;
                else stops11 = itemData11.ost;
                len11 = stops11.length;
                for(i31 = 0; i31 < len11; i31 += 1){
                    stop11 = stops11[i31];
                    if (!itemData11.g._collapsable) stop11.setAttribute("offset", oValues11[i31 * 2] + "%");
                    stop11.setAttribute("stop-opacity", oValues11[i31 * 2 + 1]);
                }
            }
            if (styleData11.t === 1) {
                if (itemData11.e._mdf || isFirstFrame11) {
                    gfill11.setAttribute("x2", pt211[0]);
                    gfill11.setAttribute("y2", pt211[1]);
                    if (hasOpacity11 && !itemData11.g._collapsable) {
                        itemData11.of.setAttribute("x2", pt211[0]);
                        itemData11.of.setAttribute("y2", pt211[1]);
                    }
                }
            } else {
                var rad11;
                if (itemData11.s._mdf || itemData11.e._mdf || isFirstFrame11) {
                    rad11 = Math.sqrt(Math.pow(pt111[0] - pt211[0], 2) + Math.pow(pt111[1] - pt211[1], 2));
                    gfill11.setAttribute("r", rad11);
                    if (hasOpacity11 && !itemData11.g._collapsable) itemData11.of.setAttribute("r", rad11);
                }
                if (itemData11.e._mdf || itemData11.h._mdf || itemData11.a._mdf || isFirstFrame11) {
                    if (!rad11) rad11 = Math.sqrt(Math.pow(pt111[0] - pt211[0], 2) + Math.pow(pt111[1] - pt211[1], 2));
                    var ang11 = Math.atan2(pt211[1] - pt111[1], pt211[0] - pt111[0]);
                    var percent11 = itemData11.h.v;
                    if (percent11 >= 1) percent11 = 0.99;
                    else if (percent11 <= -1) percent11 = -0.99;
                    var dist41 = rad11 * percent11;
                    var x41 = Math.cos(ang11 + itemData11.a.v) * dist41 + pt111[0];
                    var y41 = Math.sin(ang11 + itemData11.a.v) * dist41 + pt111[1];
                    gfill11.setAttribute("fx", x41);
                    gfill11.setAttribute("fy", y41);
                    if (hasOpacity11 && !itemData11.g._collapsable) {
                        itemData11.of.setAttribute("fx", x41);
                        itemData11.of.setAttribute("fy", y41);
                    }
                } // gfill.setAttribute('fy','200');
            }
        }
        function renderStroke11(styleData11, itemData11, isFirstFrame11) {
            var styleElem11 = itemData11.style;
            var d31 = itemData11.d;
            if (d31 && (d31._mdf || isFirstFrame11) && d31.dashStr) {
                styleElem11.pElem.setAttribute("stroke-dasharray", d31.dashStr);
                styleElem11.pElem.setAttribute("stroke-dashoffset", d31.dashoffset[0]);
            }
            if (itemData11.c && (itemData11.c._mdf || isFirstFrame11)) styleElem11.pElem.setAttribute("stroke", "rgb(" + bmFloor(itemData11.c.v[0]) + "," + bmFloor(itemData11.c.v[1]) + "," + bmFloor(itemData11.c.v[2]) + ")");
            if (itemData11.o._mdf || isFirstFrame11) styleElem11.pElem.setAttribute("stroke-opacity", itemData11.o.v);
            if (itemData11.w._mdf || isFirstFrame11) {
                styleElem11.pElem.setAttribute("stroke-width", itemData11.w.v);
                if (styleElem11.msElem) styleElem11.msElem.setAttribute("stroke-width", itemData11.w.v);
            }
        }
        return ob11;
    }();
    function SVGShapeElement(data11, globalData11, comp11) {
        // List of drawable elements
        this.shapes = []; // Full shape data
        this.shapesData = data11.shapes; // List of styles that will be applied to shapes
        this.stylesList = []; // List of modifiers that will be applied to shapes
        this.shapeModifiers = []; // List of items in shape tree
        this.itemsData = []; // List of items in previous shape tree
        this.processedElements = []; // List of animated components
        this.animatedContents = [];
        this.initElement(data11, globalData11, comp11); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
        // List of elements that have been created
        this.prevViewData = []; // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        IShapeElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], SVGShapeElement);
    SVGShapeElement.prototype.initSecondaryElement = function() {};
    SVGShapeElement.prototype.identityMatrix = new Matrix();
    SVGShapeElement.prototype.buildExpressionInterface = function() {};
    SVGShapeElement.prototype.createContent = function() {
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
        this.filterUniqueShapes();
    };
    /*
  This method searches for multiple shapes that affect a single element and one of them is animated
  */ SVGShapeElement.prototype.filterUniqueShapes = function() {
        var i31;
        var len11 = this.shapes.length;
        var shape31;
        var j31;
        var jLen11 = this.stylesList.length;
        var style11;
        var tempShapes11 = [];
        var areAnimated11 = false;
        for(j31 = 0; j31 < jLen11; j31 += 1){
            style11 = this.stylesList[j31];
            areAnimated11 = false;
            tempShapes11.length = 0;
            for(i31 = 0; i31 < len11; i31 += 1){
                shape31 = this.shapes[i31];
                if (shape31.styles.indexOf(style11) !== -1) {
                    tempShapes11.push(shape31);
                    areAnimated11 = shape31._isAnimated || areAnimated11;
                }
            }
            if (tempShapes11.length > 1 && areAnimated11) this.setShapesAsAnimated(tempShapes11);
        }
    };
    SVGShapeElement.prototype.setShapesAsAnimated = function(shapes11) {
        var i31;
        var len11 = shapes11.length;
        for(i31 = 0; i31 < len11; i31 += 1)shapes11[i31].setAsAnimated();
    };
    SVGShapeElement.prototype.createStyleElement = function(data11, level11) {
        // TODO: prevent drawing of hidden styles
        var elementData11;
        var styleOb11 = new SVGStyleData(data11, level11);
        var pathElement11 = styleOb11.pElem;
        if (data11.ty === "st") elementData11 = new SVGStrokeStyleData(this, data11, styleOb11);
        else if (data11.ty === "fl") elementData11 = new SVGFillStyleData(this, data11, styleOb11);
        else if (data11.ty === "gf" || data11.ty === "gs") {
            var GradientConstructor11 = data11.ty === "gf" ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
            elementData11 = new GradientConstructor11(this, data11, styleOb11);
            this.globalData.defs.appendChild(elementData11.gf);
            if (elementData11.maskId) {
                this.globalData.defs.appendChild(elementData11.ms);
                this.globalData.defs.appendChild(elementData11.of);
                pathElement11.setAttribute("mask", "url(" + getLocationHref() + "#" + elementData11.maskId + ")");
            }
        } else if (data11.ty === "no") elementData11 = new SVGNoStyleData(this, data11, styleOb11);
        if (data11.ty === "st" || data11.ty === "gs") {
            pathElement11.setAttribute("stroke-linecap", lineCapEnum[data11.lc || 2]);
            pathElement11.setAttribute("stroke-linejoin", lineJoinEnum[data11.lj || 2]);
            pathElement11.setAttribute("fill-opacity", "0");
            if (data11.lj === 1) pathElement11.setAttribute("stroke-miterlimit", data11.ml);
        }
        if (data11.r === 2) pathElement11.setAttribute("fill-rule", "evenodd");
        if (data11.ln) pathElement11.setAttribute("id", data11.ln);
        if (data11.cl) pathElement11.setAttribute("class", data11.cl);
        if (data11.bm) pathElement11.style["mix-blend-mode"] = getBlendMode(data11.bm);
        this.stylesList.push(styleOb11);
        this.addToAnimatedContents(data11, elementData11);
        return elementData11;
    };
    SVGShapeElement.prototype.createGroupElement = function(data11) {
        var elementData11 = new ShapeGroupData();
        if (data11.ln) elementData11.gr.setAttribute("id", data11.ln);
        if (data11.cl) elementData11.gr.setAttribute("class", data11.cl);
        if (data11.bm) elementData11.gr.style["mix-blend-mode"] = getBlendMode(data11.bm);
        return elementData11;
    };
    SVGShapeElement.prototype.createTransformElement = function(data11, container11) {
        var transformProperty11 = TransformPropertyFactory.getTransformProperty(this, data11, this);
        var elementData11 = new SVGTransformData(transformProperty11, transformProperty11.o, container11);
        this.addToAnimatedContents(data11, elementData11);
        return elementData11;
    };
    SVGShapeElement.prototype.createShapeElement = function(data11, ownTransformers11, level11) {
        var ty11 = 4;
        if (data11.ty === "rc") ty11 = 5;
        else if (data11.ty === "el") ty11 = 6;
        else if (data11.ty === "sr") ty11 = 7;
        var shapeProperty11 = ShapePropertyFactory.getShapeProp(this, data11, ty11, this);
        var elementData11 = new SVGShapeData(ownTransformers11, level11, shapeProperty11);
        this.shapes.push(elementData11);
        this.addShapeToModifiers(elementData11);
        this.addToAnimatedContents(data11, elementData11);
        return elementData11;
    };
    SVGShapeElement.prototype.addToAnimatedContents = function(data11, element11) {
        var i31 = 0;
        var len11 = this.animatedContents.length;
        while(i31 < len11){
            if (this.animatedContents[i31].element === element11) return;
            i31 += 1;
        }
        this.animatedContents.push({
            fn: SVGElementsRenderer.createRenderFunction(data11),
            element: element11,
            data: data11
        });
    };
    SVGShapeElement.prototype.setElementStyles = function(elementData11) {
        var arr31 = elementData11.styles;
        var j31;
        var jLen11 = this.stylesList.length;
        for(j31 = 0; j31 < jLen11; j31 += 1)if (!this.stylesList[j31].closed) arr31.push(this.stylesList[j31]);
    };
    SVGShapeElement.prototype.reloadShapes = function() {
        this._isFirstFrame = true;
        var i31;
        var len11 = this.itemsData.length;
        for(i31 = 0; i31 < len11; i31 += 1)this.prevViewData[i31] = this.itemsData[i31];
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
        this.filterUniqueShapes();
        len11 = this.dynamicProperties.length;
        for(i31 = 0; i31 < len11; i31 += 1)this.dynamicProperties[i31].getValue();
        this.renderModifiers();
    };
    SVGShapeElement.prototype.searchShapes = function(arr31, itemsData11, prevViewData11, container11, level11, transformers11, render11) {
        var ownTransformers11 = [].concat(transformers11);
        var i31;
        var len11 = arr31.length - 1;
        var j31;
        var jLen11;
        var ownStyles11 = [];
        var ownModifiers11 = [];
        var currentTransform11;
        var modifier11;
        var processedPos11;
        for(i31 = len11; i31 >= 0; i31 -= 1){
            processedPos11 = this.searchProcessedElement(arr31[i31]);
            if (!processedPos11) arr31[i31]._render = render11;
            else itemsData11[i31] = prevViewData11[processedPos11 - 1];
            if (arr31[i31].ty === "fl" || arr31[i31].ty === "st" || arr31[i31].ty === "gf" || arr31[i31].ty === "gs" || arr31[i31].ty === "no") {
                if (!processedPos11) itemsData11[i31] = this.createStyleElement(arr31[i31], level11);
                else itemsData11[i31].style.closed = false;
                if (arr31[i31]._render) {
                    if (itemsData11[i31].style.pElem.parentNode !== container11) container11.appendChild(itemsData11[i31].style.pElem);
                }
                ownStyles11.push(itemsData11[i31].style);
            } else if (arr31[i31].ty === "gr") {
                if (!processedPos11) itemsData11[i31] = this.createGroupElement(arr31[i31]);
                else {
                    jLen11 = itemsData11[i31].it.length;
                    for(j31 = 0; j31 < jLen11; j31 += 1)itemsData11[i31].prevViewData[j31] = itemsData11[i31].it[j31];
                }
                this.searchShapes(arr31[i31].it, itemsData11[i31].it, itemsData11[i31].prevViewData, itemsData11[i31].gr, level11 + 1, ownTransformers11, render11);
                if (arr31[i31]._render) {
                    if (itemsData11[i31].gr.parentNode !== container11) container11.appendChild(itemsData11[i31].gr);
                }
            } else if (arr31[i31].ty === "tr") {
                if (!processedPos11) itemsData11[i31] = this.createTransformElement(arr31[i31], container11);
                currentTransform11 = itemsData11[i31].transform;
                ownTransformers11.push(currentTransform11);
            } else if (arr31[i31].ty === "sh" || arr31[i31].ty === "rc" || arr31[i31].ty === "el" || arr31[i31].ty === "sr") {
                if (!processedPos11) itemsData11[i31] = this.createShapeElement(arr31[i31], ownTransformers11, level11);
                this.setElementStyles(itemsData11[i31]);
            } else if (arr31[i31].ty === "tm" || arr31[i31].ty === "rd" || arr31[i31].ty === "ms" || arr31[i31].ty === "pb" || arr31[i31].ty === "zz" || arr31[i31].ty === "op") {
                if (!processedPos11) {
                    modifier11 = ShapeModifiers.getModifier(arr31[i31].ty);
                    modifier11.init(this, arr31[i31]);
                    itemsData11[i31] = modifier11;
                    this.shapeModifiers.push(modifier11);
                } else {
                    modifier11 = itemsData11[i31];
                    modifier11.closed = false;
                }
                ownModifiers11.push(modifier11);
            } else if (arr31[i31].ty === "rp") {
                if (!processedPos11) {
                    modifier11 = ShapeModifiers.getModifier(arr31[i31].ty);
                    itemsData11[i31] = modifier11;
                    modifier11.init(this, arr31, i31, itemsData11);
                    this.shapeModifiers.push(modifier11);
                    render11 = false;
                } else {
                    modifier11 = itemsData11[i31];
                    modifier11.closed = true;
                }
                ownModifiers11.push(modifier11);
            }
            this.addProcessedElement(arr31[i31], i31 + 1);
        }
        len11 = ownStyles11.length;
        for(i31 = 0; i31 < len11; i31 += 1)ownStyles11[i31].closed = true;
        len11 = ownModifiers11.length;
        for(i31 = 0; i31 < len11; i31 += 1)ownModifiers11[i31].closed = true;
    };
    SVGShapeElement.prototype.renderInnerContent = function() {
        this.renderModifiers();
        var i31;
        var len11 = this.stylesList.length;
        for(i31 = 0; i31 < len11; i31 += 1)this.stylesList[i31].reset();
        this.renderShape();
        for(i31 = 0; i31 < len11; i31 += 1)if (this.stylesList[i31]._mdf || this._isFirstFrame) {
            if (this.stylesList[i31].msElem) {
                this.stylesList[i31].msElem.setAttribute("d", this.stylesList[i31].d); // Adding M0 0 fixes same mask bug on all browsers
                this.stylesList[i31].d = "M0 0" + this.stylesList[i31].d;
            }
            this.stylesList[i31].pElem.setAttribute("d", this.stylesList[i31].d || "M0 0");
        }
    };
    SVGShapeElement.prototype.renderShape = function() {
        var i31;
        var len11 = this.animatedContents.length;
        var animatedContent11;
        for(i31 = 0; i31 < len11; i31 += 1){
            animatedContent11 = this.animatedContents[i31];
            if ((this._isFirstFrame || animatedContent11.element._isAnimated) && animatedContent11.data !== true) animatedContent11.fn(animatedContent11.data, animatedContent11.element, this._isFirstFrame);
        }
    };
    SVGShapeElement.prototype.destroy = function() {
        this.destroyBaseElement();
        this.shapesData = null;
        this.itemsData = null;
    };
    function LetterProps(o31, sw11, sc11, fc11, m31, p61) {
        this.o = o31;
        this.sw = sw11;
        this.sc = sc11;
        this.fc = fc11;
        this.m = m31;
        this.p = p61;
        this._mdf = {
            o: true,
            sw: !!sw11,
            sc: !!sc11,
            fc: !!fc11,
            m: true,
            p: true
        };
    }
    LetterProps.prototype.update = function(o31, sw11, sc11, fc11, m31, p61) {
        this._mdf.o = false;
        this._mdf.sw = false;
        this._mdf.sc = false;
        this._mdf.fc = false;
        this._mdf.m = false;
        this._mdf.p = false;
        var updated11 = false;
        if (this.o !== o31) {
            this.o = o31;
            this._mdf.o = true;
            updated11 = true;
        }
        if (this.sw !== sw11) {
            this.sw = sw11;
            this._mdf.sw = true;
            updated11 = true;
        }
        if (this.sc !== sc11) {
            this.sc = sc11;
            this._mdf.sc = true;
            updated11 = true;
        }
        if (this.fc !== fc11) {
            this.fc = fc11;
            this._mdf.fc = true;
            updated11 = true;
        }
        if (this.m !== m31) {
            this.m = m31;
            this._mdf.m = true;
            updated11 = true;
        }
        if (p61.length && (this.p[0] !== p61[0] || this.p[1] !== p61[1] || this.p[4] !== p61[4] || this.p[5] !== p61[5] || this.p[12] !== p61[12] || this.p[13] !== p61[13])) {
            this.p = p61;
            this._mdf.p = true;
            updated11 = true;
        }
        return updated11;
    };
    function TextProperty(elem31, data11) {
        this._frameId = initialDefaultFrame;
        this.pv = "";
        this.v = "";
        this.kf = false;
        this._isFirstFrame = true;
        this._mdf = false;
        if (data11.d && data11.d.sid) data11.d = elem31.globalData.slotManager.getProp(data11.d);
        this.data = data11;
        this.elem = elem31;
        this.comp = this.elem.comp;
        this.keysIndex = 0;
        this.canResize = false;
        this.minimumFontSize = 1;
        this.effectsSequence = [];
        this.currentData = {
            ascent: 0,
            boxWidth: this.defaultBoxWidth,
            f: "",
            fStyle: "",
            fWeight: "",
            fc: "",
            j: "",
            justifyOffset: "",
            l: [],
            lh: 0,
            lineWidths: [],
            ls: "",
            of: "",
            s: "",
            sc: "",
            sw: 0,
            t: 0,
            tr: 0,
            sz: 0,
            ps: null,
            fillColorAnim: false,
            strokeColorAnim: false,
            strokeWidthAnim: false,
            yOffset: 0,
            finalSize: 0,
            finalText: [],
            finalLineHeight: 0,
            __complete: false
        };
        this.copyData(this.currentData, this.data.d.k[0].s);
        if (!this.searchProperty()) this.completeTextData(this.currentData);
    }
    TextProperty.prototype.defaultBoxWidth = [
        0,
        0
    ];
    TextProperty.prototype.copyData = function(obj11, data11) {
        for(var s41 in data11)if (Object.prototype.hasOwnProperty.call(data11, s41)) obj11[s41] = data11[s41];
        return obj11;
    };
    TextProperty.prototype.setCurrentData = function(data11) {
        if (!data11.__complete) this.completeTextData(data11);
        this.currentData = data11;
        this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth;
        this._mdf = true;
    };
    TextProperty.prototype.searchProperty = function() {
        return this.searchKeyframes();
    };
    TextProperty.prototype.searchKeyframes = function() {
        this.kf = this.data.d.k.length > 1;
        if (this.kf) this.addEffect(this.getKeyframeValue.bind(this));
        return this.kf;
    };
    TextProperty.prototype.addEffect = function(effectFunction11) {
        this.effectsSequence.push(effectFunction11);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.getValue = function(_finalValue11) {
        if ((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !_finalValue11) return;
        this.currentData.t = this.data.d.k[this.keysIndex].s.t;
        var currentValue11 = this.currentData;
        var currentIndex11 = this.keysIndex;
        if (this.lock) {
            this.setCurrentData(this.currentData);
            return;
        }
        this.lock = true;
        this._mdf = false;
        var i31;
        var len11 = this.effectsSequence.length;
        var finalValue11 = _finalValue11 || this.data.d.k[this.keysIndex].s;
        for(i31 = 0; i31 < len11; i31 += 1)// Checking if index changed to prevent creating a new object every time the expression updates.
        if (currentIndex11 !== this.keysIndex) finalValue11 = this.effectsSequence[i31](finalValue11, finalValue11.t);
        else finalValue11 = this.effectsSequence[i31](this.currentData, finalValue11.t);
        if (currentValue11 !== finalValue11) this.setCurrentData(finalValue11);
        this.v = this.currentData;
        this.pv = this.v;
        this.lock = false;
        this.frameId = this.elem.globalData.frameId;
    };
    TextProperty.prototype.getKeyframeValue = function() {
        var textKeys11 = this.data.d.k;
        var frameNum11 = this.elem.comp.renderedFrame;
        var i31 = 0;
        var len11 = textKeys11.length;
        while(i31 <= len11 - 1){
            if (i31 === len11 - 1 || textKeys11[i31 + 1].t > frameNum11) break;
            i31 += 1;
        }
        if (this.keysIndex !== i31) this.keysIndex = i31;
        return this.data.d.k[this.keysIndex].s;
    };
    TextProperty.prototype.buildFinalText = function(text11) {
        var charactersArray11 = [];
        var i31 = 0;
        var len11 = text11.length;
        var charCode11;
        var secondCharCode11;
        var shouldCombine11 = false;
        var shouldCombineNext11 = false;
        var currentChars11 = "";
        while(i31 < len11){
            shouldCombine11 = shouldCombineNext11;
            shouldCombineNext11 = false;
            charCode11 = text11.charCodeAt(i31);
            currentChars11 = text11.charAt(i31);
            if (FontManager.isCombinedCharacter(charCode11)) shouldCombine11 = true; // It's a potential surrogate pair (this is the High surrogate)
            else if (charCode11 >= 0xD800 && charCode11 <= 0xDBFF) {
                if (FontManager.isRegionalFlag(text11, i31)) currentChars11 = text11.substr(i31, 14);
                else {
                    secondCharCode11 = text11.charCodeAt(i31 + 1); // It's a surrogate pair (this is the Low surrogate)
                    if (secondCharCode11 >= 0xDC00 && secondCharCode11 <= 0xDFFF) {
                        if (FontManager.isModifier(charCode11, secondCharCode11)) {
                            currentChars11 = text11.substr(i31, 2);
                            shouldCombine11 = true;
                        } else if (FontManager.isFlagEmoji(text11.substr(i31, 4))) currentChars11 = text11.substr(i31, 4);
                        else currentChars11 = text11.substr(i31, 2);
                    }
                }
            } else if (charCode11 > 0xDBFF) {
                secondCharCode11 = text11.charCodeAt(i31 + 1);
                if (FontManager.isVariationSelector(charCode11)) shouldCombine11 = true;
            } else if (FontManager.isZeroWidthJoiner(charCode11)) {
                shouldCombine11 = true;
                shouldCombineNext11 = true;
            }
            if (shouldCombine11) {
                charactersArray11[charactersArray11.length - 1] += currentChars11;
                shouldCombine11 = false;
            } else charactersArray11.push(currentChars11);
            i31 += currentChars11.length;
        }
        return charactersArray11;
    };
    TextProperty.prototype.completeTextData = function(documentData11) {
        documentData11.__complete = true;
        var fontManager11 = this.elem.globalData.fontManager;
        var data11 = this.data;
        var letters11 = [];
        var i31;
        var len11;
        var newLineFlag11;
        var index11 = 0;
        var val31;
        var anchorGrouping11 = data11.m.g;
        var currentSize11 = 0;
        var currentPos11 = 0;
        var currentLine11 = 0;
        var lineWidths11 = [];
        var lineWidth11 = 0;
        var maxLineWidth11 = 0;
        var j31;
        var jLen11;
        var fontData11 = fontManager11.getFontByName(documentData11.f);
        var charData11;
        var cLength11 = 0;
        var fontProps11 = getFontProperties(fontData11);
        documentData11.fWeight = fontProps11.weight;
        documentData11.fStyle = fontProps11.style;
        documentData11.finalSize = documentData11.s;
        documentData11.finalText = this.buildFinalText(documentData11.t);
        len11 = documentData11.finalText.length;
        documentData11.finalLineHeight = documentData11.lh;
        var trackingOffset11 = documentData11.tr / 1000 * documentData11.finalSize;
        var charCode11;
        if (documentData11.sz) {
            var flag11 = true;
            var boxWidth11 = documentData11.sz[0];
            var boxHeight11 = documentData11.sz[1];
            var currentHeight11;
            var finalText11;
            while(flag11){
                finalText11 = this.buildFinalText(documentData11.t);
                currentHeight11 = 0;
                lineWidth11 = 0;
                len11 = finalText11.length;
                trackingOffset11 = documentData11.tr / 1000 * documentData11.finalSize;
                var lastSpaceIndex11 = -1;
                for(i31 = 0; i31 < len11; i31 += 1){
                    charCode11 = finalText11[i31].charCodeAt(0);
                    newLineFlag11 = false;
                    if (finalText11[i31] === " ") lastSpaceIndex11 = i31;
                    else if (charCode11 === 13 || charCode11 === 3) {
                        lineWidth11 = 0;
                        newLineFlag11 = true;
                        currentHeight11 += documentData11.finalLineHeight || documentData11.finalSize * 1.2;
                    }
                    if (fontManager11.chars) {
                        charData11 = fontManager11.getCharData(finalText11[i31], fontData11.fStyle, fontData11.fFamily);
                        cLength11 = newLineFlag11 ? 0 : charData11.w * documentData11.finalSize / 100;
                    } else // tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
                    cLength11 = fontManager11.measureText(finalText11[i31], documentData11.f, documentData11.finalSize);
                    if (lineWidth11 + cLength11 > boxWidth11 && finalText11[i31] !== " ") {
                        if (lastSpaceIndex11 === -1) len11 += 1;
                        else i31 = lastSpaceIndex11;
                        currentHeight11 += documentData11.finalLineHeight || documentData11.finalSize * 1.2;
                        finalText11.splice(i31, lastSpaceIndex11 === i31 ? 1 : 0, "\r"); // finalText = finalText.substr(0,i) + "\r" + finalText.substr(i === lastSpaceIndex ? i + 1 : i);
                        lastSpaceIndex11 = -1;
                        lineWidth11 = 0;
                    } else {
                        lineWidth11 += cLength11;
                        lineWidth11 += trackingOffset11;
                    }
                }
                currentHeight11 += fontData11.ascent * documentData11.finalSize / 100;
                if (this.canResize && documentData11.finalSize > this.minimumFontSize && boxHeight11 < currentHeight11) {
                    documentData11.finalSize -= 1;
                    documentData11.finalLineHeight = documentData11.finalSize * documentData11.lh / documentData11.s;
                } else {
                    documentData11.finalText = finalText11;
                    len11 = documentData11.finalText.length;
                    flag11 = false;
                }
            }
        }
        lineWidth11 = -trackingOffset11;
        cLength11 = 0;
        var uncollapsedSpaces11 = 0;
        var currentChar11;
        for(i31 = 0; i31 < len11; i31 += 1){
            newLineFlag11 = false;
            currentChar11 = documentData11.finalText[i31];
            charCode11 = currentChar11.charCodeAt(0);
            if (charCode11 === 13 || charCode11 === 3) {
                uncollapsedSpaces11 = 0;
                lineWidths11.push(lineWidth11);
                maxLineWidth11 = lineWidth11 > maxLineWidth11 ? lineWidth11 : maxLineWidth11;
                lineWidth11 = -2 * trackingOffset11;
                val31 = "";
                newLineFlag11 = true;
                currentLine11 += 1;
            } else val31 = currentChar11;
            if (fontManager11.chars) {
                charData11 = fontManager11.getCharData(currentChar11, fontData11.fStyle, fontManager11.getFontByName(documentData11.f).fFamily);
                cLength11 = newLineFlag11 ? 0 : charData11.w * documentData11.finalSize / 100;
            } else // var charWidth = fontManager.measureText(val, documentData.f, documentData.finalSize);
            // tCanvasHelper.font = documentData.finalSize + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
            cLength11 = fontManager11.measureText(val31, documentData11.f, documentData11.finalSize);
             //
            if (currentChar11 === " ") uncollapsedSpaces11 += cLength11 + trackingOffset11;
            else {
                lineWidth11 += cLength11 + trackingOffset11 + uncollapsedSpaces11;
                uncollapsedSpaces11 = 0;
            }
            letters11.push({
                l: cLength11,
                an: cLength11,
                add: currentSize11,
                n: newLineFlag11,
                anIndexes: [],
                val: val31,
                line: currentLine11,
                animatorJustifyOffset: 0
            });
            if (anchorGrouping11 == 2) {
                // eslint-disable-line eqeqeq
                currentSize11 += cLength11;
                if (val31 === "" || val31 === " " || i31 === len11 - 1) {
                    if (val31 === "" || val31 === " ") currentSize11 -= cLength11;
                    while(currentPos11 <= i31){
                        letters11[currentPos11].an = currentSize11;
                        letters11[currentPos11].ind = index11;
                        letters11[currentPos11].extra = cLength11;
                        currentPos11 += 1;
                    }
                    index11 += 1;
                    currentSize11 = 0;
                }
            } else if (anchorGrouping11 == 3) {
                // eslint-disable-line eqeqeq
                currentSize11 += cLength11;
                if (val31 === "" || i31 === len11 - 1) {
                    if (val31 === "") currentSize11 -= cLength11;
                    while(currentPos11 <= i31){
                        letters11[currentPos11].an = currentSize11;
                        letters11[currentPos11].ind = index11;
                        letters11[currentPos11].extra = cLength11;
                        currentPos11 += 1;
                    }
                    currentSize11 = 0;
                    index11 += 1;
                }
            } else {
                letters11[index11].ind = index11;
                letters11[index11].extra = 0;
                index11 += 1;
            }
        }
        documentData11.l = letters11;
        maxLineWidth11 = lineWidth11 > maxLineWidth11 ? lineWidth11 : maxLineWidth11;
        lineWidths11.push(lineWidth11);
        if (documentData11.sz) {
            documentData11.boxWidth = documentData11.sz[0];
            documentData11.justifyOffset = 0;
        } else {
            documentData11.boxWidth = maxLineWidth11;
            switch(documentData11.j){
                case 1:
                    documentData11.justifyOffset = -documentData11.boxWidth;
                    break;
                case 2:
                    documentData11.justifyOffset = -documentData11.boxWidth / 2;
                    break;
                default:
                    documentData11.justifyOffset = 0;
            }
        }
        documentData11.lineWidths = lineWidths11;
        var animators11 = data11.a;
        var animatorData11;
        var letterData11;
        jLen11 = animators11.length;
        var based11;
        var ind11;
        var indexes11 = [];
        for(j31 = 0; j31 < jLen11; j31 += 1){
            animatorData11 = animators11[j31];
            if (animatorData11.a.sc) documentData11.strokeColorAnim = true;
            if (animatorData11.a.sw) documentData11.strokeWidthAnim = true;
            if (animatorData11.a.fc || animatorData11.a.fh || animatorData11.a.fs || animatorData11.a.fb) documentData11.fillColorAnim = true;
            ind11 = 0;
            based11 = animatorData11.s.b;
            for(i31 = 0; i31 < len11; i31 += 1){
                letterData11 = letters11[i31];
                letterData11.anIndexes[j31] = ind11;
                if (based11 == 1 && letterData11.val !== "" || based11 == 2 && letterData11.val !== "" && letterData11.val !== " " || based11 == 3 && (letterData11.n || letterData11.val == " " || i31 == len11 - 1) || based11 == 4 && (letterData11.n || i31 == len11 - 1)) {
                    // eslint-disable-line eqeqeq
                    if (animatorData11.s.rn === 1) indexes11.push(ind11);
                    ind11 += 1;
                }
            }
            data11.a[j31].s.totalChars = ind11;
            var currentInd11 = -1;
            var newInd11;
            if (animatorData11.s.rn === 1) for(i31 = 0; i31 < len11; i31 += 1){
                letterData11 = letters11[i31];
                if (currentInd11 != letterData11.anIndexes[j31]) {
                    // eslint-disable-line eqeqeq
                    currentInd11 = letterData11.anIndexes[j31];
                    newInd11 = indexes11.splice(Math.floor(Math.random() * indexes11.length), 1)[0];
                }
                letterData11.anIndexes[j31] = newInd11;
            }
        }
        documentData11.yOffset = documentData11.finalLineHeight || documentData11.finalSize * 1.2;
        documentData11.ls = documentData11.ls || 0;
        documentData11.ascent = fontData11.ascent * documentData11.finalSize / 100;
    };
    TextProperty.prototype.updateDocumentData = function(newData11, index11) {
        index11 = index11 === undefined ? this.keysIndex : index11;
        var dData11 = this.copyData({}, this.data.d.k[index11].s);
        dData11 = this.copyData(dData11, newData11);
        this.data.d.k[index11].s = dData11;
        this.recalculate(index11);
        this.setCurrentData(dData11);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.recalculate = function(index11) {
        var dData11 = this.data.d.k[index11].s;
        dData11.__complete = false;
        this.keysIndex = 0;
        this._isFirstFrame = true;
        this.getValue(dData11);
    };
    TextProperty.prototype.canResizeFont = function(_canResize11) {
        this.canResize = _canResize11;
        this.recalculate(this.keysIndex);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.setMinimumFontSize = function(_fontValue11) {
        this.minimumFontSize = Math.floor(_fontValue11) || 1;
        this.recalculate(this.keysIndex);
        this.elem.addDynamicProperty(this);
    };
    var TextSelectorProp = function() {
        var max11 = Math.max;
        var min11 = Math.min;
        var floor11 = Math.floor;
        function TextSelectorPropFactory11(elem31, data11) {
            this._currentTextLength = -1;
            this.k = false;
            this.data = data11;
            this.elem = elem31;
            this.comp = elem31.comp;
            this.finalS = 0;
            this.finalE = 0;
            this.initDynamicPropertyContainer(elem31);
            this.s = PropertyFactory.getProp(elem31, data11.s || {
                k: 0
            }, 0, 0, this);
            if ("e" in data11) this.e = PropertyFactory.getProp(elem31, data11.e, 0, 0, this);
            else this.e = {
                v: 100
            };
            this.o = PropertyFactory.getProp(elem31, data11.o || {
                k: 0
            }, 0, 0, this);
            this.xe = PropertyFactory.getProp(elem31, data11.xe || {
                k: 0
            }, 0, 0, this);
            this.ne = PropertyFactory.getProp(elem31, data11.ne || {
                k: 0
            }, 0, 0, this);
            this.sm = PropertyFactory.getProp(elem31, data11.sm || {
                k: 100
            }, 0, 0, this);
            this.a = PropertyFactory.getProp(elem31, data11.a, 0, 0.01, this);
            if (!this.dynamicProperties.length) this.getValue();
        }
        TextSelectorPropFactory11.prototype = {
            getMult: function getMult11(ind11) {
                if (this._currentTextLength !== this.elem.textProperty.currentData.l.length) this.getValue();
                var x111 = 0;
                var y111 = 0;
                var x211 = 1;
                var y211 = 1;
                if (this.ne.v > 0) x111 = this.ne.v / 100.0;
                else y111 = -this.ne.v / 100.0;
                if (this.xe.v > 0) x211 = 1.0 - this.xe.v / 100.0;
                else y211 = 1.0 + this.xe.v / 100.0;
                var easer11 = BezierFactory.getBezierEasing(x111, y111, x211, y211).get;
                var mult11 = 0;
                var s41 = this.finalS;
                var e31 = this.finalE;
                var type11 = this.data.sh;
                if (type11 === 2) {
                    if (e31 === s41) mult11 = ind11 >= e31 ? 1 : 0;
                    else mult11 = max11(0, min11(0.5 / (e31 - s41) + (ind11 - s41) / (e31 - s41), 1));
                    mult11 = easer11(mult11);
                } else if (type11 === 3) {
                    if (e31 === s41) mult11 = ind11 >= e31 ? 0 : 1;
                    else mult11 = 1 - max11(0, min11(0.5 / (e31 - s41) + (ind11 - s41) / (e31 - s41), 1));
                    mult11 = easer11(mult11);
                } else if (type11 === 4) {
                    if (e31 === s41) mult11 = 0;
                    else {
                        mult11 = max11(0, min11(0.5 / (e31 - s41) + (ind11 - s41) / (e31 - s41), 1));
                        if (mult11 < 0.5) mult11 *= 2;
                        else mult11 = 1 - 2 * (mult11 - 0.5);
                    }
                    mult11 = easer11(mult11);
                } else if (type11 === 5) {
                    if (e31 === s41) mult11 = 0;
                    else {
                        var tot11 = e31 - s41;
                        /* ind += 0.5;
                      mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind; */ ind11 = min11(max11(0, ind11 + 0.5 - s41), e31 - s41);
                        var x41 = -tot11 / 2 + ind11;
                        var a31 = tot11 / 2;
                        mult11 = Math.sqrt(1 - x41 * x41 / (a31 * a31));
                    }
                    mult11 = easer11(mult11);
                } else if (type11 === 6) {
                    if (e31 === s41) mult11 = 0;
                    else {
                        ind11 = min11(max11(0, ind11 + 0.5 - s41), e31 - s41);
                        mult11 = (1 + Math.cos(Math.PI + Math.PI * 2 * ind11 / (e31 - s41))) / 2; // eslint-disable-line
                    }
                    mult11 = easer11(mult11);
                } else {
                    if (ind11 >= floor11(s41)) {
                        if (ind11 - s41 < 0) mult11 = max11(0, min11(min11(e31, 1) - (s41 - ind11), 1));
                        else mult11 = max11(0, min11(e31 - ind11, 1));
                    }
                    mult11 = easer11(mult11);
                } // Smoothness implementation.
                // The smoothness represents a reduced range of the original [0; 1] range.
                // if smoothness is 25%, the new range will be [0.375; 0.625]
                // Steps are:
                // - find the lower value of the new range (threshold)
                // - if multiplier is smaller than that value, floor it to 0
                // - if it is larger,
                //     - subtract the threshold
                //     - divide it by the smoothness (this will return the range to [0; 1])
                // Note: If it doesn't work on some scenarios, consider applying it before the easer.
                if (this.sm.v !== 100) {
                    var smoothness11 = this.sm.v * 0.01;
                    if (smoothness11 === 0) smoothness11 = 0.00000001;
                    var threshold11 = 0.5 - smoothness11 * 0.5;
                    if (mult11 < threshold11) mult11 = 0;
                    else {
                        mult11 = (mult11 - threshold11) / smoothness11;
                        if (mult11 > 1) mult11 = 1;
                    }
                }
                return mult11 * this.a.v;
            },
            getValue: function getValue11(newCharsFlag11) {
                this.iterateDynamicProperties();
                this._mdf = newCharsFlag11 || this._mdf;
                this._currentTextLength = this.elem.textProperty.currentData.l.length || 0;
                if (newCharsFlag11 && this.data.r === 2) this.e.v = this._currentTextLength;
                var divisor11 = this.data.r === 2 ? 1 : 100 / this.data.totalChars;
                var o31 = this.o.v / divisor11;
                var s41 = this.s.v / divisor11 + o31;
                var e31 = this.e.v / divisor11 + o31;
                if (s41 > e31) {
                    var _s11 = s41;
                    s41 = e31;
                    e31 = _s11;
                }
                this.finalS = s41;
                this.finalE = e31;
            }
        };
        extendPrototype([
            DynamicPropertyContainer
        ], TextSelectorPropFactory11);
        function getTextSelectorProp11(elem31, data11, arr31) {
            return new TextSelectorPropFactory11(elem31, data11, arr31);
        }
        return {
            getTextSelectorProp: getTextSelectorProp11
        };
    }();
    function TextAnimatorDataProperty(elem31, animatorProps11, container11) {
        var defaultData11 = {
            propType: false
        };
        var getProp11 = PropertyFactory.getProp;
        var textAnimatorAnimatables11 = animatorProps11.a;
        this.a = {
            r: textAnimatorAnimatables11.r ? getProp11(elem31, textAnimatorAnimatables11.r, 0, degToRads, container11) : defaultData11,
            rx: textAnimatorAnimatables11.rx ? getProp11(elem31, textAnimatorAnimatables11.rx, 0, degToRads, container11) : defaultData11,
            ry: textAnimatorAnimatables11.ry ? getProp11(elem31, textAnimatorAnimatables11.ry, 0, degToRads, container11) : defaultData11,
            sk: textAnimatorAnimatables11.sk ? getProp11(elem31, textAnimatorAnimatables11.sk, 0, degToRads, container11) : defaultData11,
            sa: textAnimatorAnimatables11.sa ? getProp11(elem31, textAnimatorAnimatables11.sa, 0, degToRads, container11) : defaultData11,
            s: textAnimatorAnimatables11.s ? getProp11(elem31, textAnimatorAnimatables11.s, 1, 0.01, container11) : defaultData11,
            a: textAnimatorAnimatables11.a ? getProp11(elem31, textAnimatorAnimatables11.a, 1, 0, container11) : defaultData11,
            o: textAnimatorAnimatables11.o ? getProp11(elem31, textAnimatorAnimatables11.o, 0, 0.01, container11) : defaultData11,
            p: textAnimatorAnimatables11.p ? getProp11(elem31, textAnimatorAnimatables11.p, 1, 0, container11) : defaultData11,
            sw: textAnimatorAnimatables11.sw ? getProp11(elem31, textAnimatorAnimatables11.sw, 0, 0, container11) : defaultData11,
            sc: textAnimatorAnimatables11.sc ? getProp11(elem31, textAnimatorAnimatables11.sc, 1, 0, container11) : defaultData11,
            fc: textAnimatorAnimatables11.fc ? getProp11(elem31, textAnimatorAnimatables11.fc, 1, 0, container11) : defaultData11,
            fh: textAnimatorAnimatables11.fh ? getProp11(elem31, textAnimatorAnimatables11.fh, 0, 0, container11) : defaultData11,
            fs: textAnimatorAnimatables11.fs ? getProp11(elem31, textAnimatorAnimatables11.fs, 0, 0.01, container11) : defaultData11,
            fb: textAnimatorAnimatables11.fb ? getProp11(elem31, textAnimatorAnimatables11.fb, 0, 0.01, container11) : defaultData11,
            t: textAnimatorAnimatables11.t ? getProp11(elem31, textAnimatorAnimatables11.t, 0, 0, container11) : defaultData11
        };
        this.s = TextSelectorProp.getTextSelectorProp(elem31, animatorProps11.s, container11);
        this.s.t = animatorProps11.s.t;
    }
    function TextAnimatorProperty(textData11, renderType11, elem31) {
        this._isFirstFrame = true;
        this._hasMaskedPath = false;
        this._frameId = -1;
        this._textData = textData11;
        this._renderType = renderType11;
        this._elem = elem31;
        this._animatorsData = createSizedArray(this._textData.a.length);
        this._pathData = {};
        this._moreOptions = {
            alignment: {}
        };
        this.renderedLetters = [];
        this.lettersChangedFlag = false;
        this.initDynamicPropertyContainer(elem31);
    }
    TextAnimatorProperty.prototype.searchProperties = function() {
        var i31;
        var len11 = this._textData.a.length;
        var animatorProps11;
        var getProp11 = PropertyFactory.getProp;
        for(i31 = 0; i31 < len11; i31 += 1){
            animatorProps11 = this._textData.a[i31];
            this._animatorsData[i31] = new TextAnimatorDataProperty(this._elem, animatorProps11, this);
        }
        if (this._textData.p && "m" in this._textData.p) {
            this._pathData = {
                a: getProp11(this._elem, this._textData.p.a, 0, 0, this),
                f: getProp11(this._elem, this._textData.p.f, 0, 0, this),
                l: getProp11(this._elem, this._textData.p.l, 0, 0, this),
                r: getProp11(this._elem, this._textData.p.r, 0, 0, this),
                p: getProp11(this._elem, this._textData.p.p, 0, 0, this),
                m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
            };
            this._hasMaskedPath = true;
        } else this._hasMaskedPath = false;
        this._moreOptions.alignment = getProp11(this._elem, this._textData.m.a, 1, 0, this);
    };
    TextAnimatorProperty.prototype.getMeasures = function(documentData11, lettersChangedFlag11) {
        this.lettersChangedFlag = lettersChangedFlag11;
        if (!this._mdf && !this._isFirstFrame && !lettersChangedFlag11 && (!this._hasMaskedPath || !this._pathData.m._mdf)) return;
        this._isFirstFrame = false;
        var alignment11 = this._moreOptions.alignment.v;
        var animators11 = this._animatorsData;
        var textData11 = this._textData;
        var matrixHelper11 = this.mHelper;
        var renderType11 = this._renderType;
        var renderedLettersCount11 = this.renderedLetters.length;
        var xPos11;
        var yPos11;
        var i31;
        var len11;
        var letters11 = documentData11.l;
        var pathInfo11;
        var currentLength11;
        var currentPoint11;
        var segmentLength11;
        var flag11;
        var pointInd11;
        var segmentInd11;
        var prevPoint11;
        var points11;
        var segments11;
        var partialLength11;
        var totalLength11;
        var perc11;
        var tanAngle11;
        var mask11;
        if (this._hasMaskedPath) {
            mask11 = this._pathData.m;
            if (!this._pathData.n || this._pathData._mdf) {
                var paths11 = mask11.v;
                if (this._pathData.r.v) paths11 = paths11.reverse();
                 // TODO: release bezier data cached from previous pathInfo: this._pathData.pi
                pathInfo11 = {
                    tLength: 0,
                    segments: []
                };
                len11 = paths11._length - 1;
                var bezierData11;
                totalLength11 = 0;
                for(i31 = 0; i31 < len11; i31 += 1){
                    bezierData11 = bez.buildBezierData(paths11.v[i31], paths11.v[i31 + 1], [
                        paths11.o[i31][0] - paths11.v[i31][0],
                        paths11.o[i31][1] - paths11.v[i31][1]
                    ], [
                        paths11.i[i31 + 1][0] - paths11.v[i31 + 1][0],
                        paths11.i[i31 + 1][1] - paths11.v[i31 + 1][1]
                    ]);
                    pathInfo11.tLength += bezierData11.segmentLength;
                    pathInfo11.segments.push(bezierData11);
                    totalLength11 += bezierData11.segmentLength;
                }
                i31 = len11;
                if (mask11.v.c) {
                    bezierData11 = bez.buildBezierData(paths11.v[i31], paths11.v[0], [
                        paths11.o[i31][0] - paths11.v[i31][0],
                        paths11.o[i31][1] - paths11.v[i31][1]
                    ], [
                        paths11.i[0][0] - paths11.v[0][0],
                        paths11.i[0][1] - paths11.v[0][1]
                    ]);
                    pathInfo11.tLength += bezierData11.segmentLength;
                    pathInfo11.segments.push(bezierData11);
                    totalLength11 += bezierData11.segmentLength;
                }
                this._pathData.pi = pathInfo11;
            }
            pathInfo11 = this._pathData.pi;
            currentLength11 = this._pathData.f.v;
            segmentInd11 = 0;
            pointInd11 = 1;
            segmentLength11 = 0;
            flag11 = true;
            segments11 = pathInfo11.segments;
            if (currentLength11 < 0 && mask11.v.c) {
                if (pathInfo11.tLength < Math.abs(currentLength11)) currentLength11 = -Math.abs(currentLength11) % pathInfo11.tLength;
                segmentInd11 = segments11.length - 1;
                points11 = segments11[segmentInd11].points;
                pointInd11 = points11.length - 1;
                while(currentLength11 < 0){
                    currentLength11 += points11[pointInd11].partialLength;
                    pointInd11 -= 1;
                    if (pointInd11 < 0) {
                        segmentInd11 -= 1;
                        points11 = segments11[segmentInd11].points;
                        pointInd11 = points11.length - 1;
                    }
                }
            }
            points11 = segments11[segmentInd11].points;
            prevPoint11 = points11[pointInd11 - 1];
            currentPoint11 = points11[pointInd11];
            partialLength11 = currentPoint11.partialLength;
        }
        len11 = letters11.length;
        xPos11 = 0;
        yPos11 = 0;
        var yOff11 = documentData11.finalSize * 1.2 * 0.714;
        var firstLine11 = true;
        var animatorProps11;
        var animatorSelector11;
        var j31;
        var jLen11;
        var letterValue11;
        jLen11 = animators11.length;
        var mult11;
        var ind11 = -1;
        var offf11;
        var xPathPos11;
        var yPathPos11;
        var initPathPos11 = currentLength11;
        var initSegmentInd11 = segmentInd11;
        var initPointInd11 = pointInd11;
        var currentLine11 = -1;
        var elemOpacity11;
        var sc11;
        var sw11;
        var fc11;
        var k31;
        var letterSw11;
        var letterSc11;
        var letterFc11;
        var letterM11 = "";
        var letterP11 = this.defaultPropsArray;
        var letterO11; //
        if (documentData11.j === 2 || documentData11.j === 1) {
            var animatorJustifyOffset11 = 0;
            var animatorFirstCharOffset11 = 0;
            var justifyOffsetMult11 = documentData11.j === 2 ? -0.5 : -1;
            var lastIndex11 = 0;
            var isNewLine11 = true;
            for(i31 = 0; i31 < len11; i31 += 1)if (letters11[i31].n) {
                if (animatorJustifyOffset11) animatorJustifyOffset11 += animatorFirstCharOffset11;
                while(lastIndex11 < i31){
                    letters11[lastIndex11].animatorJustifyOffset = animatorJustifyOffset11;
                    lastIndex11 += 1;
                }
                animatorJustifyOffset11 = 0;
                isNewLine11 = true;
            } else {
                for(j31 = 0; j31 < jLen11; j31 += 1){
                    animatorProps11 = animators11[j31].a;
                    if (animatorProps11.t.propType) {
                        if (isNewLine11 && documentData11.j === 2) animatorFirstCharOffset11 += animatorProps11.t.v * justifyOffsetMult11;
                        animatorSelector11 = animators11[j31].s;
                        mult11 = animatorSelector11.getMult(letters11[i31].anIndexes[j31], textData11.a[j31].s.totalChars);
                        if (mult11.length) animatorJustifyOffset11 += animatorProps11.t.v * mult11[0] * justifyOffsetMult11;
                        else animatorJustifyOffset11 += animatorProps11.t.v * mult11 * justifyOffsetMult11;
                    }
                }
                isNewLine11 = false;
            }
            if (animatorJustifyOffset11) animatorJustifyOffset11 += animatorFirstCharOffset11;
            while(lastIndex11 < i31){
                letters11[lastIndex11].animatorJustifyOffset = animatorJustifyOffset11;
                lastIndex11 += 1;
            }
        } //
        for(i31 = 0; i31 < len11; i31 += 1){
            matrixHelper11.reset();
            elemOpacity11 = 1;
            if (letters11[i31].n) {
                xPos11 = 0;
                yPos11 += documentData11.yOffset;
                yPos11 += firstLine11 ? 1 : 0;
                currentLength11 = initPathPos11;
                firstLine11 = false;
                if (this._hasMaskedPath) {
                    segmentInd11 = initSegmentInd11;
                    pointInd11 = initPointInd11;
                    points11 = segments11[segmentInd11].points;
                    prevPoint11 = points11[pointInd11 - 1];
                    currentPoint11 = points11[pointInd11];
                    partialLength11 = currentPoint11.partialLength;
                    segmentLength11 = 0;
                }
                letterM11 = "";
                letterFc11 = "";
                letterSw11 = "";
                letterO11 = "";
                letterP11 = this.defaultPropsArray;
            } else {
                if (this._hasMaskedPath) {
                    if (currentLine11 !== letters11[i31].line) {
                        switch(documentData11.j){
                            case 1:
                                currentLength11 += totalLength11 - documentData11.lineWidths[letters11[i31].line];
                                break;
                            case 2:
                                currentLength11 += (totalLength11 - documentData11.lineWidths[letters11[i31].line]) / 2;
                                break;
                            default:
                                break;
                        }
                        currentLine11 = letters11[i31].line;
                    }
                    if (ind11 !== letters11[i31].ind) {
                        if (letters11[ind11]) currentLength11 += letters11[ind11].extra;
                        currentLength11 += letters11[i31].an / 2;
                        ind11 = letters11[i31].ind;
                    }
                    currentLength11 += alignment11[0] * letters11[i31].an * 0.005;
                    var animatorOffset11 = 0;
                    for(j31 = 0; j31 < jLen11; j31 += 1){
                        animatorProps11 = animators11[j31].a;
                        if (animatorProps11.p.propType) {
                            animatorSelector11 = animators11[j31].s;
                            mult11 = animatorSelector11.getMult(letters11[i31].anIndexes[j31], textData11.a[j31].s.totalChars);
                            if (mult11.length) animatorOffset11 += animatorProps11.p.v[0] * mult11[0];
                            else animatorOffset11 += animatorProps11.p.v[0] * mult11;
                        }
                        if (animatorProps11.a.propType) {
                            animatorSelector11 = animators11[j31].s;
                            mult11 = animatorSelector11.getMult(letters11[i31].anIndexes[j31], textData11.a[j31].s.totalChars);
                            if (mult11.length) animatorOffset11 += animatorProps11.a.v[0] * mult11[0];
                            else animatorOffset11 += animatorProps11.a.v[0] * mult11;
                        }
                    }
                    flag11 = true; // Force alignment only works with a single line for now
                    if (this._pathData.a.v) {
                        currentLength11 = letters11[0].an * 0.5 + (totalLength11 - this._pathData.f.v - letters11[0].an * 0.5 - letters11[letters11.length - 1].an * 0.5) * ind11 / (len11 - 1);
                        currentLength11 += this._pathData.f.v;
                    }
                    while(flag11){
                        if (segmentLength11 + partialLength11 >= currentLength11 + animatorOffset11 || !points11) {
                            perc11 = (currentLength11 + animatorOffset11 - segmentLength11) / currentPoint11.partialLength;
                            xPathPos11 = prevPoint11.point[0] + (currentPoint11.point[0] - prevPoint11.point[0]) * perc11;
                            yPathPos11 = prevPoint11.point[1] + (currentPoint11.point[1] - prevPoint11.point[1]) * perc11;
                            matrixHelper11.translate(-alignment11[0] * letters11[i31].an * 0.005, -(alignment11[1] * yOff11) * 0.01);
                            flag11 = false;
                        } else if (points11) {
                            segmentLength11 += currentPoint11.partialLength;
                            pointInd11 += 1;
                            if (pointInd11 >= points11.length) {
                                pointInd11 = 0;
                                segmentInd11 += 1;
                                if (!segments11[segmentInd11]) {
                                    if (mask11.v.c) {
                                        pointInd11 = 0;
                                        segmentInd11 = 0;
                                        points11 = segments11[segmentInd11].points;
                                    } else {
                                        segmentLength11 -= currentPoint11.partialLength;
                                        points11 = null;
                                    }
                                } else points11 = segments11[segmentInd11].points;
                            }
                            if (points11) {
                                prevPoint11 = currentPoint11;
                                currentPoint11 = points11[pointInd11];
                                partialLength11 = currentPoint11.partialLength;
                            }
                        }
                    }
                    offf11 = letters11[i31].an / 2 - letters11[i31].add;
                    matrixHelper11.translate(-offf11, 0, 0);
                } else {
                    offf11 = letters11[i31].an / 2 - letters11[i31].add;
                    matrixHelper11.translate(-offf11, 0, 0); // Grouping alignment
                    matrixHelper11.translate(-alignment11[0] * letters11[i31].an * 0.005, -alignment11[1] * yOff11 * 0.01, 0);
                }
                for(j31 = 0; j31 < jLen11; j31 += 1){
                    animatorProps11 = animators11[j31].a;
                    if (animatorProps11.t.propType) {
                        animatorSelector11 = animators11[j31].s;
                        mult11 = animatorSelector11.getMult(letters11[i31].anIndexes[j31], textData11.a[j31].s.totalChars); // This condition is to prevent applying tracking to first character in each line. Might be better to use a boolean "isNewLine"
                        if (xPos11 !== 0 || documentData11.j !== 0) {
                            if (this._hasMaskedPath) {
                                if (mult11.length) currentLength11 += animatorProps11.t.v * mult11[0];
                                else currentLength11 += animatorProps11.t.v * mult11;
                            } else if (mult11.length) xPos11 += animatorProps11.t.v * mult11[0];
                            else xPos11 += animatorProps11.t.v * mult11;
                        }
                    }
                }
                if (documentData11.strokeWidthAnim) sw11 = documentData11.sw || 0;
                if (documentData11.strokeColorAnim) {
                    if (documentData11.sc) sc11 = [
                        documentData11.sc[0],
                        documentData11.sc[1],
                        documentData11.sc[2]
                    ];
                    else sc11 = [
                        0,
                        0,
                        0
                    ];
                }
                if (documentData11.fillColorAnim && documentData11.fc) fc11 = [
                    documentData11.fc[0],
                    documentData11.fc[1],
                    documentData11.fc[2]
                ];
                for(j31 = 0; j31 < jLen11; j31 += 1){
                    animatorProps11 = animators11[j31].a;
                    if (animatorProps11.a.propType) {
                        animatorSelector11 = animators11[j31].s;
                        mult11 = animatorSelector11.getMult(letters11[i31].anIndexes[j31], textData11.a[j31].s.totalChars);
                        if (mult11.length) matrixHelper11.translate(-animatorProps11.a.v[0] * mult11[0], -animatorProps11.a.v[1] * mult11[1], animatorProps11.a.v[2] * mult11[2]);
                        else matrixHelper11.translate(-animatorProps11.a.v[0] * mult11, -animatorProps11.a.v[1] * mult11, animatorProps11.a.v[2] * mult11);
                    }
                }
                for(j31 = 0; j31 < jLen11; j31 += 1){
                    animatorProps11 = animators11[j31].a;
                    if (animatorProps11.s.propType) {
                        animatorSelector11 = animators11[j31].s;
                        mult11 = animatorSelector11.getMult(letters11[i31].anIndexes[j31], textData11.a[j31].s.totalChars);
                        if (mult11.length) matrixHelper11.scale(1 + (animatorProps11.s.v[0] - 1) * mult11[0], 1 + (animatorProps11.s.v[1] - 1) * mult11[1], 1);
                        else matrixHelper11.scale(1 + (animatorProps11.s.v[0] - 1) * mult11, 1 + (animatorProps11.s.v[1] - 1) * mult11, 1);
                    }
                }
                for(j31 = 0; j31 < jLen11; j31 += 1){
                    animatorProps11 = animators11[j31].a;
                    animatorSelector11 = animators11[j31].s;
                    mult11 = animatorSelector11.getMult(letters11[i31].anIndexes[j31], textData11.a[j31].s.totalChars);
                    if (animatorProps11.sk.propType) {
                        if (mult11.length) matrixHelper11.skewFromAxis(-animatorProps11.sk.v * mult11[0], animatorProps11.sa.v * mult11[1]);
                        else matrixHelper11.skewFromAxis(-animatorProps11.sk.v * mult11, animatorProps11.sa.v * mult11);
                    }
                    if (animatorProps11.r.propType) {
                        if (mult11.length) matrixHelper11.rotateZ(-animatorProps11.r.v * mult11[2]);
                        else matrixHelper11.rotateZ(-animatorProps11.r.v * mult11);
                    }
                    if (animatorProps11.ry.propType) {
                        if (mult11.length) matrixHelper11.rotateY(animatorProps11.ry.v * mult11[1]);
                        else matrixHelper11.rotateY(animatorProps11.ry.v * mult11);
                    }
                    if (animatorProps11.rx.propType) {
                        if (mult11.length) matrixHelper11.rotateX(animatorProps11.rx.v * mult11[0]);
                        else matrixHelper11.rotateX(animatorProps11.rx.v * mult11);
                    }
                    if (animatorProps11.o.propType) {
                        if (mult11.length) elemOpacity11 += (animatorProps11.o.v * mult11[0] - elemOpacity11) * mult11[0];
                        else elemOpacity11 += (animatorProps11.o.v * mult11 - elemOpacity11) * mult11;
                    }
                    if (documentData11.strokeWidthAnim && animatorProps11.sw.propType) {
                        if (mult11.length) sw11 += animatorProps11.sw.v * mult11[0];
                        else sw11 += animatorProps11.sw.v * mult11;
                    }
                    if (documentData11.strokeColorAnim && animatorProps11.sc.propType) {
                        for(k31 = 0; k31 < 3; k31 += 1)if (mult11.length) sc11[k31] += (animatorProps11.sc.v[k31] - sc11[k31]) * mult11[0];
                        else sc11[k31] += (animatorProps11.sc.v[k31] - sc11[k31]) * mult11;
                    }
                    if (documentData11.fillColorAnim && documentData11.fc) {
                        if (animatorProps11.fc.propType) {
                            for(k31 = 0; k31 < 3; k31 += 1)if (mult11.length) fc11[k31] += (animatorProps11.fc.v[k31] - fc11[k31]) * mult11[0];
                            else fc11[k31] += (animatorProps11.fc.v[k31] - fc11[k31]) * mult11;
                        }
                        if (animatorProps11.fh.propType) {
                            if (mult11.length) fc11 = addHueToRGB(fc11, animatorProps11.fh.v * mult11[0]);
                            else fc11 = addHueToRGB(fc11, animatorProps11.fh.v * mult11);
                        }
                        if (animatorProps11.fs.propType) {
                            if (mult11.length) fc11 = addSaturationToRGB(fc11, animatorProps11.fs.v * mult11[0]);
                            else fc11 = addSaturationToRGB(fc11, animatorProps11.fs.v * mult11);
                        }
                        if (animatorProps11.fb.propType) {
                            if (mult11.length) fc11 = addBrightnessToRGB(fc11, animatorProps11.fb.v * mult11[0]);
                            else fc11 = addBrightnessToRGB(fc11, animatorProps11.fb.v * mult11);
                        }
                    }
                }
                for(j31 = 0; j31 < jLen11; j31 += 1){
                    animatorProps11 = animators11[j31].a;
                    if (animatorProps11.p.propType) {
                        animatorSelector11 = animators11[j31].s;
                        mult11 = animatorSelector11.getMult(letters11[i31].anIndexes[j31], textData11.a[j31].s.totalChars);
                        if (this._hasMaskedPath) {
                            if (mult11.length) matrixHelper11.translate(0, animatorProps11.p.v[1] * mult11[0], -animatorProps11.p.v[2] * mult11[1]);
                            else matrixHelper11.translate(0, animatorProps11.p.v[1] * mult11, -animatorProps11.p.v[2] * mult11);
                        } else if (mult11.length) matrixHelper11.translate(animatorProps11.p.v[0] * mult11[0], animatorProps11.p.v[1] * mult11[1], -animatorProps11.p.v[2] * mult11[2]);
                        else matrixHelper11.translate(animatorProps11.p.v[0] * mult11, animatorProps11.p.v[1] * mult11, -animatorProps11.p.v[2] * mult11);
                    }
                }
                if (documentData11.strokeWidthAnim) letterSw11 = sw11 < 0 ? 0 : sw11;
                if (documentData11.strokeColorAnim) letterSc11 = "rgb(" + Math.round(sc11[0] * 255) + "," + Math.round(sc11[1] * 255) + "," + Math.round(sc11[2] * 255) + ")";
                if (documentData11.fillColorAnim && documentData11.fc) letterFc11 = "rgb(" + Math.round(fc11[0] * 255) + "," + Math.round(fc11[1] * 255) + "," + Math.round(fc11[2] * 255) + ")";
                if (this._hasMaskedPath) {
                    matrixHelper11.translate(0, -documentData11.ls);
                    matrixHelper11.translate(0, alignment11[1] * yOff11 * 0.01 + yPos11, 0);
                    if (this._pathData.p.v) {
                        tanAngle11 = (currentPoint11.point[1] - prevPoint11.point[1]) / (currentPoint11.point[0] - prevPoint11.point[0]);
                        var rot11 = Math.atan(tanAngle11) * 180 / Math.PI;
                        if (currentPoint11.point[0] < prevPoint11.point[0]) rot11 += 180;
                        matrixHelper11.rotate(-rot11 * Math.PI / 180);
                    }
                    matrixHelper11.translate(xPathPos11, yPathPos11, 0);
                    currentLength11 -= alignment11[0] * letters11[i31].an * 0.005;
                    if (letters11[i31 + 1] && ind11 !== letters11[i31 + 1].ind) {
                        currentLength11 += letters11[i31].an / 2;
                        currentLength11 += documentData11.tr * 0.001 * documentData11.finalSize;
                    }
                } else {
                    matrixHelper11.translate(xPos11, yPos11, 0);
                    if (documentData11.ps) // matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
                    matrixHelper11.translate(documentData11.ps[0], documentData11.ps[1] + documentData11.ascent, 0);
                    switch(documentData11.j){
                        case 1:
                            matrixHelper11.translate(letters11[i31].animatorJustifyOffset + documentData11.justifyOffset + (documentData11.boxWidth - documentData11.lineWidths[letters11[i31].line]), 0, 0);
                            break;
                        case 2:
                            matrixHelper11.translate(letters11[i31].animatorJustifyOffset + documentData11.justifyOffset + (documentData11.boxWidth - documentData11.lineWidths[letters11[i31].line]) / 2, 0, 0);
                            break;
                        default:
                            break;
                    }
                    matrixHelper11.translate(0, -documentData11.ls);
                    matrixHelper11.translate(offf11, 0, 0);
                    matrixHelper11.translate(alignment11[0] * letters11[i31].an * 0.005, alignment11[1] * yOff11 * 0.01, 0);
                    xPos11 += letters11[i31].l + documentData11.tr * 0.001 * documentData11.finalSize;
                }
                if (renderType11 === "html") letterM11 = matrixHelper11.toCSS();
                else if (renderType11 === "svg") letterM11 = matrixHelper11.to2dCSS();
                else letterP11 = [
                    matrixHelper11.props[0],
                    matrixHelper11.props[1],
                    matrixHelper11.props[2],
                    matrixHelper11.props[3],
                    matrixHelper11.props[4],
                    matrixHelper11.props[5],
                    matrixHelper11.props[6],
                    matrixHelper11.props[7],
                    matrixHelper11.props[8],
                    matrixHelper11.props[9],
                    matrixHelper11.props[10],
                    matrixHelper11.props[11],
                    matrixHelper11.props[12],
                    matrixHelper11.props[13],
                    matrixHelper11.props[14],
                    matrixHelper11.props[15]
                ];
                letterO11 = elemOpacity11;
            }
            if (renderedLettersCount11 <= i31) {
                letterValue11 = new LetterProps(letterO11, letterSw11, letterSc11, letterFc11, letterM11, letterP11);
                this.renderedLetters.push(letterValue11);
                renderedLettersCount11 += 1;
                this.lettersChangedFlag = true;
            } else {
                letterValue11 = this.renderedLetters[i31];
                this.lettersChangedFlag = letterValue11.update(letterO11, letterSw11, letterSc11, letterFc11, letterM11, letterP11) || this.lettersChangedFlag;
            }
        }
    };
    TextAnimatorProperty.prototype.getValue = function() {
        if (this._elem.globalData.frameId === this._frameId) return;
        this._frameId = this._elem.globalData.frameId;
        this.iterateDynamicProperties();
    };
    TextAnimatorProperty.prototype.mHelper = new Matrix();
    TextAnimatorProperty.prototype.defaultPropsArray = [];
    extendPrototype([
        DynamicPropertyContainer
    ], TextAnimatorProperty);
    function ITextElement() {}
    ITextElement.prototype.initElement = function(data11, globalData11, comp11) {
        this.lettersChangedFlag = true;
        this.initFrame();
        this.initBaseData(data11, globalData11, comp11);
        this.textProperty = new TextProperty(this, data11.t, this.dynamicProperties);
        this.textAnimator = new TextAnimatorProperty(data11.t, this.renderType, this);
        this.initTransform(data11, globalData11, comp11);
        this.initHierarchy();
        this.initRenderable();
        this.initRendererElement();
        this.createContainerElements();
        this.createRenderableComponents();
        this.createContent();
        this.hide();
        this.textAnimator.searchProperties(this.dynamicProperties);
    };
    ITextElement.prototype.prepareFrame = function(num11) {
        this._mdf = false;
        this.prepareRenderableFrame(num11);
        this.prepareProperties(num11, this.isInRange);
    };
    ITextElement.prototype.createPathShape = function(matrixHelper11, shapes11) {
        var j31;
        var jLen11 = shapes11.length;
        var pathNodes11;
        var shapeStr11 = "";
        for(j31 = 0; j31 < jLen11; j31 += 1)if (shapes11[j31].ty === "sh") {
            pathNodes11 = shapes11[j31].ks.k;
            shapeStr11 += buildShapeString(pathNodes11, pathNodes11.i.length, true, matrixHelper11);
        }
        return shapeStr11;
    };
    ITextElement.prototype.updateDocumentData = function(newData11, index11) {
        this.textProperty.updateDocumentData(newData11, index11);
    };
    ITextElement.prototype.canResizeFont = function(_canResize11) {
        this.textProperty.canResizeFont(_canResize11);
    };
    ITextElement.prototype.setMinimumFontSize = function(_fontSize11) {
        this.textProperty.setMinimumFontSize(_fontSize11);
    };
    ITextElement.prototype.applyTextPropertiesToMatrix = function(documentData11, matrixHelper11, lineNumber11, xPos11, yPos11) {
        if (documentData11.ps) matrixHelper11.translate(documentData11.ps[0], documentData11.ps[1] + documentData11.ascent, 0);
        matrixHelper11.translate(0, -documentData11.ls, 0);
        switch(documentData11.j){
            case 1:
                matrixHelper11.translate(documentData11.justifyOffset + (documentData11.boxWidth - documentData11.lineWidths[lineNumber11]), 0, 0);
                break;
            case 2:
                matrixHelper11.translate(documentData11.justifyOffset + (documentData11.boxWidth - documentData11.lineWidths[lineNumber11]) / 2, 0, 0);
                break;
            default:
                break;
        }
        matrixHelper11.translate(xPos11, yPos11, 0);
    };
    ITextElement.prototype.buildColor = function(colorData11) {
        return "rgb(" + Math.round(colorData11[0] * 255) + "," + Math.round(colorData11[1] * 255) + "," + Math.round(colorData11[2] * 255) + ")";
    };
    ITextElement.prototype.emptyProp = new LetterProps();
    ITextElement.prototype.destroy = function() {};
    ITextElement.prototype.validateText = function() {
        if (this.textProperty._mdf || this.textProperty._isFirstFrame) {
            this.buildNewText();
            this.textProperty._isFirstFrame = false;
            this.textProperty._mdf = false;
        }
    };
    var emptyShapeData = {
        shapes: []
    };
    function SVGTextLottieElement(data11, globalData11, comp11) {
        this.textSpans = [];
        this.renderType = "svg";
        this.initElement(data11, globalData11, comp11);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement,
        ITextElement
    ], SVGTextLottieElement);
    SVGTextLottieElement.prototype.createContent = function() {
        if (this.data.singleShape && !this.globalData.fontManager.chars) this.textContainer = createNS("text");
    };
    SVGTextLottieElement.prototype.buildTextContents = function(textArray11) {
        var i31 = 0;
        var len11 = textArray11.length;
        var textContents11 = [];
        var currentTextContent11 = "";
        while(i31 < len11){
            if (textArray11[i31] === String.fromCharCode(13) || textArray11[i31] === String.fromCharCode(3)) {
                textContents11.push(currentTextContent11);
                currentTextContent11 = "";
            } else currentTextContent11 += textArray11[i31];
            i31 += 1;
        }
        textContents11.push(currentTextContent11);
        return textContents11;
    };
    SVGTextLottieElement.prototype.buildShapeData = function(data11, scale21) {
        // data should probably be cloned to apply scale separately to each instance of a text on different layers
        // but since text internal content gets only rendered once and then it's never rerendered,
        // it's probably safe not to clone data and reuse always the same instance even if the object is mutated.
        // Avoiding cloning is preferred since cloning each character shape data is expensive
        if (data11.shapes && data11.shapes.length) {
            var shape31 = data11.shapes[0];
            if (shape31.it) {
                var shapeItem11 = shape31.it[shape31.it.length - 1];
                if (shapeItem11.s) {
                    shapeItem11.s.k[0] = scale21;
                    shapeItem11.s.k[1] = scale21;
                }
            }
        }
        return data11;
    };
    SVGTextLottieElement.prototype.buildNewText = function() {
        this.addDynamicProperty(this);
        var i31;
        var len11;
        var documentData11 = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData11 ? documentData11.l.length : 0);
        if (documentData11.fc) this.layerElement.setAttribute("fill", this.buildColor(documentData11.fc));
        else this.layerElement.setAttribute("fill", "rgba(0,0,0,0)");
        if (documentData11.sc) {
            this.layerElement.setAttribute("stroke", this.buildColor(documentData11.sc));
            this.layerElement.setAttribute("stroke-width", documentData11.sw);
        }
        this.layerElement.setAttribute("font-size", documentData11.finalSize);
        var fontData11 = this.globalData.fontManager.getFontByName(documentData11.f);
        if (fontData11.fClass) this.layerElement.setAttribute("class", fontData11.fClass);
        else {
            this.layerElement.setAttribute("font-family", fontData11.fFamily);
            var fWeight11 = documentData11.fWeight;
            var fStyle11 = documentData11.fStyle;
            this.layerElement.setAttribute("font-style", fStyle11);
            this.layerElement.setAttribute("font-weight", fWeight11);
        }
        this.layerElement.setAttribute("aria-label", documentData11.t);
        var letters11 = documentData11.l || [];
        var usesGlyphs11 = !!this.globalData.fontManager.chars;
        len11 = letters11.length;
        var tSpan11;
        var matrixHelper11 = this.mHelper;
        var shapeStr11 = "";
        var singleShape11 = this.data.singleShape;
        var xPos11 = 0;
        var yPos11 = 0;
        var firstLine11 = true;
        var trackingOffset11 = documentData11.tr * 0.001 * documentData11.finalSize;
        if (singleShape11 && !usesGlyphs11 && !documentData11.sz) {
            var tElement11 = this.textContainer;
            var justify11 = "start";
            switch(documentData11.j){
                case 1:
                    justify11 = "end";
                    break;
                case 2:
                    justify11 = "middle";
                    break;
                default:
                    justify11 = "start";
                    break;
            }
            tElement11.setAttribute("text-anchor", justify11);
            tElement11.setAttribute("letter-spacing", trackingOffset11);
            var textContent11 = this.buildTextContents(documentData11.finalText);
            len11 = textContent11.length;
            yPos11 = documentData11.ps ? documentData11.ps[1] + documentData11.ascent : 0;
            for(i31 = 0; i31 < len11; i31 += 1){
                tSpan11 = this.textSpans[i31].span || createNS("tspan");
                tSpan11.textContent = textContent11[i31];
                tSpan11.setAttribute("x", 0);
                tSpan11.setAttribute("y", yPos11);
                tSpan11.style.display = "inherit";
                tElement11.appendChild(tSpan11);
                if (!this.textSpans[i31]) this.textSpans[i31] = {
                    span: null,
                    glyph: null
                };
                this.textSpans[i31].span = tSpan11;
                yPos11 += documentData11.finalLineHeight;
            }
            this.layerElement.appendChild(tElement11);
        } else {
            var cachedSpansLength11 = this.textSpans.length;
            var charData11;
            for(i31 = 0; i31 < len11; i31 += 1){
                if (!this.textSpans[i31]) this.textSpans[i31] = {
                    span: null,
                    childSpan: null,
                    glyph: null
                };
                if (!usesGlyphs11 || !singleShape11 || i31 === 0) {
                    tSpan11 = cachedSpansLength11 > i31 ? this.textSpans[i31].span : createNS(usesGlyphs11 ? "g" : "text");
                    if (cachedSpansLength11 <= i31) {
                        tSpan11.setAttribute("stroke-linecap", "butt");
                        tSpan11.setAttribute("stroke-linejoin", "round");
                        tSpan11.setAttribute("stroke-miterlimit", "4");
                        this.textSpans[i31].span = tSpan11;
                        if (usesGlyphs11) {
                            var childSpan11 = createNS("g");
                            tSpan11.appendChild(childSpan11);
                            this.textSpans[i31].childSpan = childSpan11;
                        }
                        this.textSpans[i31].span = tSpan11;
                        this.layerElement.appendChild(tSpan11);
                    }
                    tSpan11.style.display = "inherit";
                }
                matrixHelper11.reset();
                if (singleShape11) {
                    if (letters11[i31].n) {
                        xPos11 = -trackingOffset11;
                        yPos11 += documentData11.yOffset;
                        yPos11 += firstLine11 ? 1 : 0;
                        firstLine11 = false;
                    }
                    this.applyTextPropertiesToMatrix(documentData11, matrixHelper11, letters11[i31].line, xPos11, yPos11);
                    xPos11 += letters11[i31].l || 0; // xPos += letters[i].val === ' ' ? 0 : trackingOffset;
                    xPos11 += trackingOffset11;
                }
                if (usesGlyphs11) {
                    charData11 = this.globalData.fontManager.getCharData(documentData11.finalText[i31], fontData11.fStyle, this.globalData.fontManager.getFontByName(documentData11.f).fFamily);
                    var glyphElement11; // t === 1 means the character has been replaced with an animated shaped
                    if (charData11.t === 1) glyphElement11 = new SVGCompElement(charData11.data, this.globalData, this);
                    else {
                        var data11 = emptyShapeData;
                        if (charData11.data && charData11.data.shapes) data11 = this.buildShapeData(charData11.data, documentData11.finalSize);
                        glyphElement11 = new SVGShapeElement(data11, this.globalData, this);
                    }
                    if (this.textSpans[i31].glyph) {
                        var glyph11 = this.textSpans[i31].glyph;
                        this.textSpans[i31].childSpan.removeChild(glyph11.layerElement);
                        glyph11.destroy();
                    }
                    this.textSpans[i31].glyph = glyphElement11;
                    glyphElement11._debug = true;
                    glyphElement11.prepareFrame(0);
                    glyphElement11.renderFrame();
                    this.textSpans[i31].childSpan.appendChild(glyphElement11.layerElement); // when using animated shapes, the layer will be scaled instead of replacing the internal scale
                    // this might have issues with strokes and might need a different solution
                    if (charData11.t === 1) this.textSpans[i31].childSpan.setAttribute("transform", "scale(" + documentData11.finalSize / 100 + "," + documentData11.finalSize / 100 + ")");
                } else {
                    if (singleShape11) tSpan11.setAttribute("transform", "translate(" + matrixHelper11.props[12] + "," + matrixHelper11.props[13] + ")");
                    tSpan11.textContent = letters11[i31].val;
                    tSpan11.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
                } //
            }
            if (singleShape11 && tSpan11) tSpan11.setAttribute("d", shapeStr11);
        }
        while(i31 < this.textSpans.length){
            this.textSpans[i31].span.style.display = "none";
            i31 += 1;
        }
        this._sizeChanged = true;
    };
    SVGTextLottieElement.prototype.sourceRectAtTime = function() {
        this.prepareFrame(this.comp.renderedFrame - this.data.st);
        this.renderInnerContent();
        if (this._sizeChanged) {
            this._sizeChanged = false;
            var textBox11 = this.layerElement.getBBox();
            this.bbox = {
                top: textBox11.y,
                left: textBox11.x,
                width: textBox11.width,
                height: textBox11.height
            };
        }
        return this.bbox;
    };
    SVGTextLottieElement.prototype.getValue = function() {
        var i31;
        var len11 = this.textSpans.length;
        var glyphElement11;
        this.renderedFrame = this.comp.renderedFrame;
        for(i31 = 0; i31 < len11; i31 += 1){
            glyphElement11 = this.textSpans[i31].glyph;
            if (glyphElement11) {
                glyphElement11.prepareFrame(this.comp.renderedFrame - this.data.st);
                if (glyphElement11._mdf) this._mdf = true;
            }
        }
    };
    SVGTextLottieElement.prototype.renderInnerContent = function() {
        this.validateText();
        if (!this.data.singleShape || this._mdf) {
            this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
            if (this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
                this._sizeChanged = true;
                var i31;
                var len11;
                var renderedLetters11 = this.textAnimator.renderedLetters;
                var letters11 = this.textProperty.currentData.l;
                len11 = letters11.length;
                var renderedLetter11;
                var textSpan11;
                var glyphElement11;
                for(i31 = 0; i31 < len11; i31 += 1)if (!letters11[i31].n) {
                    renderedLetter11 = renderedLetters11[i31];
                    textSpan11 = this.textSpans[i31].span;
                    glyphElement11 = this.textSpans[i31].glyph;
                    if (glyphElement11) glyphElement11.renderFrame();
                    if (renderedLetter11._mdf.m) textSpan11.setAttribute("transform", renderedLetter11.m);
                    if (renderedLetter11._mdf.o) textSpan11.setAttribute("opacity", renderedLetter11.o);
                    if (renderedLetter11._mdf.sw) textSpan11.setAttribute("stroke-width", renderedLetter11.sw);
                    if (renderedLetter11._mdf.sc) textSpan11.setAttribute("stroke", renderedLetter11.sc);
                    if (renderedLetter11._mdf.fc) textSpan11.setAttribute("fill", renderedLetter11.fc);
                }
            }
        }
    };
    function ISolidElement(data11, globalData11, comp11) {
        this.initElement(data11, globalData11, comp11);
    }
    extendPrototype([
        IImageElement
    ], ISolidElement);
    ISolidElement.prototype.createContent = function() {
        var rect11 = createNS("rect"); /// /rect.style.width = this.data.sw;
        /// /rect.style.height = this.data.sh;
        /// /rect.style.fill = this.data.sc;
        rect11.setAttribute("width", this.data.sw);
        rect11.setAttribute("height", this.data.sh);
        rect11.setAttribute("fill", this.data.sc);
        this.layerElement.appendChild(rect11);
    };
    function NullElement(data11, globalData11, comp11) {
        this.initFrame();
        this.initBaseData(data11, globalData11, comp11);
        this.initFrame();
        this.initTransform(data11, globalData11, comp11);
        this.initHierarchy();
    }
    NullElement.prototype.prepareFrame = function(num11) {
        this.prepareProperties(num11, true);
    };
    NullElement.prototype.renderFrame = function() {};
    NullElement.prototype.getBaseElement = function() {
        return null;
    };
    NullElement.prototype.destroy = function() {};
    NullElement.prototype.sourceRectAtTime = function() {};
    NullElement.prototype.hide = function() {};
    extendPrototype([
        BaseElement,
        TransformElement,
        HierarchyElement,
        FrameElement
    ], NullElement);
    function SVGRendererBase() {}
    extendPrototype([
        BaseRenderer
    ], SVGRendererBase);
    SVGRendererBase.prototype.createNull = function(data11) {
        return new NullElement(data11, this.globalData, this);
    };
    SVGRendererBase.prototype.createShape = function(data11) {
        return new SVGShapeElement(data11, this.globalData, this);
    };
    SVGRendererBase.prototype.createText = function(data11) {
        return new SVGTextLottieElement(data11, this.globalData, this);
    };
    SVGRendererBase.prototype.createImage = function(data11) {
        return new IImageElement(data11, this.globalData, this);
    };
    SVGRendererBase.prototype.createSolid = function(data11) {
        return new ISolidElement(data11, this.globalData, this);
    };
    SVGRendererBase.prototype.configAnimation = function(animData11) {
        this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg");
        this.svgElement.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");
        if (this.renderConfig.viewBoxSize) this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize);
        else this.svgElement.setAttribute("viewBox", "0 0 " + animData11.w + " " + animData11.h);
        if (!this.renderConfig.viewBoxOnly) {
            this.svgElement.setAttribute("width", animData11.w);
            this.svgElement.setAttribute("height", animData11.h);
            this.svgElement.style.width = "100%";
            this.svgElement.style.height = "100%";
            this.svgElement.style.transform = "translate3d(0,0,0)";
            this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility;
        }
        if (this.renderConfig.width) this.svgElement.setAttribute("width", this.renderConfig.width);
        if (this.renderConfig.height) this.svgElement.setAttribute("height", this.renderConfig.height);
        if (this.renderConfig.className) this.svgElement.setAttribute("class", this.renderConfig.className);
        if (this.renderConfig.id) this.svgElement.setAttribute("id", this.renderConfig.id);
        if (this.renderConfig.focusable !== undefined) this.svgElement.setAttribute("focusable", this.renderConfig.focusable);
        this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio); // this.layerElement.style.transform = 'translate3d(0,0,0)';
        // this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
        this.animationItem.wrapper.appendChild(this.svgElement); // Mask animation
        var defs11 = this.globalData.defs;
        this.setupGlobalData(animData11, defs11);
        this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
        this.data = animData11;
        var maskElement11 = createNS("clipPath");
        var rect11 = createNS("rect");
        rect11.setAttribute("width", animData11.w);
        rect11.setAttribute("height", animData11.h);
        rect11.setAttribute("x", 0);
        rect11.setAttribute("y", 0);
        var maskId11 = createElementID();
        maskElement11.setAttribute("id", maskId11);
        maskElement11.appendChild(rect11);
        this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + maskId11 + ")");
        defs11.appendChild(maskElement11);
        this.layers = animData11.layers;
        this.elements = createSizedArray(animData11.layers.length);
    };
    SVGRendererBase.prototype.destroy = function() {
        if (this.animationItem.wrapper) this.animationItem.wrapper.innerText = "";
        this.layerElement = null;
        this.globalData.defs = null;
        var i31;
        var len11 = this.layers ? this.layers.length : 0;
        for(i31 = 0; i31 < len11; i31 += 1)if (this.elements[i31] && this.elements[i31].destroy) this.elements[i31].destroy();
        this.elements.length = 0;
        this.destroyed = true;
        this.animationItem = null;
    };
    SVGRendererBase.prototype.updateContainerSize = function() {};
    SVGRendererBase.prototype.findIndexByInd = function(ind11) {
        var i31 = 0;
        var len11 = this.layers.length;
        for(i31 = 0; i31 < len11; i31 += 1){
            if (this.layers[i31].ind === ind11) return i31;
        }
        return -1;
    };
    SVGRendererBase.prototype.buildItem = function(pos11) {
        var elements11 = this.elements;
        if (elements11[pos11] || this.layers[pos11].ty === 99) return;
        elements11[pos11] = true;
        var element11 = this.createItem(this.layers[pos11]);
        elements11[pos11] = element11;
        if (getExpressionsPlugin()) {
            if (this.layers[pos11].ty === 0) this.globalData.projectInterface.registerComposition(element11);
            element11.initExpressions();
        }
        this.appendElementInPos(element11, pos11);
        if (this.layers[pos11].tt) {
            var elementIndex11 = "tp" in this.layers[pos11] ? this.findIndexByInd(this.layers[pos11].tp) : pos11 - 1;
            if (elementIndex11 === -1) return;
            if (!this.elements[elementIndex11] || this.elements[elementIndex11] === true) {
                this.buildItem(elementIndex11);
                this.addPendingElement(element11);
            } else {
                var matteElement11 = elements11[elementIndex11];
                var matteMask11 = matteElement11.getMatte(this.layers[pos11].tt);
                element11.setMatte(matteMask11);
            }
        }
    };
    SVGRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element11 = this.pendingElements.pop();
            element11.checkParenting();
            if (element11.data.tt) {
                var i31 = 0;
                var len11 = this.elements.length;
                while(i31 < len11){
                    if (this.elements[i31] === element11) {
                        var elementIndex11 = "tp" in element11.data ? this.findIndexByInd(element11.data.tp) : i31 - 1;
                        var matteElement11 = this.elements[elementIndex11];
                        var matteMask11 = matteElement11.getMatte(this.layers[i31].tt);
                        element11.setMatte(matteMask11);
                        break;
                    }
                    i31 += 1;
                }
            }
        }
    };
    SVGRendererBase.prototype.renderFrame = function(num11) {
        if (this.renderedFrame === num11 || this.destroyed) return;
        if (num11 === null) num11 = this.renderedFrame;
        else this.renderedFrame = num11;
         // console.log('-------');
        // console.log('FRAME ',num);
        this.globalData.frameNum = num11;
        this.globalData.frameId += 1;
        this.globalData.projectInterface.currentFrame = num11;
        this.globalData._mdf = false;
        var i31;
        var len11 = this.layers.length;
        if (!this.completeLayers) this.checkLayers(num11);
        for(i31 = len11 - 1; i31 >= 0; i31 -= 1)if (this.completeLayers || this.elements[i31]) this.elements[i31].prepareFrame(num11 - this.layers[i31].st);
        if (this.globalData._mdf) {
            for(i31 = 0; i31 < len11; i31 += 1)if (this.completeLayers || this.elements[i31]) this.elements[i31].renderFrame();
        }
    };
    SVGRendererBase.prototype.appendElementInPos = function(element11, pos11) {
        var newElement11 = element11.getBaseElement();
        if (!newElement11) return;
        var i31 = 0;
        var nextElement11;
        while(i31 < pos11){
            if (this.elements[i31] && this.elements[i31] !== true && this.elements[i31].getBaseElement()) nextElement11 = this.elements[i31].getBaseElement();
            i31 += 1;
        }
        if (nextElement11) this.layerElement.insertBefore(newElement11, nextElement11);
        else this.layerElement.appendChild(newElement11);
    };
    SVGRendererBase.prototype.hide = function() {
        this.layerElement.style.display = "none";
    };
    SVGRendererBase.prototype.show = function() {
        this.layerElement.style.display = "block";
    };
    function ICompElement() {}
    extendPrototype([
        BaseElement,
        TransformElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], ICompElement);
    ICompElement.prototype.initElement = function(data11, globalData11, comp11) {
        this.initFrame();
        this.initBaseData(data11, globalData11, comp11);
        this.initTransform(data11, globalData11, comp11);
        this.initRenderable();
        this.initHierarchy();
        this.initRendererElement();
        this.createContainerElements();
        this.createRenderableComponents();
        if (this.data.xt || !globalData11.progressiveLoad) this.buildAllItems();
        this.hide();
    };
    /* ICompElement.prototype.hide = function(){
      if(!this.hidden){
          this.hideElement();
          var i,len = this.elements.length;
          for( i = 0; i < len; i+=1 ){
              if(this.elements[i]){
                  this.elements[i].hide();
              }
          }
      }
  }; */ ICompElement.prototype.prepareFrame = function(num11) {
        this._mdf = false;
        this.prepareRenderableFrame(num11);
        this.prepareProperties(num11, this.isInRange);
        if (!this.isInRange && !this.data.xt) return;
        if (!this.tm._placeholder) {
            var timeRemapped11 = this.tm.v;
            if (timeRemapped11 === this.data.op) timeRemapped11 = this.data.op - 1;
            this.renderedFrame = timeRemapped11;
        } else this.renderedFrame = num11 / this.data.sr;
        var i31;
        var len11 = this.elements.length;
        if (!this.completeLayers) this.checkLayers(this.renderedFrame);
         // This iteration needs to be backwards because of how expressions connect between each other
        for(i31 = len11 - 1; i31 >= 0; i31 -= 1)if (this.completeLayers || this.elements[i31]) {
            this.elements[i31].prepareFrame(this.renderedFrame - this.layers[i31].st);
            if (this.elements[i31]._mdf) this._mdf = true;
        }
    };
    ICompElement.prototype.renderInnerContent = function() {
        var i31;
        var len11 = this.layers.length;
        for(i31 = 0; i31 < len11; i31 += 1)if (this.completeLayers || this.elements[i31]) this.elements[i31].renderFrame();
    };
    ICompElement.prototype.setElements = function(elems11) {
        this.elements = elems11;
    };
    ICompElement.prototype.getElements = function() {
        return this.elements;
    };
    ICompElement.prototype.destroyElements = function() {
        var i31;
        var len11 = this.layers.length;
        for(i31 = 0; i31 < len11; i31 += 1)if (this.elements[i31]) this.elements[i31].destroy();
    };
    ICompElement.prototype.destroy = function() {
        this.destroyElements();
        this.destroyBaseElement();
    };
    function SVGCompElement(data11, globalData11, comp11) {
        this.layers = data11.layers;
        this.supports3d = true;
        this.completeLayers = false;
        this.pendingElements = [];
        this.elements = this.layers ? createSizedArray(this.layers.length) : [];
        this.initElement(data11, globalData11, comp11);
        this.tm = data11.tm ? PropertyFactory.getProp(this, data11.tm, 0, globalData11.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        SVGRendererBase,
        ICompElement,
        SVGBaseElement
    ], SVGCompElement);
    SVGCompElement.prototype.createComp = function(data11) {
        return new SVGCompElement(data11, this.globalData, this);
    };
    function SVGRenderer(animationItem11, config11) {
        this.animationItem = animationItem11;
        this.layers = null;
        this.renderedFrame = -1;
        this.svgElement = createNS("svg");
        var ariaLabel11 = "";
        if (config11 && config11.title) {
            var titleElement11 = createNS("title");
            var titleId11 = createElementID();
            titleElement11.setAttribute("id", titleId11);
            titleElement11.textContent = config11.title;
            this.svgElement.appendChild(titleElement11);
            ariaLabel11 += titleId11;
        }
        if (config11 && config11.description) {
            var descElement11 = createNS("desc");
            var descId11 = createElementID();
            descElement11.setAttribute("id", descId11);
            descElement11.textContent = config11.description;
            this.svgElement.appendChild(descElement11);
            ariaLabel11 += " " + descId11;
        }
        if (ariaLabel11) this.svgElement.setAttribute("aria-labelledby", ariaLabel11);
        var defs11 = createNS("defs");
        this.svgElement.appendChild(defs11);
        var maskElement11 = createNS("g");
        this.svgElement.appendChild(maskElement11);
        this.layerElement = maskElement11;
        this.renderConfig = {
            preserveAspectRatio: config11 && config11.preserveAspectRatio || "xMidYMid meet",
            imagePreserveAspectRatio: config11 && config11.imagePreserveAspectRatio || "xMidYMid slice",
            contentVisibility: config11 && config11.contentVisibility || "visible",
            progressiveLoad: config11 && config11.progressiveLoad || false,
            hideOnTransparent: !(config11 && config11.hideOnTransparent === false),
            viewBoxOnly: config11 && config11.viewBoxOnly || false,
            viewBoxSize: config11 && config11.viewBoxSize || false,
            className: config11 && config11.className || "",
            id: config11 && config11.id || "",
            focusable: config11 && config11.focusable,
            filterSize: {
                width: config11 && config11.filterSize && config11.filterSize.width || "100%",
                height: config11 && config11.filterSize && config11.filterSize.height || "100%",
                x: config11 && config11.filterSize && config11.filterSize.x || "0%",
                y: config11 && config11.filterSize && config11.filterSize.y || "0%"
            },
            width: config11 && config11.width,
            height: config11 && config11.height,
            runExpressions: !config11 || config11.runExpressions === undefined || config11.runExpressions
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            defs: defs11,
            renderConfig: this.renderConfig
        };
        this.elements = [];
        this.pendingElements = [];
        this.destroyed = false;
        this.rendererType = "svg";
    }
    extendPrototype([
        SVGRendererBase
    ], SVGRenderer);
    SVGRenderer.prototype.createComp = function(data11) {
        return new SVGCompElement(data11, this.globalData, this);
    };
    function ShapeTransformManager() {
        this.sequences = {};
        this.sequenceList = [];
        this.transform_key_count = 0;
    }
    ShapeTransformManager.prototype = {
        addTransformSequence: function addTransformSequence11(transforms11) {
            var i31;
            var len11 = transforms11.length;
            var key11 = "_";
            for(i31 = 0; i31 < len11; i31 += 1)key11 += transforms11[i31].transform.key + "_";
            var sequence11 = this.sequences[key11];
            if (!sequence11) {
                sequence11 = {
                    transforms: [].concat(transforms11),
                    finalTransform: new Matrix(),
                    _mdf: false
                };
                this.sequences[key11] = sequence11;
                this.sequenceList.push(sequence11);
            }
            return sequence11;
        },
        processSequence: function processSequence11(sequence11, isFirstFrame11) {
            var i31 = 0;
            var len11 = sequence11.transforms.length;
            var _mdf11 = isFirstFrame11;
            while(i31 < len11 && !isFirstFrame11){
                if (sequence11.transforms[i31].transform.mProps._mdf) {
                    _mdf11 = true;
                    break;
                }
                i31 += 1;
            }
            if (_mdf11) {
                sequence11.finalTransform.reset();
                for(i31 = len11 - 1; i31 >= 0; i31 -= 1)sequence11.finalTransform.multiply(sequence11.transforms[i31].transform.mProps.v);
            }
            sequence11._mdf = _mdf11;
        },
        processSequences: function processSequences11(isFirstFrame11) {
            var i31;
            var len11 = this.sequenceList.length;
            for(i31 = 0; i31 < len11; i31 += 1)this.processSequence(this.sequenceList[i31], isFirstFrame11);
        },
        getNewKey: function getNewKey11() {
            this.transform_key_count += 1;
            return "_" + this.transform_key_count;
        }
    };
    var lumaLoader = function lumaLoader11() {
        var id11 = "__lottie_element_luma_buffer";
        var lumaBuffer11 = null;
        var lumaBufferCtx11 = null;
        var svg11 = null; // This alternate solution has a slight delay before the filter is applied, resulting in a flicker on the first frame.
        // Keeping this here for reference, and in the future, if offscreen canvas supports url filters, this can be used.
        // For now, neither of them work for offscreen canvas, so canvas workers can't support the luma track matte mask.
        // Naming it solution 2 to mark the extra comment lines.
        /*
    var svgString = [
      '<svg xmlns="http://www.w3.org/2000/svg">',
      '<filter id="' + id + '">',
      '<feColorMatrix type="matrix" color-interpolation-filters="sRGB" values="',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0',
      '"/>',
      '</filter>',
      '</svg>',
    ].join('');
    var blob = new Blob([svgString], { type: 'image/svg+xml' });
    var url = URL.createObjectURL(blob);
    */ function createLumaSvgFilter11() {
            var _svg11 = createNS("svg");
            var fil11 = createNS("filter");
            var matrix11 = createNS("feColorMatrix");
            fil11.setAttribute("id", id11);
            matrix11.setAttribute("type", "matrix");
            matrix11.setAttribute("color-interpolation-filters", "sRGB");
            matrix11.setAttribute("values", "0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0");
            fil11.appendChild(matrix11);
            _svg11.appendChild(fil11);
            _svg11.setAttribute("id", id11 + "_svg");
            if (featureSupport.svgLumaHidden) _svg11.style.display = "none";
            return _svg11;
        }
        function loadLuma11() {
            if (!lumaBuffer11) {
                svg11 = createLumaSvgFilter11();
                document.body.appendChild(svg11);
                lumaBuffer11 = createTag("canvas");
                lumaBufferCtx11 = lumaBuffer11.getContext("2d"); // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2
                lumaBufferCtx11.filter = "url(#" + id11 + ")";
                lumaBufferCtx11.fillStyle = "rgba(0,0,0,0)";
                lumaBufferCtx11.fillRect(0, 0, 1, 1);
            }
        }
        function getLuma11(canvas11) {
            if (!lumaBuffer11) loadLuma11();
            lumaBuffer11.width = canvas11.width;
            lumaBuffer11.height = canvas11.height; // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2
            lumaBufferCtx11.filter = "url(#" + id11 + ")";
            return lumaBuffer11;
        }
        return {
            load: loadLuma11,
            get: getLuma11
        };
    };
    function createCanvas(width11, height11) {
        if (featureSupport.offscreenCanvas) return new OffscreenCanvas(width11, height11);
        var canvas11 = createTag("canvas");
        canvas11.width = width11;
        canvas11.height = height11;
        return canvas11;
    }
    var assetLoader = function() {
        return {
            loadLumaCanvas: lumaLoader.load,
            getLumaCanvas: lumaLoader.get,
            createCanvas: createCanvas
        };
    }();
    var registeredEffects = {};
    function CVEffects(elem31) {
        var i31;
        var len11 = elem31.data.ef ? elem31.data.ef.length : 0;
        this.filters = [];
        var filterManager11;
        for(i31 = 0; i31 < len11; i31 += 1){
            filterManager11 = null;
            var type11 = elem31.data.ef[i31].ty;
            if (registeredEffects[type11]) {
                var Effect11 = registeredEffects[type11].effect;
                filterManager11 = new Effect11(elem31.effectsManager.effectElements[i31], elem31);
            }
            if (filterManager11) this.filters.push(filterManager11);
        }
        if (this.filters.length) elem31.addRenderableComponent(this);
    }
    CVEffects.prototype.renderFrame = function(_isFirstFrame11) {
        var i31;
        var len11 = this.filters.length;
        for(i31 = 0; i31 < len11; i31 += 1)this.filters[i31].renderFrame(_isFirstFrame11);
    };
    CVEffects.prototype.getEffects = function(type11) {
        var i31;
        var len11 = this.filters.length;
        var effects11 = [];
        for(i31 = 0; i31 < len11; i31 += 1)if (this.filters[i31].type === type11) effects11.push(this.filters[i31]);
        return effects11;
    };
    function registerEffect(id11, effect11) {
        registeredEffects[id11] = {
            effect: effect11
        };
    }
    function CVMaskElement(data11, element11) {
        this.data = data11;
        this.element = element11;
        this.masksProperties = this.data.masksProperties || [];
        this.viewData = createSizedArray(this.masksProperties.length);
        var i31;
        var len11 = this.masksProperties.length;
        var hasMasks11 = false;
        for(i31 = 0; i31 < len11; i31 += 1){
            if (this.masksProperties[i31].mode !== "n") hasMasks11 = true;
            this.viewData[i31] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[i31], 3);
        }
        this.hasMasks = hasMasks11;
        if (hasMasks11) this.element.addRenderableComponent(this);
    }
    CVMaskElement.prototype.renderFrame = function() {
        if (!this.hasMasks) return;
        var transform11 = this.element.finalTransform.mat;
        var ctx11 = this.element.canvasContext;
        var i31;
        var len11 = this.masksProperties.length;
        var pt51;
        var pts11;
        var data11;
        ctx11.beginPath();
        for(i31 = 0; i31 < len11; i31 += 1)if (this.masksProperties[i31].mode !== "n") {
            if (this.masksProperties[i31].inv) {
                ctx11.moveTo(0, 0);
                ctx11.lineTo(this.element.globalData.compSize.w, 0);
                ctx11.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h);
                ctx11.lineTo(0, this.element.globalData.compSize.h);
                ctx11.lineTo(0, 0);
            }
            data11 = this.viewData[i31].v;
            pt51 = transform11.applyToPointArray(data11.v[0][0], data11.v[0][1], 0);
            ctx11.moveTo(pt51[0], pt51[1]);
            var j31;
            var jLen11 = data11._length;
            for(j31 = 1; j31 < jLen11; j31 += 1){
                pts11 = transform11.applyToTriplePoints(data11.o[j31 - 1], data11.i[j31], data11.v[j31]);
                ctx11.bezierCurveTo(pts11[0], pts11[1], pts11[2], pts11[3], pts11[4], pts11[5]);
            }
            pts11 = transform11.applyToTriplePoints(data11.o[j31 - 1], data11.i[0], data11.v[0]);
            ctx11.bezierCurveTo(pts11[0], pts11[1], pts11[2], pts11[3], pts11[4], pts11[5]);
        }
        this.element.globalData.renderer.save(true);
        ctx11.clip();
    };
    CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty;
    CVMaskElement.prototype.destroy = function() {
        this.element = null;
    };
    function CVBaseElement() {}
    var operationsMap = {
        1: "source-in",
        2: "source-out",
        3: "source-in",
        4: "source-out"
    };
    CVBaseElement.prototype = {
        createElements: function createElements11() {},
        initRendererElement: function initRendererElement11() {},
        createContainerElements: function createContainerElements11() {
            // If the layer is masked we will use two buffers to store each different states of the drawing
            // This solution is not ideal for several reason. But unfortunately, because of the recursive
            // nature of the render tree, it's the only simple way to make sure one inner mask doesn't override an outer mask.
            // TODO: try to reduce the size of these buffers to the size of the composition contaning the layer
            // It might be challenging because the layer most likely is transformed in some way
            if (this.data.tt >= 1) {
                this.buffers = [];
                var canvasContext11 = this.globalData.canvasContext;
                var bufferCanvas11 = assetLoader.createCanvas(canvasContext11.canvas.width, canvasContext11.canvas.height);
                this.buffers.push(bufferCanvas11);
                var bufferCanvas211 = assetLoader.createCanvas(canvasContext11.canvas.width, canvasContext11.canvas.height);
                this.buffers.push(bufferCanvas211);
                if (this.data.tt >= 3 && !document._isProxy) assetLoader.loadLumaCanvas();
            }
            this.canvasContext = this.globalData.canvasContext;
            this.transformCanvas = this.globalData.transformCanvas;
            this.renderableEffectsManager = new CVEffects(this);
            this.searchEffectTransforms();
        },
        createContent: function createContent11() {},
        setBlendMode: function setBlendMode11() {
            var globalData11 = this.globalData;
            if (globalData11.blendMode !== this.data.bm) {
                globalData11.blendMode = this.data.bm;
                var blendModeValue11 = getBlendMode(this.data.bm);
                globalData11.canvasContext.globalCompositeOperation = blendModeValue11;
            }
        },
        createRenderableComponents: function createRenderableComponents11() {
            this.maskManager = new CVMaskElement(this.data, this);
            this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
        },
        hideElement: function hideElement11() {
            if (!this.hidden && (!this.isInRange || this.isTransparent)) this.hidden = true;
        },
        showElement: function showElement11() {
            if (this.isInRange && !this.isTransparent) {
                this.hidden = false;
                this._isFirstFrame = true;
                this.maskManager._isFirstFrame = true;
            }
        },
        clearCanvas: function clearCanvas11(canvasContext11) {
            canvasContext11.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
        },
        prepareLayer: function prepareLayer11() {
            if (this.data.tt >= 1) {
                var buffer11 = this.buffers[0];
                var bufferCtx11 = buffer11.getContext("2d");
                this.clearCanvas(bufferCtx11); // on the first buffer we store the current state of the global drawing
                bufferCtx11.drawImage(this.canvasContext.canvas, 0, 0); // The next four lines are to clear the canvas
                // TODO: Check if there is a way to clear the canvas without resetting the transform
                this.currentTransform = this.canvasContext.getTransform();
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
                this.clearCanvas(this.canvasContext);
                this.canvasContext.setTransform(this.currentTransform);
            }
        },
        exitLayer: function exitLayer11() {
            if (this.data.tt >= 1) {
                var buffer11 = this.buffers[1]; // On the second buffer we store the current state of the global drawing
                // that only contains the content of this layer
                // (if it is a composition, it also includes the nested layers)
                var bufferCtx11 = buffer11.getContext("2d");
                this.clearCanvas(bufferCtx11);
                bufferCtx11.drawImage(this.canvasContext.canvas, 0, 0); // We clear the canvas again
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
                this.clearCanvas(this.canvasContext);
                this.canvasContext.setTransform(this.currentTransform); // We draw the mask
                var mask11 = this.comp.getElementById("tp" in this.data ? this.data.tp : this.data.ind - 1);
                mask11.renderFrame(true); // We draw the second buffer (that contains the content of this layer)
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0); // If the mask is a Luma matte, we need to do two extra painting operations
                // the _isProxy check is to avoid drawing a fake canvas in workers that will throw an error
                if (this.data.tt >= 3 && !document._isProxy) {
                    // We copy the painted mask to a buffer that has a color matrix filter applied to it
                    // that applies the rgb values to the alpha channel
                    var lumaBuffer11 = assetLoader.getLumaCanvas(this.canvasContext.canvas);
                    var lumaBufferCtx11 = lumaBuffer11.getContext("2d");
                    lumaBufferCtx11.drawImage(this.canvasContext.canvas, 0, 0);
                    this.clearCanvas(this.canvasContext); // we repaint the context with the mask applied to it
                    this.canvasContext.drawImage(lumaBuffer11, 0, 0);
                }
                this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt];
                this.canvasContext.drawImage(buffer11, 0, 0); // We finally draw the first buffer (that contains the content of the global drawing)
                // We use destination-over to draw the global drawing below the current layer
                this.canvasContext.globalCompositeOperation = "destination-over";
                this.canvasContext.drawImage(this.buffers[0], 0, 0);
                this.canvasContext.setTransform(this.currentTransform); // We reset the globalCompositeOperation to source-over, the standard type of operation
                this.canvasContext.globalCompositeOperation = "source-over";
            }
        },
        renderFrame: function renderFrame11(forceRender11) {
            if (this.hidden || this.data.hd) return;
            if (this.data.td === 1 && !forceRender11) return;
            this.renderTransform();
            this.renderRenderable();
            this.renderLocalTransform();
            this.setBlendMode();
            var forceRealStack11 = this.data.ty === 0;
            this.prepareLayer();
            this.globalData.renderer.save(forceRealStack11);
            this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props);
            this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity);
            this.renderInnerContent();
            this.globalData.renderer.restore(forceRealStack11);
            this.exitLayer();
            if (this.maskManager.hasMasks) this.globalData.renderer.restore(true);
            if (this._isFirstFrame) this._isFirstFrame = false;
        },
        destroy: function destroy11() {
            this.canvasContext = null;
            this.data = null;
            this.globalData = null;
            this.maskManager.destroy();
        },
        mHelper: new Matrix()
    };
    CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement;
    CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;
    function CVShapeData(element11, data11, styles11, transformsManager11) {
        this.styledShapes = [];
        this.tr = [
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var ty11 = 4;
        if (data11.ty === "rc") ty11 = 5;
        else if (data11.ty === "el") ty11 = 6;
        else if (data11.ty === "sr") ty11 = 7;
        this.sh = ShapePropertyFactory.getShapeProp(element11, data11, ty11, element11);
        var i31;
        var len11 = styles11.length;
        var styledShape11;
        for(i31 = 0; i31 < len11; i31 += 1)if (!styles11[i31].closed) {
            styledShape11 = {
                transforms: transformsManager11.addTransformSequence(styles11[i31].transforms),
                trNodes: []
            };
            this.styledShapes.push(styledShape11);
            styles11[i31].elements.push(styledShape11);
        }
    }
    CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;
    function CVShapeElement(data11, globalData11, comp11) {
        this.shapes = [];
        this.shapesData = data11.shapes;
        this.stylesList = [];
        this.itemsData = [];
        this.prevViewData = [];
        this.shapeModifiers = [];
        this.processedElements = [];
        this.transformsManager = new ShapeTransformManager();
        this.initElement(data11, globalData11, comp11);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        IShapeElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVShapeElement);
    CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement;
    CVShapeElement.prototype.transformHelper = {
        opacity: 1,
        _opMdf: false
    };
    CVShapeElement.prototype.dashResetter = [];
    CVShapeElement.prototype.createContent = function() {
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
    };
    CVShapeElement.prototype.createStyleElement = function(data11, transforms11) {
        var styleElem11 = {
            data: data11,
            type: data11.ty,
            preTransforms: this.transformsManager.addTransformSequence(transforms11),
            transforms: [],
            elements: [],
            closed: data11.hd === true
        };
        var elementData11 = {};
        if (data11.ty === "fl" || data11.ty === "st") {
            elementData11.c = PropertyFactory.getProp(this, data11.c, 1, 255, this);
            if (!elementData11.c.k) styleElem11.co = "rgb(" + bmFloor(elementData11.c.v[0]) + "," + bmFloor(elementData11.c.v[1]) + "," + bmFloor(elementData11.c.v[2]) + ")";
        } else if (data11.ty === "gf" || data11.ty === "gs") {
            elementData11.s = PropertyFactory.getProp(this, data11.s, 1, null, this);
            elementData11.e = PropertyFactory.getProp(this, data11.e, 1, null, this);
            elementData11.h = PropertyFactory.getProp(this, data11.h || {
                k: 0
            }, 0, 0.01, this);
            elementData11.a = PropertyFactory.getProp(this, data11.a || {
                k: 0
            }, 0, degToRads, this);
            elementData11.g = new GradientProperty(this, data11.g, this);
        }
        elementData11.o = PropertyFactory.getProp(this, data11.o, 0, 0.01, this);
        if (data11.ty === "st" || data11.ty === "gs") {
            styleElem11.lc = lineCapEnum[data11.lc || 2];
            styleElem11.lj = lineJoinEnum[data11.lj || 2];
            if (data11.lj == 1) // eslint-disable-line eqeqeq
            styleElem11.ml = data11.ml;
            elementData11.w = PropertyFactory.getProp(this, data11.w, 0, null, this);
            if (!elementData11.w.k) styleElem11.wi = elementData11.w.v;
            if (data11.d) {
                var d31 = new DashProperty(this, data11.d, "canvas", this);
                elementData11.d = d31;
                if (!elementData11.d.k) {
                    styleElem11.da = elementData11.d.dashArray;
                    styleElem11["do"] = elementData11.d.dashoffset[0];
                }
            }
        } else styleElem11.r = data11.r === 2 ? "evenodd" : "nonzero";
        this.stylesList.push(styleElem11);
        elementData11.style = styleElem11;
        return elementData11;
    };
    CVShapeElement.prototype.createGroupElement = function() {
        var elementData11 = {
            it: [],
            prevViewData: []
        };
        return elementData11;
    };
    CVShapeElement.prototype.createTransformElement = function(data11) {
        var elementData11 = {
            transform: {
                opacity: 1,
                _opMdf: false,
                key: this.transformsManager.getNewKey(),
                op: PropertyFactory.getProp(this, data11.o, 0, 0.01, this),
                mProps: TransformPropertyFactory.getTransformProperty(this, data11, this)
            }
        };
        return elementData11;
    };
    CVShapeElement.prototype.createShapeElement = function(data11) {
        var elementData11 = new CVShapeData(this, data11, this.stylesList, this.transformsManager);
        this.shapes.push(elementData11);
        this.addShapeToModifiers(elementData11);
        return elementData11;
    };
    CVShapeElement.prototype.reloadShapes = function() {
        this._isFirstFrame = true;
        var i31;
        var len11 = this.itemsData.length;
        for(i31 = 0; i31 < len11; i31 += 1)this.prevViewData[i31] = this.itemsData[i31];
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
        len11 = this.dynamicProperties.length;
        for(i31 = 0; i31 < len11; i31 += 1)this.dynamicProperties[i31].getValue();
        this.renderModifiers();
        this.transformsManager.processSequences(this._isFirstFrame);
    };
    CVShapeElement.prototype.addTransformToStyleList = function(transform11) {
        var i31;
        var len11 = this.stylesList.length;
        for(i31 = 0; i31 < len11; i31 += 1)if (!this.stylesList[i31].closed) this.stylesList[i31].transforms.push(transform11);
    };
    CVShapeElement.prototype.removeTransformFromStyleList = function() {
        var i31;
        var len11 = this.stylesList.length;
        for(i31 = 0; i31 < len11; i31 += 1)if (!this.stylesList[i31].closed) this.stylesList[i31].transforms.pop();
    };
    CVShapeElement.prototype.closeStyles = function(styles11) {
        var i31;
        var len11 = styles11.length;
        for(i31 = 0; i31 < len11; i31 += 1)styles11[i31].closed = true;
    };
    CVShapeElement.prototype.searchShapes = function(arr31, itemsData11, prevViewData11, shouldRender11, transforms11) {
        var i31;
        var len11 = arr31.length - 1;
        var j31;
        var jLen11;
        var ownStyles11 = [];
        var ownModifiers11 = [];
        var processedPos11;
        var modifier11;
        var currentTransform11;
        var ownTransforms11 = [].concat(transforms11);
        for(i31 = len11; i31 >= 0; i31 -= 1){
            processedPos11 = this.searchProcessedElement(arr31[i31]);
            if (!processedPos11) arr31[i31]._shouldRender = shouldRender11;
            else itemsData11[i31] = prevViewData11[processedPos11 - 1];
            if (arr31[i31].ty === "fl" || arr31[i31].ty === "st" || arr31[i31].ty === "gf" || arr31[i31].ty === "gs") {
                if (!processedPos11) itemsData11[i31] = this.createStyleElement(arr31[i31], ownTransforms11);
                else itemsData11[i31].style.closed = false;
                ownStyles11.push(itemsData11[i31].style);
            } else if (arr31[i31].ty === "gr") {
                if (!processedPos11) itemsData11[i31] = this.createGroupElement(arr31[i31]);
                else {
                    jLen11 = itemsData11[i31].it.length;
                    for(j31 = 0; j31 < jLen11; j31 += 1)itemsData11[i31].prevViewData[j31] = itemsData11[i31].it[j31];
                }
                this.searchShapes(arr31[i31].it, itemsData11[i31].it, itemsData11[i31].prevViewData, shouldRender11, ownTransforms11);
            } else if (arr31[i31].ty === "tr") {
                if (!processedPos11) {
                    currentTransform11 = this.createTransformElement(arr31[i31]);
                    itemsData11[i31] = currentTransform11;
                }
                ownTransforms11.push(itemsData11[i31]);
                this.addTransformToStyleList(itemsData11[i31]);
            } else if (arr31[i31].ty === "sh" || arr31[i31].ty === "rc" || arr31[i31].ty === "el" || arr31[i31].ty === "sr") {
                if (!processedPos11) itemsData11[i31] = this.createShapeElement(arr31[i31]);
            } else if (arr31[i31].ty === "tm" || arr31[i31].ty === "rd" || arr31[i31].ty === "pb" || arr31[i31].ty === "zz" || arr31[i31].ty === "op") {
                if (!processedPos11) {
                    modifier11 = ShapeModifiers.getModifier(arr31[i31].ty);
                    modifier11.init(this, arr31[i31]);
                    itemsData11[i31] = modifier11;
                    this.shapeModifiers.push(modifier11);
                } else {
                    modifier11 = itemsData11[i31];
                    modifier11.closed = false;
                }
                ownModifiers11.push(modifier11);
            } else if (arr31[i31].ty === "rp") {
                if (!processedPos11) {
                    modifier11 = ShapeModifiers.getModifier(arr31[i31].ty);
                    itemsData11[i31] = modifier11;
                    modifier11.init(this, arr31, i31, itemsData11);
                    this.shapeModifiers.push(modifier11);
                    shouldRender11 = false;
                } else {
                    modifier11 = itemsData11[i31];
                    modifier11.closed = true;
                }
                ownModifiers11.push(modifier11);
            }
            this.addProcessedElement(arr31[i31], i31 + 1);
        }
        this.removeTransformFromStyleList();
        this.closeStyles(ownStyles11);
        len11 = ownModifiers11.length;
        for(i31 = 0; i31 < len11; i31 += 1)ownModifiers11[i31].closed = true;
    };
    CVShapeElement.prototype.renderInnerContent = function() {
        this.transformHelper.opacity = 1;
        this.transformHelper._opMdf = false;
        this.renderModifiers();
        this.transformsManager.processSequences(this._isFirstFrame);
        this.renderShape(this.transformHelper, this.shapesData, this.itemsData, true);
    };
    CVShapeElement.prototype.renderShapeTransform = function(parentTransform11, groupTransform11) {
        if (parentTransform11._opMdf || groupTransform11.op._mdf || this._isFirstFrame) {
            groupTransform11.opacity = parentTransform11.opacity;
            groupTransform11.opacity *= groupTransform11.op.v;
            groupTransform11._opMdf = true;
        }
    };
    CVShapeElement.prototype.drawLayer = function() {
        var i31;
        var len11 = this.stylesList.length;
        var j31;
        var jLen11;
        var k31;
        var kLen11;
        var elems11;
        var nodes11;
        var renderer11 = this.globalData.renderer;
        var ctx11 = this.globalData.canvasContext;
        var type11;
        var currentStyle11;
        for(i31 = 0; i31 < len11; i31 += 1){
            currentStyle11 = this.stylesList[i31];
            type11 = currentStyle11.type; // Skipping style when
            // Stroke width equals 0
            // style should not be rendered (extra unused repeaters)
            // current opacity equals 0
            // global opacity equals 0
            if (!((type11 === "st" || type11 === "gs") && currentStyle11.wi === 0 || !currentStyle11.data._shouldRender || currentStyle11.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
                renderer11.save();
                elems11 = currentStyle11.elements;
                if (type11 === "st" || type11 === "gs") {
                    renderer11.ctxStrokeStyle(type11 === "st" ? currentStyle11.co : currentStyle11.grd); // ctx.strokeStyle = type === 'st' ? currentStyle.co : currentStyle.grd;
                    renderer11.ctxLineWidth(currentStyle11.wi); // ctx.lineWidth = currentStyle.wi;
                    renderer11.ctxLineCap(currentStyle11.lc); // ctx.lineCap = currentStyle.lc;
                    renderer11.ctxLineJoin(currentStyle11.lj); // ctx.lineJoin = currentStyle.lj;
                    renderer11.ctxMiterLimit(currentStyle11.ml || 0); // ctx.miterLimit = currentStyle.ml || 0;
                } else renderer11.ctxFillStyle(type11 === "fl" ? currentStyle11.co : currentStyle11.grd); // ctx.fillStyle = type === 'fl' ? currentStyle.co : currentStyle.grd;
                renderer11.ctxOpacity(currentStyle11.coOp);
                if (type11 !== "st" && type11 !== "gs") ctx11.beginPath();
                renderer11.ctxTransform(currentStyle11.preTransforms.finalTransform.props);
                jLen11 = elems11.length;
                for(j31 = 0; j31 < jLen11; j31 += 1){
                    if (type11 === "st" || type11 === "gs") {
                        ctx11.beginPath();
                        if (currentStyle11.da) {
                            ctx11.setLineDash(currentStyle11.da);
                            ctx11.lineDashOffset = currentStyle11["do"];
                        }
                    }
                    nodes11 = elems11[j31].trNodes;
                    kLen11 = nodes11.length;
                    for(k31 = 0; k31 < kLen11; k31 += 1){
                        if (nodes11[k31].t === "m") ctx11.moveTo(nodes11[k31].p[0], nodes11[k31].p[1]);
                        else if (nodes11[k31].t === "c") ctx11.bezierCurveTo(nodes11[k31].pts[0], nodes11[k31].pts[1], nodes11[k31].pts[2], nodes11[k31].pts[3], nodes11[k31].pts[4], nodes11[k31].pts[5]);
                        else ctx11.closePath();
                    }
                    if (type11 === "st" || type11 === "gs") {
                        // ctx.stroke();
                        renderer11.ctxStroke();
                        if (currentStyle11.da) ctx11.setLineDash(this.dashResetter);
                    }
                }
                if (type11 !== "st" && type11 !== "gs") // ctx.fill(currentStyle.r);
                this.globalData.renderer.ctxFill(currentStyle11.r);
                renderer11.restore();
            }
        }
    };
    CVShapeElement.prototype.renderShape = function(parentTransform11, items11, data11, isMain11) {
        var i31;
        var len11 = items11.length - 1;
        var groupTransform11;
        groupTransform11 = parentTransform11;
        for(i31 = len11; i31 >= 0; i31 -= 1){
            if (items11[i31].ty === "tr") {
                groupTransform11 = data11[i31].transform;
                this.renderShapeTransform(parentTransform11, groupTransform11);
            } else if (items11[i31].ty === "sh" || items11[i31].ty === "el" || items11[i31].ty === "rc" || items11[i31].ty === "sr") this.renderPath(items11[i31], data11[i31]);
            else if (items11[i31].ty === "fl") this.renderFill(items11[i31], data11[i31], groupTransform11);
            else if (items11[i31].ty === "st") this.renderStroke(items11[i31], data11[i31], groupTransform11);
            else if (items11[i31].ty === "gf" || items11[i31].ty === "gs") this.renderGradientFill(items11[i31], data11[i31], groupTransform11);
            else if (items11[i31].ty === "gr") this.renderShape(groupTransform11, items11[i31].it, data11[i31].it);
            else items11[i31].ty;
        }
        if (isMain11) this.drawLayer();
    };
    CVShapeElement.prototype.renderStyledShape = function(styledShape11, shape31) {
        if (this._isFirstFrame || shape31._mdf || styledShape11.transforms._mdf) {
            var shapeNodes11 = styledShape11.trNodes;
            var paths11 = shape31.paths;
            var i31;
            var len11;
            var j31;
            var jLen11 = paths11._length;
            shapeNodes11.length = 0;
            var groupTransformMat11 = styledShape11.transforms.finalTransform;
            for(j31 = 0; j31 < jLen11; j31 += 1){
                var pathNodes11 = paths11.shapes[j31];
                if (pathNodes11 && pathNodes11.v) {
                    len11 = pathNodes11._length;
                    for(i31 = 1; i31 < len11; i31 += 1){
                        if (i31 === 1) shapeNodes11.push({
                            t: "m",
                            p: groupTransformMat11.applyToPointArray(pathNodes11.v[0][0], pathNodes11.v[0][1], 0)
                        });
                        shapeNodes11.push({
                            t: "c",
                            pts: groupTransformMat11.applyToTriplePoints(pathNodes11.o[i31 - 1], pathNodes11.i[i31], pathNodes11.v[i31])
                        });
                    }
                    if (len11 === 1) shapeNodes11.push({
                        t: "m",
                        p: groupTransformMat11.applyToPointArray(pathNodes11.v[0][0], pathNodes11.v[0][1], 0)
                    });
                    if (pathNodes11.c && len11) {
                        shapeNodes11.push({
                            t: "c",
                            pts: groupTransformMat11.applyToTriplePoints(pathNodes11.o[i31 - 1], pathNodes11.i[0], pathNodes11.v[0])
                        });
                        shapeNodes11.push({
                            t: "z"
                        });
                    }
                }
            }
            styledShape11.trNodes = shapeNodes11;
        }
    };
    CVShapeElement.prototype.renderPath = function(pathData11, itemData11) {
        if (pathData11.hd !== true && pathData11._shouldRender) {
            var i31;
            var len11 = itemData11.styledShapes.length;
            for(i31 = 0; i31 < len11; i31 += 1)this.renderStyledShape(itemData11.styledShapes[i31], itemData11.sh);
        }
    };
    CVShapeElement.prototype.renderFill = function(styleData11, itemData11, groupTransform11) {
        var styleElem11 = itemData11.style;
        if (itemData11.c._mdf || this._isFirstFrame) styleElem11.co = "rgb(" + bmFloor(itemData11.c.v[0]) + "," + bmFloor(itemData11.c.v[1]) + "," + bmFloor(itemData11.c.v[2]) + ")";
        if (itemData11.o._mdf || groupTransform11._opMdf || this._isFirstFrame) styleElem11.coOp = itemData11.o.v * groupTransform11.opacity;
    };
    CVShapeElement.prototype.renderGradientFill = function(styleData11, itemData11, groupTransform11) {
        var styleElem11 = itemData11.style;
        var grd11;
        if (!styleElem11.grd || itemData11.g._mdf || itemData11.s._mdf || itemData11.e._mdf || styleData11.t !== 1 && (itemData11.h._mdf || itemData11.a._mdf)) {
            var ctx11 = this.globalData.canvasContext;
            var pt111 = itemData11.s.v;
            var pt211 = itemData11.e.v;
            if (styleData11.t === 1) grd11 = ctx11.createLinearGradient(pt111[0], pt111[1], pt211[0], pt211[1]);
            else {
                var rad11 = Math.sqrt(Math.pow(pt111[0] - pt211[0], 2) + Math.pow(pt111[1] - pt211[1], 2));
                var ang11 = Math.atan2(pt211[1] - pt111[1], pt211[0] - pt111[0]);
                var percent11 = itemData11.h.v;
                if (percent11 >= 1) percent11 = 0.99;
                else if (percent11 <= -1) percent11 = -0.99;
                var dist41 = rad11 * percent11;
                var x41 = Math.cos(ang11 + itemData11.a.v) * dist41 + pt111[0];
                var y41 = Math.sin(ang11 + itemData11.a.v) * dist41 + pt111[1];
                grd11 = ctx11.createRadialGradient(x41, y41, 0, pt111[0], pt111[1], rad11);
            }
            var i31;
            var len11 = styleData11.g.p;
            var cValues11 = itemData11.g.c;
            var opacity11 = 1;
            for(i31 = 0; i31 < len11; i31 += 1){
                if (itemData11.g._hasOpacity && itemData11.g._collapsable) opacity11 = itemData11.g.o[i31 * 2 + 1];
                grd11.addColorStop(cValues11[i31 * 4] / 100, "rgba(" + cValues11[i31 * 4 + 1] + "," + cValues11[i31 * 4 + 2] + "," + cValues11[i31 * 4 + 3] + "," + opacity11 + ")");
            }
            styleElem11.grd = grd11;
        }
        styleElem11.coOp = itemData11.o.v * groupTransform11.opacity;
    };
    CVShapeElement.prototype.renderStroke = function(styleData11, itemData11, groupTransform11) {
        var styleElem11 = itemData11.style;
        var d31 = itemData11.d;
        if (d31 && (d31._mdf || this._isFirstFrame)) {
            styleElem11.da = d31.dashArray;
            styleElem11["do"] = d31.dashoffset[0];
        }
        if (itemData11.c._mdf || this._isFirstFrame) styleElem11.co = "rgb(" + bmFloor(itemData11.c.v[0]) + "," + bmFloor(itemData11.c.v[1]) + "," + bmFloor(itemData11.c.v[2]) + ")";
        if (itemData11.o._mdf || groupTransform11._opMdf || this._isFirstFrame) styleElem11.coOp = itemData11.o.v * groupTransform11.opacity;
        if (itemData11.w._mdf || this._isFirstFrame) styleElem11.wi = itemData11.w.v;
    };
    CVShapeElement.prototype.destroy = function() {
        this.shapesData = null;
        this.globalData = null;
        this.canvasContext = null;
        this.stylesList.length = 0;
        this.itemsData.length = 0;
    };
    function CVTextElement(data11, globalData11, comp11) {
        this.textSpans = [];
        this.yOffset = 0;
        this.fillColorAnim = false;
        this.strokeColorAnim = false;
        this.strokeWidthAnim = false;
        this.stroke = false;
        this.fill = false;
        this.justifyOffset = 0;
        this.currentRender = null;
        this.renderType = "canvas";
        this.values = {
            fill: "rgba(0,0,0,0)",
            stroke: "rgba(0,0,0,0)",
            sWidth: 0,
            fValue: ""
        };
        this.initElement(data11, globalData11, comp11);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement,
        ITextElement
    ], CVTextElement);
    CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d");
    CVTextElement.prototype.buildNewText = function() {
        var documentData11 = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData11.l ? documentData11.l.length : 0);
        var hasFill11 = false;
        if (documentData11.fc) {
            hasFill11 = true;
            this.values.fill = this.buildColor(documentData11.fc);
        } else this.values.fill = "rgba(0,0,0,0)";
        this.fill = hasFill11;
        var hasStroke11 = false;
        if (documentData11.sc) {
            hasStroke11 = true;
            this.values.stroke = this.buildColor(documentData11.sc);
            this.values.sWidth = documentData11.sw;
        }
        var fontData11 = this.globalData.fontManager.getFontByName(documentData11.f);
        var i31;
        var len11;
        var letters11 = documentData11.l;
        var matrixHelper11 = this.mHelper;
        this.stroke = hasStroke11;
        this.values.fValue = documentData11.finalSize + "px " + this.globalData.fontManager.getFontByName(documentData11.f).fFamily;
        len11 = documentData11.finalText.length; // this.tHelper.font = this.values.fValue;
        var charData11;
        var shapeData11;
        var k31;
        var kLen11;
        var shapes11;
        var j31;
        var jLen11;
        var pathNodes11;
        var commands11;
        var pathArr11;
        var singleShape11 = this.data.singleShape;
        var trackingOffset11 = documentData11.tr * 0.001 * documentData11.finalSize;
        var xPos11 = 0;
        var yPos11 = 0;
        var firstLine11 = true;
        var cnt11 = 0;
        for(i31 = 0; i31 < len11; i31 += 1){
            charData11 = this.globalData.fontManager.getCharData(documentData11.finalText[i31], fontData11.fStyle, this.globalData.fontManager.getFontByName(documentData11.f).fFamily);
            shapeData11 = charData11 && charData11.data || {};
            matrixHelper11.reset();
            if (singleShape11 && letters11[i31].n) {
                xPos11 = -trackingOffset11;
                yPos11 += documentData11.yOffset;
                yPos11 += firstLine11 ? 1 : 0;
                firstLine11 = false;
            }
            shapes11 = shapeData11.shapes ? shapeData11.shapes[0].it : [];
            jLen11 = shapes11.length;
            matrixHelper11.scale(documentData11.finalSize / 100, documentData11.finalSize / 100);
            if (singleShape11) this.applyTextPropertiesToMatrix(documentData11, matrixHelper11, letters11[i31].line, xPos11, yPos11);
            commands11 = createSizedArray(jLen11 - 1);
            var commandsCounter11 = 0;
            for(j31 = 0; j31 < jLen11; j31 += 1)if (shapes11[j31].ty === "sh") {
                kLen11 = shapes11[j31].ks.k.i.length;
                pathNodes11 = shapes11[j31].ks.k;
                pathArr11 = [];
                for(k31 = 1; k31 < kLen11; k31 += 1){
                    if (k31 === 1) pathArr11.push(matrixHelper11.applyToX(pathNodes11.v[0][0], pathNodes11.v[0][1], 0), matrixHelper11.applyToY(pathNodes11.v[0][0], pathNodes11.v[0][1], 0));
                    pathArr11.push(matrixHelper11.applyToX(pathNodes11.o[k31 - 1][0], pathNodes11.o[k31 - 1][1], 0), matrixHelper11.applyToY(pathNodes11.o[k31 - 1][0], pathNodes11.o[k31 - 1][1], 0), matrixHelper11.applyToX(pathNodes11.i[k31][0], pathNodes11.i[k31][1], 0), matrixHelper11.applyToY(pathNodes11.i[k31][0], pathNodes11.i[k31][1], 0), matrixHelper11.applyToX(pathNodes11.v[k31][0], pathNodes11.v[k31][1], 0), matrixHelper11.applyToY(pathNodes11.v[k31][0], pathNodes11.v[k31][1], 0));
                }
                pathArr11.push(matrixHelper11.applyToX(pathNodes11.o[k31 - 1][0], pathNodes11.o[k31 - 1][1], 0), matrixHelper11.applyToY(pathNodes11.o[k31 - 1][0], pathNodes11.o[k31 - 1][1], 0), matrixHelper11.applyToX(pathNodes11.i[0][0], pathNodes11.i[0][1], 0), matrixHelper11.applyToY(pathNodes11.i[0][0], pathNodes11.i[0][1], 0), matrixHelper11.applyToX(pathNodes11.v[0][0], pathNodes11.v[0][1], 0), matrixHelper11.applyToY(pathNodes11.v[0][0], pathNodes11.v[0][1], 0));
                commands11[commandsCounter11] = pathArr11;
                commandsCounter11 += 1;
            }
            if (singleShape11) {
                xPos11 += letters11[i31].l;
                xPos11 += trackingOffset11;
            }
            if (this.textSpans[cnt11]) this.textSpans[cnt11].elem = commands11;
            else this.textSpans[cnt11] = {
                elem: commands11
            };
            cnt11 += 1;
        }
    };
    CVTextElement.prototype.renderInnerContent = function() {
        this.validateText();
        var ctx11 = this.canvasContext;
        ctx11.font = this.values.fValue;
        this.globalData.renderer.ctxLineCap("butt"); // ctx.lineCap = 'butt';
        this.globalData.renderer.ctxLineJoin("miter"); // ctx.lineJoin = 'miter';
        this.globalData.renderer.ctxMiterLimit(4); // ctx.miterLimit = 4;
        if (!this.data.singleShape) this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
        var i31;
        var len11;
        var j31;
        var jLen11;
        var k31;
        var kLen11;
        var renderedLetters11 = this.textAnimator.renderedLetters;
        var letters11 = this.textProperty.currentData.l;
        len11 = letters11.length;
        var renderedLetter11;
        var lastFill11 = null;
        var lastStroke11 = null;
        var lastStrokeW11 = null;
        var commands11;
        var pathArr11;
        var renderer11 = this.globalData.renderer;
        for(i31 = 0; i31 < len11; i31 += 1)if (!letters11[i31].n) {
            renderedLetter11 = renderedLetters11[i31];
            if (renderedLetter11) {
                renderer11.save();
                renderer11.ctxTransform(renderedLetter11.p);
                renderer11.ctxOpacity(renderedLetter11.o);
            }
            if (this.fill) {
                if (renderedLetter11 && renderedLetter11.fc) {
                    if (lastFill11 !== renderedLetter11.fc) {
                        renderer11.ctxFillStyle(renderedLetter11.fc);
                        lastFill11 = renderedLetter11.fc; // ctx.fillStyle = renderedLetter.fc;
                    }
                } else if (lastFill11 !== this.values.fill) {
                    lastFill11 = this.values.fill;
                    renderer11.ctxFillStyle(this.values.fill); // ctx.fillStyle = this.values.fill;
                }
                commands11 = this.textSpans[i31].elem;
                jLen11 = commands11.length;
                this.globalData.canvasContext.beginPath();
                for(j31 = 0; j31 < jLen11; j31 += 1){
                    pathArr11 = commands11[j31];
                    kLen11 = pathArr11.length;
                    this.globalData.canvasContext.moveTo(pathArr11[0], pathArr11[1]);
                    for(k31 = 2; k31 < kLen11; k31 += 6)this.globalData.canvasContext.bezierCurveTo(pathArr11[k31], pathArr11[k31 + 1], pathArr11[k31 + 2], pathArr11[k31 + 3], pathArr11[k31 + 4], pathArr11[k31 + 5]);
                }
                this.globalData.canvasContext.closePath();
                renderer11.ctxFill(); // this.globalData.canvasContext.fill();
            /// ctx.fillText(this.textSpans[i].val,0,0);
            }
            if (this.stroke) {
                if (renderedLetter11 && renderedLetter11.sw) {
                    if (lastStrokeW11 !== renderedLetter11.sw) {
                        lastStrokeW11 = renderedLetter11.sw;
                        renderer11.ctxLineWidth(renderedLetter11.sw); // ctx.lineWidth = renderedLetter.sw;
                    }
                } else if (lastStrokeW11 !== this.values.sWidth) {
                    lastStrokeW11 = this.values.sWidth;
                    renderer11.ctxLineWidth(this.values.sWidth); // ctx.lineWidth = this.values.sWidth;
                }
                if (renderedLetter11 && renderedLetter11.sc) {
                    if (lastStroke11 !== renderedLetter11.sc) {
                        lastStroke11 = renderedLetter11.sc;
                        renderer11.ctxStrokeStyle(renderedLetter11.sc); // ctx.strokeStyle = renderedLetter.sc;
                    }
                } else if (lastStroke11 !== this.values.stroke) {
                    lastStroke11 = this.values.stroke;
                    renderer11.ctxStrokeStyle(this.values.stroke); // ctx.strokeStyle = this.values.stroke;
                }
                commands11 = this.textSpans[i31].elem;
                jLen11 = commands11.length;
                this.globalData.canvasContext.beginPath();
                for(j31 = 0; j31 < jLen11; j31 += 1){
                    pathArr11 = commands11[j31];
                    kLen11 = pathArr11.length;
                    this.globalData.canvasContext.moveTo(pathArr11[0], pathArr11[1]);
                    for(k31 = 2; k31 < kLen11; k31 += 6)this.globalData.canvasContext.bezierCurveTo(pathArr11[k31], pathArr11[k31 + 1], pathArr11[k31 + 2], pathArr11[k31 + 3], pathArr11[k31 + 4], pathArr11[k31 + 5]);
                }
                this.globalData.canvasContext.closePath();
                renderer11.ctxStroke(); // this.globalData.canvasContext.stroke();
            /// ctx.strokeText(letters[i].val,0,0);
            }
            if (renderedLetter11) this.globalData.renderer.restore();
        }
    };
    function CVImageElement(data11, globalData11, comp11) {
        this.assetData = globalData11.getAssetData(data11.refId);
        this.img = globalData11.imageLoader.getAsset(this.assetData);
        this.initElement(data11, globalData11, comp11);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVImageElement);
    CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement;
    CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
    CVImageElement.prototype.createContent = function() {
        if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
            var canvas11 = createTag("canvas");
            canvas11.width = this.assetData.w;
            canvas11.height = this.assetData.h;
            var ctx11 = canvas11.getContext("2d");
            var imgW11 = this.img.width;
            var imgH11 = this.img.height;
            var imgRel11 = imgW11 / imgH11;
            var canvasRel11 = this.assetData.w / this.assetData.h;
            var widthCrop11;
            var heightCrop11;
            var par11 = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
            if (imgRel11 > canvasRel11 && par11 === "xMidYMid slice" || imgRel11 < canvasRel11 && par11 !== "xMidYMid slice") {
                heightCrop11 = imgH11;
                widthCrop11 = heightCrop11 * canvasRel11;
            } else {
                widthCrop11 = imgW11;
                heightCrop11 = widthCrop11 / canvasRel11;
            }
            ctx11.drawImage(this.img, (imgW11 - widthCrop11) / 2, (imgH11 - heightCrop11) / 2, widthCrop11, heightCrop11, 0, 0, this.assetData.w, this.assetData.h);
            this.img = canvas11;
        }
    };
    CVImageElement.prototype.renderInnerContent = function() {
        this.canvasContext.drawImage(this.img, 0, 0);
    };
    CVImageElement.prototype.destroy = function() {
        this.img = null;
    };
    function CVSolidElement(data11, globalData11, comp11) {
        this.initElement(data11, globalData11, comp11);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVSolidElement);
    CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement;
    CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
    CVSolidElement.prototype.renderInnerContent = function() {
        // var ctx = this.canvasContext;
        this.globalData.renderer.ctxFillStyle(this.data.sc); // ctx.fillStyle = this.data.sc;
        this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh); // ctx.fillRect(0, 0, this.data.sw, this.data.sh);
    //
    };
    function CanvasRendererBase() {}
    extendPrototype([
        BaseRenderer
    ], CanvasRendererBase);
    CanvasRendererBase.prototype.createShape = function(data11) {
        return new CVShapeElement(data11, this.globalData, this);
    };
    CanvasRendererBase.prototype.createText = function(data11) {
        return new CVTextElement(data11, this.globalData, this);
    };
    CanvasRendererBase.prototype.createImage = function(data11) {
        return new CVImageElement(data11, this.globalData, this);
    };
    CanvasRendererBase.prototype.createSolid = function(data11) {
        return new CVSolidElement(data11, this.globalData, this);
    };
    CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;
    CanvasRendererBase.prototype.ctxTransform = function(props11) {
        if (props11[0] === 1 && props11[1] === 0 && props11[4] === 0 && props11[5] === 1 && props11[12] === 0 && props11[13] === 0) return;
        this.canvasContext.transform(props11[0], props11[1], props11[4], props11[5], props11[12], props11[13]);
    };
    CanvasRendererBase.prototype.ctxOpacity = function(op11) {
        this.canvasContext.globalAlpha *= op11 < 0 ? 0 : op11;
    };
    CanvasRendererBase.prototype.ctxFillStyle = function(value31) {
        this.canvasContext.fillStyle = value31;
    };
    CanvasRendererBase.prototype.ctxStrokeStyle = function(value31) {
        this.canvasContext.strokeStyle = value31;
    };
    CanvasRendererBase.prototype.ctxLineWidth = function(value31) {
        this.canvasContext.lineWidth = value31;
    };
    CanvasRendererBase.prototype.ctxLineCap = function(value31) {
        this.canvasContext.lineCap = value31;
    };
    CanvasRendererBase.prototype.ctxLineJoin = function(value31) {
        this.canvasContext.lineJoin = value31;
    };
    CanvasRendererBase.prototype.ctxMiterLimit = function(value31) {
        this.canvasContext.miterLimit = value31;
    };
    CanvasRendererBase.prototype.ctxFill = function(rule11) {
        this.canvasContext.fill(rule11);
    };
    CanvasRendererBase.prototype.ctxFillRect = function(x41, y41, w11, h31) {
        this.canvasContext.fillRect(x41, y41, w11, h31);
    };
    CanvasRendererBase.prototype.ctxStroke = function() {
        this.canvasContext.stroke();
    };
    CanvasRendererBase.prototype.reset = function() {
        if (!this.renderConfig.clearCanvas) {
            this.canvasContext.restore();
            return;
        }
        this.contextData.reset();
    };
    CanvasRendererBase.prototype.save = function() {
        this.canvasContext.save();
    };
    CanvasRendererBase.prototype.restore = function(actionFlag11) {
        if (!this.renderConfig.clearCanvas) {
            this.canvasContext.restore();
            return;
        }
        if (actionFlag11) this.globalData.blendMode = "source-over";
        this.contextData.restore(actionFlag11);
    };
    CanvasRendererBase.prototype.configAnimation = function(animData11) {
        if (this.animationItem.wrapper) {
            this.animationItem.container = createTag("canvas");
            var containerStyle11 = this.animationItem.container.style;
            containerStyle11.width = "100%";
            containerStyle11.height = "100%";
            var origin11 = "0px 0px 0px";
            containerStyle11.transformOrigin = origin11;
            containerStyle11.mozTransformOrigin = origin11;
            containerStyle11.webkitTransformOrigin = origin11;
            containerStyle11["-webkit-transform"] = origin11;
            containerStyle11.contentVisibility = this.renderConfig.contentVisibility;
            this.animationItem.wrapper.appendChild(this.animationItem.container);
            this.canvasContext = this.animationItem.container.getContext("2d");
            if (this.renderConfig.className) this.animationItem.container.setAttribute("class", this.renderConfig.className);
            if (this.renderConfig.id) this.animationItem.container.setAttribute("id", this.renderConfig.id);
        } else this.canvasContext = this.renderConfig.context;
        this.contextData.setContext(this.canvasContext);
        this.data = animData11;
        this.layers = animData11.layers;
        this.transformCanvas = {
            w: animData11.w,
            h: animData11.h,
            sx: 0,
            sy: 0,
            tx: 0,
            ty: 0
        };
        this.setupGlobalData(animData11, document.body);
        this.globalData.canvasContext = this.canvasContext;
        this.globalData.renderer = this;
        this.globalData.isDashed = false;
        this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
        this.globalData.transformCanvas = this.transformCanvas;
        this.elements = createSizedArray(animData11.layers.length);
        this.updateContainerSize();
    };
    CanvasRendererBase.prototype.updateContainerSize = function(width11, height11) {
        this.reset();
        var elementWidth11;
        var elementHeight11;
        if (width11) {
            elementWidth11 = width11;
            elementHeight11 = height11;
            this.canvasContext.canvas.width = elementWidth11;
            this.canvasContext.canvas.height = elementHeight11;
        } else {
            if (this.animationItem.wrapper && this.animationItem.container) {
                elementWidth11 = this.animationItem.wrapper.offsetWidth;
                elementHeight11 = this.animationItem.wrapper.offsetHeight;
            } else {
                elementWidth11 = this.canvasContext.canvas.width;
                elementHeight11 = this.canvasContext.canvas.height;
            }
            this.canvasContext.canvas.width = elementWidth11 * this.renderConfig.dpr;
            this.canvasContext.canvas.height = elementHeight11 * this.renderConfig.dpr;
        }
        var elementRel11;
        var animationRel11;
        if (this.renderConfig.preserveAspectRatio.indexOf("meet") !== -1 || this.renderConfig.preserveAspectRatio.indexOf("slice") !== -1) {
            var par11 = this.renderConfig.preserveAspectRatio.split(" ");
            var fillType11 = par11[1] || "meet";
            var pos11 = par11[0] || "xMidYMid";
            var xPos11 = pos11.substr(0, 4);
            var yPos11 = pos11.substr(4);
            elementRel11 = elementWidth11 / elementHeight11;
            animationRel11 = this.transformCanvas.w / this.transformCanvas.h;
            if (animationRel11 > elementRel11 && fillType11 === "meet" || animationRel11 < elementRel11 && fillType11 === "slice") {
                this.transformCanvas.sx = elementWidth11 / (this.transformCanvas.w / this.renderConfig.dpr);
                this.transformCanvas.sy = elementWidth11 / (this.transformCanvas.w / this.renderConfig.dpr);
            } else {
                this.transformCanvas.sx = elementHeight11 / (this.transformCanvas.h / this.renderConfig.dpr);
                this.transformCanvas.sy = elementHeight11 / (this.transformCanvas.h / this.renderConfig.dpr);
            }
            if (xPos11 === "xMid" && (animationRel11 < elementRel11 && fillType11 === "meet" || animationRel11 > elementRel11 && fillType11 === "slice")) this.transformCanvas.tx = (elementWidth11 - this.transformCanvas.w * (elementHeight11 / this.transformCanvas.h)) / 2 * this.renderConfig.dpr;
            else if (xPos11 === "xMax" && (animationRel11 < elementRel11 && fillType11 === "meet" || animationRel11 > elementRel11 && fillType11 === "slice")) this.transformCanvas.tx = (elementWidth11 - this.transformCanvas.w * (elementHeight11 / this.transformCanvas.h)) * this.renderConfig.dpr;
            else this.transformCanvas.tx = 0;
            if (yPos11 === "YMid" && (animationRel11 > elementRel11 && fillType11 === "meet" || animationRel11 < elementRel11 && fillType11 === "slice")) this.transformCanvas.ty = (elementHeight11 - this.transformCanvas.h * (elementWidth11 / this.transformCanvas.w)) / 2 * this.renderConfig.dpr;
            else if (yPos11 === "YMax" && (animationRel11 > elementRel11 && fillType11 === "meet" || animationRel11 < elementRel11 && fillType11 === "slice")) this.transformCanvas.ty = (elementHeight11 - this.transformCanvas.h * (elementWidth11 / this.transformCanvas.w)) * this.renderConfig.dpr;
            else this.transformCanvas.ty = 0;
        } else if (this.renderConfig.preserveAspectRatio === "none") {
            this.transformCanvas.sx = elementWidth11 / (this.transformCanvas.w / this.renderConfig.dpr);
            this.transformCanvas.sy = elementHeight11 / (this.transformCanvas.h / this.renderConfig.dpr);
            this.transformCanvas.tx = 0;
            this.transformCanvas.ty = 0;
        } else {
            this.transformCanvas.sx = this.renderConfig.dpr;
            this.transformCanvas.sy = this.renderConfig.dpr;
            this.transformCanvas.tx = 0;
            this.transformCanvas.ty = 0;
        }
        this.transformCanvas.props = [
            this.transformCanvas.sx,
            0,
            0,
            0,
            0,
            this.transformCanvas.sy,
            0,
            0,
            0,
            0,
            1,
            0,
            this.transformCanvas.tx,
            this.transformCanvas.ty,
            0,
            1
        ];
        /* var i, len = this.elements.length;
      for(i=0;i<len;i+=1){
          if(this.elements[i] && this.elements[i].data.ty === 0){
              this.elements[i].resize(this.globalData.transformCanvas);
          }
      } */ this.ctxTransform(this.transformCanvas.props);
        this.canvasContext.beginPath();
        this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
        this.canvasContext.closePath();
        this.canvasContext.clip();
        this.renderFrame(this.renderedFrame, true);
    };
    CanvasRendererBase.prototype.destroy = function() {
        if (this.renderConfig.clearCanvas && this.animationItem.wrapper) this.animationItem.wrapper.innerText = "";
        var i31;
        var len11 = this.layers ? this.layers.length : 0;
        for(i31 = len11 - 1; i31 >= 0; i31 -= 1)if (this.elements[i31] && this.elements[i31].destroy) this.elements[i31].destroy();
        this.elements.length = 0;
        this.globalData.canvasContext = null;
        this.animationItem.container = null;
        this.destroyed = true;
    };
    CanvasRendererBase.prototype.renderFrame = function(num11, forceRender11) {
        if (this.renderedFrame === num11 && this.renderConfig.clearCanvas === true && !forceRender11 || this.destroyed || num11 === -1) return;
        this.renderedFrame = num11;
        this.globalData.frameNum = num11 - this.animationItem._isFirstFrame;
        this.globalData.frameId += 1;
        this.globalData._mdf = !this.renderConfig.clearCanvas || forceRender11;
        this.globalData.projectInterface.currentFrame = num11; // console.log('--------');
        // console.log('NEW: ',num);
        var i31;
        var len11 = this.layers.length;
        if (!this.completeLayers) this.checkLayers(num11);
        for(i31 = len11 - 1; i31 >= 0; i31 -= 1)if (this.completeLayers || this.elements[i31]) this.elements[i31].prepareFrame(num11 - this.layers[i31].st);
        if (this.globalData._mdf) {
            if (this.renderConfig.clearCanvas === true) this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
            else this.save();
            for(i31 = len11 - 1; i31 >= 0; i31 -= 1)if (this.completeLayers || this.elements[i31]) this.elements[i31].renderFrame();
            if (this.renderConfig.clearCanvas !== true) this.restore();
        }
    };
    CanvasRendererBase.prototype.buildItem = function(pos11) {
        var elements11 = this.elements;
        if (elements11[pos11] || this.layers[pos11].ty === 99) return;
        var element11 = this.createItem(this.layers[pos11], this, this.globalData);
        elements11[pos11] = element11;
        element11.initExpressions();
    /* if(this.layers[pos].ty === 0){
          element.resize(this.globalData.transformCanvas);
      } */ };
    CanvasRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element11 = this.pendingElements.pop();
            element11.checkParenting();
        }
    };
    CanvasRendererBase.prototype.hide = function() {
        this.animationItem.container.style.display = "none";
    };
    CanvasRendererBase.prototype.show = function() {
        this.animationItem.container.style.display = "block";
    };
    function CanvasContext() {
        this.opacity = -1;
        this.transform = createTypedArray("float32", 16);
        this.fillStyle = "";
        this.strokeStyle = "";
        this.lineWidth = "";
        this.lineCap = "";
        this.lineJoin = "";
        this.miterLimit = "";
        this.id = Math.random();
    }
    function CVContextData() {
        this.stack = [];
        this.cArrPos = 0;
        this.cTr = new Matrix();
        var i31;
        var len11 = 15;
        for(i31 = 0; i31 < len11; i31 += 1){
            var canvasContext11 = new CanvasContext();
            this.stack[i31] = canvasContext11;
        }
        this._length = len11;
        this.nativeContext = null;
        this.transformMat = new Matrix();
        this.currentOpacity = 1; //
        this.currentFillStyle = "";
        this.appliedFillStyle = ""; //
        this.currentStrokeStyle = "";
        this.appliedStrokeStyle = ""; //
        this.currentLineWidth = "";
        this.appliedLineWidth = ""; //
        this.currentLineCap = "";
        this.appliedLineCap = ""; //
        this.currentLineJoin = "";
        this.appliedLineJoin = ""; //
        this.appliedMiterLimit = "";
        this.currentMiterLimit = "";
    }
    CVContextData.prototype.duplicate = function() {
        var newLength11 = this._length * 2;
        var i31 = 0;
        for(i31 = this._length; i31 < newLength11; i31 += 1)this.stack[i31] = new CanvasContext();
        this._length = newLength11;
    };
    CVContextData.prototype.reset = function() {
        this.cArrPos = 0;
        this.cTr.reset();
        this.stack[this.cArrPos].opacity = 1;
    };
    CVContextData.prototype.restore = function(forceRestore11) {
        this.cArrPos -= 1;
        var currentContext11 = this.stack[this.cArrPos];
        var transform11 = currentContext11.transform;
        var i31;
        var arr31 = this.cTr.props;
        for(i31 = 0; i31 < 16; i31 += 1)arr31[i31] = transform11[i31];
        if (forceRestore11) {
            this.nativeContext.restore();
            var prevStack11 = this.stack[this.cArrPos + 1];
            this.appliedFillStyle = prevStack11.fillStyle;
            this.appliedStrokeStyle = prevStack11.strokeStyle;
            this.appliedLineWidth = prevStack11.lineWidth;
            this.appliedLineCap = prevStack11.lineCap;
            this.appliedLineJoin = prevStack11.lineJoin;
            this.appliedMiterLimit = prevStack11.miterLimit;
        }
        this.nativeContext.setTransform(transform11[0], transform11[1], transform11[4], transform11[5], transform11[12], transform11[13]);
        if (forceRestore11 || currentContext11.opacity !== -1 && this.currentOpacity !== currentContext11.opacity) {
            this.nativeContext.globalAlpha = currentContext11.opacity;
            this.currentOpacity = currentContext11.opacity;
        }
        this.currentFillStyle = currentContext11.fillStyle;
        this.currentStrokeStyle = currentContext11.strokeStyle;
        this.currentLineWidth = currentContext11.lineWidth;
        this.currentLineCap = currentContext11.lineCap;
        this.currentLineJoin = currentContext11.lineJoin;
        this.currentMiterLimit = currentContext11.miterLimit;
    };
    CVContextData.prototype.save = function(saveOnNativeFlag11) {
        if (saveOnNativeFlag11) this.nativeContext.save();
        var props11 = this.cTr.props;
        if (this._length <= this.cArrPos) this.duplicate();
        var currentStack11 = this.stack[this.cArrPos];
        var i31;
        for(i31 = 0; i31 < 16; i31 += 1)currentStack11.transform[i31] = props11[i31];
        this.cArrPos += 1;
        var newStack11 = this.stack[this.cArrPos];
        newStack11.opacity = currentStack11.opacity;
        newStack11.fillStyle = currentStack11.fillStyle;
        newStack11.strokeStyle = currentStack11.strokeStyle;
        newStack11.lineWidth = currentStack11.lineWidth;
        newStack11.lineCap = currentStack11.lineCap;
        newStack11.lineJoin = currentStack11.lineJoin;
        newStack11.miterLimit = currentStack11.miterLimit;
    };
    CVContextData.prototype.setOpacity = function(value31) {
        this.stack[this.cArrPos].opacity = value31;
    };
    CVContextData.prototype.setContext = function(value31) {
        this.nativeContext = value31;
    };
    CVContextData.prototype.fillStyle = function(value31) {
        if (this.stack[this.cArrPos].fillStyle !== value31) {
            this.currentFillStyle = value31;
            this.stack[this.cArrPos].fillStyle = value31;
        }
    };
    CVContextData.prototype.strokeStyle = function(value31) {
        if (this.stack[this.cArrPos].strokeStyle !== value31) {
            this.currentStrokeStyle = value31;
            this.stack[this.cArrPos].strokeStyle = value31;
        }
    };
    CVContextData.prototype.lineWidth = function(value31) {
        if (this.stack[this.cArrPos].lineWidth !== value31) {
            this.currentLineWidth = value31;
            this.stack[this.cArrPos].lineWidth = value31;
        }
    };
    CVContextData.prototype.lineCap = function(value31) {
        if (this.stack[this.cArrPos].lineCap !== value31) {
            this.currentLineCap = value31;
            this.stack[this.cArrPos].lineCap = value31;
        }
    };
    CVContextData.prototype.lineJoin = function(value31) {
        if (this.stack[this.cArrPos].lineJoin !== value31) {
            this.currentLineJoin = value31;
            this.stack[this.cArrPos].lineJoin = value31;
        }
    };
    CVContextData.prototype.miterLimit = function(value31) {
        if (this.stack[this.cArrPos].miterLimit !== value31) {
            this.currentMiterLimit = value31;
            this.stack[this.cArrPos].miterLimit = value31;
        }
    };
    CVContextData.prototype.transform = function(props11) {
        this.transformMat.cloneFromProps(props11); // Taking the last transform value from the stored stack of transforms
        var currentTransform11 = this.cTr; // Applying the last transform value after the new transform to respect the order of transformations
        this.transformMat.multiply(currentTransform11); // Storing the new transformed value in the stored transform
        currentTransform11.cloneFromProps(this.transformMat.props);
        var trProps11 = currentTransform11.props; // Applying the new transform to the canvas
        this.nativeContext.setTransform(trProps11[0], trProps11[1], trProps11[4], trProps11[5], trProps11[12], trProps11[13]);
    };
    CVContextData.prototype.opacity = function(op11) {
        var currentOpacity11 = this.stack[this.cArrPos].opacity;
        currentOpacity11 *= op11 < 0 ? 0 : op11;
        if (this.stack[this.cArrPos].opacity !== currentOpacity11) {
            if (this.currentOpacity !== op11) {
                this.nativeContext.globalAlpha = op11;
                this.currentOpacity = op11;
            }
            this.stack[this.cArrPos].opacity = currentOpacity11;
        }
    };
    CVContextData.prototype.fill = function(rule11) {
        if (this.appliedFillStyle !== this.currentFillStyle) {
            this.appliedFillStyle = this.currentFillStyle;
            this.nativeContext.fillStyle = this.appliedFillStyle;
        }
        this.nativeContext.fill(rule11);
    };
    CVContextData.prototype.fillRect = function(x41, y41, w11, h31) {
        if (this.appliedFillStyle !== this.currentFillStyle) {
            this.appliedFillStyle = this.currentFillStyle;
            this.nativeContext.fillStyle = this.appliedFillStyle;
        }
        this.nativeContext.fillRect(x41, y41, w11, h31);
    };
    CVContextData.prototype.stroke = function() {
        if (this.appliedStrokeStyle !== this.currentStrokeStyle) {
            this.appliedStrokeStyle = this.currentStrokeStyle;
            this.nativeContext.strokeStyle = this.appliedStrokeStyle;
        }
        if (this.appliedLineWidth !== this.currentLineWidth) {
            this.appliedLineWidth = this.currentLineWidth;
            this.nativeContext.lineWidth = this.appliedLineWidth;
        }
        if (this.appliedLineCap !== this.currentLineCap) {
            this.appliedLineCap = this.currentLineCap;
            this.nativeContext.lineCap = this.appliedLineCap;
        }
        if (this.appliedLineJoin !== this.currentLineJoin) {
            this.appliedLineJoin = this.currentLineJoin;
            this.nativeContext.lineJoin = this.appliedLineJoin;
        }
        if (this.appliedMiterLimit !== this.currentMiterLimit) {
            this.appliedMiterLimit = this.currentMiterLimit;
            this.nativeContext.miterLimit = this.appliedMiterLimit;
        }
        this.nativeContext.stroke();
    };
    function CVCompElement(data11, globalData11, comp11) {
        this.completeLayers = false;
        this.layers = data11.layers;
        this.pendingElements = [];
        this.elements = createSizedArray(this.layers.length);
        this.initElement(data11, globalData11, comp11);
        this.tm = data11.tm ? PropertyFactory.getProp(this, data11.tm, 0, globalData11.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        CanvasRendererBase,
        ICompElement,
        CVBaseElement
    ], CVCompElement);
    CVCompElement.prototype.renderInnerContent = function() {
        var ctx11 = this.canvasContext;
        ctx11.beginPath();
        ctx11.moveTo(0, 0);
        ctx11.lineTo(this.data.w, 0);
        ctx11.lineTo(this.data.w, this.data.h);
        ctx11.lineTo(0, this.data.h);
        ctx11.lineTo(0, 0);
        ctx11.clip();
        var i31;
        var len11 = this.layers.length;
        for(i31 = len11 - 1; i31 >= 0; i31 -= 1)if (this.completeLayers || this.elements[i31]) this.elements[i31].renderFrame();
    };
    CVCompElement.prototype.destroy = function() {
        var i31;
        var len11 = this.layers.length;
        for(i31 = len11 - 1; i31 >= 0; i31 -= 1)if (this.elements[i31]) this.elements[i31].destroy();
        this.layers = null;
        this.elements = null;
    };
    CVCompElement.prototype.createComp = function(data11) {
        return new CVCompElement(data11, this.globalData, this);
    };
    function CanvasRenderer(animationItem11, config11) {
        this.animationItem = animationItem11;
        this.renderConfig = {
            clearCanvas: config11 && config11.clearCanvas !== undefined ? config11.clearCanvas : true,
            context: config11 && config11.context || null,
            progressiveLoad: config11 && config11.progressiveLoad || false,
            preserveAspectRatio: config11 && config11.preserveAspectRatio || "xMidYMid meet",
            imagePreserveAspectRatio: config11 && config11.imagePreserveAspectRatio || "xMidYMid slice",
            contentVisibility: config11 && config11.contentVisibility || "visible",
            className: config11 && config11.className || "",
            id: config11 && config11.id || "",
            runExpressions: !config11 || config11.runExpressions === undefined || config11.runExpressions
        };
        this.renderConfig.dpr = config11 && config11.dpr || 1;
        if (this.animationItem.wrapper) this.renderConfig.dpr = config11 && config11.dpr || window.devicePixelRatio || 1;
        this.renderedFrame = -1;
        this.globalData = {
            frameNum: -1,
            _mdf: false,
            renderConfig: this.renderConfig,
            currentGlobalAlpha: -1
        };
        this.contextData = new CVContextData();
        this.elements = [];
        this.pendingElements = [];
        this.transformMat = new Matrix();
        this.completeLayers = false;
        this.rendererType = "canvas";
        if (this.renderConfig.clearCanvas) {
            this.ctxTransform = this.contextData.transform.bind(this.contextData);
            this.ctxOpacity = this.contextData.opacity.bind(this.contextData);
            this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData);
            this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData);
            this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData);
            this.ctxLineCap = this.contextData.lineCap.bind(this.contextData);
            this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData);
            this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData);
            this.ctxFill = this.contextData.fill.bind(this.contextData);
            this.ctxFillRect = this.contextData.fillRect.bind(this.contextData);
            this.ctxStroke = this.contextData.stroke.bind(this.contextData);
            this.save = this.contextData.save.bind(this.contextData);
        }
    }
    extendPrototype([
        CanvasRendererBase
    ], CanvasRenderer);
    CanvasRenderer.prototype.createComp = function(data11) {
        return new CVCompElement(data11, this.globalData, this);
    };
    function HBaseElement() {}
    HBaseElement.prototype = {
        checkBlendMode: function checkBlendMode11() {},
        initRendererElement: function initRendererElement11() {
            this.baseElement = createTag(this.data.tg || "div");
            if (this.data.hasMask) {
                this.svgElement = createNS("svg");
                this.layerElement = createNS("g");
                this.maskedElement = this.layerElement;
                this.svgElement.appendChild(this.layerElement);
                this.baseElement.appendChild(this.svgElement);
            } else this.layerElement = this.baseElement;
            styleDiv(this.baseElement);
        },
        createContainerElements: function createContainerElements11() {
            this.renderableEffectsManager = new CVEffects(this);
            this.transformedElement = this.baseElement;
            this.maskedElement = this.layerElement;
            if (this.data.ln) this.layerElement.setAttribute("id", this.data.ln);
            if (this.data.cl) this.layerElement.setAttribute("class", this.data.cl);
            if (this.data.bm !== 0) this.setBlendMode();
        },
        renderElement: function renderElement11() {
            var transformedElementStyle11 = this.transformedElement ? this.transformedElement.style : {};
            if (this.finalTransform._matMdf) {
                var matrixValue11 = this.finalTransform.mat.toCSS();
                transformedElementStyle11.transform = matrixValue11;
                transformedElementStyle11.webkitTransform = matrixValue11;
            }
            if (this.finalTransform._opMdf) transformedElementStyle11.opacity = this.finalTransform.mProp.o.v;
        },
        renderFrame: function renderFrame11() {
            // If it is exported as hidden (data.hd === true) no need to render
            // If it is not visible no need to render
            if (this.data.hd || this.hidden) return;
            this.renderTransform();
            this.renderRenderable();
            this.renderElement();
            this.renderInnerContent();
            if (this._isFirstFrame) this._isFirstFrame = false;
        },
        destroy: function destroy11() {
            this.layerElement = null;
            this.transformedElement = null;
            if (this.matteElement) this.matteElement = null;
            if (this.maskManager) {
                this.maskManager.destroy();
                this.maskManager = null;
            }
        },
        createRenderableComponents: function createRenderableComponents11() {
            this.maskManager = new MaskElement(this.data, this, this.globalData);
        },
        addEffects: function addEffects11() {},
        setMatte: function setMatte11() {}
    };
    HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement;
    HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy;
    HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting;
    function HSolidElement(data11, globalData11, comp11) {
        this.initElement(data11, globalData11, comp11);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], HSolidElement);
    HSolidElement.prototype.createContent = function() {
        var rect11;
        if (this.data.hasMask) {
            rect11 = createNS("rect");
            rect11.setAttribute("width", this.data.sw);
            rect11.setAttribute("height", this.data.sh);
            rect11.setAttribute("fill", this.data.sc);
            this.svgElement.setAttribute("width", this.data.sw);
            this.svgElement.setAttribute("height", this.data.sh);
        } else {
            rect11 = createTag("div");
            rect11.style.width = this.data.sw + "px";
            rect11.style.height = this.data.sh + "px";
            rect11.style.backgroundColor = this.data.sc;
        }
        this.layerElement.appendChild(rect11);
    };
    function HShapeElement(data11, globalData11, comp11) {
        // List of drawable elements
        this.shapes = []; // Full shape data
        this.shapesData = data11.shapes; // List of styles that will be applied to shapes
        this.stylesList = []; // List of modifiers that will be applied to shapes
        this.shapeModifiers = []; // List of items in shape tree
        this.itemsData = []; // List of items in previous shape tree
        this.processedElements = []; // List of animated components
        this.animatedContents = [];
        this.shapesContainer = createNS("g");
        this.initElement(data11, globalData11, comp11); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
        // List of elements that have been created
        this.prevViewData = [];
        this.currentBBox = {
            x: 999999,
            y: -999999,
            h: 0,
            w: 0
        };
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HSolidElement,
        SVGShapeElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], HShapeElement);
    HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent;
    HShapeElement.prototype.createContent = function() {
        var cont11;
        this.baseElement.style.fontSize = 0;
        if (this.data.hasMask) {
            this.layerElement.appendChild(this.shapesContainer);
            cont11 = this.svgElement;
        } else {
            cont11 = createNS("svg");
            var size11 = this.comp.data ? this.comp.data : this.globalData.compSize;
            cont11.setAttribute("width", size11.w);
            cont11.setAttribute("height", size11.h);
            cont11.appendChild(this.shapesContainer);
            this.layerElement.appendChild(cont11);
        }
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], true);
        this.filterUniqueShapes();
        this.shapeCont = cont11;
    };
    HShapeElement.prototype.getTransformedPoint = function(transformers11, point11) {
        var i31;
        var len11 = transformers11.length;
        for(i31 = 0; i31 < len11; i31 += 1)point11 = transformers11[i31].mProps.v.applyToPointArray(point11[0], point11[1], 0);
        return point11;
    };
    HShapeElement.prototype.calculateShapeBoundingBox = function(item11, boundingBox11) {
        var shape31 = item11.sh.v;
        var transformers11 = item11.transformers;
        var i31;
        var len11 = shape31._length;
        var vPoint11;
        var oPoint11;
        var nextIPoint11;
        var nextVPoint11;
        if (len11 <= 1) return;
        for(i31 = 0; i31 < len11 - 1; i31 += 1){
            vPoint11 = this.getTransformedPoint(transformers11, shape31.v[i31]);
            oPoint11 = this.getTransformedPoint(transformers11, shape31.o[i31]);
            nextIPoint11 = this.getTransformedPoint(transformers11, shape31.i[i31 + 1]);
            nextVPoint11 = this.getTransformedPoint(transformers11, shape31.v[i31 + 1]);
            this.checkBounds(vPoint11, oPoint11, nextIPoint11, nextVPoint11, boundingBox11);
        }
        if (shape31.c) {
            vPoint11 = this.getTransformedPoint(transformers11, shape31.v[i31]);
            oPoint11 = this.getTransformedPoint(transformers11, shape31.o[i31]);
            nextIPoint11 = this.getTransformedPoint(transformers11, shape31.i[0]);
            nextVPoint11 = this.getTransformedPoint(transformers11, shape31.v[0]);
            this.checkBounds(vPoint11, oPoint11, nextIPoint11, nextVPoint11, boundingBox11);
        }
    };
    HShapeElement.prototype.checkBounds = function(vPoint11, oPoint11, nextIPoint11, nextVPoint11, boundingBox11) {
        this.getBoundsOfCurve(vPoint11, oPoint11, nextIPoint11, nextVPoint11);
        var bounds11 = this.shapeBoundingBox;
        boundingBox11.x = bmMin(bounds11.left, boundingBox11.x);
        boundingBox11.xMax = bmMax(bounds11.right, boundingBox11.xMax);
        boundingBox11.y = bmMin(bounds11.top, boundingBox11.y);
        boundingBox11.yMax = bmMax(bounds11.bottom, boundingBox11.yMax);
    };
    HShapeElement.prototype.shapeBoundingBox = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    };
    HShapeElement.prototype.tempBoundingBox = {
        x: 0,
        xMax: 0,
        y: 0,
        yMax: 0,
        width: 0,
        height: 0
    };
    HShapeElement.prototype.getBoundsOfCurve = function(p011, p141, p221, p311) {
        var bounds11 = [
            [
                p011[0],
                p311[0]
            ],
            [
                p011[1],
                p311[1]
            ]
        ];
        for(var a31, b31, c41, t31, b2ac11, t111, t211, i31 = 0; i31 < 2; ++i31){
            // eslint-disable-line no-plusplus
            b31 = 6 * p011[i31] - 12 * p141[i31] + 6 * p221[i31];
            a31 = -3 * p011[i31] + 9 * p141[i31] - 9 * p221[i31] + 3 * p311[i31];
            c41 = 3 * p141[i31] - 3 * p011[i31];
            b31 |= 0; // eslint-disable-line no-bitwise
            a31 |= 0; // eslint-disable-line no-bitwise
            c41 |= 0; // eslint-disable-line no-bitwise
            if (a31 === 0 && b31 === 0) ;
            else if (a31 === 0) {
                t31 = -c41 / b31;
                if (t31 > 0 && t31 < 1) bounds11[i31].push(this.calculateF(t31, p011, p141, p221, p311, i31));
            } else {
                b2ac11 = b31 * b31 - 4 * c41 * a31;
                if (b2ac11 >= 0) {
                    t111 = (-b31 + bmSqrt(b2ac11)) / (2 * a31);
                    if (t111 > 0 && t111 < 1) bounds11[i31].push(this.calculateF(t111, p011, p141, p221, p311, i31));
                    t211 = (-b31 - bmSqrt(b2ac11)) / (2 * a31);
                    if (t211 > 0 && t211 < 1) bounds11[i31].push(this.calculateF(t211, p011, p141, p221, p311, i31));
                }
            }
        }
        this.shapeBoundingBox.left = bmMin.apply(null, bounds11[0]);
        this.shapeBoundingBox.top = bmMin.apply(null, bounds11[1]);
        this.shapeBoundingBox.right = bmMax.apply(null, bounds11[0]);
        this.shapeBoundingBox.bottom = bmMax.apply(null, bounds11[1]);
    };
    HShapeElement.prototype.calculateF = function(t31, p011, p141, p221, p311, i31) {
        return bmPow(1 - t31, 3) * p011[i31] + 3 * bmPow(1 - t31, 2) * t31 * p141[i31] + 3 * (1 - t31) * bmPow(t31, 2) * p221[i31] + bmPow(t31, 3) * p311[i31];
    };
    HShapeElement.prototype.calculateBoundingBox = function(itemsData11, boundingBox11) {
        var i31;
        var len11 = itemsData11.length;
        for(i31 = 0; i31 < len11; i31 += 1){
            if (itemsData11[i31] && itemsData11[i31].sh) this.calculateShapeBoundingBox(itemsData11[i31], boundingBox11);
            else if (itemsData11[i31] && itemsData11[i31].it) this.calculateBoundingBox(itemsData11[i31].it, boundingBox11);
            else if (itemsData11[i31] && itemsData11[i31].style && itemsData11[i31].w) this.expandStrokeBoundingBox(itemsData11[i31].w, boundingBox11);
        }
    };
    HShapeElement.prototype.expandStrokeBoundingBox = function(widthProperty11, boundingBox11) {
        var width11 = 0;
        if (widthProperty11.keyframes) {
            for(var i31 = 0; i31 < widthProperty11.keyframes.length; i31 += 1){
                var kfw11 = widthProperty11.keyframes[i31].s;
                if (kfw11 > width11) width11 = kfw11;
            }
            width11 *= widthProperty11.mult;
        } else width11 = widthProperty11.v * widthProperty11.mult;
        boundingBox11.x -= width11;
        boundingBox11.xMax += width11;
        boundingBox11.y -= width11;
        boundingBox11.yMax += width11;
    };
    HShapeElement.prototype.currentBoxContains = function(box11) {
        return this.currentBBox.x <= box11.x && this.currentBBox.y <= box11.y && this.currentBBox.width + this.currentBBox.x >= box11.x + box11.width && this.currentBBox.height + this.currentBBox.y >= box11.y + box11.height;
    };
    HShapeElement.prototype.renderInnerContent = function() {
        this._renderShapeFrame();
        if (!this.hidden && (this._isFirstFrame || this._mdf)) {
            var tempBoundingBox11 = this.tempBoundingBox;
            var max11 = 999999;
            tempBoundingBox11.x = max11;
            tempBoundingBox11.xMax = -max11;
            tempBoundingBox11.y = max11;
            tempBoundingBox11.yMax = -max11;
            this.calculateBoundingBox(this.itemsData, tempBoundingBox11);
            tempBoundingBox11.width = tempBoundingBox11.xMax < tempBoundingBox11.x ? 0 : tempBoundingBox11.xMax - tempBoundingBox11.x;
            tempBoundingBox11.height = tempBoundingBox11.yMax < tempBoundingBox11.y ? 0 : tempBoundingBox11.yMax - tempBoundingBox11.y; // var tempBoundingBox = this.shapeCont.getBBox();
            if (this.currentBoxContains(tempBoundingBox11)) return;
            var changed11 = false;
            if (this.currentBBox.w !== tempBoundingBox11.width) {
                this.currentBBox.w = tempBoundingBox11.width;
                this.shapeCont.setAttribute("width", tempBoundingBox11.width);
                changed11 = true;
            }
            if (this.currentBBox.h !== tempBoundingBox11.height) {
                this.currentBBox.h = tempBoundingBox11.height;
                this.shapeCont.setAttribute("height", tempBoundingBox11.height);
                changed11 = true;
            }
            if (changed11 || this.currentBBox.x !== tempBoundingBox11.x || this.currentBBox.y !== tempBoundingBox11.y) {
                this.currentBBox.w = tempBoundingBox11.width;
                this.currentBBox.h = tempBoundingBox11.height;
                this.currentBBox.x = tempBoundingBox11.x;
                this.currentBBox.y = tempBoundingBox11.y;
                this.shapeCont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
                var shapeStyle11 = this.shapeCont.style;
                var shapeTransform11 = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
                shapeStyle11.transform = shapeTransform11;
                shapeStyle11.webkitTransform = shapeTransform11;
            }
        }
    };
    function HTextElement(data11, globalData11, comp11) {
        this.textSpans = [];
        this.textPaths = [];
        this.currentBBox = {
            x: 999999,
            y: -999999,
            h: 0,
            w: 0
        };
        this.renderType = "svg";
        this.isMasked = false;
        this.initElement(data11, globalData11, comp11);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement,
        ITextElement
    ], HTextElement);
    HTextElement.prototype.createContent = function() {
        this.isMasked = this.checkMasks();
        if (this.isMasked) {
            this.renderType = "svg";
            this.compW = this.comp.data.w;
            this.compH = this.comp.data.h;
            this.svgElement.setAttribute("width", this.compW);
            this.svgElement.setAttribute("height", this.compH);
            var g31 = createNS("g");
            this.maskedElement.appendChild(g31);
            this.innerElem = g31;
        } else {
            this.renderType = "html";
            this.innerElem = this.layerElement;
        }
        this.checkParenting();
    };
    HTextElement.prototype.buildNewText = function() {
        var documentData11 = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData11.l ? documentData11.l.length : 0);
        var innerElemStyle11 = this.innerElem.style;
        var textColor11 = documentData11.fc ? this.buildColor(documentData11.fc) : "rgba(0,0,0,0)";
        innerElemStyle11.fill = textColor11;
        innerElemStyle11.color = textColor11;
        if (documentData11.sc) {
            innerElemStyle11.stroke = this.buildColor(documentData11.sc);
            innerElemStyle11.strokeWidth = documentData11.sw + "px";
        }
        var fontData11 = this.globalData.fontManager.getFontByName(documentData11.f);
        if (!this.globalData.fontManager.chars) {
            innerElemStyle11.fontSize = documentData11.finalSize + "px";
            innerElemStyle11.lineHeight = documentData11.finalSize + "px";
            if (fontData11.fClass) this.innerElem.className = fontData11.fClass;
            else {
                innerElemStyle11.fontFamily = fontData11.fFamily;
                var fWeight11 = documentData11.fWeight;
                var fStyle11 = documentData11.fStyle;
                innerElemStyle11.fontStyle = fStyle11;
                innerElemStyle11.fontWeight = fWeight11;
            }
        }
        var i31;
        var len11;
        var letters11 = documentData11.l;
        len11 = letters11.length;
        var tSpan11;
        var tParent11;
        var tCont11;
        var matrixHelper11 = this.mHelper;
        var shapes11;
        var shapeStr11 = "";
        var cnt11 = 0;
        for(i31 = 0; i31 < len11; i31 += 1){
            if (this.globalData.fontManager.chars) {
                if (!this.textPaths[cnt11]) {
                    tSpan11 = createNS("path");
                    tSpan11.setAttribute("stroke-linecap", lineCapEnum[1]);
                    tSpan11.setAttribute("stroke-linejoin", lineJoinEnum[2]);
                    tSpan11.setAttribute("stroke-miterlimit", "4");
                } else tSpan11 = this.textPaths[cnt11];
                if (!this.isMasked) {
                    if (this.textSpans[cnt11]) {
                        tParent11 = this.textSpans[cnt11];
                        tCont11 = tParent11.children[0];
                    } else {
                        tParent11 = createTag("div");
                        tParent11.style.lineHeight = 0;
                        tCont11 = createNS("svg");
                        tCont11.appendChild(tSpan11);
                        styleDiv(tParent11);
                    }
                }
            } else if (!this.isMasked) {
                if (this.textSpans[cnt11]) {
                    tParent11 = this.textSpans[cnt11];
                    tSpan11 = this.textPaths[cnt11];
                } else {
                    tParent11 = createTag("span");
                    styleDiv(tParent11);
                    tSpan11 = createTag("span");
                    styleDiv(tSpan11);
                    tParent11.appendChild(tSpan11);
                }
            } else tSpan11 = this.textPaths[cnt11] ? this.textPaths[cnt11] : createNS("text");
             // tSpan.setAttribute('visibility', 'hidden');
            if (this.globalData.fontManager.chars) {
                var charData11 = this.globalData.fontManager.getCharData(documentData11.finalText[i31], fontData11.fStyle, this.globalData.fontManager.getFontByName(documentData11.f).fFamily);
                var shapeData11;
                if (charData11) shapeData11 = charData11.data;
                else shapeData11 = null;
                matrixHelper11.reset();
                if (shapeData11 && shapeData11.shapes && shapeData11.shapes.length) {
                    shapes11 = shapeData11.shapes[0].it;
                    matrixHelper11.scale(documentData11.finalSize / 100, documentData11.finalSize / 100);
                    shapeStr11 = this.createPathShape(matrixHelper11, shapes11);
                    tSpan11.setAttribute("d", shapeStr11);
                }
                if (!this.isMasked) {
                    this.innerElem.appendChild(tParent11);
                    if (shapeData11 && shapeData11.shapes) {
                        // document.body.appendChild is needed to get exact measure of shape
                        document.body.appendChild(tCont11);
                        var boundingBox11 = tCont11.getBBox();
                        tCont11.setAttribute("width", boundingBox11.width + 2);
                        tCont11.setAttribute("height", boundingBox11.height + 2);
                        tCont11.setAttribute("viewBox", boundingBox11.x - 1 + " " + (boundingBox11.y - 1) + " " + (boundingBox11.width + 2) + " " + (boundingBox11.height + 2));
                        var tContStyle11 = tCont11.style;
                        var tContTranslation11 = "translate(" + (boundingBox11.x - 1) + "px," + (boundingBox11.y - 1) + "px)";
                        tContStyle11.transform = tContTranslation11;
                        tContStyle11.webkitTransform = tContTranslation11;
                        letters11[i31].yOffset = boundingBox11.y - 1;
                    } else {
                        tCont11.setAttribute("width", 1);
                        tCont11.setAttribute("height", 1);
                    }
                    tParent11.appendChild(tCont11);
                } else this.innerElem.appendChild(tSpan11);
            } else {
                tSpan11.textContent = letters11[i31].val;
                tSpan11.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
                if (!this.isMasked) {
                    this.innerElem.appendChild(tParent11); //
                    var tStyle11 = tSpan11.style;
                    var tSpanTranslation11 = "translate3d(0," + -documentData11.finalSize / 1.2 + "px,0)";
                    tStyle11.transform = tSpanTranslation11;
                    tStyle11.webkitTransform = tSpanTranslation11;
                } else this.innerElem.appendChild(tSpan11);
            } //
            if (!this.isMasked) this.textSpans[cnt11] = tParent11;
            else this.textSpans[cnt11] = tSpan11;
            this.textSpans[cnt11].style.display = "block";
            this.textPaths[cnt11] = tSpan11;
            cnt11 += 1;
        }
        while(cnt11 < this.textSpans.length){
            this.textSpans[cnt11].style.display = "none";
            cnt11 += 1;
        }
    };
    HTextElement.prototype.renderInnerContent = function() {
        this.validateText();
        var svgStyle11;
        if (this.data.singleShape) {
            if (!this._isFirstFrame && !this.lettersChangedFlag) return;
            if (this.isMasked && this.finalTransform._matMdf) {
                // Todo Benchmark if using this is better than getBBox
                this.svgElement.setAttribute("viewBox", -this.finalTransform.mProp.p.v[0] + " " + -this.finalTransform.mProp.p.v[1] + " " + this.compW + " " + this.compH);
                svgStyle11 = this.svgElement.style;
                var translation11 = "translate(" + -this.finalTransform.mProp.p.v[0] + "px," + -this.finalTransform.mProp.p.v[1] + "px)";
                svgStyle11.transform = translation11;
                svgStyle11.webkitTransform = translation11;
            }
        }
        this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
        if (!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag) return;
        var i31;
        var len11;
        var count11 = 0;
        var renderedLetters11 = this.textAnimator.renderedLetters;
        var letters11 = this.textProperty.currentData.l;
        len11 = letters11.length;
        var renderedLetter11;
        var textSpan11;
        var textPath11;
        for(i31 = 0; i31 < len11; i31 += 1)if (letters11[i31].n) count11 += 1;
        else {
            textSpan11 = this.textSpans[i31];
            textPath11 = this.textPaths[i31];
            renderedLetter11 = renderedLetters11[count11];
            count11 += 1;
            if (renderedLetter11._mdf.m) {
                if (!this.isMasked) {
                    textSpan11.style.webkitTransform = renderedLetter11.m;
                    textSpan11.style.transform = renderedLetter11.m;
                } else textSpan11.setAttribute("transform", renderedLetter11.m);
            } /// /textSpan.setAttribute('opacity',renderedLetter.o);
            textSpan11.style.opacity = renderedLetter11.o;
            if (renderedLetter11.sw && renderedLetter11._mdf.sw) textPath11.setAttribute("stroke-width", renderedLetter11.sw);
            if (renderedLetter11.sc && renderedLetter11._mdf.sc) textPath11.setAttribute("stroke", renderedLetter11.sc);
            if (renderedLetter11.fc && renderedLetter11._mdf.fc) {
                textPath11.setAttribute("fill", renderedLetter11.fc);
                textPath11.style.color = renderedLetter11.fc;
            }
        }
        if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
            var boundingBox11 = this.innerElem.getBBox();
            if (this.currentBBox.w !== boundingBox11.width) {
                this.currentBBox.w = boundingBox11.width;
                this.svgElement.setAttribute("width", boundingBox11.width);
            }
            if (this.currentBBox.h !== boundingBox11.height) {
                this.currentBBox.h = boundingBox11.height;
                this.svgElement.setAttribute("height", boundingBox11.height);
            }
            var margin11 = 1;
            if (this.currentBBox.w !== boundingBox11.width + margin11 * 2 || this.currentBBox.h !== boundingBox11.height + margin11 * 2 || this.currentBBox.x !== boundingBox11.x - margin11 || this.currentBBox.y !== boundingBox11.y - margin11) {
                this.currentBBox.w = boundingBox11.width + margin11 * 2;
                this.currentBBox.h = boundingBox11.height + margin11 * 2;
                this.currentBBox.x = boundingBox11.x - margin11;
                this.currentBBox.y = boundingBox11.y - margin11;
                this.svgElement.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
                svgStyle11 = this.svgElement.style;
                var svgTransform11 = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
                svgStyle11.transform = svgTransform11;
                svgStyle11.webkitTransform = svgTransform11;
            }
        }
    };
    function HCameraElement(data11, globalData11, comp11) {
        this.initFrame();
        this.initBaseData(data11, globalData11, comp11);
        this.initHierarchy();
        var getProp11 = PropertyFactory.getProp;
        this.pe = getProp11(this, data11.pe, 0, 0, this);
        if (data11.ks.p.s) {
            this.px = getProp11(this, data11.ks.p.x, 1, 0, this);
            this.py = getProp11(this, data11.ks.p.y, 1, 0, this);
            this.pz = getProp11(this, data11.ks.p.z, 1, 0, this);
        } else this.p = getProp11(this, data11.ks.p, 1, 0, this);
        if (data11.ks.a) this.a = getProp11(this, data11.ks.a, 1, 0, this);
        if (data11.ks.or.k.length && data11.ks.or.k[0].to) {
            var i31;
            var len11 = data11.ks.or.k.length;
            for(i31 = 0; i31 < len11; i31 += 1){
                data11.ks.or.k[i31].to = null;
                data11.ks.or.k[i31].ti = null;
            }
        }
        this.or = getProp11(this, data11.ks.or, 1, degToRads, this);
        this.or.sh = true;
        this.rx = getProp11(this, data11.ks.rx, 0, degToRads, this);
        this.ry = getProp11(this, data11.ks.ry, 0, degToRads, this);
        this.rz = getProp11(this, data11.ks.rz, 0, degToRads, this);
        this.mat = new Matrix();
        this._prevMat = new Matrix();
        this._isFirstFrame = true; // TODO: find a better way to make the HCamera element to be compatible with the LayerInterface and TransformInterface.
        this.finalTransform = {
            mProp: this
        };
    }
    extendPrototype([
        BaseElement,
        FrameElement,
        HierarchyElement
    ], HCameraElement);
    HCameraElement.prototype.setup = function() {
        var i31;
        var len11 = this.comp.threeDElements.length;
        var comp11;
        var perspectiveStyle11;
        var containerStyle11;
        for(i31 = 0; i31 < len11; i31 += 1){
            // [perspectiveElem,container]
            comp11 = this.comp.threeDElements[i31];
            if (comp11.type === "3d") {
                perspectiveStyle11 = comp11.perspectiveElem.style;
                containerStyle11 = comp11.container.style;
                var perspective11 = this.pe.v + "px";
                var origin11 = "0px 0px 0px";
                var matrix11 = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
                perspectiveStyle11.perspective = perspective11;
                perspectiveStyle11.webkitPerspective = perspective11;
                containerStyle11.transformOrigin = origin11;
                containerStyle11.mozTransformOrigin = origin11;
                containerStyle11.webkitTransformOrigin = origin11;
                perspectiveStyle11.transform = matrix11;
                perspectiveStyle11.webkitTransform = matrix11;
            }
        }
    };
    HCameraElement.prototype.createElements = function() {};
    HCameraElement.prototype.hide = function() {};
    HCameraElement.prototype.renderFrame = function() {
        var _mdf11 = this._isFirstFrame;
        var i31;
        var len11;
        if (this.hierarchy) {
            len11 = this.hierarchy.length;
            for(i31 = 0; i31 < len11; i31 += 1)_mdf11 = this.hierarchy[i31].finalTransform.mProp._mdf || _mdf11;
        }
        if (_mdf11 || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
            this.mat.reset();
            if (this.hierarchy) {
                len11 = this.hierarchy.length - 1;
                for(i31 = len11; i31 >= 0; i31 -= 1){
                    var mTransf11 = this.hierarchy[i31].finalTransform.mProp;
                    this.mat.translate(-mTransf11.p.v[0], -mTransf11.p.v[1], mTransf11.p.v[2]);
                    this.mat.rotateX(-mTransf11.or.v[0]).rotateY(-mTransf11.or.v[1]).rotateZ(mTransf11.or.v[2]);
                    this.mat.rotateX(-mTransf11.rx.v).rotateY(-mTransf11.ry.v).rotateZ(mTransf11.rz.v);
                    this.mat.scale(1 / mTransf11.s.v[0], 1 / mTransf11.s.v[1], 1 / mTransf11.s.v[2]);
                    this.mat.translate(mTransf11.a.v[0], mTransf11.a.v[1], mTransf11.a.v[2]);
                }
            }
            if (this.p) this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]);
            else this.mat.translate(-this.px.v, -this.py.v, this.pz.v);
            if (this.a) {
                var diffVector11;
                if (this.p) diffVector11 = [
                    this.p.v[0] - this.a.v[0],
                    this.p.v[1] - this.a.v[1],
                    this.p.v[2] - this.a.v[2]
                ];
                else diffVector11 = [
                    this.px.v - this.a.v[0],
                    this.py.v - this.a.v[1],
                    this.pz.v - this.a.v[2]
                ];
                var mag11 = Math.sqrt(Math.pow(diffVector11[0], 2) + Math.pow(diffVector11[1], 2) + Math.pow(diffVector11[2], 2)); // var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));
                var lookDir11 = [
                    diffVector11[0] / mag11,
                    diffVector11[1] / mag11,
                    diffVector11[2] / mag11
                ];
                var lookLengthOnXZ11 = Math.sqrt(lookDir11[2] * lookDir11[2] + lookDir11[0] * lookDir11[0]);
                var mRotationX11 = Math.atan2(lookDir11[1], lookLengthOnXZ11);
                var mRotationY11 = Math.atan2(lookDir11[0], -lookDir11[2]);
                this.mat.rotateY(mRotationY11).rotateX(-mRotationX11);
            }
            this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
            this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
            this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0);
            this.mat.translate(0, 0, this.pe.v);
            var hasMatrixChanged11 = !this._prevMat.equals(this.mat);
            if ((hasMatrixChanged11 || this.pe._mdf) && this.comp.threeDElements) {
                len11 = this.comp.threeDElements.length;
                var comp11;
                var perspectiveStyle11;
                var containerStyle11;
                for(i31 = 0; i31 < len11; i31 += 1){
                    comp11 = this.comp.threeDElements[i31];
                    if (comp11.type === "3d") {
                        if (hasMatrixChanged11) {
                            var matValue11 = this.mat.toCSS();
                            containerStyle11 = comp11.container.style;
                            containerStyle11.transform = matValue11;
                            containerStyle11.webkitTransform = matValue11;
                        }
                        if (this.pe._mdf) {
                            perspectiveStyle11 = comp11.perspectiveElem.style;
                            perspectiveStyle11.perspective = this.pe.v + "px";
                            perspectiveStyle11.webkitPerspective = this.pe.v + "px";
                        }
                    }
                }
                this.mat.clone(this._prevMat);
            }
        }
        this._isFirstFrame = false;
    };
    HCameraElement.prototype.prepareFrame = function(num11) {
        this.prepareProperties(num11, true);
    };
    HCameraElement.prototype.destroy = function() {};
    HCameraElement.prototype.getBaseElement = function() {
        return null;
    };
    function HImageElement(data11, globalData11, comp11) {
        this.assetData = globalData11.getAssetData(data11.refId);
        this.initElement(data11, globalData11, comp11);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HSolidElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], HImageElement);
    HImageElement.prototype.createContent = function() {
        var assetPath11 = this.globalData.getAssetsPath(this.assetData);
        var img11 = new Image();
        if (this.data.hasMask) {
            this.imageElem = createNS("image");
            this.imageElem.setAttribute("width", this.assetData.w + "px");
            this.imageElem.setAttribute("height", this.assetData.h + "px");
            this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", assetPath11);
            this.layerElement.appendChild(this.imageElem);
            this.baseElement.setAttribute("width", this.assetData.w);
            this.baseElement.setAttribute("height", this.assetData.h);
        } else this.layerElement.appendChild(img11);
        img11.crossOrigin = "anonymous";
        img11.src = assetPath11;
        if (this.data.ln) this.baseElement.setAttribute("id", this.data.ln);
    };
    function HybridRendererBase(animationItem11, config11) {
        this.animationItem = animationItem11;
        this.layers = null;
        this.renderedFrame = -1;
        this.renderConfig = {
            className: config11 && config11.className || "",
            imagePreserveAspectRatio: config11 && config11.imagePreserveAspectRatio || "xMidYMid slice",
            hideOnTransparent: !(config11 && config11.hideOnTransparent === false),
            filterSize: {
                width: config11 && config11.filterSize && config11.filterSize.width || "400%",
                height: config11 && config11.filterSize && config11.filterSize.height || "400%",
                x: config11 && config11.filterSize && config11.filterSize.x || "-100%",
                y: config11 && config11.filterSize && config11.filterSize.y || "-100%"
            }
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            renderConfig: this.renderConfig
        };
        this.pendingElements = [];
        this.elements = [];
        this.threeDElements = [];
        this.destroyed = false;
        this.camera = null;
        this.supports3d = true;
        this.rendererType = "html";
    }
    extendPrototype([
        BaseRenderer
    ], HybridRendererBase);
    HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem;
    HybridRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element11 = this.pendingElements.pop();
            element11.checkParenting();
        }
    };
    HybridRendererBase.prototype.appendElementInPos = function(element11, pos11) {
        var newDOMElement11 = element11.getBaseElement();
        if (!newDOMElement11) return;
        var layer11 = this.layers[pos11];
        if (!layer11.ddd || !this.supports3d) {
            if (this.threeDElements) this.addTo3dContainer(newDOMElement11, pos11);
            else {
                var i31 = 0;
                var nextDOMElement11;
                var nextLayer11;
                var tmpDOMElement11;
                while(i31 < pos11){
                    if (this.elements[i31] && this.elements[i31] !== true && this.elements[i31].getBaseElement) {
                        nextLayer11 = this.elements[i31];
                        tmpDOMElement11 = this.layers[i31].ddd ? this.getThreeDContainerByPos(i31) : nextLayer11.getBaseElement();
                        nextDOMElement11 = tmpDOMElement11 || nextDOMElement11;
                    }
                    i31 += 1;
                }
                if (nextDOMElement11) {
                    if (!layer11.ddd || !this.supports3d) this.layerElement.insertBefore(newDOMElement11, nextDOMElement11);
                } else if (!layer11.ddd || !this.supports3d) this.layerElement.appendChild(newDOMElement11);
            }
        } else this.addTo3dContainer(newDOMElement11, pos11);
    };
    HybridRendererBase.prototype.createShape = function(data11) {
        if (!this.supports3d) return new SVGShapeElement(data11, this.globalData, this);
        return new HShapeElement(data11, this.globalData, this);
    };
    HybridRendererBase.prototype.createText = function(data11) {
        if (!this.supports3d) return new SVGTextLottieElement(data11, this.globalData, this);
        return new HTextElement(data11, this.globalData, this);
    };
    HybridRendererBase.prototype.createCamera = function(data11) {
        this.camera = new HCameraElement(data11, this.globalData, this);
        return this.camera;
    };
    HybridRendererBase.prototype.createImage = function(data11) {
        if (!this.supports3d) return new IImageElement(data11, this.globalData, this);
        return new HImageElement(data11, this.globalData, this);
    };
    HybridRendererBase.prototype.createSolid = function(data11) {
        if (!this.supports3d) return new ISolidElement(data11, this.globalData, this);
        return new HSolidElement(data11, this.globalData, this);
    };
    HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;
    HybridRendererBase.prototype.getThreeDContainerByPos = function(pos11) {
        var i31 = 0;
        var len11 = this.threeDElements.length;
        while(i31 < len11){
            if (this.threeDElements[i31].startPos <= pos11 && this.threeDElements[i31].endPos >= pos11) return this.threeDElements[i31].perspectiveElem;
            i31 += 1;
        }
        return null;
    };
    HybridRendererBase.prototype.createThreeDContainer = function(pos11, type11) {
        var perspectiveElem11 = createTag("div");
        var style11;
        var containerStyle11;
        styleDiv(perspectiveElem11);
        var container11 = createTag("div");
        styleDiv(container11);
        if (type11 === "3d") {
            style11 = perspectiveElem11.style;
            style11.width = this.globalData.compSize.w + "px";
            style11.height = this.globalData.compSize.h + "px";
            var center11 = "50% 50%";
            style11.webkitTransformOrigin = center11;
            style11.mozTransformOrigin = center11;
            style11.transformOrigin = center11;
            containerStyle11 = container11.style;
            var matrix11 = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
            containerStyle11.transform = matrix11;
            containerStyle11.webkitTransform = matrix11;
        }
        perspectiveElem11.appendChild(container11); // this.resizerElem.appendChild(perspectiveElem);
        var threeDContainerData11 = {
            container: container11,
            perspectiveElem: perspectiveElem11,
            startPos: pos11,
            endPos: pos11,
            type: type11
        };
        this.threeDElements.push(threeDContainerData11);
        return threeDContainerData11;
    };
    HybridRendererBase.prototype.build3dContainers = function() {
        var i31;
        var len11 = this.layers.length;
        var lastThreeDContainerData11;
        var currentContainer11 = "";
        for(i31 = 0; i31 < len11; i31 += 1)if (this.layers[i31].ddd && this.layers[i31].ty !== 3) {
            if (currentContainer11 !== "3d") {
                currentContainer11 = "3d";
                lastThreeDContainerData11 = this.createThreeDContainer(i31, "3d");
            }
            lastThreeDContainerData11.endPos = Math.max(lastThreeDContainerData11.endPos, i31);
        } else {
            if (currentContainer11 !== "2d") {
                currentContainer11 = "2d";
                lastThreeDContainerData11 = this.createThreeDContainer(i31, "2d");
            }
            lastThreeDContainerData11.endPos = Math.max(lastThreeDContainerData11.endPos, i31);
        }
        len11 = this.threeDElements.length;
        for(i31 = len11 - 1; i31 >= 0; i31 -= 1)this.resizerElem.appendChild(this.threeDElements[i31].perspectiveElem);
    };
    HybridRendererBase.prototype.addTo3dContainer = function(elem31, pos11) {
        var i31 = 0;
        var len11 = this.threeDElements.length;
        while(i31 < len11){
            if (pos11 <= this.threeDElements[i31].endPos) {
                var j31 = this.threeDElements[i31].startPos;
                var nextElement11;
                while(j31 < pos11){
                    if (this.elements[j31] && this.elements[j31].getBaseElement) nextElement11 = this.elements[j31].getBaseElement();
                    j31 += 1;
                }
                if (nextElement11) this.threeDElements[i31].container.insertBefore(elem31, nextElement11);
                else this.threeDElements[i31].container.appendChild(elem31);
                break;
            }
            i31 += 1;
        }
    };
    HybridRendererBase.prototype.configAnimation = function(animData11) {
        var resizerElem11 = createTag("div");
        var wrapper11 = this.animationItem.wrapper;
        var style11 = resizerElem11.style;
        style11.width = animData11.w + "px";
        style11.height = animData11.h + "px";
        this.resizerElem = resizerElem11;
        styleDiv(resizerElem11);
        style11.transformStyle = "flat";
        style11.mozTransformStyle = "flat";
        style11.webkitTransformStyle = "flat";
        if (this.renderConfig.className) resizerElem11.setAttribute("class", this.renderConfig.className);
        wrapper11.appendChild(resizerElem11);
        style11.overflow = "hidden";
        var svg11 = createNS("svg");
        svg11.setAttribute("width", "1");
        svg11.setAttribute("height", "1");
        styleDiv(svg11);
        this.resizerElem.appendChild(svg11);
        var defs11 = createNS("defs");
        svg11.appendChild(defs11);
        this.data = animData11; // Mask animation
        this.setupGlobalData(animData11, svg11);
        this.globalData.defs = defs11;
        this.layers = animData11.layers;
        this.layerElement = this.resizerElem;
        this.build3dContainers();
        this.updateContainerSize();
    };
    HybridRendererBase.prototype.destroy = function() {
        if (this.animationItem.wrapper) this.animationItem.wrapper.innerText = "";
        this.animationItem.container = null;
        this.globalData.defs = null;
        var i31;
        var len11 = this.layers ? this.layers.length : 0;
        for(i31 = 0; i31 < len11; i31 += 1)if (this.elements[i31] && this.elements[i31].destroy) this.elements[i31].destroy();
        this.elements.length = 0;
        this.destroyed = true;
        this.animationItem = null;
    };
    HybridRendererBase.prototype.updateContainerSize = function() {
        var elementWidth11 = this.animationItem.wrapper.offsetWidth;
        var elementHeight11 = this.animationItem.wrapper.offsetHeight;
        var elementRel11 = elementWidth11 / elementHeight11;
        var animationRel11 = this.globalData.compSize.w / this.globalData.compSize.h;
        var sx11;
        var sy11;
        var tx11;
        var ty11;
        if (animationRel11 > elementRel11) {
            sx11 = elementWidth11 / this.globalData.compSize.w;
            sy11 = elementWidth11 / this.globalData.compSize.w;
            tx11 = 0;
            ty11 = (elementHeight11 - this.globalData.compSize.h * (elementWidth11 / this.globalData.compSize.w)) / 2;
        } else {
            sx11 = elementHeight11 / this.globalData.compSize.h;
            sy11 = elementHeight11 / this.globalData.compSize.h;
            tx11 = (elementWidth11 - this.globalData.compSize.w * (elementHeight11 / this.globalData.compSize.h)) / 2;
            ty11 = 0;
        }
        var style11 = this.resizerElem.style;
        style11.webkitTransform = "matrix3d(" + sx11 + ",0,0,0,0," + sy11 + ",0,0,0,0,1,0," + tx11 + "," + ty11 + ",0,1)";
        style11.transform = style11.webkitTransform;
    };
    HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame;
    HybridRendererBase.prototype.hide = function() {
        this.resizerElem.style.display = "none";
    };
    HybridRendererBase.prototype.show = function() {
        this.resizerElem.style.display = "block";
    };
    HybridRendererBase.prototype.initItems = function() {
        this.buildAllItems();
        if (this.camera) this.camera.setup();
        else {
            var cWidth11 = this.globalData.compSize.w;
            var cHeight11 = this.globalData.compSize.h;
            var i31;
            var len11 = this.threeDElements.length;
            for(i31 = 0; i31 < len11; i31 += 1){
                var style11 = this.threeDElements[i31].perspectiveElem.style;
                style11.webkitPerspective = Math.sqrt(Math.pow(cWidth11, 2) + Math.pow(cHeight11, 2)) + "px";
                style11.perspective = style11.webkitPerspective;
            }
        }
    };
    HybridRendererBase.prototype.searchExtraCompositions = function(assets11) {
        var i31;
        var len11 = assets11.length;
        var floatingContainer11 = createTag("div");
        for(i31 = 0; i31 < len11; i31 += 1)if (assets11[i31].xt) {
            var comp11 = this.createComp(assets11[i31], floatingContainer11, this.globalData.comp, null);
            comp11.initExpressions();
            this.globalData.projectInterface.registerComposition(comp11);
        }
    };
    function HCompElement(data11, globalData11, comp11) {
        this.layers = data11.layers;
        this.supports3d = !data11.hasMask;
        this.completeLayers = false;
        this.pendingElements = [];
        this.elements = this.layers ? createSizedArray(this.layers.length) : [];
        this.initElement(data11, globalData11, comp11);
        this.tm = data11.tm ? PropertyFactory.getProp(this, data11.tm, 0, globalData11.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        HybridRendererBase,
        ICompElement,
        HBaseElement
    ], HCompElement);
    HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements;
    HCompElement.prototype.createContainerElements = function() {
        this._createBaseContainerElements(); // divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';
        if (this.data.hasMask) {
            this.svgElement.setAttribute("width", this.data.w);
            this.svgElement.setAttribute("height", this.data.h);
            this.transformedElement = this.baseElement;
        } else this.transformedElement = this.layerElement;
    };
    HCompElement.prototype.addTo3dContainer = function(elem31, pos11) {
        var j31 = 0;
        var nextElement11;
        while(j31 < pos11){
            if (this.elements[j31] && this.elements[j31].getBaseElement) nextElement11 = this.elements[j31].getBaseElement();
            j31 += 1;
        }
        if (nextElement11) this.layerElement.insertBefore(elem31, nextElement11);
        else this.layerElement.appendChild(elem31);
    };
    HCompElement.prototype.createComp = function(data11) {
        if (!this.supports3d) return new SVGCompElement(data11, this.globalData, this);
        return new HCompElement(data11, this.globalData, this);
    };
    function HybridRenderer(animationItem11, config11) {
        this.animationItem = animationItem11;
        this.layers = null;
        this.renderedFrame = -1;
        this.renderConfig = {
            className: config11 && config11.className || "",
            imagePreserveAspectRatio: config11 && config11.imagePreserveAspectRatio || "xMidYMid slice",
            hideOnTransparent: !(config11 && config11.hideOnTransparent === false),
            filterSize: {
                width: config11 && config11.filterSize && config11.filterSize.width || "400%",
                height: config11 && config11.filterSize && config11.filterSize.height || "400%",
                x: config11 && config11.filterSize && config11.filterSize.x || "-100%",
                y: config11 && config11.filterSize && config11.filterSize.y || "-100%"
            },
            runExpressions: !config11 || config11.runExpressions === undefined || config11.runExpressions
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            renderConfig: this.renderConfig
        };
        this.pendingElements = [];
        this.elements = [];
        this.threeDElements = [];
        this.destroyed = false;
        this.camera = null;
        this.supports3d = true;
        this.rendererType = "html";
    }
    extendPrototype([
        HybridRendererBase
    ], HybridRenderer);
    HybridRenderer.prototype.createComp = function(data11) {
        if (!this.supports3d) return new SVGCompElement(data11, this.globalData, this);
        return new HCompElement(data11, this.globalData, this);
    };
    var CompExpressionInterface = function() {
        return function(comp11) {
            function _thisLayerFunction11(name11) {
                var i31 = 0;
                var len11 = comp11.layers.length;
                while(i31 < len11){
                    if (comp11.layers[i31].nm === name11 || comp11.layers[i31].ind === name11) return comp11.elements[i31].layerInterface;
                    i31 += 1;
                }
                return null; // return {active:false};
            }
            Object.defineProperty(_thisLayerFunction11, "_name", {
                value: comp11.data.nm
            });
            _thisLayerFunction11.layer = _thisLayerFunction11;
            _thisLayerFunction11.pixelAspect = 1;
            _thisLayerFunction11.height = comp11.data.h || comp11.globalData.compSize.h;
            _thisLayerFunction11.width = comp11.data.w || comp11.globalData.compSize.w;
            _thisLayerFunction11.pixelAspect = 1;
            _thisLayerFunction11.frameDuration = 1 / comp11.globalData.frameRate;
            _thisLayerFunction11.displayStartTime = 0;
            _thisLayerFunction11.numLayers = comp11.layers.length;
            return _thisLayerFunction11;
        };
    }();
    function _typeof$2(obj11) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$2 = function _typeof11(obj11) {
            return typeof obj11;
        };
        else _typeof$2 = function _typeof11(obj11) {
            return obj11 && typeof Symbol === "function" && obj11.constructor === Symbol && obj11 !== Symbol.prototype ? "symbol" : typeof obj11;
        };
        return _typeof$2(obj11);
    }
    /* eslint-disable */ /*
   Copyright 2014 David Bau.

   Permission is hereby granted, free of charge, to any person obtaining
   a copy of this software and associated documentation files (the
   "Software"), to deal in the Software without restriction, including
   without limitation the rights to use, copy, modify, merge, publish,
   distribute, sublicense, and/or sell copies of the Software, and to
   permit persons to whom the Software is furnished to do so, subject to
   the following conditions:

   The above copyright notice and this permission notice shall be
   included in all copies or substantial portions of the Software.

   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
   EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
   MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
   IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
   CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
   TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
   SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

   */ function seedRandom(pool11, math11) {
        //
        // The following constants are related to IEEE 754 limits.
        //
        var global11 = this, width11 = 256, // each RC4 output is 0 <= x < 256
        chunks11 = 6, // at least six RC4 outputs for each double
        digits11 = 52, // there are 52 significant digits in a double
        rngname11 = "random", // rngname: name for Math.random and Math.seedrandom
        startdenom11 = math11.pow(width11, chunks11), significance11 = math11.pow(2, digits11), overflow11 = significance11 * 2, mask11 = width11 - 1, nodecrypto11; // node.js crypto module, initialized at the bottom.
        //
        // seedrandom()
        // This is the seedrandom function described above.
        //
        function seedrandom11(seed11, options11, callback11) {
            var key11 = [];
            options11 = options11 === true ? {
                entropy: true
            } : options11 || {}; // Flatten the seed string or build one from local entropy if needed.
            var shortseed11 = mixkey11(flatten11(options11.entropy ? [
                seed11,
                tostring11(pool11)
            ] : seed11 === null ? autoseed11() : seed11, 3), key11); // Use the seed to initialize an ARC4 generator.
            var arc411 = new ARC411(key11); // This function returns a random double in [0, 1) that contains
            // randomness in every bit of the mantissa of the IEEE 754 value.
            var prng11 = function prng11() {
                var n31 = arc411.g(chunks11), // Start with a numerator n < 2 ^ 48
                d31 = startdenom11, //   and denominator d = 2 ^ 48.
                x41 = 0; //   and no 'extra last byte'.
                while(n31 < significance11){
                    // Fill up all significant digits by
                    n31 = (n31 + x41) * width11; //   shifting numerator and
                    d31 *= width11; //   denominator and generating a
                    x41 = arc411.g(1); //   new least-significant-byte.
                }
                while(n31 >= overflow11){
                    // To avoid rounding up, before adding
                    n31 /= 2; //   last byte, shift everything
                    d31 /= 2; //   right using integer math until
                    x41 >>>= 1; //   we have exactly the desired bits.
                }
                return (n31 + x41) / d31; // Form the number within [0, 1).
            };
            prng11.int32 = function() {
                return arc411.g(4) | 0;
            };
            prng11.quick = function() {
                return arc411.g(4) / 0x100000000;
            };
            prng11["double"] = prng11; // Mix the randomness into accumulated entropy.
            mixkey11(tostring11(arc411.S), pool11); // Calling convention: what to return as a function of prng, seed, is_math.
            return (options11.pass || callback11 || function(prng11, seed11, is_math_call11, state11) {
                if (state11) {
                    // Load the arc4 state from the given state if it has an S array.
                    if (state11.S) copy11(state11, arc411);
                     // Only provide the .state method if requested via options.state.
                    prng11.state = function() {
                        return copy11(arc411, {});
                    };
                } // If called as a method of Math (Math.seedrandom()), mutate
                // Math.random because that is how seedrandom.js has worked since v1.0.
                if (is_math_call11) {
                    math11[rngname11] = prng11;
                    return seed11;
                } else return prng11;
            })(prng11, shortseed11, "global" in options11 ? options11.global : this == math11, options11.state);
        }
        math11["seed" + rngname11] = seedrandom11; //
        // ARC4
        //
        // An ARC4 implementation.  The constructor takes a key in the form of
        // an array of at most (width) integers that should be 0 <= x < (width).
        //
        // The g(count) method returns a pseudorandom integer that concatenates
        // the next (count) outputs from ARC4.  Its return value is a number x
        // that is in the range 0 <= x < (width ^ count).
        //
        function ARC411(key11) {
            var t31, keylen11 = key11.length, me11 = this, i31 = 0, j31 = me11.i = me11.j = 0, s41 = me11.S = []; // The empty key [] is treated as [0].
            if (!keylen11) key11 = [
                keylen11++
            ];
             // Set up S using the standard key scheduling algorithm.
            while(i31 < width11)s41[i31] = i31++;
            for(i31 = 0; i31 < width11; i31++){
                s41[i31] = s41[j31 = mask11 & j31 + key11[i31 % keylen11] + (t31 = s41[i31])];
                s41[j31] = t31;
            } // The "g" method returns the next (count) outputs as one number.
            me11.g = function(count11) {
                // Using instance members instead of closure state nearly doubles speed.
                var t31, r11 = 0, i31 = me11.i, j31 = me11.j, s41 = me11.S;
                while(count11--){
                    t31 = s41[i31 = mask11 & i31 + 1];
                    r11 = r11 * width11 + s41[mask11 & (s41[i31] = s41[j31 = mask11 & j31 + t31]) + (s41[j31] = t31)];
                }
                me11.i = i31;
                me11.j = j31;
                return r11; // For robust unpredictability, the function call below automatically
            // discards an initial batch of values.  This is called RC4-drop[256].
            // See http://google.com/search?q=rsa+fluhrer+response&btnI
            };
        } //
        // copy()
        // Copies internal state of ARC4 to or from a plain object.
        //
        function copy11(f31, t31) {
            t31.i = f31.i;
            t31.j = f31.j;
            t31.S = f31.S.slice();
            return t31;
        } //
        // flatten()
        // Converts an object tree to nested arrays of strings.
        //
        function flatten11(obj11, depth11) {
            var result11 = [], typ11 = _typeof$2(obj11), prop11;
            if (depth11 && typ11 == "object") {
                for(prop11 in obj11)try {
                    result11.push(flatten11(obj11[prop11], depth11 - 1));
                } catch (e31) {}
            }
            return result11.length ? result11 : typ11 == "string" ? obj11 : obj11 + "\x00";
        } //
        // mixkey()
        // Mixes a string seed into a key that is an array of integers, and
        // returns a shortened string seed that is equivalent to the result key.
        //
        function mixkey11(seed11, key11) {
            var stringseed11 = seed11 + "", smear11, j31 = 0;
            while(j31 < stringseed11.length)key11[mask11 & j31] = mask11 & (smear11 ^= key11[mask11 & j31] * 19) + stringseed11.charCodeAt(j31++);
            return tostring11(key11);
        } //
        // autoseed()
        // Returns an object for autoseeding, using window.crypto and Node crypto
        // module if available.
        //
        function autoseed11() {
            try {
                if (nodecrypto11) return tostring11(nodecrypto11.randomBytes(width11));
                var out11 = new Uint8Array(width11);
                (global11.crypto || global11.msCrypto).getRandomValues(out11);
                return tostring11(out11);
            } catch (e31) {
                var browser11 = global11.navigator, plugins11 = browser11 && browser11.plugins;
                return [
                    +new Date(),
                    global11,
                    plugins11,
                    global11.screen,
                    tostring11(pool11)
                ];
            }
        } //
        // tostring()
        // Converts an array of charcodes to a string
        //
        function tostring11(a31) {
            return String.fromCharCode.apply(0, a31);
        } //
        // When seedrandom.js is loaded, we immediately mix a few bits
        // from the built-in RNG into the entropy pool.  Because we do
        // not want to interfere with deterministic PRNG state later,
        // seedrandom will not call math.random on its own again after
        // initialization.
        //
        mixkey11(math11.random(), pool11); //
    // Nodejs and AMD support: export the implementation as a module using
    // either convention.
    //
    // End anonymous scope, and pass initial values.
    }
    function initialize$2(BMMath11) {
        seedRandom([], BMMath11);
    }
    var propTypes = {
        SHAPE: "shape"
    };
    function _typeof$1(obj11) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$1 = function _typeof11(obj11) {
            return typeof obj11;
        };
        else _typeof$1 = function _typeof11(obj11) {
            return obj11 && typeof Symbol === "function" && obj11.constructor === Symbol && obj11 !== Symbol.prototype ? "symbol" : typeof obj11;
        };
        return _typeof$1(obj11);
    }
    var ExpressionManager = function() {
        "use strict";
        var ob = {};
        var Math = BMMath;
        var window = null;
        var document = null;
        var XMLHttpRequest = null;
        var fetch = null;
        var frames = null;
        var _lottieGlobal = {};
        initialize$2(BMMath);
        function resetFrame() {
            _lottieGlobal = {};
        }
        function $bm_isInstanceOfArray(arr31) {
            return arr31.constructor === Array || arr31.constructor === Float32Array;
        }
        function isNumerable(tOfV11, v51) {
            return tOfV11 === "number" || v51 instanceof Number || tOfV11 === "boolean" || tOfV11 === "string";
        }
        function $bm_neg(a31) {
            var tOfA11 = _typeof$1(a31);
            if (tOfA11 === "number" || a31 instanceof Number || tOfA11 === "boolean") return -a31;
            if ($bm_isInstanceOfArray(a31)) {
                var i31;
                var lenA11 = a31.length;
                var retArr11 = [];
                for(i31 = 0; i31 < lenA11; i31 += 1)retArr11[i31] = -a31[i31];
                return retArr11;
            }
            if (a31.propType) return a31.v;
            return -a31;
        }
        var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, "easeIn").get;
        var easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, "easeOut").get;
        var easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, "easeInOut").get;
        function sum(a31, b31) {
            var tOfA11 = _typeof$1(a31);
            var tOfB11 = _typeof$1(b31);
            if (isNumerable(tOfA11, a31) && isNumerable(tOfB11, b31) || tOfA11 === "string" || tOfB11 === "string") return a31 + b31;
            if ($bm_isInstanceOfArray(a31) && isNumerable(tOfB11, b31)) {
                a31 = a31.slice(0);
                a31[0] += b31;
                return a31;
            }
            if (isNumerable(tOfA11, a31) && $bm_isInstanceOfArray(b31)) {
                b31 = b31.slice(0);
                b31[0] = a31 + b31[0];
                return b31;
            }
            if ($bm_isInstanceOfArray(a31) && $bm_isInstanceOfArray(b31)) {
                var i31 = 0;
                var lenA11 = a31.length;
                var lenB11 = b31.length;
                var retArr11 = [];
                while(i31 < lenA11 || i31 < lenB11){
                    if ((typeof a31[i31] === "number" || a31[i31] instanceof Number) && (typeof b31[i31] === "number" || b31[i31] instanceof Number)) retArr11[i31] = a31[i31] + b31[i31];
                    else retArr11[i31] = b31[i31] === undefined ? a31[i31] : a31[i31] || b31[i31];
                    i31 += 1;
                }
                return retArr11;
            }
            return 0;
        }
        var add = sum;
        function sub(a31, b31) {
            var tOfA11 = _typeof$1(a31);
            var tOfB11 = _typeof$1(b31);
            if (isNumerable(tOfA11, a31) && isNumerable(tOfB11, b31)) {
                if (tOfA11 === "string") a31 = parseInt(a31, 10);
                if (tOfB11 === "string") b31 = parseInt(b31, 10);
                return a31 - b31;
            }
            if ($bm_isInstanceOfArray(a31) && isNumerable(tOfB11, b31)) {
                a31 = a31.slice(0);
                a31[0] -= b31;
                return a31;
            }
            if (isNumerable(tOfA11, a31) && $bm_isInstanceOfArray(b31)) {
                b31 = b31.slice(0);
                b31[0] = a31 - b31[0];
                return b31;
            }
            if ($bm_isInstanceOfArray(a31) && $bm_isInstanceOfArray(b31)) {
                var i31 = 0;
                var lenA11 = a31.length;
                var lenB11 = b31.length;
                var retArr11 = [];
                while(i31 < lenA11 || i31 < lenB11){
                    if ((typeof a31[i31] === "number" || a31[i31] instanceof Number) && (typeof b31[i31] === "number" || b31[i31] instanceof Number)) retArr11[i31] = a31[i31] - b31[i31];
                    else retArr11[i31] = b31[i31] === undefined ? a31[i31] : a31[i31] || b31[i31];
                    i31 += 1;
                }
                return retArr11;
            }
            return 0;
        }
        function mul(a31, b31) {
            var tOfA11 = _typeof$1(a31);
            var tOfB11 = _typeof$1(b31);
            var arr31;
            if (isNumerable(tOfA11, a31) && isNumerable(tOfB11, b31)) return a31 * b31;
            var i31;
            var len11;
            if ($bm_isInstanceOfArray(a31) && isNumerable(tOfB11, b31)) {
                len11 = a31.length;
                arr31 = createTypedArray("float32", len11);
                for(i31 = 0; i31 < len11; i31 += 1)arr31[i31] = a31[i31] * b31;
                return arr31;
            }
            if (isNumerable(tOfA11, a31) && $bm_isInstanceOfArray(b31)) {
                len11 = b31.length;
                arr31 = createTypedArray("float32", len11);
                for(i31 = 0; i31 < len11; i31 += 1)arr31[i31] = a31 * b31[i31];
                return arr31;
            }
            return 0;
        }
        function div(a31, b31) {
            var tOfA11 = _typeof$1(a31);
            var tOfB11 = _typeof$1(b31);
            var arr31;
            if (isNumerable(tOfA11, a31) && isNumerable(tOfB11, b31)) return a31 / b31;
            var i31;
            var len11;
            if ($bm_isInstanceOfArray(a31) && isNumerable(tOfB11, b31)) {
                len11 = a31.length;
                arr31 = createTypedArray("float32", len11);
                for(i31 = 0; i31 < len11; i31 += 1)arr31[i31] = a31[i31] / b31;
                return arr31;
            }
            if (isNumerable(tOfA11, a31) && $bm_isInstanceOfArray(b31)) {
                len11 = b31.length;
                arr31 = createTypedArray("float32", len11);
                for(i31 = 0; i31 < len11; i31 += 1)arr31[i31] = a31 / b31[i31];
                return arr31;
            }
            return 0;
        }
        function mod(a31, b31) {
            if (typeof a31 === "string") a31 = parseInt(a31, 10);
            if (typeof b31 === "string") b31 = parseInt(b31, 10);
            return a31 % b31;
        }
        var $bm_sum = sum;
        var $bm_sub = sub;
        var $bm_mul = mul;
        var $bm_div = div;
        var $bm_mod = mod;
        function clamp(num11, min11, max11) {
            if (min11 > max11) {
                var mm11 = max11;
                max11 = min11;
                min11 = mm11;
            }
            return Math.min(Math.max(num11, min11), max11);
        }
        function radiansToDegrees(val31) {
            return val31 / degToRads;
        }
        var radians_to_degrees = radiansToDegrees;
        function degreesToRadians(val31) {
            return val31 * degToRads;
        }
        var degrees_to_radians = radiansToDegrees;
        var helperLengthArray = [
            0,
            0,
            0,
            0,
            0,
            0
        ];
        function length(arr111, arr211) {
            if (typeof arr111 === "number" || arr111 instanceof Number) {
                arr211 = arr211 || 0;
                return Math.abs(arr111 - arr211);
            }
            if (!arr211) arr211 = helperLengthArray;
            var i31;
            var len11 = Math.min(arr111.length, arr211.length);
            var addedLength11 = 0;
            for(i31 = 0; i31 < len11; i31 += 1)addedLength11 += Math.pow(arr211[i31] - arr111[i31], 2);
            return Math.sqrt(addedLength11);
        }
        function normalize(vec11) {
            return div(vec11, length(vec11));
        }
        function rgbToHsl(val31) {
            var r11 = val31[0];
            var g31 = val31[1];
            var b31 = val31[2];
            var max11 = Math.max(r11, g31, b31);
            var min11 = Math.min(r11, g31, b31);
            var h31;
            var s41;
            var l31 = (max11 + min11) / 2;
            if (max11 === min11) {
                h31 = 0; // achromatic
                s41 = 0; // achromatic
            } else {
                var d31 = max11 - min11;
                s41 = l31 > 0.5 ? d31 / (2 - max11 - min11) : d31 / (max11 + min11);
                switch(max11){
                    case r11:
                        h31 = (g31 - b31) / d31 + (g31 < b31 ? 6 : 0);
                        break;
                    case g31:
                        h31 = (b31 - r11) / d31 + 2;
                        break;
                    case b31:
                        h31 = (r11 - g31) / d31 + 4;
                        break;
                    default:
                        break;
                }
                h31 /= 6;
            }
            return [
                h31,
                s41,
                l31,
                val31[3]
            ];
        }
        function hue2rgb(p61, q11, t31) {
            if (t31 < 0) t31 += 1;
            if (t31 > 1) t31 -= 1;
            if (t31 < 1 / 6) return p61 + (q11 - p61) * 6 * t31;
            if (t31 < 0.5) return q11;
            if (t31 < 2 / 3) return p61 + (q11 - p61) * (2 / 3 - t31) * 6;
            return p61;
        }
        function hslToRgb(val31) {
            var h31 = val31[0];
            var s41 = val31[1];
            var l31 = val31[2];
            var r11;
            var g31;
            var b31;
            if (s41 === 0) {
                r11 = l31; // achromatic
                b31 = l31; // achromatic
                g31 = l31; // achromatic
            } else {
                var q11 = l31 < 0.5 ? l31 * (1 + s41) : l31 + s41 - l31 * s41;
                var p61 = 2 * l31 - q11;
                r11 = hue2rgb(p61, q11, h31 + 1 / 3);
                g31 = hue2rgb(p61, q11, h31);
                b31 = hue2rgb(p61, q11, h31 - 1 / 3);
            }
            return [
                r11,
                g31,
                b31,
                val31[3]
            ];
        }
        function linear(t31, tMin11, tMax11, value111, value211) {
            if (value111 === undefined || value211 === undefined) {
                value111 = tMin11;
                value211 = tMax11;
                tMin11 = 0;
                tMax11 = 1;
            }
            if (tMax11 < tMin11) {
                var _tMin11 = tMax11;
                tMax11 = tMin11;
                tMin11 = _tMin11;
            }
            if (t31 <= tMin11) return value111;
            if (t31 >= tMax11) return value211;
            var perc11 = tMax11 === tMin11 ? 0 : (t31 - tMin11) / (tMax11 - tMin11);
            if (!value111.length) return value111 + (value211 - value111) * perc11;
            var i31;
            var len11 = value111.length;
            var arr31 = createTypedArray("float32", len11);
            for(i31 = 0; i31 < len11; i31 += 1)arr31[i31] = value111[i31] + (value211[i31] - value111[i31]) * perc11;
            return arr31;
        }
        function random(min11, max11) {
            if (max11 === undefined) {
                if (min11 === undefined) {
                    min11 = 0;
                    max11 = 1;
                } else {
                    max11 = min11;
                    min11 = undefined;
                }
            }
            if (max11.length) {
                var i31;
                var len11 = max11.length;
                if (!min11) min11 = createTypedArray("float32", len11);
                var arr31 = createTypedArray("float32", len11);
                var rnd11 = BMMath.random();
                for(i31 = 0; i31 < len11; i31 += 1)arr31[i31] = min11[i31] + rnd11 * (max11[i31] - min11[i31]);
                return arr31;
            }
            if (min11 === undefined) min11 = 0;
            var rndm11 = BMMath.random();
            return min11 + rndm11 * (max11 - min11);
        }
        function createPath(points11, inTangents11, outTangents11, closed11) {
            var i31;
            var len11 = points11.length;
            var path11 = shapePool.newElement();
            path11.setPathData(!!closed11, len11);
            var arrPlaceholder11 = [
                0,
                0
            ];
            var inVertexPoint11;
            var outVertexPoint11;
            for(i31 = 0; i31 < len11; i31 += 1){
                inVertexPoint11 = inTangents11 && inTangents11[i31] ? inTangents11[i31] : arrPlaceholder11;
                outVertexPoint11 = outTangents11 && outTangents11[i31] ? outTangents11[i31] : arrPlaceholder11;
                path11.setTripleAt(points11[i31][0], points11[i31][1], outVertexPoint11[0] + points11[i31][0], outVertexPoint11[1] + points11[i31][1], inVertexPoint11[0] + points11[i31][0], inVertexPoint11[1] + points11[i31][1], i31, true);
            }
            return path11;
        }
        function initiateExpression(elem, data, property) {
            // Bail out if we don't want expressions
            function noOp(_value11) {
                return _value11;
            }
            if (!elem.globalData.renderConfig.runExpressions) return noOp;
            var val = data.x;
            var needsVelocity = /velocity(?![\w\d])/.test(val);
            var _needsRandom = val.indexOf("random") !== -1;
            var elemType = elem.data.ty;
            var transform;
            var $bm_transform;
            var content;
            var effect;
            var thisProperty = property;
            thisProperty.valueAtTime = thisProperty.getValueAtTime;
            Object.defineProperty(thisProperty, "value", {
                get: function get11() {
                    return thisProperty.v;
                }
            });
            elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate;
            elem.comp.displayStartTime = 0;
            var inPoint = elem.data.ip / elem.comp.globalData.frameRate;
            var outPoint = elem.data.op / elem.comp.globalData.frameRate;
            var width = elem.data.sw ? elem.data.sw : 0;
            var height = elem.data.sh ? elem.data.sh : 0;
            var name = elem.data.nm;
            var loopIn;
            var loop_in;
            var loopOut;
            var loop_out;
            var smooth;
            var toWorld;
            var fromWorld;
            var fromComp;
            var toComp;
            var fromCompToSurface;
            var position;
            var rotation;
            var anchorPoint;
            var scale;
            var thisLayer;
            var thisComp;
            var mask;
            var valueAtTime;
            var velocityAtTime;
            var scoped_bm_rt; // val = val.replace(/(\\?"|')((http)(s)?(:\/))?\/.*?(\\?"|')/g, "\"\""); // deter potential network calls
            var expression_function = eval("[function _expression_function(){" + val + ";scoped_bm_rt=$bm_rt}]")[0]; // eslint-disable-line no-eval
            var numKeys = property.kf ? data.k.length : 0;
            var active = !this.data || this.data.hd !== true;
            var wiggle = (function wiggle11(freq11, amp11) {
                var iWiggle11;
                var j31;
                var lenWiggle11 = this.pv.length ? this.pv.length : 1;
                var addedAmps11 = createTypedArray("float32", lenWiggle11);
                freq11 = 5;
                var iterations11 = Math.floor(time * freq11);
                iWiggle11 = 0;
                j31 = 0;
                while(iWiggle11 < iterations11){
                    // var rnd = BMMath.random();
                    for(j31 = 0; j31 < lenWiggle11; j31 += 1)addedAmps11[j31] += -amp11 + amp11 * 2 * BMMath.random(); // addedAmps[j] += -amp + amp*2*rnd;
                    iWiggle11 += 1;
                } // var rnd2 = BMMath.random();
                var periods11 = time * freq11;
                var perc11 = periods11 - Math.floor(periods11);
                var arr31 = createTypedArray("float32", lenWiggle11);
                if (lenWiggle11 > 1) {
                    for(j31 = 0; j31 < lenWiggle11; j31 += 1)arr31[j31] = this.pv[j31] + addedAmps11[j31] + (-amp11 + amp11 * 2 * BMMath.random()) * perc11; // arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
                    return arr31;
                }
                return this.pv + addedAmps11[0] + (-amp11 + amp11 * 2 * BMMath.random()) * perc11;
            }).bind(this);
            if (thisProperty.loopIn) {
                loopIn = thisProperty.loopIn.bind(thisProperty);
                loop_in = loopIn;
            }
            if (thisProperty.loopOut) {
                loopOut = thisProperty.loopOut.bind(thisProperty);
                loop_out = loopOut;
            }
            if (thisProperty.smooth) smooth = thisProperty.smooth.bind(thisProperty);
            function loopInDuration(type11, duration11) {
                return loopIn(type11, duration11, true);
            }
            function loopOutDuration(type11, duration11) {
                return loopOut(type11, duration11, true);
            }
            if (this.getValueAtTime) valueAtTime = this.getValueAtTime.bind(this);
            if (this.getVelocityAtTime) velocityAtTime = this.getVelocityAtTime.bind(this);
            var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
            function lookAt(elem111, elem211) {
                var fVec11 = [
                    elem211[0] - elem111[0],
                    elem211[1] - elem111[1],
                    elem211[2] - elem111[2]
                ];
                var pitch11 = Math.atan2(fVec11[0], Math.sqrt(fVec11[1] * fVec11[1] + fVec11[2] * fVec11[2])) / degToRads;
                var yaw11 = -Math.atan2(fVec11[1], fVec11[2]) / degToRads;
                return [
                    yaw11,
                    pitch11,
                    0
                ];
            }
            function easeOut(t31, tMin11, tMax11, val111, val211) {
                return applyEase(easeOutBez, t31, tMin11, tMax11, val111, val211);
            }
            function easeIn(t31, tMin11, tMax11, val111, val211) {
                return applyEase(easeInBez, t31, tMin11, tMax11, val111, val211);
            }
            function ease(t31, tMin11, tMax11, val111, val211) {
                return applyEase(easeInOutBez, t31, tMin11, tMax11, val111, val211);
            }
            function applyEase(fn11, t31, tMin11, tMax11, val111, val211) {
                if (val111 === undefined) {
                    val111 = tMin11;
                    val211 = tMax11;
                } else t31 = (t31 - tMin11) / (tMax11 - tMin11);
                if (t31 > 1) t31 = 1;
                else if (t31 < 0) t31 = 0;
                var mult11 = fn11(t31);
                if ($bm_isInstanceOfArray(val111)) {
                    var iKey11;
                    var lenKey11 = val111.length;
                    var arr31 = createTypedArray("float32", lenKey11);
                    for(iKey11 = 0; iKey11 < lenKey11; iKey11 += 1)arr31[iKey11] = (val211[iKey11] - val111[iKey11]) * mult11 + val111[iKey11];
                    return arr31;
                }
                return (val211 - val111) * mult11 + val111;
            }
            function nearestKey(time11) {
                var iKey11;
                var lenKey11 = data.k.length;
                var index11;
                var keyTime11;
                if (!data.k.length || typeof data.k[0] === "number") {
                    index11 = 0;
                    keyTime11 = 0;
                } else {
                    index11 = -1;
                    time11 *= elem.comp.globalData.frameRate;
                    if (time11 < data.k[0].t) {
                        index11 = 1;
                        keyTime11 = data.k[0].t;
                    } else {
                        for(iKey11 = 0; iKey11 < lenKey11 - 1; iKey11 += 1){
                            if (time11 === data.k[iKey11].t) {
                                index11 = iKey11 + 1;
                                keyTime11 = data.k[iKey11].t;
                                break;
                            } else if (time11 > data.k[iKey11].t && time11 < data.k[iKey11 + 1].t) {
                                if (time11 - data.k[iKey11].t > data.k[iKey11 + 1].t - time11) {
                                    index11 = iKey11 + 2;
                                    keyTime11 = data.k[iKey11 + 1].t;
                                } else {
                                    index11 = iKey11 + 1;
                                    keyTime11 = data.k[iKey11].t;
                                }
                                break;
                            }
                        }
                        if (index11 === -1) {
                            index11 = iKey11 + 1;
                            keyTime11 = data.k[iKey11].t;
                        }
                    }
                }
                var obKey11 = {};
                obKey11.index = index11;
                obKey11.time = keyTime11 / elem.comp.globalData.frameRate;
                return obKey11;
            }
            function key(ind11) {
                var obKey11;
                var iKey11;
                var lenKey11;
                if (!data.k.length || typeof data.k[0] === "number") throw new Error("The property has no keyframe at index " + ind11);
                ind11 -= 1;
                obKey11 = {
                    time: data.k[ind11].t / elem.comp.globalData.frameRate,
                    value: []
                };
                var arr31 = Object.prototype.hasOwnProperty.call(data.k[ind11], "s") ? data.k[ind11].s : data.k[ind11 - 1].e;
                lenKey11 = arr31.length;
                for(iKey11 = 0; iKey11 < lenKey11; iKey11 += 1){
                    obKey11[iKey11] = arr31[iKey11];
                    obKey11.value[iKey11] = arr31[iKey11];
                }
                return obKey11;
            }
            function framesToTime(fr11, fps11) {
                if (!fps11) fps11 = elem.comp.globalData.frameRate;
                return fr11 / fps11;
            }
            function timeToFrames(t31, fps11) {
                if (!t31 && t31 !== 0) t31 = time;
                if (!fps11) fps11 = elem.comp.globalData.frameRate;
                return t31 * fps11;
            }
            function seedRandom(seed11) {
                BMMath.seedrandom(randSeed + seed11);
            }
            function sourceRectAtTime() {
                return elem.sourceRectAtTime();
            }
            function substring(init11, end31) {
                if (typeof value === "string") {
                    if (end31 === undefined) return value.substring(init11);
                    return value.substring(init11, end31);
                }
                return "";
            }
            function substr(init11, end31) {
                if (typeof value === "string") {
                    if (end31 === undefined) return value.substr(init11);
                    return value.substr(init11, end31);
                }
                return "";
            }
            function posterizeTime(framesPerSecond11) {
                time = framesPerSecond11 === 0 ? 0 : Math.floor(time * framesPerSecond11) / framesPerSecond11;
                value = valueAtTime(time);
            }
            var time;
            var velocity;
            var value;
            var text;
            var textIndex;
            var textTotal;
            var selectorValue;
            var index = elem.data.ind;
            var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
            var parent;
            var randSeed = Math.floor(Math.random() * 1000000);
            var globalData = elem.globalData;
            function executeExpression(_value11) {
                // globalData.pushExpression();
                value = _value11;
                if (this.frameExpressionId === elem.globalData.frameId && this.propType !== "textSelector") return value;
                if (this.propType === "textSelector") {
                    textIndex = this.textIndex;
                    textTotal = this.textTotal;
                    selectorValue = this.selectorValue;
                }
                if (!thisLayer) {
                    text = elem.layerInterface.text;
                    thisLayer = elem.layerInterface;
                    thisComp = elem.comp.compInterface;
                    toWorld = thisLayer.toWorld.bind(thisLayer);
                    fromWorld = thisLayer.fromWorld.bind(thisLayer);
                    fromComp = thisLayer.fromComp.bind(thisLayer);
                    toComp = thisLayer.toComp.bind(thisLayer);
                    mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null;
                    fromCompToSurface = fromComp;
                }
                if (!transform) {
                    transform = elem.layerInterface("ADBE Transform Group");
                    $bm_transform = transform;
                    if (transform) anchorPoint = transform.anchorPoint;
                }
                if (elemType === 4 && !content) content = thisLayer("ADBE Root Vectors Group");
                if (!effect) effect = thisLayer(4);
                hasParent = !!(elem.hierarchy && elem.hierarchy.length);
                if (hasParent && !parent) parent = elem.hierarchy[0].layerInterface;
                time = this.comp.renderedFrame / this.comp.globalData.frameRate;
                if (_needsRandom) seedRandom(randSeed + time);
                if (needsVelocity) velocity = velocityAtTime(time);
                expression_function();
                this.frameExpressionId = elem.globalData.frameId; // TODO: Check if it's possible to return on ShapeInterface the .v value
                // Changed this to a ternary operation because Rollup failed compiling it correctly
                scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt;
                return scoped_bm_rt;
            } // Bundlers will see these as dead code and unless we reference them
            executeExpression.__preventDeadCodeRemoval = [
                $bm_transform,
                anchorPoint,
                time,
                velocity,
                inPoint,
                outPoint,
                width,
                height,
                name,
                loop_in,
                loop_out,
                smooth,
                toComp,
                fromCompToSurface,
                toWorld,
                fromWorld,
                mask,
                position,
                rotation,
                scale,
                thisComp,
                numKeys,
                active,
                wiggle,
                loopInDuration,
                loopOutDuration,
                comp,
                lookAt,
                easeOut,
                easeIn,
                ease,
                nearestKey,
                key,
                text,
                textIndex,
                textTotal,
                selectorValue,
                framesToTime,
                timeToFrames,
                sourceRectAtTime,
                substring,
                substr,
                posterizeTime,
                index,
                globalData
            ];
            return executeExpression;
        }
        ob.initiateExpression = initiateExpression;
        ob.__preventDeadCodeRemoval = [
            window,
            document,
            XMLHttpRequest,
            fetch,
            frames,
            $bm_neg,
            add,
            $bm_sum,
            $bm_sub,
            $bm_mul,
            $bm_div,
            $bm_mod,
            clamp,
            radians_to_degrees,
            degreesToRadians,
            degrees_to_radians,
            normalize,
            rgbToHsl,
            hslToRgb,
            linear,
            random,
            createPath,
            _lottieGlobal
        ];
        ob.resetFrame = resetFrame;
        return ob;
    }();
    var Expressions = function() {
        var ob11 = {};
        ob11.initExpressions = initExpressions11;
        ob11.resetFrame = ExpressionManager.resetFrame;
        function initExpressions11(animation11) {
            var stackCount11 = 0;
            var registers11 = [];
            function pushExpression11() {
                stackCount11 += 1;
            }
            function popExpression11() {
                stackCount11 -= 1;
                if (stackCount11 === 0) releaseInstances11();
            }
            function registerExpressionProperty11(expression11) {
                if (registers11.indexOf(expression11) === -1) registers11.push(expression11);
            }
            function releaseInstances11() {
                var i31;
                var len11 = registers11.length;
                for(i31 = 0; i31 < len11; i31 += 1)registers11[i31].release();
                registers11.length = 0;
            }
            animation11.renderer.compInterface = CompExpressionInterface(animation11.renderer);
            animation11.renderer.globalData.projectInterface.registerComposition(animation11.renderer);
            animation11.renderer.globalData.pushExpression = pushExpression11;
            animation11.renderer.globalData.popExpression = popExpression11;
            animation11.renderer.globalData.registerExpressionProperty = registerExpressionProperty11;
        }
        return ob11;
    }();
    var MaskManagerInterface = function() {
        function MaskInterface11(mask11, data11) {
            this._mask = mask11;
            this._data = data11;
        }
        Object.defineProperty(MaskInterface11.prototype, "maskPath", {
            get: function get11() {
                if (this._mask.prop.k) this._mask.prop.getValue();
                return this._mask.prop;
            }
        });
        Object.defineProperty(MaskInterface11.prototype, "maskOpacity", {
            get: function get11() {
                if (this._mask.op.k) this._mask.op.getValue();
                return this._mask.op.v * 100;
            }
        });
        var MaskManager11 = function MaskManager11(maskManager11) {
            var _masksInterfaces11 = createSizedArray(maskManager11.viewData.length);
            var i31;
            var len11 = maskManager11.viewData.length;
            for(i31 = 0; i31 < len11; i31 += 1)_masksInterfaces11[i31] = new MaskInterface11(maskManager11.viewData[i31], maskManager11.masksProperties[i31]);
            var maskFunction11 = function maskFunction11(name11) {
                i31 = 0;
                while(i31 < len11){
                    if (maskManager11.masksProperties[i31].nm === name11) return _masksInterfaces11[i31];
                    i31 += 1;
                }
                return null;
            };
            return maskFunction11;
        };
        return MaskManager11;
    }();
    var ExpressionPropertyInterface = function() {
        var defaultUnidimensionalValue11 = {
            pv: 0,
            v: 0,
            mult: 1
        };
        var defaultMultidimensionalValue11 = {
            pv: [
                0,
                0,
                0
            ],
            v: [
                0,
                0,
                0
            ],
            mult: 1
        };
        function completeProperty11(expressionValue11, property11, type11) {
            Object.defineProperty(expressionValue11, "velocity", {
                get: function get11() {
                    return property11.getVelocityAtTime(property11.comp.currentFrame);
                }
            });
            expressionValue11.numKeys = property11.keyframes ? property11.keyframes.length : 0;
            expressionValue11.key = function(pos11) {
                if (!expressionValue11.numKeys) return 0;
                var value31 = "";
                if ("s" in property11.keyframes[pos11 - 1]) value31 = property11.keyframes[pos11 - 1].s;
                else if ("e" in property11.keyframes[pos11 - 2]) value31 = property11.keyframes[pos11 - 2].e;
                else value31 = property11.keyframes[pos11 - 2].s;
                var valueProp11 = type11 === "unidimensional" ? new Number(value31) : Object.assign({}, value31); // eslint-disable-line no-new-wrappers
                valueProp11.time = property11.keyframes[pos11 - 1].t / property11.elem.comp.globalData.frameRate;
                valueProp11.value = type11 === "unidimensional" ? value31[0] : value31;
                return valueProp11;
            };
            expressionValue11.valueAtTime = property11.getValueAtTime;
            expressionValue11.speedAtTime = property11.getSpeedAtTime;
            expressionValue11.velocityAtTime = property11.getVelocityAtTime;
            expressionValue11.propertyGroup = property11.propertyGroup;
        }
        function UnidimensionalPropertyInterface11(property11) {
            if (!property11 || !("pv" in property11)) property11 = defaultUnidimensionalValue11;
            var mult11 = 1 / property11.mult;
            var val31 = property11.pv * mult11;
            var expressionValue11 = new Number(val31); // eslint-disable-line no-new-wrappers
            expressionValue11.value = val31;
            completeProperty11(expressionValue11, property11, "unidimensional");
            return function() {
                if (property11.k) property11.getValue();
                val31 = property11.v * mult11;
                if (expressionValue11.value !== val31) {
                    expressionValue11 = new Number(val31); // eslint-disable-line no-new-wrappers
                    expressionValue11.value = val31;
                    completeProperty11(expressionValue11, property11, "unidimensional");
                }
                return expressionValue11;
            };
        }
        function MultidimensionalPropertyInterface11(property11) {
            if (!property11 || !("pv" in property11)) property11 = defaultMultidimensionalValue11;
            var mult11 = 1 / property11.mult;
            var len11 = property11.data && property11.data.l || property11.pv.length;
            var expressionValue11 = createTypedArray("float32", len11);
            var arrValue11 = createTypedArray("float32", len11);
            expressionValue11.value = arrValue11;
            completeProperty11(expressionValue11, property11, "multidimensional");
            return function() {
                if (property11.k) property11.getValue();
                for(var i31 = 0; i31 < len11; i31 += 1){
                    arrValue11[i31] = property11.v[i31] * mult11;
                    expressionValue11[i31] = arrValue11[i31];
                }
                return expressionValue11;
            };
        } // TODO: try to avoid using this getter
        function defaultGetter11() {
            return defaultUnidimensionalValue11;
        }
        return function(property11) {
            if (!property11) return defaultGetter11;
            if (property11.propType === "unidimensional") return UnidimensionalPropertyInterface11(property11);
            return MultidimensionalPropertyInterface11(property11);
        };
    }();
    var TransformExpressionInterface = function() {
        return function(transform11) {
            function _thisFunction11(name11) {
                switch(name11){
                    case "scale":
                    case "Scale":
                    case "ADBE Scale":
                    case 6:
                        return _thisFunction11.scale;
                    case "rotation":
                    case "Rotation":
                    case "ADBE Rotation":
                    case "ADBE Rotate Z":
                    case 10:
                        return _thisFunction11.rotation;
                    case "ADBE Rotate X":
                        return _thisFunction11.xRotation;
                    case "ADBE Rotate Y":
                        return _thisFunction11.yRotation;
                    case "position":
                    case "Position":
                    case "ADBE Position":
                    case 2:
                        return _thisFunction11.position;
                    case "ADBE Position_0":
                        return _thisFunction11.xPosition;
                    case "ADBE Position_1":
                        return _thisFunction11.yPosition;
                    case "ADBE Position_2":
                        return _thisFunction11.zPosition;
                    case "anchorPoint":
                    case "AnchorPoint":
                    case "Anchor Point":
                    case "ADBE AnchorPoint":
                    case 1:
                        return _thisFunction11.anchorPoint;
                    case "opacity":
                    case "Opacity":
                    case 11:
                        return _thisFunction11.opacity;
                    default:
                        return null;
                }
            }
            Object.defineProperty(_thisFunction11, "rotation", {
                get: ExpressionPropertyInterface(transform11.r || transform11.rz)
            });
            Object.defineProperty(_thisFunction11, "zRotation", {
                get: ExpressionPropertyInterface(transform11.rz || transform11.r)
            });
            Object.defineProperty(_thisFunction11, "xRotation", {
                get: ExpressionPropertyInterface(transform11.rx)
            });
            Object.defineProperty(_thisFunction11, "yRotation", {
                get: ExpressionPropertyInterface(transform11.ry)
            });
            Object.defineProperty(_thisFunction11, "scale", {
                get: ExpressionPropertyInterface(transform11.s)
            });
            var _px11;
            var _py11;
            var _pz11;
            var _transformFactory11;
            if (transform11.p) _transformFactory11 = ExpressionPropertyInterface(transform11.p);
            else {
                _px11 = ExpressionPropertyInterface(transform11.px);
                _py11 = ExpressionPropertyInterface(transform11.py);
                if (transform11.pz) _pz11 = ExpressionPropertyInterface(transform11.pz);
            }
            Object.defineProperty(_thisFunction11, "position", {
                get: function get11() {
                    if (transform11.p) return _transformFactory11();
                    return [
                        _px11(),
                        _py11(),
                        _pz11 ? _pz11() : 0
                    ];
                }
            });
            Object.defineProperty(_thisFunction11, "xPosition", {
                get: ExpressionPropertyInterface(transform11.px)
            });
            Object.defineProperty(_thisFunction11, "yPosition", {
                get: ExpressionPropertyInterface(transform11.py)
            });
            Object.defineProperty(_thisFunction11, "zPosition", {
                get: ExpressionPropertyInterface(transform11.pz)
            });
            Object.defineProperty(_thisFunction11, "anchorPoint", {
                get: ExpressionPropertyInterface(transform11.a)
            });
            Object.defineProperty(_thisFunction11, "opacity", {
                get: ExpressionPropertyInterface(transform11.o)
            });
            Object.defineProperty(_thisFunction11, "skew", {
                get: ExpressionPropertyInterface(transform11.sk)
            });
            Object.defineProperty(_thisFunction11, "skewAxis", {
                get: ExpressionPropertyInterface(transform11.sa)
            });
            Object.defineProperty(_thisFunction11, "orientation", {
                get: ExpressionPropertyInterface(transform11.or)
            });
            return _thisFunction11;
        };
    }();
    var LayerExpressionInterface = function() {
        function getMatrix11(time11) {
            var toWorldMat11 = new Matrix();
            if (time11 !== undefined) {
                var propMatrix11 = this._elem.finalTransform.mProp.getValueAtTime(time11);
                propMatrix11.clone(toWorldMat11);
            } else {
                var transformMat11 = this._elem.finalTransform.mProp;
                transformMat11.applyToMatrix(toWorldMat11);
            }
            return toWorldMat11;
        }
        function toWorldVec11(arr31, time11) {
            var toWorldMat11 = this.getMatrix(time11);
            toWorldMat11.props[12] = 0;
            toWorldMat11.props[13] = 0;
            toWorldMat11.props[14] = 0;
            return this.applyPoint(toWorldMat11, arr31);
        }
        function toWorld11(arr31, time11) {
            var toWorldMat11 = this.getMatrix(time11);
            return this.applyPoint(toWorldMat11, arr31);
        }
        function fromWorldVec11(arr31, time11) {
            var toWorldMat11 = this.getMatrix(time11);
            toWorldMat11.props[12] = 0;
            toWorldMat11.props[13] = 0;
            toWorldMat11.props[14] = 0;
            return this.invertPoint(toWorldMat11, arr31);
        }
        function fromWorld11(arr31, time11) {
            var toWorldMat11 = this.getMatrix(time11);
            return this.invertPoint(toWorldMat11, arr31);
        }
        function applyPoint11(matrix11, arr31) {
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i31;
                var len11 = this._elem.hierarchy.length;
                for(i31 = 0; i31 < len11; i31 += 1)this._elem.hierarchy[i31].finalTransform.mProp.applyToMatrix(matrix11);
            }
            return matrix11.applyToPointArray(arr31[0], arr31[1], arr31[2] || 0);
        }
        function invertPoint11(matrix11, arr31) {
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i31;
                var len11 = this._elem.hierarchy.length;
                for(i31 = 0; i31 < len11; i31 += 1)this._elem.hierarchy[i31].finalTransform.mProp.applyToMatrix(matrix11);
            }
            return matrix11.inversePoint(arr31);
        }
        function fromComp11(arr31) {
            var toWorldMat11 = new Matrix();
            toWorldMat11.reset();
            this._elem.finalTransform.mProp.applyToMatrix(toWorldMat11);
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i31;
                var len11 = this._elem.hierarchy.length;
                for(i31 = 0; i31 < len11; i31 += 1)this._elem.hierarchy[i31].finalTransform.mProp.applyToMatrix(toWorldMat11);
                return toWorldMat11.inversePoint(arr31);
            }
            return toWorldMat11.inversePoint(arr31);
        }
        function sampleImage11() {
            return [
                1,
                1,
                1,
                1
            ];
        }
        return function(elem31) {
            var transformInterface11;
            function _registerMaskInterface11(maskManager11) {
                _thisLayerFunction11.mask = new MaskManagerInterface(maskManager11, elem31);
            }
            function _registerEffectsInterface11(effects11) {
                _thisLayerFunction11.effect = effects11;
            }
            function _thisLayerFunction11(name11) {
                switch(name11){
                    case "ADBE Root Vectors Group":
                    case "Contents":
                    case 2:
                        return _thisLayerFunction11.shapeInterface;
                    case 1:
                    case 6:
                    case "Transform":
                    case "transform":
                    case "ADBE Transform Group":
                        return transformInterface11;
                    case 4:
                    case "ADBE Effect Parade":
                    case "effects":
                    case "Effects":
                        return _thisLayerFunction11.effect;
                    case "ADBE Text Properties":
                        return _thisLayerFunction11.textInterface;
                    default:
                        return null;
                }
            }
            _thisLayerFunction11.getMatrix = getMatrix11;
            _thisLayerFunction11.invertPoint = invertPoint11;
            _thisLayerFunction11.applyPoint = applyPoint11;
            _thisLayerFunction11.toWorld = toWorld11;
            _thisLayerFunction11.toWorldVec = toWorldVec11;
            _thisLayerFunction11.fromWorld = fromWorld11;
            _thisLayerFunction11.fromWorldVec = fromWorldVec11;
            _thisLayerFunction11.toComp = toWorld11;
            _thisLayerFunction11.fromComp = fromComp11;
            _thisLayerFunction11.sampleImage = sampleImage11;
            _thisLayerFunction11.sourceRectAtTime = elem31.sourceRectAtTime.bind(elem31);
            _thisLayerFunction11._elem = elem31;
            transformInterface11 = TransformExpressionInterface(elem31.finalTransform.mProp);
            var anchorPointDescriptor11 = getDescriptor(transformInterface11, "anchorPoint");
            Object.defineProperties(_thisLayerFunction11, {
                hasParent: {
                    get: function get11() {
                        return elem31.hierarchy.length;
                    }
                },
                parent: {
                    get: function get11() {
                        return elem31.hierarchy[0].layerInterface;
                    }
                },
                rotation: getDescriptor(transformInterface11, "rotation"),
                scale: getDescriptor(transformInterface11, "scale"),
                position: getDescriptor(transformInterface11, "position"),
                opacity: getDescriptor(transformInterface11, "opacity"),
                anchorPoint: anchorPointDescriptor11,
                anchor_point: anchorPointDescriptor11,
                transform: {
                    get: function get11() {
                        return transformInterface11;
                    }
                },
                active: {
                    get: function get11() {
                        return elem31.isInRange;
                    }
                }
            });
            _thisLayerFunction11.startTime = elem31.data.st;
            _thisLayerFunction11.index = elem31.data.ind;
            _thisLayerFunction11.source = elem31.data.refId;
            _thisLayerFunction11.height = elem31.data.ty === 0 ? elem31.data.h : 100;
            _thisLayerFunction11.width = elem31.data.ty === 0 ? elem31.data.w : 100;
            _thisLayerFunction11.inPoint = elem31.data.ip / elem31.comp.globalData.frameRate;
            _thisLayerFunction11.outPoint = elem31.data.op / elem31.comp.globalData.frameRate;
            _thisLayerFunction11._name = elem31.data.nm;
            _thisLayerFunction11.registerMaskInterface = _registerMaskInterface11;
            _thisLayerFunction11.registerEffectsInterface = _registerEffectsInterface11;
            return _thisLayerFunction11;
        };
    }();
    var propertyGroupFactory = function() {
        return function(interfaceFunction11, parentPropertyGroup11) {
            return function(val31) {
                val31 = val31 === undefined ? 1 : val31;
                if (val31 <= 0) return interfaceFunction11;
                return parentPropertyGroup11(val31 - 1);
            };
        };
    }();
    var PropertyInterface = function() {
        return function(propertyName11, propertyGroup11) {
            var interfaceFunction11 = {
                _name: propertyName11
            };
            function _propertyGroup11(val31) {
                val31 = val31 === undefined ? 1 : val31;
                if (val31 <= 0) return interfaceFunction11;
                return propertyGroup11(val31 - 1);
            }
            return _propertyGroup11;
        };
    }();
    var EffectsExpressionInterface = function() {
        var ob11 = {
            createEffectsInterface: createEffectsInterface11
        };
        function createEffectsInterface11(elem31, propertyGroup11) {
            if (elem31.effectsManager) {
                var effectElements11 = [];
                var effectsData11 = elem31.data.ef;
                var i31;
                var len11 = elem31.effectsManager.effectElements.length;
                for(i31 = 0; i31 < len11; i31 += 1)effectElements11.push(createGroupInterface11(effectsData11[i31], elem31.effectsManager.effectElements[i31], propertyGroup11, elem31));
                var effects11 = elem31.data.ef || [];
                var groupInterface11 = function groupInterface11(name11) {
                    i31 = 0;
                    len11 = effects11.length;
                    while(i31 < len11){
                        if (name11 === effects11[i31].nm || name11 === effects11[i31].mn || name11 === effects11[i31].ix) return effectElements11[i31];
                        i31 += 1;
                    }
                    return null;
                };
                Object.defineProperty(groupInterface11, "numProperties", {
                    get: function get11() {
                        return effects11.length;
                    }
                });
                return groupInterface11;
            }
            return null;
        }
        function createGroupInterface11(data11, elements11, propertyGroup11, elem31) {
            function groupInterface11(name11) {
                var effects11 = data11.ef;
                var i31 = 0;
                var len11 = effects11.length;
                while(i31 < len11){
                    if (name11 === effects11[i31].nm || name11 === effects11[i31].mn || name11 === effects11[i31].ix) {
                        if (effects11[i31].ty === 5) return effectElements11[i31];
                        return effectElements11[i31]();
                    }
                    i31 += 1;
                }
                throw new Error();
            }
            var _propertyGroup11 = propertyGroupFactory(groupInterface11, propertyGroup11);
            var effectElements11 = [];
            var i31;
            var len11 = data11.ef.length;
            for(i31 = 0; i31 < len11; i31 += 1)if (data11.ef[i31].ty === 5) effectElements11.push(createGroupInterface11(data11.ef[i31], elements11.effectElements[i31], elements11.effectElements[i31].propertyGroup, elem31));
            else effectElements11.push(createValueInterface11(elements11.effectElements[i31], data11.ef[i31].ty, elem31, _propertyGroup11));
            if (data11.mn === "ADBE Color Control") Object.defineProperty(groupInterface11, "color", {
                get: function get11() {
                    return effectElements11[0]();
                }
            });
            Object.defineProperties(groupInterface11, {
                numProperties: {
                    get: function get11() {
                        return data11.np;
                    }
                },
                _name: {
                    value: data11.nm
                },
                propertyGroup: {
                    value: _propertyGroup11
                }
            });
            groupInterface11.enabled = data11.en !== 0;
            groupInterface11.active = groupInterface11.enabled;
            return groupInterface11;
        }
        function createValueInterface11(element11, type11, elem31, propertyGroup11) {
            var expressionProperty11 = ExpressionPropertyInterface(element11.p);
            function interfaceFunction11() {
                if (type11 === 10) return elem31.comp.compInterface(element11.p.v);
                return expressionProperty11();
            }
            if (element11.p.setGroupProperty) element11.p.setGroupProperty(PropertyInterface("", propertyGroup11));
            return interfaceFunction11;
        }
        return ob11;
    }();
    var ShapePathInterface = function() {
        return function pathInterfaceFactory11(shape31, view11, propertyGroup11) {
            var prop11 = view11.sh;
            function interfaceFunction11(val31) {
                if (val31 === "Shape" || val31 === "shape" || val31 === "Path" || val31 === "path" || val31 === "ADBE Vector Shape" || val31 === 2) return interfaceFunction11.path;
                return null;
            }
            var _propertyGroup11 = propertyGroupFactory(interfaceFunction11, propertyGroup11);
            prop11.setGroupProperty(PropertyInterface("Path", _propertyGroup11));
            Object.defineProperties(interfaceFunction11, {
                path: {
                    get: function get11() {
                        if (prop11.k) prop11.getValue();
                        return prop11;
                    }
                },
                shape: {
                    get: function get11() {
                        if (prop11.k) prop11.getValue();
                        return prop11;
                    }
                },
                _name: {
                    value: shape31.nm
                },
                ix: {
                    value: shape31.ix
                },
                propertyIndex: {
                    value: shape31.ix
                },
                mn: {
                    value: shape31.mn
                },
                propertyGroup: {
                    value: propertyGroup11
                }
            });
            return interfaceFunction11;
        };
    }();
    var ShapeExpressionInterface = function() {
        function iterateElements11(shapes11, view11, propertyGroup11) {
            var arr31 = [];
            var i31;
            var len11 = shapes11 ? shapes11.length : 0;
            for(i31 = 0; i31 < len11; i31 += 1){
                if (shapes11[i31].ty === "gr") arr31.push(groupInterfaceFactory11(shapes11[i31], view11[i31], propertyGroup11));
                else if (shapes11[i31].ty === "fl") arr31.push(fillInterfaceFactory11(shapes11[i31], view11[i31], propertyGroup11));
                else if (shapes11[i31].ty === "st") arr31.push(strokeInterfaceFactory11(shapes11[i31], view11[i31], propertyGroup11));
                else if (shapes11[i31].ty === "tm") arr31.push(trimInterfaceFactory11(shapes11[i31], view11[i31], propertyGroup11));
                else if (shapes11[i31].ty === "tr") ;
                else if (shapes11[i31].ty === "el") arr31.push(ellipseInterfaceFactory11(shapes11[i31], view11[i31], propertyGroup11));
                else if (shapes11[i31].ty === "sr") arr31.push(starInterfaceFactory11(shapes11[i31], view11[i31], propertyGroup11));
                else if (shapes11[i31].ty === "sh") arr31.push(ShapePathInterface(shapes11[i31], view11[i31], propertyGroup11));
                else if (shapes11[i31].ty === "rc") arr31.push(rectInterfaceFactory11(shapes11[i31], view11[i31], propertyGroup11));
                else if (shapes11[i31].ty === "rd") arr31.push(roundedInterfaceFactory11(shapes11[i31], view11[i31], propertyGroup11));
                else if (shapes11[i31].ty === "rp") arr31.push(repeaterInterfaceFactory11(shapes11[i31], view11[i31], propertyGroup11));
                else if (shapes11[i31].ty === "gf") arr31.push(gradientFillInterfaceFactory11(shapes11[i31], view11[i31], propertyGroup11));
                else arr31.push(defaultInterfaceFactory11(shapes11[i31], view11[i31], propertyGroup11));
            }
            return arr31;
        }
        function contentsInterfaceFactory11(shape31, view11, propertyGroup11) {
            var interfaces11;
            var interfaceFunction11 = function _interfaceFunction11(value31) {
                var i31 = 0;
                var len11 = interfaces11.length;
                while(i31 < len11){
                    if (interfaces11[i31]._name === value31 || interfaces11[i31].mn === value31 || interfaces11[i31].propertyIndex === value31 || interfaces11[i31].ix === value31 || interfaces11[i31].ind === value31) return interfaces11[i31];
                    i31 += 1;
                }
                if (typeof value31 === "number") return interfaces11[value31 - 1];
                return null;
            };
            interfaceFunction11.propertyGroup = propertyGroupFactory(interfaceFunction11, propertyGroup11);
            interfaces11 = iterateElements11(shape31.it, view11.it, interfaceFunction11.propertyGroup);
            interfaceFunction11.numProperties = interfaces11.length;
            var transformInterface11 = transformInterfaceFactory11(shape31.it[shape31.it.length - 1], view11.it[view11.it.length - 1], interfaceFunction11.propertyGroup);
            interfaceFunction11.transform = transformInterface11;
            interfaceFunction11.propertyIndex = shape31.cix;
            interfaceFunction11._name = shape31.nm;
            return interfaceFunction11;
        }
        function groupInterfaceFactory11(shape31, view11, propertyGroup11) {
            var interfaceFunction11 = function _interfaceFunction11(value31) {
                switch(value31){
                    case "ADBE Vectors Group":
                    case "Contents":
                    case 2:
                        return interfaceFunction11.content;
                    // Not necessary for now. Keeping them here in case a new case appears
                    // case 'ADBE Vector Transform Group':
                    // case 3:
                    default:
                        return interfaceFunction11.transform;
                }
            };
            interfaceFunction11.propertyGroup = propertyGroupFactory(interfaceFunction11, propertyGroup11);
            var content11 = contentsInterfaceFactory11(shape31, view11, interfaceFunction11.propertyGroup);
            var transformInterface11 = transformInterfaceFactory11(shape31.it[shape31.it.length - 1], view11.it[view11.it.length - 1], interfaceFunction11.propertyGroup);
            interfaceFunction11.content = content11;
            interfaceFunction11.transform = transformInterface11;
            Object.defineProperty(interfaceFunction11, "_name", {
                get: function get11() {
                    return shape31.nm;
                }
            }); // interfaceFunction.content = interfaceFunction;
            interfaceFunction11.numProperties = shape31.np;
            interfaceFunction11.propertyIndex = shape31.ix;
            interfaceFunction11.nm = shape31.nm;
            interfaceFunction11.mn = shape31.mn;
            return interfaceFunction11;
        }
        function fillInterfaceFactory11(shape31, view11, propertyGroup11) {
            function interfaceFunction11(val31) {
                if (val31 === "Color" || val31 === "color") return interfaceFunction11.color;
                if (val31 === "Opacity" || val31 === "opacity") return interfaceFunction11.opacity;
                return null;
            }
            Object.defineProperties(interfaceFunction11, {
                color: {
                    get: ExpressionPropertyInterface(view11.c)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view11.o)
                },
                _name: {
                    value: shape31.nm
                },
                mn: {
                    value: shape31.mn
                }
            });
            view11.c.setGroupProperty(PropertyInterface("Color", propertyGroup11));
            view11.o.setGroupProperty(PropertyInterface("Opacity", propertyGroup11));
            return interfaceFunction11;
        }
        function gradientFillInterfaceFactory11(shape31, view11, propertyGroup11) {
            function interfaceFunction11(val31) {
                if (val31 === "Start Point" || val31 === "start point") return interfaceFunction11.startPoint;
                if (val31 === "End Point" || val31 === "end point") return interfaceFunction11.endPoint;
                if (val31 === "Opacity" || val31 === "opacity") return interfaceFunction11.opacity;
                return null;
            }
            Object.defineProperties(interfaceFunction11, {
                startPoint: {
                    get: ExpressionPropertyInterface(view11.s)
                },
                endPoint: {
                    get: ExpressionPropertyInterface(view11.e)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view11.o)
                },
                type: {
                    get: function get11() {
                        return "a";
                    }
                },
                _name: {
                    value: shape31.nm
                },
                mn: {
                    value: shape31.mn
                }
            });
            view11.s.setGroupProperty(PropertyInterface("Start Point", propertyGroup11));
            view11.e.setGroupProperty(PropertyInterface("End Point", propertyGroup11));
            view11.o.setGroupProperty(PropertyInterface("Opacity", propertyGroup11));
            return interfaceFunction11;
        }
        function defaultInterfaceFactory11() {
            function interfaceFunction11() {
                return null;
            }
            return interfaceFunction11;
        }
        function strokeInterfaceFactory11(shape31, view11, propertyGroup11) {
            var _propertyGroup11 = propertyGroupFactory(interfaceFunction11, propertyGroup11);
            var _dashPropertyGroup11 = propertyGroupFactory(dashOb11, _propertyGroup11);
            function addPropertyToDashOb11(i31) {
                Object.defineProperty(dashOb11, shape31.d[i31].nm, {
                    get: ExpressionPropertyInterface(view11.d.dataProps[i31].p)
                });
            }
            var i31;
            var len11 = shape31.d ? shape31.d.length : 0;
            var dashOb11 = {};
            for(i31 = 0; i31 < len11; i31 += 1){
                addPropertyToDashOb11(i31);
                view11.d.dataProps[i31].p.setGroupProperty(_dashPropertyGroup11);
            }
            function interfaceFunction11(val31) {
                if (val31 === "Color" || val31 === "color") return interfaceFunction11.color;
                if (val31 === "Opacity" || val31 === "opacity") return interfaceFunction11.opacity;
                if (val31 === "Stroke Width" || val31 === "stroke width") return interfaceFunction11.strokeWidth;
                return null;
            }
            Object.defineProperties(interfaceFunction11, {
                color: {
                    get: ExpressionPropertyInterface(view11.c)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view11.o)
                },
                strokeWidth: {
                    get: ExpressionPropertyInterface(view11.w)
                },
                dash: {
                    get: function get11() {
                        return dashOb11;
                    }
                },
                _name: {
                    value: shape31.nm
                },
                mn: {
                    value: shape31.mn
                }
            });
            view11.c.setGroupProperty(PropertyInterface("Color", _propertyGroup11));
            view11.o.setGroupProperty(PropertyInterface("Opacity", _propertyGroup11));
            view11.w.setGroupProperty(PropertyInterface("Stroke Width", _propertyGroup11));
            return interfaceFunction11;
        }
        function trimInterfaceFactory11(shape31, view11, propertyGroup11) {
            function interfaceFunction11(val31) {
                if (val31 === shape31.e.ix || val31 === "End" || val31 === "end") return interfaceFunction11.end;
                if (val31 === shape31.s.ix) return interfaceFunction11.start;
                if (val31 === shape31.o.ix) return interfaceFunction11.offset;
                return null;
            }
            var _propertyGroup11 = propertyGroupFactory(interfaceFunction11, propertyGroup11);
            interfaceFunction11.propertyIndex = shape31.ix;
            view11.s.setGroupProperty(PropertyInterface("Start", _propertyGroup11));
            view11.e.setGroupProperty(PropertyInterface("End", _propertyGroup11));
            view11.o.setGroupProperty(PropertyInterface("Offset", _propertyGroup11));
            interfaceFunction11.propertyIndex = shape31.ix;
            interfaceFunction11.propertyGroup = propertyGroup11;
            Object.defineProperties(interfaceFunction11, {
                start: {
                    get: ExpressionPropertyInterface(view11.s)
                },
                end: {
                    get: ExpressionPropertyInterface(view11.e)
                },
                offset: {
                    get: ExpressionPropertyInterface(view11.o)
                },
                _name: {
                    value: shape31.nm
                }
            });
            interfaceFunction11.mn = shape31.mn;
            return interfaceFunction11;
        }
        function transformInterfaceFactory11(shape31, view11, propertyGroup11) {
            function interfaceFunction11(value31) {
                if (shape31.a.ix === value31 || value31 === "Anchor Point") return interfaceFunction11.anchorPoint;
                if (shape31.o.ix === value31 || value31 === "Opacity") return interfaceFunction11.opacity;
                if (shape31.p.ix === value31 || value31 === "Position") return interfaceFunction11.position;
                if (shape31.r.ix === value31 || value31 === "Rotation" || value31 === "ADBE Vector Rotation") return interfaceFunction11.rotation;
                if (shape31.s.ix === value31 || value31 === "Scale") return interfaceFunction11.scale;
                if (shape31.sk && shape31.sk.ix === value31 || value31 === "Skew") return interfaceFunction11.skew;
                if (shape31.sa && shape31.sa.ix === value31 || value31 === "Skew Axis") return interfaceFunction11.skewAxis;
                return null;
            }
            var _propertyGroup11 = propertyGroupFactory(interfaceFunction11, propertyGroup11);
            view11.transform.mProps.o.setGroupProperty(PropertyInterface("Opacity", _propertyGroup11));
            view11.transform.mProps.p.setGroupProperty(PropertyInterface("Position", _propertyGroup11));
            view11.transform.mProps.a.setGroupProperty(PropertyInterface("Anchor Point", _propertyGroup11));
            view11.transform.mProps.s.setGroupProperty(PropertyInterface("Scale", _propertyGroup11));
            view11.transform.mProps.r.setGroupProperty(PropertyInterface("Rotation", _propertyGroup11));
            if (view11.transform.mProps.sk) {
                view11.transform.mProps.sk.setGroupProperty(PropertyInterface("Skew", _propertyGroup11));
                view11.transform.mProps.sa.setGroupProperty(PropertyInterface("Skew Angle", _propertyGroup11));
            }
            view11.transform.op.setGroupProperty(PropertyInterface("Opacity", _propertyGroup11));
            Object.defineProperties(interfaceFunction11, {
                opacity: {
                    get: ExpressionPropertyInterface(view11.transform.mProps.o)
                },
                position: {
                    get: ExpressionPropertyInterface(view11.transform.mProps.p)
                },
                anchorPoint: {
                    get: ExpressionPropertyInterface(view11.transform.mProps.a)
                },
                scale: {
                    get: ExpressionPropertyInterface(view11.transform.mProps.s)
                },
                rotation: {
                    get: ExpressionPropertyInterface(view11.transform.mProps.r)
                },
                skew: {
                    get: ExpressionPropertyInterface(view11.transform.mProps.sk)
                },
                skewAxis: {
                    get: ExpressionPropertyInterface(view11.transform.mProps.sa)
                },
                _name: {
                    value: shape31.nm
                }
            });
            interfaceFunction11.ty = "tr";
            interfaceFunction11.mn = shape31.mn;
            interfaceFunction11.propertyGroup = propertyGroup11;
            return interfaceFunction11;
        }
        function ellipseInterfaceFactory11(shape31, view11, propertyGroup11) {
            function interfaceFunction11(value31) {
                if (shape31.p.ix === value31) return interfaceFunction11.position;
                if (shape31.s.ix === value31) return interfaceFunction11.size;
                return null;
            }
            var _propertyGroup11 = propertyGroupFactory(interfaceFunction11, propertyGroup11);
            interfaceFunction11.propertyIndex = shape31.ix;
            var prop11 = view11.sh.ty === "tm" ? view11.sh.prop : view11.sh;
            prop11.s.setGroupProperty(PropertyInterface("Size", _propertyGroup11));
            prop11.p.setGroupProperty(PropertyInterface("Position", _propertyGroup11));
            Object.defineProperties(interfaceFunction11, {
                size: {
                    get: ExpressionPropertyInterface(prop11.s)
                },
                position: {
                    get: ExpressionPropertyInterface(prop11.p)
                },
                _name: {
                    value: shape31.nm
                }
            });
            interfaceFunction11.mn = shape31.mn;
            return interfaceFunction11;
        }
        function starInterfaceFactory11(shape31, view11, propertyGroup11) {
            function interfaceFunction11(value31) {
                if (shape31.p.ix === value31) return interfaceFunction11.position;
                if (shape31.r.ix === value31) return interfaceFunction11.rotation;
                if (shape31.pt.ix === value31) return interfaceFunction11.points;
                if (shape31.or.ix === value31 || value31 === "ADBE Vector Star Outer Radius") return interfaceFunction11.outerRadius;
                if (shape31.os.ix === value31) return interfaceFunction11.outerRoundness;
                if (shape31.ir && (shape31.ir.ix === value31 || value31 === "ADBE Vector Star Inner Radius")) return interfaceFunction11.innerRadius;
                if (shape31.is && shape31.is.ix === value31) return interfaceFunction11.innerRoundness;
                return null;
            }
            var _propertyGroup11 = propertyGroupFactory(interfaceFunction11, propertyGroup11);
            var prop11 = view11.sh.ty === "tm" ? view11.sh.prop : view11.sh;
            interfaceFunction11.propertyIndex = shape31.ix;
            prop11.or.setGroupProperty(PropertyInterface("Outer Radius", _propertyGroup11));
            prop11.os.setGroupProperty(PropertyInterface("Outer Roundness", _propertyGroup11));
            prop11.pt.setGroupProperty(PropertyInterface("Points", _propertyGroup11));
            prop11.p.setGroupProperty(PropertyInterface("Position", _propertyGroup11));
            prop11.r.setGroupProperty(PropertyInterface("Rotation", _propertyGroup11));
            if (shape31.ir) {
                prop11.ir.setGroupProperty(PropertyInterface("Inner Radius", _propertyGroup11));
                prop11.is.setGroupProperty(PropertyInterface("Inner Roundness", _propertyGroup11));
            }
            Object.defineProperties(interfaceFunction11, {
                position: {
                    get: ExpressionPropertyInterface(prop11.p)
                },
                rotation: {
                    get: ExpressionPropertyInterface(prop11.r)
                },
                points: {
                    get: ExpressionPropertyInterface(prop11.pt)
                },
                outerRadius: {
                    get: ExpressionPropertyInterface(prop11.or)
                },
                outerRoundness: {
                    get: ExpressionPropertyInterface(prop11.os)
                },
                innerRadius: {
                    get: ExpressionPropertyInterface(prop11.ir)
                },
                innerRoundness: {
                    get: ExpressionPropertyInterface(prop11.is)
                },
                _name: {
                    value: shape31.nm
                }
            });
            interfaceFunction11.mn = shape31.mn;
            return interfaceFunction11;
        }
        function rectInterfaceFactory11(shape31, view11, propertyGroup11) {
            function interfaceFunction11(value31) {
                if (shape31.p.ix === value31) return interfaceFunction11.position;
                if (shape31.r.ix === value31) return interfaceFunction11.roundness;
                if (shape31.s.ix === value31 || value31 === "Size" || value31 === "ADBE Vector Rect Size") return interfaceFunction11.size;
                return null;
            }
            var _propertyGroup11 = propertyGroupFactory(interfaceFunction11, propertyGroup11);
            var prop11 = view11.sh.ty === "tm" ? view11.sh.prop : view11.sh;
            interfaceFunction11.propertyIndex = shape31.ix;
            prop11.p.setGroupProperty(PropertyInterface("Position", _propertyGroup11));
            prop11.s.setGroupProperty(PropertyInterface("Size", _propertyGroup11));
            prop11.r.setGroupProperty(PropertyInterface("Rotation", _propertyGroup11));
            Object.defineProperties(interfaceFunction11, {
                position: {
                    get: ExpressionPropertyInterface(prop11.p)
                },
                roundness: {
                    get: ExpressionPropertyInterface(prop11.r)
                },
                size: {
                    get: ExpressionPropertyInterface(prop11.s)
                },
                _name: {
                    value: shape31.nm
                }
            });
            interfaceFunction11.mn = shape31.mn;
            return interfaceFunction11;
        }
        function roundedInterfaceFactory11(shape31, view11, propertyGroup11) {
            function interfaceFunction11(value31) {
                if (shape31.r.ix === value31 || value31 === "Round Corners 1") return interfaceFunction11.radius;
                return null;
            }
            var _propertyGroup11 = propertyGroupFactory(interfaceFunction11, propertyGroup11);
            var prop11 = view11;
            interfaceFunction11.propertyIndex = shape31.ix;
            prop11.rd.setGroupProperty(PropertyInterface("Radius", _propertyGroup11));
            Object.defineProperties(interfaceFunction11, {
                radius: {
                    get: ExpressionPropertyInterface(prop11.rd)
                },
                _name: {
                    value: shape31.nm
                }
            });
            interfaceFunction11.mn = shape31.mn;
            return interfaceFunction11;
        }
        function repeaterInterfaceFactory11(shape31, view11, propertyGroup11) {
            function interfaceFunction11(value31) {
                if (shape31.c.ix === value31 || value31 === "Copies") return interfaceFunction11.copies;
                if (shape31.o.ix === value31 || value31 === "Offset") return interfaceFunction11.offset;
                return null;
            }
            var _propertyGroup11 = propertyGroupFactory(interfaceFunction11, propertyGroup11);
            var prop11 = view11;
            interfaceFunction11.propertyIndex = shape31.ix;
            prop11.c.setGroupProperty(PropertyInterface("Copies", _propertyGroup11));
            prop11.o.setGroupProperty(PropertyInterface("Offset", _propertyGroup11));
            Object.defineProperties(interfaceFunction11, {
                copies: {
                    get: ExpressionPropertyInterface(prop11.c)
                },
                offset: {
                    get: ExpressionPropertyInterface(prop11.o)
                },
                _name: {
                    value: shape31.nm
                }
            });
            interfaceFunction11.mn = shape31.mn;
            return interfaceFunction11;
        }
        return function(shapes11, view11, propertyGroup11) {
            var interfaces11;
            function _interfaceFunction11(value31) {
                if (typeof value31 === "number") {
                    value31 = value31 === undefined ? 1 : value31;
                    if (value31 === 0) return propertyGroup11;
                    return interfaces11[value31 - 1];
                }
                var i31 = 0;
                var len11 = interfaces11.length;
                while(i31 < len11){
                    if (interfaces11[i31]._name === value31) return interfaces11[i31];
                    i31 += 1;
                }
                return null;
            }
            function parentGroupWrapper11() {
                return propertyGroup11;
            }
            _interfaceFunction11.propertyGroup = propertyGroupFactory(_interfaceFunction11, parentGroupWrapper11);
            interfaces11 = iterateElements11(shapes11, view11, _interfaceFunction11.propertyGroup);
            _interfaceFunction11.numProperties = interfaces11.length;
            _interfaceFunction11._name = "Contents";
            return _interfaceFunction11;
        };
    }();
    var TextExpressionInterface = function() {
        return function(elem31) {
            var _sourceText11;
            function _thisLayerFunction11(name11) {
                switch(name11){
                    case "ADBE Text Document":
                        return _thisLayerFunction11.sourceText;
                    default:
                        return null;
                }
            }
            Object.defineProperty(_thisLayerFunction11, "sourceText", {
                get: function get11() {
                    elem31.textProperty.getValue();
                    var stringValue11 = elem31.textProperty.currentData.t;
                    if (!_sourceText11 || stringValue11 !== _sourceText11.value) {
                        _sourceText11 = new String(stringValue11); // eslint-disable-line no-new-wrappers
                        // If stringValue is an empty string, eval returns undefined, so it has to be returned as a String primitive
                        _sourceText11.value = stringValue11 || new String(stringValue11); // eslint-disable-line no-new-wrappers
                        Object.defineProperty(_sourceText11, "style", {
                            get: function get11() {
                                return {
                                    fillColor: elem31.textProperty.currentData.fc
                                };
                            }
                        });
                    }
                    return _sourceText11;
                }
            });
            return _thisLayerFunction11;
        };
    }();
    function _typeof(obj11) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof11(obj11) {
            return typeof obj11;
        };
        else _typeof = function _typeof11(obj11) {
            return obj11 && typeof Symbol === "function" && obj11.constructor === Symbol && obj11 !== Symbol.prototype ? "symbol" : typeof obj11;
        };
        return _typeof(obj11);
    }
    var FootageInterface = function() {
        var outlineInterfaceFactory11 = function outlineInterfaceFactory11(elem31) {
            var currentPropertyName11 = "";
            var currentProperty11 = elem31.getFootageData();
            function init11() {
                currentPropertyName11 = "";
                currentProperty11 = elem31.getFootageData();
                return searchProperty11;
            }
            function searchProperty11(value31) {
                if (currentProperty11[value31]) {
                    currentPropertyName11 = value31;
                    currentProperty11 = currentProperty11[value31];
                    if (_typeof(currentProperty11) === "object") return searchProperty11;
                    return currentProperty11;
                }
                var propertyNameIndex11 = value31.indexOf(currentPropertyName11);
                if (propertyNameIndex11 !== -1) {
                    var index11 = parseInt(value31.substr(propertyNameIndex11 + currentPropertyName11.length), 10);
                    currentProperty11 = currentProperty11[index11];
                    if (_typeof(currentProperty11) === "object") return searchProperty11;
                    return currentProperty11;
                }
                return "";
            }
            return init11;
        };
        var dataInterfaceFactory11 = function dataInterfaceFactory11(elem31) {
            function interfaceFunction11(value31) {
                if (value31 === "Outline") return interfaceFunction11.outlineInterface();
                return null;
            }
            interfaceFunction11._name = "Outline";
            interfaceFunction11.outlineInterface = outlineInterfaceFactory11(elem31);
            return interfaceFunction11;
        };
        return function(elem31) {
            function _interfaceFunction11(value31) {
                if (value31 === "Data") return _interfaceFunction11.dataInterface;
                return null;
            }
            _interfaceFunction11._name = "Data";
            _interfaceFunction11.dataInterface = dataInterfaceFactory11(elem31);
            return _interfaceFunction11;
        };
    }();
    var interfaces = {
        layer: LayerExpressionInterface,
        effects: EffectsExpressionInterface,
        comp: CompExpressionInterface,
        shape: ShapeExpressionInterface,
        text: TextExpressionInterface,
        footage: FootageInterface
    };
    function getInterface(type11) {
        return interfaces[type11] || null;
    }
    var expressionHelpers = function() {
        function searchExpressions11(elem31, data11, prop11) {
            if (data11.x) {
                prop11.k = true;
                prop11.x = true;
                prop11.initiateExpression = ExpressionManager.initiateExpression;
                prop11.effectsSequence.push(prop11.initiateExpression(elem31, data11, prop11).bind(prop11));
            }
        }
        function getValueAtTime11(frameNum11) {
            frameNum11 *= this.elem.globalData.frameRate;
            frameNum11 -= this.offsetTime;
            if (frameNum11 !== this._cachingAtTime.lastFrame) {
                this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < frameNum11 ? this._cachingAtTime.lastIndex : 0;
                this._cachingAtTime.value = this.interpolateValue(frameNum11, this._cachingAtTime);
                this._cachingAtTime.lastFrame = frameNum11;
            }
            return this._cachingAtTime.value;
        }
        function getSpeedAtTime11(frameNum11) {
            var delta11 = -0.01;
            var v111 = this.getValueAtTime(frameNum11);
            var v211 = this.getValueAtTime(frameNum11 + delta11);
            var speed11 = 0;
            if (v111.length) {
                var i31;
                for(i31 = 0; i31 < v111.length; i31 += 1)speed11 += Math.pow(v211[i31] - v111[i31], 2);
                speed11 = Math.sqrt(speed11) * 100;
            } else speed11 = 0;
            return speed11;
        }
        function getVelocityAtTime11(frameNum11) {
            if (this.vel !== undefined) return this.vel;
            var delta11 = -0.001; // frameNum += this.elem.data.st;
            var v111 = this.getValueAtTime(frameNum11);
            var v211 = this.getValueAtTime(frameNum11 + delta11);
            var velocity11;
            if (v111.length) {
                velocity11 = createTypedArray("float32", v111.length);
                var i31;
                for(i31 = 0; i31 < v111.length; i31 += 1)// removing frameRate
                // if needed, don't add it here
                // velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
                velocity11[i31] = (v211[i31] - v111[i31]) / delta11;
            } else velocity11 = (v211 - v111) / delta11;
            return velocity11;
        }
        function getStaticValueAtTime11() {
            return this.pv;
        }
        function setGroupProperty11(propertyGroup11) {
            this.propertyGroup = propertyGroup11;
        }
        return {
            searchExpressions: searchExpressions11,
            getSpeedAtTime: getSpeedAtTime11,
            getVelocityAtTime: getVelocityAtTime11,
            getValueAtTime: getValueAtTime11,
            getStaticValueAtTime: getStaticValueAtTime11,
            setGroupProperty: setGroupProperty11
        };
    }();
    function addPropertyDecorator() {
        function loopOut11(type11, duration11, durationFlag11) {
            if (!this.k || !this.keyframes) return this.pv;
            type11 = type11 ? type11.toLowerCase() : "";
            var currentFrame11 = this.comp.renderedFrame;
            var keyframes11 = this.keyframes;
            var lastKeyFrame11 = keyframes11[keyframes11.length - 1].t;
            if (currentFrame11 <= lastKeyFrame11) return this.pv;
            var cycleDuration11;
            var firstKeyFrame11;
            if (!durationFlag11) {
                if (!duration11 || duration11 > keyframes11.length - 1) duration11 = keyframes11.length - 1;
                firstKeyFrame11 = keyframes11[keyframes11.length - 1 - duration11].t;
                cycleDuration11 = lastKeyFrame11 - firstKeyFrame11;
            } else {
                if (!duration11) cycleDuration11 = Math.max(0, lastKeyFrame11 - this.elem.data.ip);
                else cycleDuration11 = Math.abs(lastKeyFrame11 - this.elem.comp.globalData.frameRate * duration11);
                firstKeyFrame11 = lastKeyFrame11 - cycleDuration11;
            }
            var i31;
            var len11;
            var ret11;
            if (type11 === "pingpong") {
                var iterations11 = Math.floor((currentFrame11 - firstKeyFrame11) / cycleDuration11);
                if (iterations11 % 2 !== 0) return this.getValueAtTime((cycleDuration11 - (currentFrame11 - firstKeyFrame11) % cycleDuration11 + firstKeyFrame11) / this.comp.globalData.frameRate, 0); // eslint-disable-line
            } else if (type11 === "offset") {
                var initV11 = this.getValueAtTime(firstKeyFrame11 / this.comp.globalData.frameRate, 0);
                var endV11 = this.getValueAtTime(lastKeyFrame11 / this.comp.globalData.frameRate, 0);
                var current11 = this.getValueAtTime(((currentFrame11 - firstKeyFrame11) % cycleDuration11 + firstKeyFrame11) / this.comp.globalData.frameRate, 0); // eslint-disable-line
                var repeats11 = Math.floor((currentFrame11 - firstKeyFrame11) / cycleDuration11);
                if (this.pv.length) {
                    ret11 = new Array(initV11.length);
                    len11 = ret11.length;
                    for(i31 = 0; i31 < len11; i31 += 1)ret11[i31] = (endV11[i31] - initV11[i31]) * repeats11 + current11[i31];
                    return ret11;
                }
                return (endV11 - initV11) * repeats11 + current11;
            } else if (type11 === "continue") {
                var lastValue11 = this.getValueAtTime(lastKeyFrame11 / this.comp.globalData.frameRate, 0);
                var nextLastValue11 = this.getValueAtTime((lastKeyFrame11 - 0.001) / this.comp.globalData.frameRate, 0);
                if (this.pv.length) {
                    ret11 = new Array(lastValue11.length);
                    len11 = ret11.length;
                    for(i31 = 0; i31 < len11; i31 += 1)ret11[i31] = lastValue11[i31] + (lastValue11[i31] - nextLastValue11[i31]) * ((currentFrame11 - lastKeyFrame11) / this.comp.globalData.frameRate) / 0.0005; // eslint-disable-line
                    return ret11;
                }
                return lastValue11 + (lastValue11 - nextLastValue11) * ((currentFrame11 - lastKeyFrame11) / 0.001);
            }
            return this.getValueAtTime(((currentFrame11 - firstKeyFrame11) % cycleDuration11 + firstKeyFrame11) / this.comp.globalData.frameRate, 0); // eslint-disable-line
        }
        function loopIn11(type11, duration11, durationFlag11) {
            if (!this.k) return this.pv;
            type11 = type11 ? type11.toLowerCase() : "";
            var currentFrame11 = this.comp.renderedFrame;
            var keyframes11 = this.keyframes;
            var firstKeyFrame11 = keyframes11[0].t;
            if (currentFrame11 >= firstKeyFrame11) return this.pv;
            var cycleDuration11;
            var lastKeyFrame11;
            if (!durationFlag11) {
                if (!duration11 || duration11 > keyframes11.length - 1) duration11 = keyframes11.length - 1;
                lastKeyFrame11 = keyframes11[duration11].t;
                cycleDuration11 = lastKeyFrame11 - firstKeyFrame11;
            } else {
                if (!duration11) cycleDuration11 = Math.max(0, this.elem.data.op - firstKeyFrame11);
                else cycleDuration11 = Math.abs(this.elem.comp.globalData.frameRate * duration11);
                lastKeyFrame11 = firstKeyFrame11 + cycleDuration11;
            }
            var i31;
            var len11;
            var ret11;
            if (type11 === "pingpong") {
                var iterations11 = Math.floor((firstKeyFrame11 - currentFrame11) / cycleDuration11);
                if (iterations11 % 2 === 0) return this.getValueAtTime(((firstKeyFrame11 - currentFrame11) % cycleDuration11 + firstKeyFrame11) / this.comp.globalData.frameRate, 0); // eslint-disable-line
            } else if (type11 === "offset") {
                var initV11 = this.getValueAtTime(firstKeyFrame11 / this.comp.globalData.frameRate, 0);
                var endV11 = this.getValueAtTime(lastKeyFrame11 / this.comp.globalData.frameRate, 0);
                var current11 = this.getValueAtTime((cycleDuration11 - (firstKeyFrame11 - currentFrame11) % cycleDuration11 + firstKeyFrame11) / this.comp.globalData.frameRate, 0);
                var repeats11 = Math.floor((firstKeyFrame11 - currentFrame11) / cycleDuration11) + 1;
                if (this.pv.length) {
                    ret11 = new Array(initV11.length);
                    len11 = ret11.length;
                    for(i31 = 0; i31 < len11; i31 += 1)ret11[i31] = current11[i31] - (endV11[i31] - initV11[i31]) * repeats11;
                    return ret11;
                }
                return current11 - (endV11 - initV11) * repeats11;
            } else if (type11 === "continue") {
                var firstValue11 = this.getValueAtTime(firstKeyFrame11 / this.comp.globalData.frameRate, 0);
                var nextFirstValue11 = this.getValueAtTime((firstKeyFrame11 + 0.001) / this.comp.globalData.frameRate, 0);
                if (this.pv.length) {
                    ret11 = new Array(firstValue11.length);
                    len11 = ret11.length;
                    for(i31 = 0; i31 < len11; i31 += 1)ret11[i31] = firstValue11[i31] + (firstValue11[i31] - nextFirstValue11[i31]) * (firstKeyFrame11 - currentFrame11) / 0.001;
                    return ret11;
                }
                return firstValue11 + (firstValue11 - nextFirstValue11) * (firstKeyFrame11 - currentFrame11) / 0.001;
            }
            return this.getValueAtTime((cycleDuration11 - ((firstKeyFrame11 - currentFrame11) % cycleDuration11 + firstKeyFrame11)) / this.comp.globalData.frameRate, 0); // eslint-disable-line
        }
        function smooth11(width11, samples11) {
            if (!this.k) return this.pv;
            width11 = (width11 || 0.4) * 0.5;
            samples11 = Math.floor(samples11 || 5);
            if (samples11 <= 1) return this.pv;
            var currentTime11 = this.comp.renderedFrame / this.comp.globalData.frameRate;
            var initFrame11 = currentTime11 - width11;
            var endFrame11 = currentTime11 + width11;
            var sampleFrequency11 = samples11 > 1 ? (endFrame11 - initFrame11) / (samples11 - 1) : 1;
            var i31 = 0;
            var j31 = 0;
            var value31;
            if (this.pv.length) value31 = createTypedArray("float32", this.pv.length);
            else value31 = 0;
            var sampleValue11;
            while(i31 < samples11){
                sampleValue11 = this.getValueAtTime(initFrame11 + i31 * sampleFrequency11);
                if (this.pv.length) for(j31 = 0; j31 < this.pv.length; j31 += 1)value31[j31] += sampleValue11[j31];
                else value31 += sampleValue11;
                i31 += 1;
            }
            if (this.pv.length) for(j31 = 0; j31 < this.pv.length; j31 += 1)value31[j31] /= samples11;
            else value31 /= samples11;
            return value31;
        }
        function getTransformValueAtTime11(time11) {
            if (!this._transformCachingAtTime) this._transformCachingAtTime = {
                v: new Matrix()
            };
             /// /
            var matrix11 = this._transformCachingAtTime.v;
            matrix11.cloneFromProps(this.pre.props);
            if (this.appliedTransformations < 1) {
                var anchor11 = this.a.getValueAtTime(time11);
                matrix11.translate(-anchor11[0] * this.a.mult, -anchor11[1] * this.a.mult, anchor11[2] * this.a.mult);
            }
            if (this.appliedTransformations < 2) {
                var scale21 = this.s.getValueAtTime(time11);
                matrix11.scale(scale21[0] * this.s.mult, scale21[1] * this.s.mult, scale21[2] * this.s.mult);
            }
            if (this.sk && this.appliedTransformations < 3) {
                var skew11 = this.sk.getValueAtTime(time11);
                var skewAxis11 = this.sa.getValueAtTime(time11);
                matrix11.skewFromAxis(-skew11 * this.sk.mult, skewAxis11 * this.sa.mult);
            }
            if (this.r && this.appliedTransformations < 4) {
                var rotation11 = this.r.getValueAtTime(time11);
                matrix11.rotate(-rotation11 * this.r.mult);
            } else if (!this.r && this.appliedTransformations < 4) {
                var rotationZ11 = this.rz.getValueAtTime(time11);
                var rotationY11 = this.ry.getValueAtTime(time11);
                var rotationX11 = this.rx.getValueAtTime(time11);
                var orientation11 = this.or.getValueAtTime(time11);
                matrix11.rotateZ(-rotationZ11 * this.rz.mult).rotateY(rotationY11 * this.ry.mult).rotateX(rotationX11 * this.rx.mult).rotateZ(-orientation11[2] * this.or.mult).rotateY(orientation11[1] * this.or.mult).rotateX(orientation11[0] * this.or.mult);
            }
            if (this.data.p && this.data.p.s) {
                var positionX11 = this.px.getValueAtTime(time11);
                var positionY11 = this.py.getValueAtTime(time11);
                if (this.data.p.z) {
                    var positionZ11 = this.pz.getValueAtTime(time11);
                    matrix11.translate(positionX11 * this.px.mult, positionY11 * this.py.mult, -positionZ11 * this.pz.mult);
                } else matrix11.translate(positionX11 * this.px.mult, positionY11 * this.py.mult, 0);
            } else {
                var position11 = this.p.getValueAtTime(time11);
                matrix11.translate(position11[0] * this.p.mult, position11[1] * this.p.mult, -position11[2] * this.p.mult);
            }
            return matrix11; /// /
        }
        function getTransformStaticValueAtTime11() {
            return this.v.clone(new Matrix());
        }
        var getTransformProperty11 = TransformPropertyFactory.getTransformProperty;
        TransformPropertyFactory.getTransformProperty = function(elem31, data11, container11) {
            var prop11 = getTransformProperty11(elem31, data11, container11);
            if (prop11.dynamicProperties.length) prop11.getValueAtTime = getTransformValueAtTime11.bind(prop11);
            else prop11.getValueAtTime = getTransformStaticValueAtTime11.bind(prop11);
            prop11.setGroupProperty = expressionHelpers.setGroupProperty;
            return prop11;
        };
        var propertyGetProp11 = PropertyFactory.getProp;
        PropertyFactory.getProp = function(elem31, data11, type11, mult11, container11) {
            var prop11 = propertyGetProp11(elem31, data11, type11, mult11, container11); // prop.getVelocityAtTime = getVelocityAtTime;
            // prop.loopOut = loopOut;
            // prop.loopIn = loopIn;
            if (prop11.kf) prop11.getValueAtTime = expressionHelpers.getValueAtTime.bind(prop11);
            else prop11.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(prop11);
            prop11.setGroupProperty = expressionHelpers.setGroupProperty;
            prop11.loopOut = loopOut11;
            prop11.loopIn = loopIn11;
            prop11.smooth = smooth11;
            prop11.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(prop11);
            prop11.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(prop11);
            prop11.numKeys = data11.a === 1 ? data11.k.length : 0;
            prop11.propertyIndex = data11.ix;
            var value31 = 0;
            if (type11 !== 0) value31 = createTypedArray("float32", data11.a === 1 ? data11.k[0].s.length : data11.k.length);
            prop11._cachingAtTime = {
                lastFrame: initialDefaultFrame,
                lastIndex: 0,
                value: value31
            };
            expressionHelpers.searchExpressions(elem31, data11, prop11);
            if (prop11.k) container11.addDynamicProperty(prop11);
            return prop11;
        };
        function getShapeValueAtTime11(frameNum11) {
            // For now this caching object is created only when needed instead of creating it when the shape is initialized.
            if (!this._cachingAtTime) this._cachingAtTime = {
                shapeValue: shapePool.clone(this.pv),
                lastIndex: 0,
                lastTime: initialDefaultFrame
            };
            frameNum11 *= this.elem.globalData.frameRate;
            frameNum11 -= this.offsetTime;
            if (frameNum11 !== this._cachingAtTime.lastTime) {
                this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < frameNum11 ? this._caching.lastIndex : 0;
                this._cachingAtTime.lastTime = frameNum11;
                this.interpolateShape(frameNum11, this._cachingAtTime.shapeValue, this._cachingAtTime);
            }
            return this._cachingAtTime.shapeValue;
        }
        var ShapePropertyConstructorFunction11 = ShapePropertyFactory.getConstructorFunction();
        var KeyframedShapePropertyConstructorFunction11 = ShapePropertyFactory.getKeyframedConstructorFunction();
        function ShapeExpressions11() {}
        ShapeExpressions11.prototype = {
            vertices: function vertices11(prop11, time11) {
                if (this.k) this.getValue();
                var shapePath11 = this.v;
                if (time11 !== undefined) shapePath11 = this.getValueAtTime(time11, 0);
                var i31;
                var len11 = shapePath11._length;
                var vertices11 = shapePath11[prop11];
                var points11 = shapePath11.v;
                var arr31 = createSizedArray(len11);
                for(i31 = 0; i31 < len11; i31 += 1)if (prop11 === "i" || prop11 === "o") arr31[i31] = [
                    vertices11[i31][0] - points11[i31][0],
                    vertices11[i31][1] - points11[i31][1]
                ];
                else arr31[i31] = [
                    vertices11[i31][0],
                    vertices11[i31][1]
                ];
                return arr31;
            },
            points: function points11(time11) {
                return this.vertices("v", time11);
            },
            inTangents: function inTangents11(time11) {
                return this.vertices("i", time11);
            },
            outTangents: function outTangents11(time11) {
                return this.vertices("o", time11);
            },
            isClosed: function isClosed11() {
                return this.v.c;
            },
            pointOnPath: function pointOnPath11(perc11, time11) {
                var shapePath11 = this.v;
                if (time11 !== undefined) shapePath11 = this.getValueAtTime(time11, 0);
                if (!this._segmentsLength) this._segmentsLength = bez.getSegmentsLength(shapePath11);
                var segmentsLength11 = this._segmentsLength;
                var lengths11 = segmentsLength11.lengths;
                var lengthPos11 = segmentsLength11.totalLength * perc11;
                var i31 = 0;
                var len11 = lengths11.length;
                var accumulatedLength11 = 0;
                var pt51;
                while(i31 < len11){
                    if (accumulatedLength11 + lengths11[i31].addedLength > lengthPos11) {
                        var initIndex11 = i31;
                        var endIndex11 = shapePath11.c && i31 === len11 - 1 ? 0 : i31 + 1;
                        var segmentPerc11 = (lengthPos11 - accumulatedLength11) / lengths11[i31].addedLength;
                        pt51 = bez.getPointInSegment(shapePath11.v[initIndex11], shapePath11.v[endIndex11], shapePath11.o[initIndex11], shapePath11.i[endIndex11], segmentPerc11, lengths11[i31]);
                        break;
                    } else accumulatedLength11 += lengths11[i31].addedLength;
                    i31 += 1;
                }
                if (!pt51) pt51 = shapePath11.c ? [
                    shapePath11.v[0][0],
                    shapePath11.v[0][1]
                ] : [
                    shapePath11.v[shapePath11._length - 1][0],
                    shapePath11.v[shapePath11._length - 1][1]
                ];
                return pt51;
            },
            vectorOnPath: function vectorOnPath11(perc11, time11, vectorType11) {
                // perc doesn't use triple equality because it can be a Number object as well as a primitive.
                if (perc11 == 1) // eslint-disable-line eqeqeq
                perc11 = this.v.c;
                else if (perc11 == 0) // eslint-disable-line eqeqeq
                perc11 = 0.999;
                var pt111 = this.pointOnPath(perc11, time11);
                var pt211 = this.pointOnPath(perc11 + 0.001, time11);
                var xLength11 = pt211[0] - pt111[0];
                var yLength11 = pt211[1] - pt111[1];
                var magnitude11 = Math.sqrt(Math.pow(xLength11, 2) + Math.pow(yLength11, 2));
                if (magnitude11 === 0) return [
                    0,
                    0
                ];
                var unitVector11 = vectorType11 === "tangent" ? [
                    xLength11 / magnitude11,
                    yLength11 / magnitude11
                ] : [
                    -yLength11 / magnitude11,
                    xLength11 / magnitude11
                ];
                return unitVector11;
            },
            tangentOnPath: function tangentOnPath11(perc11, time11) {
                return this.vectorOnPath(perc11, time11, "tangent");
            },
            normalOnPath: function normalOnPath11(perc11, time11) {
                return this.vectorOnPath(perc11, time11, "normal");
            },
            setGroupProperty: expressionHelpers.setGroupProperty,
            getValueAtTime: expressionHelpers.getStaticValueAtTime
        };
        extendPrototype([
            ShapeExpressions11
        ], ShapePropertyConstructorFunction11);
        extendPrototype([
            ShapeExpressions11
        ], KeyframedShapePropertyConstructorFunction11);
        KeyframedShapePropertyConstructorFunction11.prototype.getValueAtTime = getShapeValueAtTime11;
        KeyframedShapePropertyConstructorFunction11.prototype.initiateExpression = ExpressionManager.initiateExpression;
        var propertyGetShapeProp11 = ShapePropertyFactory.getShapeProp;
        ShapePropertyFactory.getShapeProp = function(elem31, data11, type11, arr31, trims11) {
            var prop11 = propertyGetShapeProp11(elem31, data11, type11, arr31, trims11);
            prop11.propertyIndex = data11.ix;
            prop11.lock = false;
            if (type11 === 3) expressionHelpers.searchExpressions(elem31, data11.pt, prop11);
            else if (type11 === 4) expressionHelpers.searchExpressions(elem31, data11.ks, prop11);
            if (prop11.k) elem31.addDynamicProperty(prop11);
            return prop11;
        };
    }
    function initialize$1() {
        addPropertyDecorator();
    }
    function addDecorator() {
        function searchExpressions11() {
            if (this.data.d.x) {
                this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this);
                this.addEffect(this.getExpressionValue.bind(this));
                return true;
            }
            return null;
        }
        TextProperty.prototype.getExpressionValue = function(currentValue11, text11) {
            var newValue11 = this.calculateExpression(text11);
            if (currentValue11.t !== newValue11) {
                var newData11 = {};
                this.copyData(newData11, currentValue11);
                newData11.t = newValue11.toString();
                newData11.__complete = false;
                return newData11;
            }
            return currentValue11;
        };
        TextProperty.prototype.searchProperty = function() {
            var isKeyframed11 = this.searchKeyframes();
            var hasExpressions11 = this.searchExpressions();
            this.kf = isKeyframed11 || hasExpressions11;
            return this.kf;
        };
        TextProperty.prototype.searchExpressions = searchExpressions11;
    }
    function initialize() {
        addDecorator();
    }
    function SVGComposableEffect() {}
    SVGComposableEffect.prototype = {
        createMergeNode: function createMergeNode11(resultId11, ins11) {
            var feMerge11 = createNS("feMerge");
            feMerge11.setAttribute("result", resultId11);
            var feMergeNode11;
            var i31;
            for(i31 = 0; i31 < ins11.length; i31 += 1){
                feMergeNode11 = createNS("feMergeNode");
                feMergeNode11.setAttribute("in", ins11[i31]);
                feMerge11.appendChild(feMergeNode11);
                feMerge11.appendChild(feMergeNode11);
            }
            return feMerge11;
        }
    };
    var linearFilterValue = "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0";
    function SVGTintFilter(filter11, filterManager11, elem31, id11, source11) {
        this.filterManager = filterManager11;
        var feColorMatrix11 = createNS("feColorMatrix");
        feColorMatrix11.setAttribute("type", "matrix");
        feColorMatrix11.setAttribute("color-interpolation-filters", "linearRGB");
        feColorMatrix11.setAttribute("values", linearFilterValue + " 1 0");
        this.linearFilter = feColorMatrix11;
        feColorMatrix11.setAttribute("result", id11 + "_tint_1");
        filter11.appendChild(feColorMatrix11);
        feColorMatrix11 = createNS("feColorMatrix");
        feColorMatrix11.setAttribute("type", "matrix");
        feColorMatrix11.setAttribute("color-interpolation-filters", "sRGB");
        feColorMatrix11.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0");
        feColorMatrix11.setAttribute("result", id11 + "_tint_2");
        filter11.appendChild(feColorMatrix11);
        this.matrixFilter = feColorMatrix11;
        var feMerge11 = this.createMergeNode(id11, [
            source11,
            id11 + "_tint_1",
            id11 + "_tint_2"
        ]);
        filter11.appendChild(feMerge11);
    }
    extendPrototype([
        SVGComposableEffect
    ], SVGTintFilter);
    SVGTintFilter.prototype.renderFrame = function(forceRender11) {
        if (forceRender11 || this.filterManager._mdf) {
            var colorBlack11 = this.filterManager.effectElements[0].p.v;
            var colorWhite11 = this.filterManager.effectElements[1].p.v;
            var opacity11 = this.filterManager.effectElements[2].p.v / 100;
            this.linearFilter.setAttribute("values", linearFilterValue + " " + opacity11 + " 0");
            this.matrixFilter.setAttribute("values", colorWhite11[0] - colorBlack11[0] + " 0 0 0 " + colorBlack11[0] + " " + (colorWhite11[1] - colorBlack11[1]) + " 0 0 0 " + colorBlack11[1] + " " + (colorWhite11[2] - colorBlack11[2]) + " 0 0 0 " + colorBlack11[2] + " 0 0 0 1 0");
        }
    };
    function SVGFillFilter(filter11, filterManager11, elem31, id11) {
        this.filterManager = filterManager11;
        var feColorMatrix11 = createNS("feColorMatrix");
        feColorMatrix11.setAttribute("type", "matrix");
        feColorMatrix11.setAttribute("color-interpolation-filters", "sRGB");
        feColorMatrix11.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0");
        feColorMatrix11.setAttribute("result", id11);
        filter11.appendChild(feColorMatrix11);
        this.matrixFilter = feColorMatrix11;
    }
    SVGFillFilter.prototype.renderFrame = function(forceRender11) {
        if (forceRender11 || this.filterManager._mdf) {
            var color41 = this.filterManager.effectElements[2].p.v;
            var opacity11 = this.filterManager.effectElements[6].p.v;
            this.matrixFilter.setAttribute("values", "0 0 0 0 " + color41[0] + " 0 0 0 0 " + color41[1] + " 0 0 0 0 " + color41[2] + " 0 0 0 " + opacity11 + " 0");
        }
    };
    function SVGStrokeEffect(fil11, filterManager11, elem31) {
        this.initialized = false;
        this.filterManager = filterManager11;
        this.elem = elem31;
        this.paths = [];
    }
    SVGStrokeEffect.prototype.initialize = function() {
        var elemChildren11 = this.elem.layerElement.children || this.elem.layerElement.childNodes;
        var path11;
        var groupPath11;
        var i31;
        var len11;
        if (this.filterManager.effectElements[1].p.v === 1) {
            len11 = this.elem.maskManager.masksProperties.length;
            i31 = 0;
        } else {
            i31 = this.filterManager.effectElements[0].p.v - 1;
            len11 = i31 + 1;
        }
        groupPath11 = createNS("g");
        groupPath11.setAttribute("fill", "none");
        groupPath11.setAttribute("stroke-linecap", "round");
        groupPath11.setAttribute("stroke-dashoffset", 1);
        for(i31; i31 < len11; i31 += 1){
            path11 = createNS("path");
            groupPath11.appendChild(path11);
            this.paths.push({
                p: path11,
                m: i31
            });
        }
        if (this.filterManager.effectElements[10].p.v === 3) {
            var mask11 = createNS("mask");
            var id11 = createElementID();
            mask11.setAttribute("id", id11);
            mask11.setAttribute("mask-type", "alpha");
            mask11.appendChild(groupPath11);
            this.elem.globalData.defs.appendChild(mask11);
            var g31 = createNS("g");
            g31.setAttribute("mask", "url(" + getLocationHref() + "#" + id11 + ")");
            while(elemChildren11[0])g31.appendChild(elemChildren11[0]);
            this.elem.layerElement.appendChild(g31);
            this.masker = mask11;
            groupPath11.setAttribute("stroke", "#fff");
        } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
            if (this.filterManager.effectElements[10].p.v === 2) {
                elemChildren11 = this.elem.layerElement.children || this.elem.layerElement.childNodes;
                while(elemChildren11.length)this.elem.layerElement.removeChild(elemChildren11[0]);
            }
            this.elem.layerElement.appendChild(groupPath11);
            this.elem.layerElement.removeAttribute("mask");
            groupPath11.setAttribute("stroke", "#fff");
        }
        this.initialized = true;
        this.pathMasker = groupPath11;
    };
    SVGStrokeEffect.prototype.renderFrame = function(forceRender11) {
        if (!this.initialized) this.initialize();
        var i31;
        var len11 = this.paths.length;
        var mask11;
        var path11;
        for(i31 = 0; i31 < len11; i31 += 1)if (this.paths[i31].m !== -1) {
            mask11 = this.elem.maskManager.viewData[this.paths[i31].m];
            path11 = this.paths[i31].p;
            if (forceRender11 || this.filterManager._mdf || mask11.prop._mdf) path11.setAttribute("d", mask11.lastPath);
            if (forceRender11 || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || mask11.prop._mdf) {
                var dasharrayValue11;
                if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
                    var s41 = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
                    var e31 = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
                    var l31 = path11.getTotalLength();
                    dasharrayValue11 = "0 0 0 " + l31 * s41 + " ";
                    var lineLength11 = l31 * (e31 - s41);
                    var segment11 = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
                    var units11 = Math.floor(lineLength11 / segment11);
                    var j31;
                    for(j31 = 0; j31 < units11; j31 += 1)dasharrayValue11 += "1 " + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + " ";
                    dasharrayValue11 += "0 " + l31 * 10 + " 0 0";
                } else dasharrayValue11 = "1 " + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
                path11.setAttribute("stroke-dasharray", dasharrayValue11);
            }
        }
        if (forceRender11 || this.filterManager.effectElements[4].p._mdf) this.pathMasker.setAttribute("stroke-width", this.filterManager.effectElements[4].p.v * 2);
        if (forceRender11 || this.filterManager.effectElements[6].p._mdf) this.pathMasker.setAttribute("opacity", this.filterManager.effectElements[6].p.v);
        if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
            if (forceRender11 || this.filterManager.effectElements[3].p._mdf) {
                var color41 = this.filterManager.effectElements[3].p.v;
                this.pathMasker.setAttribute("stroke", "rgb(" + bmFloor(color41[0] * 255) + "," + bmFloor(color41[1] * 255) + "," + bmFloor(color41[2] * 255) + ")");
            }
        }
    };
    function SVGTritoneFilter(filter11, filterManager11, elem31, id11) {
        this.filterManager = filterManager11;
        var feColorMatrix11 = createNS("feColorMatrix");
        feColorMatrix11.setAttribute("type", "matrix");
        feColorMatrix11.setAttribute("color-interpolation-filters", "linearRGB");
        feColorMatrix11.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0");
        filter11.appendChild(feColorMatrix11);
        var feComponentTransfer11 = createNS("feComponentTransfer");
        feComponentTransfer11.setAttribute("color-interpolation-filters", "sRGB");
        feComponentTransfer11.setAttribute("result", id11);
        this.matrixFilter = feComponentTransfer11;
        var feFuncR11 = createNS("feFuncR");
        feFuncR11.setAttribute("type", "table");
        feComponentTransfer11.appendChild(feFuncR11);
        this.feFuncR = feFuncR11;
        var feFuncG11 = createNS("feFuncG");
        feFuncG11.setAttribute("type", "table");
        feComponentTransfer11.appendChild(feFuncG11);
        this.feFuncG = feFuncG11;
        var feFuncB11 = createNS("feFuncB");
        feFuncB11.setAttribute("type", "table");
        feComponentTransfer11.appendChild(feFuncB11);
        this.feFuncB = feFuncB11;
        filter11.appendChild(feComponentTransfer11);
    }
    SVGTritoneFilter.prototype.renderFrame = function(forceRender11) {
        if (forceRender11 || this.filterManager._mdf) {
            var color111 = this.filterManager.effectElements[0].p.v;
            var color211 = this.filterManager.effectElements[1].p.v;
            var color311 = this.filterManager.effectElements[2].p.v;
            var tableR11 = color311[0] + " " + color211[0] + " " + color111[0];
            var tableG11 = color311[1] + " " + color211[1] + " " + color111[1];
            var tableB11 = color311[2] + " " + color211[2] + " " + color111[2];
            this.feFuncR.setAttribute("tableValues", tableR11);
            this.feFuncG.setAttribute("tableValues", tableG11);
            this.feFuncB.setAttribute("tableValues", tableB11);
        }
    };
    function SVGProLevelsFilter(filter11, filterManager11, elem31, id11) {
        this.filterManager = filterManager11;
        var effectElements11 = this.filterManager.effectElements;
        var feComponentTransfer11 = createNS("feComponentTransfer"); // Red
        if (effectElements11[10].p.k || effectElements11[10].p.v !== 0 || effectElements11[11].p.k || effectElements11[11].p.v !== 1 || effectElements11[12].p.k || effectElements11[12].p.v !== 1 || effectElements11[13].p.k || effectElements11[13].p.v !== 0 || effectElements11[14].p.k || effectElements11[14].p.v !== 1) this.feFuncR = this.createFeFunc("feFuncR", feComponentTransfer11);
         // Green
        if (effectElements11[17].p.k || effectElements11[17].p.v !== 0 || effectElements11[18].p.k || effectElements11[18].p.v !== 1 || effectElements11[19].p.k || effectElements11[19].p.v !== 1 || effectElements11[20].p.k || effectElements11[20].p.v !== 0 || effectElements11[21].p.k || effectElements11[21].p.v !== 1) this.feFuncG = this.createFeFunc("feFuncG", feComponentTransfer11);
         // Blue
        if (effectElements11[24].p.k || effectElements11[24].p.v !== 0 || effectElements11[25].p.k || effectElements11[25].p.v !== 1 || effectElements11[26].p.k || effectElements11[26].p.v !== 1 || effectElements11[27].p.k || effectElements11[27].p.v !== 0 || effectElements11[28].p.k || effectElements11[28].p.v !== 1) this.feFuncB = this.createFeFunc("feFuncB", feComponentTransfer11);
         // Alpha
        if (effectElements11[31].p.k || effectElements11[31].p.v !== 0 || effectElements11[32].p.k || effectElements11[32].p.v !== 1 || effectElements11[33].p.k || effectElements11[33].p.v !== 1 || effectElements11[34].p.k || effectElements11[34].p.v !== 0 || effectElements11[35].p.k || effectElements11[35].p.v !== 1) this.feFuncA = this.createFeFunc("feFuncA", feComponentTransfer11);
         // RGB
        if (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) {
            feComponentTransfer11.setAttribute("color-interpolation-filters", "sRGB");
            filter11.appendChild(feComponentTransfer11);
        }
        if (effectElements11[3].p.k || effectElements11[3].p.v !== 0 || effectElements11[4].p.k || effectElements11[4].p.v !== 1 || effectElements11[5].p.k || effectElements11[5].p.v !== 1 || effectElements11[6].p.k || effectElements11[6].p.v !== 0 || effectElements11[7].p.k || effectElements11[7].p.v !== 1) {
            feComponentTransfer11 = createNS("feComponentTransfer");
            feComponentTransfer11.setAttribute("color-interpolation-filters", "sRGB");
            feComponentTransfer11.setAttribute("result", id11);
            filter11.appendChild(feComponentTransfer11);
            this.feFuncRComposed = this.createFeFunc("feFuncR", feComponentTransfer11);
            this.feFuncGComposed = this.createFeFunc("feFuncG", feComponentTransfer11);
            this.feFuncBComposed = this.createFeFunc("feFuncB", feComponentTransfer11);
        }
    }
    SVGProLevelsFilter.prototype.createFeFunc = function(type11, feComponentTransfer11) {
        var feFunc11 = createNS(type11);
        feFunc11.setAttribute("type", "table");
        feComponentTransfer11.appendChild(feFunc11);
        return feFunc11;
    };
    SVGProLevelsFilter.prototype.getTableValue = function(inputBlack11, inputWhite11, gamma11, outputBlack11, outputWhite11) {
        var cnt11 = 0;
        var segments11 = 256;
        var perc11;
        var min11 = Math.min(inputBlack11, inputWhite11);
        var max11 = Math.max(inputBlack11, inputWhite11);
        var table11 = Array.call(null, {
            length: segments11
        });
        var colorValue11;
        var pos11 = 0;
        var outputDelta11 = outputWhite11 - outputBlack11;
        var inputDelta11 = inputWhite11 - inputBlack11;
        while(cnt11 <= 256){
            perc11 = cnt11 / 256;
            if (perc11 <= min11) colorValue11 = inputDelta11 < 0 ? outputWhite11 : outputBlack11;
            else if (perc11 >= max11) colorValue11 = inputDelta11 < 0 ? outputBlack11 : outputWhite11;
            else colorValue11 = outputBlack11 + outputDelta11 * Math.pow((perc11 - inputBlack11) / inputDelta11, 1 / gamma11);
            table11[pos11] = colorValue11;
            pos11 += 1;
            cnt11 += 256 / (segments11 - 1);
        }
        return table11.join(" ");
    };
    SVGProLevelsFilter.prototype.renderFrame = function(forceRender11) {
        if (forceRender11 || this.filterManager._mdf) {
            var val31;
            var effectElements11 = this.filterManager.effectElements;
            if (this.feFuncRComposed && (forceRender11 || effectElements11[3].p._mdf || effectElements11[4].p._mdf || effectElements11[5].p._mdf || effectElements11[6].p._mdf || effectElements11[7].p._mdf)) {
                val31 = this.getTableValue(effectElements11[3].p.v, effectElements11[4].p.v, effectElements11[5].p.v, effectElements11[6].p.v, effectElements11[7].p.v);
                this.feFuncRComposed.setAttribute("tableValues", val31);
                this.feFuncGComposed.setAttribute("tableValues", val31);
                this.feFuncBComposed.setAttribute("tableValues", val31);
            }
            if (this.feFuncR && (forceRender11 || effectElements11[10].p._mdf || effectElements11[11].p._mdf || effectElements11[12].p._mdf || effectElements11[13].p._mdf || effectElements11[14].p._mdf)) {
                val31 = this.getTableValue(effectElements11[10].p.v, effectElements11[11].p.v, effectElements11[12].p.v, effectElements11[13].p.v, effectElements11[14].p.v);
                this.feFuncR.setAttribute("tableValues", val31);
            }
            if (this.feFuncG && (forceRender11 || effectElements11[17].p._mdf || effectElements11[18].p._mdf || effectElements11[19].p._mdf || effectElements11[20].p._mdf || effectElements11[21].p._mdf)) {
                val31 = this.getTableValue(effectElements11[17].p.v, effectElements11[18].p.v, effectElements11[19].p.v, effectElements11[20].p.v, effectElements11[21].p.v);
                this.feFuncG.setAttribute("tableValues", val31);
            }
            if (this.feFuncB && (forceRender11 || effectElements11[24].p._mdf || effectElements11[25].p._mdf || effectElements11[26].p._mdf || effectElements11[27].p._mdf || effectElements11[28].p._mdf)) {
                val31 = this.getTableValue(effectElements11[24].p.v, effectElements11[25].p.v, effectElements11[26].p.v, effectElements11[27].p.v, effectElements11[28].p.v);
                this.feFuncB.setAttribute("tableValues", val31);
            }
            if (this.feFuncA && (forceRender11 || effectElements11[31].p._mdf || effectElements11[32].p._mdf || effectElements11[33].p._mdf || effectElements11[34].p._mdf || effectElements11[35].p._mdf)) {
                val31 = this.getTableValue(effectElements11[31].p.v, effectElements11[32].p.v, effectElements11[33].p.v, effectElements11[34].p.v, effectElements11[35].p.v);
                this.feFuncA.setAttribute("tableValues", val31);
            }
        }
    };
    function SVGDropShadowEffect(filter11, filterManager11, elem31, id11, source11) {
        var globalFilterSize11 = filterManager11.container.globalData.renderConfig.filterSize;
        var filterSize11 = filterManager11.data.fs || globalFilterSize11;
        filter11.setAttribute("x", filterSize11.x || globalFilterSize11.x);
        filter11.setAttribute("y", filterSize11.y || globalFilterSize11.y);
        filter11.setAttribute("width", filterSize11.width || globalFilterSize11.width);
        filter11.setAttribute("height", filterSize11.height || globalFilterSize11.height);
        this.filterManager = filterManager11;
        var feGaussianBlur11 = createNS("feGaussianBlur");
        feGaussianBlur11.setAttribute("in", "SourceAlpha");
        feGaussianBlur11.setAttribute("result", id11 + "_drop_shadow_1");
        feGaussianBlur11.setAttribute("stdDeviation", "0");
        this.feGaussianBlur = feGaussianBlur11;
        filter11.appendChild(feGaussianBlur11);
        var feOffset11 = createNS("feOffset");
        feOffset11.setAttribute("dx", "25");
        feOffset11.setAttribute("dy", "0");
        feOffset11.setAttribute("in", id11 + "_drop_shadow_1");
        feOffset11.setAttribute("result", id11 + "_drop_shadow_2");
        this.feOffset = feOffset11;
        filter11.appendChild(feOffset11);
        var feFlood11 = createNS("feFlood");
        feFlood11.setAttribute("flood-color", "#00ff00");
        feFlood11.setAttribute("flood-opacity", "1");
        feFlood11.setAttribute("result", id11 + "_drop_shadow_3");
        this.feFlood = feFlood11;
        filter11.appendChild(feFlood11);
        var feComposite11 = createNS("feComposite");
        feComposite11.setAttribute("in", id11 + "_drop_shadow_3");
        feComposite11.setAttribute("in2", id11 + "_drop_shadow_2");
        feComposite11.setAttribute("operator", "in");
        feComposite11.setAttribute("result", id11 + "_drop_shadow_4");
        filter11.appendChild(feComposite11);
        var feMerge11 = this.createMergeNode(id11, [
            id11 + "_drop_shadow_4",
            source11
        ]);
        filter11.appendChild(feMerge11); //
    }
    extendPrototype([
        SVGComposableEffect
    ], SVGDropShadowEffect);
    SVGDropShadowEffect.prototype.renderFrame = function(forceRender11) {
        if (forceRender11 || this.filterManager._mdf) {
            if (forceRender11 || this.filterManager.effectElements[4].p._mdf) this.feGaussianBlur.setAttribute("stdDeviation", this.filterManager.effectElements[4].p.v / 4);
            if (forceRender11 || this.filterManager.effectElements[0].p._mdf) {
                var col11 = this.filterManager.effectElements[0].p.v;
                this.feFlood.setAttribute("flood-color", rgbToHex(Math.round(col11[0] * 255), Math.round(col11[1] * 255), Math.round(col11[2] * 255)));
            }
            if (forceRender11 || this.filterManager.effectElements[1].p._mdf) this.feFlood.setAttribute("flood-opacity", this.filterManager.effectElements[1].p.v / 255);
            if (forceRender11 || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
                var distance11 = this.filterManager.effectElements[3].p.v;
                var angle11 = (this.filterManager.effectElements[2].p.v - 90) * degToRads;
                var x41 = distance11 * Math.cos(angle11);
                var y41 = distance11 * Math.sin(angle11);
                this.feOffset.setAttribute("dx", x41);
                this.feOffset.setAttribute("dy", y41);
            }
        }
    };
    var _svgMatteSymbols = [];
    function SVGMatte3Effect(filterElem11, filterManager11, elem31) {
        this.initialized = false;
        this.filterManager = filterManager11;
        this.filterElem = filterElem11;
        this.elem = elem31;
        elem31.matteElement = createNS("g");
        elem31.matteElement.appendChild(elem31.layerElement);
        elem31.matteElement.appendChild(elem31.transformedElement);
        elem31.baseElement = elem31.matteElement;
    }
    SVGMatte3Effect.prototype.findSymbol = function(mask11) {
        var i31 = 0;
        var len11 = _svgMatteSymbols.length;
        while(i31 < len11){
            if (_svgMatteSymbols[i31] === mask11) return _svgMatteSymbols[i31];
            i31 += 1;
        }
        return null;
    };
    SVGMatte3Effect.prototype.replaceInParent = function(mask11, symbolId11) {
        var parentNode11 = mask11.layerElement.parentNode;
        if (!parentNode11) return;
        var children11 = parentNode11.children;
        var i31 = 0;
        var len11 = children11.length;
        while(i31 < len11){
            if (children11[i31] === mask11.layerElement) break;
            i31 += 1;
        }
        var nextChild11;
        if (i31 <= len11 - 2) nextChild11 = children11[i31 + 1];
        var useElem11 = createNS("use");
        useElem11.setAttribute("href", "#" + symbolId11);
        if (nextChild11) parentNode11.insertBefore(useElem11, nextChild11);
        else parentNode11.appendChild(useElem11);
    };
    SVGMatte3Effect.prototype.setElementAsMask = function(elem31, mask11) {
        if (!this.findSymbol(mask11)) {
            var symbolId11 = createElementID();
            var masker11 = createNS("mask");
            masker11.setAttribute("id", mask11.layerId);
            masker11.setAttribute("mask-type", "alpha");
            _svgMatteSymbols.push(mask11);
            var defs11 = elem31.globalData.defs;
            defs11.appendChild(masker11);
            var symbol11 = createNS("symbol");
            symbol11.setAttribute("id", symbolId11);
            this.replaceInParent(mask11, symbolId11);
            symbol11.appendChild(mask11.layerElement);
            defs11.appendChild(symbol11);
            var useElem11 = createNS("use");
            useElem11.setAttribute("href", "#" + symbolId11);
            masker11.appendChild(useElem11);
            mask11.data.hd = false;
            mask11.show();
        }
        elem31.setMatte(mask11.layerId);
    };
    SVGMatte3Effect.prototype.initialize = function() {
        var ind11 = this.filterManager.effectElements[0].p.v;
        var elements11 = this.elem.comp.elements;
        var i31 = 0;
        var len11 = elements11.length;
        while(i31 < len11){
            if (elements11[i31] && elements11[i31].data.ind === ind11) this.setElementAsMask(this.elem, elements11[i31]);
            i31 += 1;
        }
        this.initialized = true;
    };
    SVGMatte3Effect.prototype.renderFrame = function() {
        if (!this.initialized) this.initialize();
    };
    function SVGGaussianBlurEffect(filter11, filterManager11, elem31, id11) {
        // Outset the filter region by 100% on all sides to accommodate blur expansion.
        filter11.setAttribute("x", "-100%");
        filter11.setAttribute("y", "-100%");
        filter11.setAttribute("width", "300%");
        filter11.setAttribute("height", "300%");
        this.filterManager = filterManager11;
        var feGaussianBlur11 = createNS("feGaussianBlur");
        feGaussianBlur11.setAttribute("result", id11);
        filter11.appendChild(feGaussianBlur11);
        this.feGaussianBlur = feGaussianBlur11;
    }
    SVGGaussianBlurEffect.prototype.renderFrame = function(forceRender11) {
        if (forceRender11 || this.filterManager._mdf) {
            // Empirical value, matching AE's blur appearance.
            var kBlurrinessToSigma11 = 0.3;
            var sigma11 = this.filterManager.effectElements[0].p.v * kBlurrinessToSigma11; // Dimensions mapping:
            //
            //   1 -> horizontal & vertical
            //   2 -> horizontal only
            //   3 -> vertical only
            //
            var dimensions11 = this.filterManager.effectElements[1].p.v;
            var sigmaX11 = dimensions11 == 3 ? 0 : sigma11; // eslint-disable-line eqeqeq
            var sigmaY11 = dimensions11 == 2 ? 0 : sigma11; // eslint-disable-line eqeqeq
            this.feGaussianBlur.setAttribute("stdDeviation", sigmaX11 + " " + sigmaY11); // Repeat edges mapping:
            //
            //   0 -> off -> duplicate
            //   1 -> on  -> wrap
            var edgeMode11 = this.filterManager.effectElements[2].p.v == 1 ? "wrap" : "duplicate"; // eslint-disable-line eqeqeq
            this.feGaussianBlur.setAttribute("edgeMode", edgeMode11);
        }
    };
    function TransformEffect() {}
    TransformEffect.prototype.init = function(effectsManager11) {
        this.effectsManager = effectsManager11;
        this.type = effectTypes.TRANSFORM_EFFECT;
        this.matrix = new Matrix();
        this.opacity = -1;
        this._mdf = false;
        this._opMdf = false;
    };
    TransformEffect.prototype.renderFrame = function(forceFrame11) {
        this._opMdf = false;
        this._mdf = false;
        if (forceFrame11 || this.effectsManager._mdf) {
            var effectElements11 = this.effectsManager.effectElements;
            var anchor11 = effectElements11[0].p.v;
            var position11 = effectElements11[1].p.v;
            var isUniformScale11 = effectElements11[2].p.v === 1;
            var scaleHeight11 = effectElements11[3].p.v;
            var scaleWidth11 = isUniformScale11 ? scaleHeight11 : effectElements11[4].p.v;
            var skew11 = effectElements11[5].p.v;
            var skewAxis11 = effectElements11[6].p.v;
            var rotation11 = effectElements11[7].p.v;
            this.matrix.reset();
            this.matrix.translate(-anchor11[0], -anchor11[1], anchor11[2]);
            this.matrix.scale(scaleWidth11 * 0.01, scaleHeight11 * 0.01, 1);
            this.matrix.rotate(-rotation11 * degToRads);
            this.matrix.skewFromAxis(-skew11 * degToRads, (skewAxis11 + 90) * degToRads);
            this.matrix.translate(position11[0], position11[1], 0);
            this._mdf = true;
            if (this.opacity !== effectElements11[8].p.v) {
                this.opacity = effectElements11[8].p.v;
                this._opMdf = true;
            }
        }
    };
    function SVGTransformEffect(_11, filterManager11) {
        this.init(filterManager11);
    }
    extendPrototype([
        TransformEffect
    ], SVGTransformEffect);
    function CVTransformEffect(effectsManager11) {
        this.init(effectsManager11);
    }
    extendPrototype([
        TransformEffect
    ], CVTransformEffect);
    registerRenderer("canvas", CanvasRenderer);
    registerRenderer("html", HybridRenderer);
    registerRenderer("svg", SVGRenderer); // Registering shape modifiers
    ShapeModifiers.registerModifier("tm", TrimModifier);
    ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier);
    ShapeModifiers.registerModifier("rp", RepeaterModifier);
    ShapeModifiers.registerModifier("rd", RoundCornersModifier);
    ShapeModifiers.registerModifier("zz", ZigZagModifier);
    ShapeModifiers.registerModifier("op", OffsetPathModifier); // Registering expression plugin
    setExpressionsPlugin(Expressions);
    setExpressionInterfaces(getInterface);
    initialize$1();
    initialize(); // Registering svg effects
    registerEffect$1(20, SVGTintFilter, true);
    registerEffect$1(21, SVGFillFilter, true);
    registerEffect$1(22, SVGStrokeEffect, false);
    registerEffect$1(23, SVGTritoneFilter, true);
    registerEffect$1(24, SVGProLevelsFilter, true);
    registerEffect$1(25, SVGDropShadowEffect, true);
    registerEffect$1(28, SVGMatte3Effect, false);
    registerEffect$1(29, SVGGaussianBlurEffect, true);
    registerEffect$1(35, SVGTransformEffect, false);
    registerEffect(35, CVTransformEffect);
    return lottie;
});

});

parcelRegister("eBXBv", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("7ueKX")).then(()=>parcelRequire("h3ZPr"));

});
parcelRegister("4WKyX", function(module, exports) {
"use strict";

var $2prpb = parcelRequire("2prpb");
module.exports = $2prpb(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("2prpb", function(module, exports) {
"use strict";
var $1c132cac09cd18d9$var$cachedBundles = {};
var $1c132cac09cd18d9$var$cachedPreloads = {};
var $1c132cac09cd18d9$var$cachedPrefetches = {};
function $1c132cac09cd18d9$var$getCache(type) {
    switch(type){
        case "preload":
            return $1c132cac09cd18d9$var$cachedPreloads;
        case "prefetch":
            return $1c132cac09cd18d9$var$cachedPrefetches;
        default:
            return $1c132cac09cd18d9$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $1c132cac09cd18d9$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("d3wlY", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("6rMJS")).then(()=>parcelRequire("9xgsm"));

});

parcelRegister("6u6hr", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("340v6")).then(()=>parcelRequire("jCFB8"));

});

parcelRegister("apwUO", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("2WHQg")).then(()=>parcelRequire("jiaaL"));

});

parcelRegister("2Q0Mt", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("jrwlB")).then(()=>parcelRequire("aVJzX"));

});

parcelRegister("slmox", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("4EKfz")).then(()=>parcelRequire("anh9Z"));

});

parcelRegister("bab5B", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("bjkxP")).then(()=>parcelRequire("eWdVA"));

});

parcelRegister("57NMR", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("dfi3e")).then(()=>parcelRequire("9xm93"));

});

parcelRegister("9ilJV", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("5Ttm6")).then(()=>parcelRequire("i2rKN"));

});

parcelRegister("c96HW", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("bzlOF")).then(()=>parcelRequire("2HKNy"));

});

parcelRegister("8EUnn", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("doZyk")).then(()=>parcelRequire("3PQzA"));

});

const $97bd2aec073fe385$var$page = document.querySelector(".page");
const $97bd2aec073fe385$var$menu = document.querySelector(".menu");
const $97bd2aec073fe385$var$openButton = $97bd2aec073fe385$var$menu.querySelector(".menu__control_type_open");
const $97bd2aec073fe385$var$closeButton = $97bd2aec073fe385$var$menu.querySelector(".menu__control_type_close");
const $97bd2aec073fe385$var$links = $97bd2aec073fe385$var$menu.querySelectorAll(".menu__link");
const $97bd2aec073fe385$var$toggleMenu = ()=>{
    $97bd2aec073fe385$var$page.classList.toggle("page_lock");
    $97bd2aec073fe385$var$menu.classList.toggle("menu_open");
    if ($97bd2aec073fe385$var$menu.classList.contains("menu_open")) // Focus on the first link
    $97bd2aec073fe385$var$links[0].focus();
    else // Focus on the control
    $97bd2aec073fe385$var$openButton.focus();
};
$97bd2aec073fe385$var$openButton.addEventListener("click", ()=>$97bd2aec073fe385$var$toggleMenu());
$97bd2aec073fe385$var$closeButton.addEventListener("click", ()=>$97bd2aec073fe385$var$toggleMenu());
$97bd2aec073fe385$var$links.forEach((link)=>{
    link.addEventListener("click", ()=>$97bd2aec073fe385$var$toggleMenu());
});
window.addEventListener("scroll", ()=>{
    if ($97bd2aec073fe385$var$menu.classList.contains("menu_open")) return;
    if (window.scrollY > 10 && !$97bd2aec073fe385$var$openButton.classList.contains("menu__control_highlight")) $97bd2aec073fe385$var$openButton.classList.add("menu__control_highlight");
    else if (window.scrollY < 10 && $97bd2aec073fe385$var$openButton.classList.contains("menu__control_highlight")) $97bd2aec073fe385$var$openButton.classList.remove("menu__control_highlight");
});



var $jPhJ8 = parcelRequire("jPhJ8");
const $0473e51beca2a206$var$ANIMATION_ALL = "all";
const $0473e51beca2a206$var$ANIMATION_DESKTOP = "desktop";
const $0473e51beca2a206$var$ANIMATION_MOBILE = "mobile";
async function $0473e51beca2a206$var$loadAnimation(currentAnimationType, loadAnimationData, config) {
    const { container: container, breakpoint: breakpoint, loop: loop, autoplay: autoplay, onLoad: onLoad } = config;
    if (!container) {
        console.error("Animation container not found");
        return currentAnimationType;
    }
    const nextAnimationType = breakpoint === null ? $0473e51beca2a206$var$ANIMATION_ALL : window.innerWidth < breakpoint ? $0473e51beca2a206$var$ANIMATION_MOBILE : $0473e51beca2a206$var$ANIMATION_DESKTOP;
    if (currentAnimationType === nextAnimationType) return currentAnimationType;
    let animationData = await loadAnimationData(nextAnimationType);
    if (animationData.data === null) return currentAnimationType;
    container.innerHTML = "";
    if (animationData.type === "animation") {
        const animation = (0, (/*@__PURE__*/$parcel$interopDefault($jPhJ8))).loadAnimation({
            container: container,
            renderer: "svg",
            loop: loop,
            autoplay: autoplay,
            animationData: animationData.data
        });
        if (typeof onLoad === "function") onLoad(animation);
        const animationLoading = async ()=>{
            return new Promise((resolve)=>{
                animation.addEventListener("DOMLoaded", function handler() {
                    resolve();
                    animation.removeEventListener("DOMLoaded", handler);
                });
            });
        };
        await animationLoading();
    }
    if (animationData.type === "image") container.appendChild(animationData.data);
    return nextAnimationType;
}
async function $0473e51beca2a206$var$observeAnimation(target, loadAnimationData, config) {
    const { breakpoint: breakpoint } = config;
    let animationType = null; // Can be null, 'desktop', or 'mobile'
    let hasObserver = false;
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach(async (entry)=>{
            if (entry.isIntersecting) {
                animationType = await $0473e51beca2a206$var$loadAnimation(animationType, loadAnimationData, config);
                observer.unobserve(entry.target);
                hasObserver = false;
            }
        });
    }, {
        rootMargin: "1000px"
    });
    if (target) {
        observer.observe(target);
        hasObserver = true;
        if (breakpoint !== null) window.addEventListener("resize", ()=>{
            if (hasObserver) return;
            const nextAnimationType = window.innerWidth < breakpoint ? $0473e51beca2a206$var$ANIMATION_MOBILE : $0473e51beca2a206$var$ANIMATION_DESKTOP;
            if (animationType === nextAnimationType) return;
            observer.observe(target);
            hasObserver = true;
        });
    }
}











window.addEventListener("load", (event)=>{
    /* Animation Earth Set up */ const containerEarth = document.getElementById("animation-earth");
    const targetEarth = containerEarth;
    const loadAnimationDataEarth = async (nextAnimationType)=>{
        let data = null;
        try {
            if (nextAnimationType === $0473e51beca2a206$var$ANIMATION_MOBILE) data = await (parcelRequire("eBXBv"));
            if (nextAnimationType === $0473e51beca2a206$var$ANIMATION_DESKTOP) data = await (parcelRequire("d3wlY"));
            if (data === null) console.error("Animation data for earth is empty");
        } catch (error) {
            console.error("Error loading animation data for earth:", error);
        }
        return {
            type: "animation",
            data: data
        };
    };
    $0473e51beca2a206$var$observeAnimation(targetEarth, loadAnimationDataEarth, {
        container: containerEarth,
        breakpoint: 1100,
        loop: true,
        autoplay: true
    });
    /* Animation Flexy Set up */ const targetFlexy = document.getElementById("flexy");
    const containerFlexy = document.getElementById("animation-flexy");
    const loadAnimationDataFlexy = async (nextAnimationType)=>{
        let data = null;
        try {
            if (nextAnimationType === $0473e51beca2a206$var$ANIMATION_MOBILE) data = await (parcelRequire("6u6hr"));
            if (nextAnimationType === $0473e51beca2a206$var$ANIMATION_DESKTOP) data = await (parcelRequire("apwUO"));
            if (data === null) console.error("Animation data for flexy is empty");
        } catch (error) {
            console.error("Error loading animation data for flexy:", error);
        }
        return {
            type: "animation",
            data: data
        };
    };
    $0473e51beca2a206$var$observeAnimation(targetFlexy, loadAnimationDataFlexy, {
        container: containerFlexy,
        breakpoint: 600,
        loop: true,
        autoplay: true
    });
    /* Animation Muffins Path Set up */ const targetPath = document.querySelector(".path");
    const pathItems = targetPath.querySelectorAll(".path__item");
    pathItems.forEach((pathItem)=>{
        const containerPath = pathItem.querySelector(".path__animation");
        const id = parseInt(pathItem.dataset.id);
        const loadAnimationDataPath = async (nextAnimationType)=>{
            let data = null;
            if (nextAnimationType === $0473e51beca2a206$var$ANIMATION_ALL) try {
                switch(id){
                    case 1:
                        data = await (parcelRequire("2Q0Mt"));
                        break;
                    case 2:
                        data = await (parcelRequire("slmox"));
                        break;
                    case 3:
                        data = await (parcelRequire("bab5B"));
                        break;
                    case 4:
                        data = await (parcelRequire("57NMR"));
                        break;
                    case 5:
                        data = await (parcelRequire("9ilJV"));
                        break;
                }
            } catch (error) {
                console.error(`Error loading animation data for path ${id}:`, error);
            }
            return {
                type: "animation",
                data: data
            };
        };
        $0473e51beca2a206$var$observeAnimation(targetPath, loadAnimationDataPath, {
            container: containerPath,
            breakpoint: null,
            loop: false,
            autoplay: false,
            onLoad: (animation)=>{
                const frames = animation.getDuration(true);
                const pathItemObserver = new MutationObserver((mutations)=>{
                    mutations.forEach((mutation)=>{
                        if (mutation.type === "attributes" && mutation.attributeName === "data-progress") {
                            const progress = parseInt(mutation.target.dataset.progress);
                            const frame = Math.round(frames * progress / 100);
                            animation.goToAndStop(frame, true);
                        }
                    });
                });
                pathItemObserver.observe(pathItem, {
                    attributes: true
                });
            }
        });
    });
    /* Animation Hero Set up */ const targetHero = document.getElementById("page");
    const containerHero = document.getElementById("animation-hero");
    const loadAnimationDataHero = async (nextAnimationType)=>{
        let data = null;
        try {
            if (nextAnimationType === $0473e51beca2a206$var$ANIMATION_MOBILE) data = await (parcelRequire("c96HW"));
            if (nextAnimationType === $0473e51beca2a206$var$ANIMATION_DESKTOP) data = await (parcelRequire("8EUnn"));
            if (data === null) console.error("Animation data for hero is empty");
        } catch (error) {
            console.error("Error loading animation data for hero:", error);
        }
        return {
            type: "animation",
            data: data
        };
    };
    $0473e51beca2a206$var$observeAnimation(targetHero, loadAnimationDataHero, {
        container: containerHero,
        breakpoint: 450,
        loop: false,
        autoplay: true
    });
});


document.querySelectorAll(".partner").forEach((partner)=>{
    const desktop = partner.querySelector(".partner__summary-control_type_desktop");
    desktop.addEventListener("click", ()=>partner.classList.toggle("partner_open"));
    const heading = partner.querySelector(".partner__heading");
    heading.addEventListener("click", ()=>partner.classList.toggle("partner_open"));
});


const $3fe8c23480bcc580$var$path = document.querySelector(".path");
const $3fe8c23480bcc580$var$pathItems = $3fe8c23480bcc580$var$path.querySelectorAll(".path__item");
const $3fe8c23480bcc580$var$DELAY = 200;
let $3fe8c23480bcc580$var$isUpdating = false;
const $3fe8c23480bcc580$var$updatePath = ()=>{
    const { y: y } = $3fe8c23480bcc580$var$path.getBoundingClientRect();
    const top = Math.max(0, window.innerHeight - $3fe8c23480bcc580$var$DELAY - y).toFixed(0);
    $3fe8c23480bcc580$var$path.style.setProperty("--line-height", `${top}px`);
    // Update progress for each activated path item
    $3fe8c23480bcc580$var$pathItems.forEach((item)=>{
        const currentProgress = parseInt(item.dataset.progress);
        let nextProgress = currentProgress;
        if (item.classList.contains("path__item_activated")) {
            const itemRect = item.getBoundingClientRect();
            const scrollDelta = window.innerHeight - itemRect.y - $3fe8c23480bcc580$var$DELAY;
            const rawProgress = Math.round(scrollDelta * 100 / itemRect.height);
            nextProgress = Math.max(0, Math.min(100, rawProgress));
        } else // Set progress to zero for non-activated items
        nextProgress = 0;
        if (currentProgress !== nextProgress) item.dataset.progress = nextProgress;
    });
    $3fe8c23480bcc580$var$isUpdating = false;
};
const $3fe8c23480bcc580$var$onScroll = ()=>{
    if (!$3fe8c23480bcc580$var$isUpdating) {
        $3fe8c23480bcc580$var$isUpdating = true;
        requestAnimationFrame($3fe8c23480bcc580$var$updatePath);
    }
};
const $3fe8c23480bcc580$var$pathItemObserver = new IntersectionObserver((entries)=>{
    entries.forEach((entry)=>{
        if (entry.isIntersecting) {
            if (entry.target.classList.contains("path__item_activated")) return;
            entry.target.classList.add("path__item_activated");
        } else {
            if (!entry.target.classList.contains("path__item_activated")) return;
            entry.target.classList.remove("path__item_activated");
        }
    });
});
$3fe8c23480bcc580$var$pathItems.forEach((item)=>{
    $3fe8c23480bcc580$var$pathItemObserver.observe(item);
});
const $3fe8c23480bcc580$var$pathObserver = new IntersectionObserver((entries)=>{
    entries.forEach((entry)=>{
        if (entry.isIntersecting) {
            if (entry.target.classList.contains("path_activated")) return;
            entry.target.classList.add("path_activated");
            window.addEventListener("scroll", $3fe8c23480bcc580$var$onScroll, {
                passive: true
            });
        } else {
            if (!entry.target.classList.contains("path_activated")) return;
            entry.target.classList.remove("path_activated");
            window.removeEventListener("scroll", $3fe8c23480bcc580$var$onScroll);
        }
    });
});
$3fe8c23480bcc580$var$pathObserver.observe($3fe8c23480bcc580$var$path);


document.querySelectorAll(".slider").forEach((slider)=>{
    const slides = slider.querySelector(".slider__slides");
    let slideWidth = slider.querySelector(".slider__slide").getBoundingClientRect().width; // made let to update on resize
    const totalSlides = slider.querySelectorAll(".slider__slide").length;
    const dots = slider.querySelectorAll(`.slider__dot`);
    const prevButton = slider.querySelector(".slider__control_to_prev");
    const nextButton = slider.querySelector(".slider__control_to_next");
    let currentSlide = 1;
    let startTouch = 0; // For touch start position
    const updateSlides = ()=>{
        slides.style.transform = `translateX(${-slideWidth * (currentSlide - 1)}px)`;
        updateDots();
        updateControls();
    };
    const nextSlide = ()=>{
        currentSlide = currentSlide % totalSlides + 1;
        updateSlides();
    };
    const prevSlide = ()=>{
        currentSlide = currentSlide === 1 ? totalSlides : currentSlide - 1;
        updateSlides();
    };
    const goToSlide = (slideNumber)=>{
        currentSlide = slideNumber;
        updateSlides();
    };
    const updateDots = ()=>{
        dots.forEach((dot, index)=>{
            dot.classList.toggle("slider__dot_active", index + 1 === currentSlide);
        });
    };
    dots.forEach((dot, index)=>{
        dot.addEventListener("click", ()=>goToSlide(index + 1));
    });
    const updateControls = ()=>{
        prevButton.style.visibility = currentSlide === 1 ? "hidden" : "visible";
        nextButton.style.visibility = currentSlide === totalSlides ? "hidden" : "visible";
    };
    // Resize event listener to update slide width and slides
    window.addEventListener("resize", ()=>{
        slideWidth = slider.querySelector(".slider__slide").getBoundingClientRect().width;
        updateSlides();
    });
    // Touch events for swiping on mobile
    slider.addEventListener("touchstart", (e)=>{
        startTouch = e.touches[0].clientX;
    });
    slider.addEventListener("touchend", (e)=>{
        const endTouch = e.changedTouches[0].clientX;
        if (startTouch - endTouch > 50) // Swipe left
        nextSlide();
        else if (startTouch - endTouch < -50) // Swipe right
        prevSlide();
    });
    prevButton.addEventListener("click", prevSlide);
    nextButton.addEventListener("click", nextSlide);
    // Initialize slides
    updateSlides();
});


const $07bb0a938a824290$var$things = document.querySelectorAll(".things");
$07bb0a938a824290$var$things.forEach((thing)=>{
    const categories = thing.querySelectorAll(".things__category");
    const items = thing.querySelectorAll(".things__item");
    let groupedItems = {};
    items.forEach((item)=>{
        const category = item.dataset.category;
        if (typeof groupedItems[category] === "undefined") groupedItems[category] = [];
        groupedItems[category] = groupedItems[category].concat(item);
    });
    categories.forEach((category)=>{
        const items = groupedItems[category.dataset.category];
        category.addEventListener("click", ()=>{
            items.forEach((item)=>{
                item.classList.toggle("things__item_open");
            });
            category.classList.toggle("things__category_open");
        });
    });
});



})();
//# sourceMappingURL=index.96f571a0.js.map
